import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Dil dosyaları
const resources = {
  tr: {
    translation: {
      "language.title": "Dil",
      // Ana sayfa
      'hero.title': 'Utkan eSIM',
      'hero.subtitle': 'Dijital Bağlantının Geleceği',
      'hero.description': 'Yeni nesil dijital bağlantı deneyimiyle sınırları kaldırıyoruz.',
      'hero.description2': 'Dünya çapında hızlı, güvenli ve uygun fiyatlı eSIM çözümleri.',

      // Özellikler
      'features.countries': '150+ Ülke',
      'features.activation': 'Anında Aktivasyon',
      'features.support': '7/24 Destek',

      // Sayaç
      'countdown.title': 'Web Sitemiz Çok Yakında!',
      'countdown.days': 'Gün',
      'countdown.hours': 'Saat',
      'countdown.minutes': 'Dakika',
      'countdown.seconds': 'Saniye',
      'countdown.launch': 'Web Sitemiz Açıldı!',
      'countdown.loading': 'Yükleniyor...',

      // Uygulamalar
      'apps.title': 'Mobil Uygulamalarımız',
      'apps.ios.label': 'Download on the',
      'apps.ios.name': 'App Store',
      'apps.android.label': 'GET IT ON',
      'apps.android.name': 'Google Play',

      // İletişim
      'contact.title': 'Lansmana Kadar Bize Ulaşın',
      'contact.whatsapp': 'WhatsApp: +90 540 155 13 33',
      'contact.email': 'E-posta: info@utkanesim.com',

      // About sayfası
      'about.hero.title': 'Utkan eSIM Hakkında',
      'about.hero.description': 'Kişisel verilerinizin güvenliği bizim için çok önemlidir. Bu politika, verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklar.',
      'about.story.title': 'Hikayemiz',
      'about.story.content': '2024 yılında tutkulu gezginler ve teknoloji meraklılarından oluşan bir ekip tarafından kurulan Utkan eSIM, insanların yurtdışında internete bağlanma şeklini devrim yaratacak şekilde değiştirmeyi hedefliyor. 190\'dan fazla ülke ve bölge için yüksek kaliteli, güvenilir eSIM veri planları sunarak, indiğiniz andan itibaren hızlı internet erişiminizi sağlıyoruz.',
      'about.mission.title': 'Misyonumuz',
      'about.mission.content': 'Gezginlere dünya çapında basit, uygun fiyatlı ve anında bağlantı sağlayarak, sınırlar olmadan keşfetmelerini, çalışmalarını ve iletişimde kalmalarını sağlamak.',
      'about.vision.title': 'Vizyonumuz',
      'about.vision.content': 'Dijital bağlantı çözümleri için önde gelen global platform olmak, dünyayı herkes için daha küçük ve daha bağlantılı bir yer haline getirmek.',
      'about.features.title': 'Neden Bizi Seçmelisiniz?',
      'about.features.instant.title': 'Anında Teslimat',
      'about.features.instant.content': 'Satın alma sonrası QR kod ile eSIM\'inizi anında alın.',
      'about.features.global.title': 'Global Kapsama',
      'about.features.global.content': '190\'dan fazla ülke ve bölge için veri planları.',
      'about.features.affordable.title': 'Uygun Fiyatlar',
      'about.features.affordable.content': 'Roaming ücretlerinde %90\'a kadar tasarruf edin.',
      'about.features.support.title': '7/24 Destek',
      'about.features.support.content': 'Dedikli destek ekibimiz her zaman yardımınızda.',
      'about.features.secure.title': 'Güvenli Bağlantı',
      'about.features.secure.content': 'En son güvenlik protokolleri ile korunan bağlantı.',
      'about.features.fast.title': 'Hızlı İnternet',
      'about.features.fast.content': '4G/5G hızlarında kesintisiz internet deneyimi.',
      'about.cta.title': 'Dijital Bağlantının Geleceğine Katılın',
      'about.cta.content': 'Utkan eSIM\'i seçtiğiniz için teşekkür ederiz. İyi seyahatler!',
      'about.cta.whatsapp': 'WhatsApp ile İletişim',
      'about.cta.email': 'E-posta Gönder',

      // Contact sayfası
      'contact.hero.title': 'Bizimle İletişime Geçin',
      'contact.hero.description': 'eSIM\'lerimiz hakkında sorularınız, teknik destek ihtiyacınız veya sadece geri bildirim vermek istiyorsanız, sizden haber almaktan mutluluk duyarız.',
      'contact.info.title': 'İletişim Bilgilerimiz',
      'contact.whatsapp.title': 'WhatsApp',
      'contact.whatsapp.subtitle': '7/24 Hızlı Destek',
      'contact.email.title': 'E-posta',
      'contact.email.subtitle': 'Genel İletişim',
      'contact.support.title': 'Teknik Destek',
      'contact.support.subtitle': 'eSIM Sorunları',
      'contact.business.title': 'İş Ortaklığı',
      'contact.business.subtitle': 'Kurumsal İletişim',
      'contact.hours.title': 'Destek Saatleri',
      'contact.hours.subtitle': '7/24 Teknik Destek',
      'contact.hours.detail': 'Pazartesi - Pazar: 00:00 - 23:59',
      'contact.form.title': 'Mesaj Gönderin',
      'contact.form.name': 'Adınız Soyadınız',
      'contact.form.name.placeholder': 'Adınızı ve soyadınızı girin',
      'contact.form.email': 'E-posta Adresiniz',
      'contact.form.email.placeholder': 'ornek@email.com',
      'contact.form.subject': 'Konu',
      'contact.form.subject.placeholder': 'Konu seçin',
      'contact.form.subject.general': 'Genel Bilgi',
      'contact.form.subject.technical': 'Teknik Destek',
      'contact.form.subject.billing': 'Fatura Soruları',
      'contact.form.subject.partnership': 'İş Ortaklığı',
      'contact.form.subject.feedback': 'Geri Bildirim',
      'contact.form.message': 'Mesajınız',
      'contact.form.message.placeholder': 'Mesajınızı buraya yazın...',
      'contact.form.submit': 'Mesaj Gönder',
      'contact.faq.title': 'Sık Sorulan Sorular',
      'contact.faq.esim.title': 'eSIM nasıl çalışır?',
      'contact.faq.esim.content': 'eSIM, fiziksel SIM kartına ihtiyaç duymadan telefonunuzda çalışan dijital SIM kartıdır. QR kod ile anında aktifleştirilir.',
      'contact.faq.phones.title': 'Hangi telefonlar eSIM destekler?',
      'contact.faq.phones.content': 'iPhone XS ve üzeri, Samsung Galaxy S20 ve üzeri, Google Pixel 3 ve üzeri modeller eSIM destekler.',
      'contact.faq.validity.title': 'Veri paketim ne kadar süre geçerli?',
      'contact.faq.validity.content': 'Paketlerin geçerlilik süresi seçtiğiniz plana göre 1-30 gün arasında değişir.',
      'contact.faq.payment.title': 'Ödeme nasıl yapılır?',
      'contact.faq.payment.content': 'Kredi kartı, PayPal ve banka havalesi ile güvenli ödeme yapabilirsiniz.',

      // Privacy sayfası
      'privacy.hero.title': 'Gizlilik Politikası',
      'privacy.hero.description': 'Kişisel verilerinizin güvenliği bizim için çok önemlidir. Bu politika, verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklar.',
      'privacy.overview.title': 'Genel Bakış',
      'privacy.overview.content': 'Bu Gizlilik Politikası, Hizmetimizi kullandığınızda bilgilerinizin toplanması, kullanılması ve ifşa edilmesi konusundaki politikalarımızı ve prosedürlerimizi açıklar. Ayrıca gizlilik haklarınızı ve yasanın sizi nasıl koruduğunu anlatır.',
      'privacy.data.title': 'Topladığımız Veriler',
      'privacy.data.personal.title': 'Kişisel Bilgiler',
      'privacy.data.personal.name': 'Ad ve soyad',
      'privacy.data.personal.email': 'E-posta adresi',
      'privacy.data.personal.phone': 'Telefon numarası',
      'privacy.data.personal.payment': 'Ödeme bilgileri',
      'privacy.data.usage.title': 'Kullanım Verileri',
      'privacy.data.usage.ip': 'IP adresi',
      'privacy.data.usage.browser': 'Tarayıcı türü',
      'privacy.data.usage.device': 'Cihaz bilgileri',
      'privacy.data.usage.stats': 'Kullanım istatistikleri',
      'privacy.security.title': 'Veri Güvenliği',
      'privacy.security.ssl.title': 'SSL Şifreleme',
      'privacy.security.ssl.content': 'Tüm veri transferleri 256-bit SSL şifreleme ile korunur.',
      'privacy.security.servers.title': 'Güvenli Sunucular',
      'privacy.security.servers.content': 'Verileriniz ISO 27001 sertifikalı güvenli sunucularda saklanır.',
      'privacy.security.access.title': 'Erişim Kontrolü',
      'privacy.security.access.content': 'Sadece yetkili personel verilerinize erişebilir.',
      'privacy.usage.title': 'Veri Kullanımı',
      'privacy.usage.intro': 'Topladığımız verileri aşağıdaki amaçlarla kullanırız:',
      'privacy.usage.service.title': 'Hizmet Sağlama',
      'privacy.usage.service.content': 'eSIM hizmetlerimizi size sunmak ve yönetmek',
      'privacy.usage.support.title': 'Müşteri Desteği',
      'privacy.usage.support.content': 'Teknik destek ve müşteri hizmetleri sağlamak',
      'privacy.usage.security.title': 'Güvenlik',
      'privacy.usage.security.content': 'Hesabınızı ve hizmetlerimizi korumak',
      'privacy.usage.improvement.title': 'İyileştirme',
      'privacy.usage.improvement.content': 'Hizmetlerimizi geliştirmek ve yeni özellikler eklemek',
      'privacy.sharing.title': 'Veri Paylaşımı',
      'privacy.sharing.intro': 'Kişisel verilerinizi üçüncü taraflarla paylaşmayız, ancak aşağıdaki durumlarda paylaşım gerekebilir:',
      'privacy.sharing.legal': 'Yasal zorunluluk durumunda',
      'privacy.sharing.providers': 'Hizmet sağlayıcılarımızla (ödeme işlemcileri gibi)',
      'privacy.sharing.threats': 'Güvenlik tehditlerini önlemek için',
      'privacy.sharing.consent': 'Açık rızanız olduğunda',
      'privacy.rights.title': 'Haklarınız',
      'privacy.rights.access.title': 'Erişim Hakkı',
      'privacy.rights.access.content': 'Hakkınızda sakladığımız verilere erişim talep edebilirsiniz.',
      'privacy.rights.correction.title': 'Düzeltme Hakkı',
      'privacy.rights.correction.content': 'Yanlış veya eksik verilerinizi düzeltebiliriz.',
      'privacy.rights.deletion.title': 'Silme Hakkı',
      'privacy.rights.deletion.content': 'Belirli koşullar altında verilerinizi silebiliriz.',
      'privacy.rights.objection.title': 'İtiraz Hakkı',
      'privacy.rights.objection.content': 'Veri işleme faaliyetlerimize itiraz edebilirsiniz.',
      'privacy.contact.title': 'İletişim',
      'privacy.contact.intro': 'Bu Gizlilik Politikası hakkında herhangi bir sorunuz varsa, aşağıdaki kanallardan bizimle iletişime geçebilirsiniz:',

      // Navigation
      'nav.about': 'Hakkımızda',
      'nav.contact': 'İletişim',
      'nav.privacy': 'Gizlilik',
      'nav.login': 'Giriş',
      'nav.account': 'Hesabım',
      'nav.logout': 'Çıkış yap',

      // Auth - marka paneli
      'auth.brand.eyebrow': 'KÜRESEL KAPSAMA',
      'auth.brand.title': '150+ ülkede, indiğin an internet.',
      'auth.brand.subtitle': 'Fiziksel SIM yok, roaming faturası yok. eSIM’ini saniyeler içinde etkinleştir.',

      // Auth - giriş
      'auth.login.eyebrow': 'HESABINA GİRİŞ',
      'auth.login.title': 'Tekrar hoş geldin',
      'auth.login.subtitle': 'eSIM’lerini yönet ve yenilerini keşfet.',

      // Auth - kayıt
      'auth.signup.eyebrow': 'YENİ HESAP',
      'auth.signup.title': 'Aramıza katıl',
      'auth.signup.subtitle': 'Birkaç adımda ilk eSIM’ine hazır ol.',

      // Auth - alanlar
      'auth.field.identifier': 'E-posta veya telefon',
      'auth.field.identifier.ph': 'ornek@email.com veya +90…',
      'auth.field.email': 'E-posta',
      'auth.field.email.ph': 'ornek@email.com',
      'auth.field.fullName': 'Ad soyad',
      'auth.field.fullName.ph': 'Adın ve soyadın',
      'auth.field.password': 'Şifre',
      'auth.field.password.ph': '••••••••',

      // Auth - aksiyonlar
      'auth.action.login': 'Giriş yap',
      'auth.action.loggingIn': 'Giriş yapılıyor…',
      'auth.action.signup': 'Hesap oluştur',
      'auth.action.signingUp': 'Hesap oluşturuluyor…',
      'auth.toSignup.q': 'Hesabın yok mu?',
      'auth.toSignup.link': 'Kayıt ol',
      'auth.toLogin.q': 'Zaten hesabın var mı?',
      'auth.toLogin.link': 'Giriş yap',
      'auth.password.show': 'Şifreyi göster',
      'auth.password.hide': 'Şifreyi gizle',

      // Auth - koşullar & hatalar
      'auth.terms.prefix': 'Devam ederek ',
      'auth.terms.link': 'Kullanım Koşulları ve Gizlilik Politikası',
      'auth.terms.suffix': '’nı kabul ediyorum.',
      'auth.error.required': 'Lütfen gerekli alanları doldur.',
      'auth.error.terms': 'Devam etmek için koşulları kabul etmelisin.',

      // E-posta doğrulama
      'verify.eyebrow': 'E-POSTA DOĞRULAMA',
      'verify.title': 'E-postanı doğrula',
      'verify.subtitle': '{{email}} adresine 6 haneli bir kod gönderdik. Doğrulamak için kodu gir.',
      'verify.code': 'Doğrulama kodu',
      'verify.code.ph': '••••••',
      'verify.action': 'Doğrula',
      'verify.verifying': 'Doğrulanıyor…',
      'verify.resend': 'Kodu tekrar gönder',
      'verify.resendIn': '{{seconds}} sn sonra tekrar gönder',
      'verify.resent': 'Yeni kod gönderildi.',
      'verify.skip': 'Şimdilik atla',

      // Şifremi unuttum
      'auth.forgot.link': 'Şifreni mi unuttun?',
      'forgot.eyebrow': 'ŞİFRE SIFIRLAMA',
      'forgot.email.title': 'Şifreni sıfırla',
      'forgot.email.subtitle':
        'Hesabının e-posta adresini gir; sana 6 haneli bir sıfırlama kodu gönderelim.',
      'forgot.email.action': 'Kod gönder',
      'forgot.email.sending': 'Gönderiliyor…',
      'forgot.reset.title': 'Yeni şifreni belirle',
      'forgot.reset.subtitle':
        '{{email}} adresine gönderdiğimiz 6 haneli kodu ve yeni şifreni gir.',
      'forgot.reset.action': 'Şifreyi güncelle',
      'forgot.reset.updating': 'Güncelleniyor…',
      'forgot.field.code': 'Sıfırlama kodu',
      'forgot.field.code.ph': '••••••',
      'forgot.field.newPassword': 'Yeni şifre',
      'forgot.field.newPassword.ph': 'En az 6 karakter',
      'forgot.resend': 'Kodu tekrar gönder',
      'forgot.resendIn': '{{seconds}} sn sonra tekrar gönder',
      'forgot.resent': 'Yeni kod gönderildi.',
      'forgot.backToLogin': 'Girişe dön',
      'forgot.changeEmail': 'E-postayı değiştir',
      'forgot.help.noMail':
        'Kod gelmediyse spam kutunu kontrol et veya e-posta adresini doğrula.',
      // Sunucu sonuç kodları → kullanıcı metni
      'reset.RESET_CODE_SENT': 'Kod gönderildi. Lütfen e-postanı kontrol et.',
      'reset.RATE_LIMITED':
        'Çok fazla deneme yaptın. Lütfen bir süre bekleyip tekrar dene.',
      'reset.MAIL_SEND_FAILED':
        'Bir şeyler ters gitti. Lütfen daha sonra tekrar dene.',
      'reset.RESET_CODE_VALID': 'Kod doğrulandı.',
      'reset.INVALID_RESET_CODE': 'Yanlış kod. Lütfen tekrar dene.',
      'reset.EXPIRED_RESET_CODE':
        'Kodun geçerlilik süresi doldu. Lütfen yeni kod iste.',
      'reset.WEAK_PASSWORD': 'Şifre en az 6 karakter olmalı.',
      'reset.PASSWORD_RESET_SUCCESS':
        'Şifren güncellendi. Yeni şifrenle giriş yapabilirsin.',
      'reset.generic': 'Bir şeyler ters gitti. Lütfen tekrar dene.',
      'login.resetSuccess':
        'Şifren güncellendi. Yeni şifrenle giriş yapabilirsin.',

      // Mağaza navigasyonu
      'store.nav.shop': 'Mağaza',

      // Ana sayfa (mağaza)
      'home.hero.title1': 'Birkaç dakikada bağlan,',
      'home.hero.title2': 'sınırların ötesinde kal.',
      'home.hero.subtitle': '190+ ülkede geçerli, güvenilir eSIM paketleri. Fiziksel SIM yok, roaming faturası yok.',
      'home.search.placeholder': 'Nereye seyahat ediyorsun?',
      'home.tabs.local': 'Yerel eSIM’ler',
      'home.tabs.regional': 'Bölgesel eSIM’ler',
      'home.tabs.lifetime': 'Ömürlük eSIM’ler',
      'home.empty': 'Aramanızla eşleşen sonuç bulunamadı.',
      'home.error.title': 'İçerik yüklenemedi',
      'home.error.retry': 'Tekrar dene',
      'home.from': 'başlangıç',
      'home.popular': 'Popüler destinasyonlar',
      'home.coverage': '190+ ülke · anında aktivasyon',
      'home.detail.soon': 'Bu seçimin paketleri çok yakında burada listelenecek.',
      'home.detail.back': 'Mağazaya dön',

      // eSIM detay / paketler
      'detail.plans': 'Paketler',
      'detail.count': '{{count}} paket',
      'detail.validity': '{{days}} gün',
      'detail.validityLifetime': 'Süresiz',
      'detail.buy': 'Satın al',
      'detail.empty': 'Bu seçim için şu an paket bulunmuyor.',
      'detail.checkoutSoon': 'Ödeme akışı çok yakında eklenecek.',
      'detail.loginToBuy': 'Satın almak için giriş yapmalısın.',
      'detail.basicFeatures': 'Temel Özellikler',
      'detail.dataAmount': 'Veri miktarı',
      'detail.validityLabel': 'Geçerlilik süresi',
      'detail.coverageArea': 'Kapsama alanı',
      'detail.activationNetworks': 'Aktivasyon ve Ağlar',
      'detail.activationMethod': 'Aktivasyon yöntemi',
      'detail.esimActivation': 'eSIM — QR kod ile anında',
      'detail.supportedNetworks': 'Desteklenen ağlar',
      'detail.description': 'Açıklama',
      'detail.price': 'Fiyat',

      // Giriş daveti modalı
      'authprompt.title': 'Devam etmek için giriş yap',
      'authprompt.message': 'eSIM satın almak için hesabına giriş yap ya da saniyeler içinde yeni bir hesap oluştur.',
      'authprompt.close': 'Kapat',

      // Footer
      'footer.tagline': 'Dünya çapında hızlı, güvenli ve uygun fiyatlı eSIM. İndiğin an internete bağlan.',
      'footer.explore': 'Keşfet',
      'footer.support': 'Destek',
      'footer.legal': 'Yasal',
      'footer.shop': 'Mağaza',
      'footer.help': 'Sıkça Sorulan Sorular',
      'footer.terms': 'Kullanım Koşulları',
      'footer.rights': '© {{year}} Utkan eSIM. Tüm hakları saklıdır.',
      'footer.apps': 'Uygulamayı indir',

      // WhatsApp destek butonu
      'whatsapp.label': 'WhatsApp’tan yaz',
      'whatsapp.message': 'Merhaba, bir eSIM destek talebim var.',

      // 404
      'notfound.eyebrow': 'SİNYAL YOK',
      'notfound.title': 'Bu sayfaya ulaşılamıyor',
      'notfound.message': 'Aradığın sayfa taşınmış ya da hiç var olmamış olabilir. Hadi seni kapsama alanına geri götürelim.',

      // Sipariş başarılı
      'order.congrats': 'Tebrikler!',
      'order.message': 'eSIM’in hazır. Aşağıdaki QR kod ile birkaç adımda kurabilirsin.',
      'order.details': 'Sipariş özeti',
      'order.activation': 'Aktivasyon',
      'order.activationDesc': 'eSIM’ini kurmak için cihazının kamerasıyla QR kodu tarat ya da kurulum kodunu elle gir.',
      'order.qrTitle': 'eSIM QR kodu',
      'order.manualLabel': 'Kurulum kodu',
      'order.copy': 'Kopyala',
      'order.copied': 'Kopyalandı',
      'order.howTo': 'Nasıl etkinleştirilir?',
      'order.step1': 'Cihazında Ayarlar > Hücresel / Mobil Veri > eSIM Ekle’ye git.',
      'order.step2': '“QR kodu kullan”ı seç ve yukarıdaki QR kodu tarat (veya kurulum kodunu elle gir).',
      'order.step3': 'Kurulum tamamlanınca eSIM planını etkinleştir.',
      'order.step4': 'Veri dolaşımının açık olduğundan emin ol — artık bağlısın!',
      'order.cta': 'Ana sayfaya dön',

      // Ödeme (checkout)
      'checkout.title': 'Ödeme',
      'checkout.summary': 'Sipariş özeti',
      'checkout.total': 'Toplam',
      'checkout.eurNote': 'Tutar PayPal’da euro (€) olarak tahsil edilir.',
      'checkout.processing': 'Ödemen doğrulanıyor…',
      'checkout.error': 'Ödeme tamamlanamadı. Lütfen tekrar dene.',
      'checkout.cancelled': 'Ödeme iptal edildi.',

      // Hesabım
      'account.title': 'Hesabım',
      'account.tab.profile': 'Profil',
      'account.tab.esims': 'eSIM’lerim',
      'account.tab.security': 'Güvenlik',
      'account.profile.title': 'Profil bilgileri',
      'account.field.phone': 'Telefon',
      'account.field.phone.ph': '+90…',
      'account.memberSince': 'Üyelik tarihi',
      'account.save': 'Kaydet',
      'account.saving': 'Kaydediliyor…',
      'account.saved': 'Bilgilerin güncellendi.',
      'account.esims.title': 'eSIM’lerim',
      'account.esims.empty': 'Henüz bir eSIM’in yok.',
      'account.esims.emptyCta': 'Mağazaya göz at',
      'account.esims.data': 'Veri',
      'account.esims.expires': 'Bitiş tarihi',
      'account.esims.viewQr': 'QR kodu göster',
      'account.esims.hideQr': 'QR kodu gizle',
      'account.esims.active': 'Aktif',
      'account.esims.passive': 'Pasif',
      'account.esims.noActive': 'Aktif eSIM’in yok.',
      'account.esims.noPassive': 'Pasif eSIM’in yok.',
      'account.esims.readyHint': 'Kullanıma hazır — süre ilk kullanımda başlar.',
      'account.esims.unavailableHint': 'Durum şu an yüklenemedi. Daha sonra tekrar deneyin.',
      'esimStatus.active': 'Aktif',
      'esimStatus.readyToUse': 'Kullanıma hazır',
      'esimStatus.inactive': 'Pasif',
      'esimStatus.unavailable': 'Durum yüklenemedi',
      'account.security.title': 'Şifre değiştir',
      'account.field.oldPassword': 'Mevcut şifre',
      'account.field.newPassword': 'Yeni şifre',
      'account.field.confirmPassword': 'Yeni şifre (tekrar)',
      'account.changePassword': 'Şifreyi güncelle',
      'account.passwordChanged': 'Şifren güncellendi.',
      'account.error.passwordMismatch': 'Yeni şifreler eşleşmiyor.',
      'account.danger.title': 'Hesap işlemleri',
      'account.delete': 'Hesabı sil',
      'account.delete.confirm': 'Hesabını kalıcı olarak silmek üzeresin. Bu işlem geri alınamaz.',
      'account.delete.confirmBtn': 'Evet, sil',
      'account.cancel': 'Vazgeç',

      // Satın alınmış eSIM detayı
      'esimDetail.back': 'Geri',
      'esimDetail.dataUsage': 'Veri kullanımı',
      'esimDetail.left': 'kalan',
      'esimDetail.leftData': 'Kalan veri',
      'esimDetail.usedData': 'Kullanılan',
      'esimDetail.totalData': 'Toplam veri',
      'esimDetail.qrDesc': 'Bu QR kodu cihazının kamerasıyla taratarak eSIM’ini kur.',
      'esimDetail.validity': 'Geçerlilik',
      'esimDetail.daysLeft': '{{days}} gün kaldı',
      'esimDetail.expired': 'Süresi doldu',
      'esimDetail.notYetActive': 'Henüz etkin değil',
      'esimDetail.leftDate': 'Kalan süre',
      'esimDetail.activationDate': 'Aktivasyon tarihi',
      'esimDetail.endDate': 'Bitiş tarihi',
      'esimDetail.technical': 'Teknik bilgiler',
      'esimDetail.activationCode': 'Aktivasyon kodu (Android)',
      'esimDetail.smdp': 'SM-DP+ adresi (iOS)',
      'esimDetail.matchingId': 'Eşleştirme kimliği (iOS)',
      'esimDetail.support': 'Teknik destek',
      'esimDetail.supportDesc': 'Bir sorun mu var? Sana yardımcı olalım.',
      'esimDetail.email': 'E-posta gönder',

      // eSIM rehberi
      'guide.eyebrow': 'eSIM REHBERİ',
      'guide.title': 'eSIM nedir, nasıl kurulur?',
      'guide.intro.title': 'eSIM nedir?',
      'guide.intro.body': 'eSIM, fiziksel SIM kartına gerek kalmadan cihazına gömülü çalışan dijital bir SIM’dir. Bir QR kod taratarak saniyeler içinde hattını kurar; 190+ ülkede kart değiştirmeden, roaming faturası olmadan internete bağlanırsın.',
      'guide.steps.title': 'Nasıl etkinleştirilir?',
      'guide.devices.title': 'Desteklenen cihazlar',
      'guide.devices.desc': 'eSIM’in çalışması için cihazının eSIM destekli olması gerekir. Markana göz at.',
      'guide.faq.title': 'Sık sorulan sorular',
      'nav.guide': 'eSIM Rehberi',
      'currency.label': 'Para birimi',

      // Statik sayfalar (About/Contact/Privacy) — yükleme & hata durumları
      'staticPage.loading': 'Sayfa yükleniyor...',
      'staticPage.errorTitle': 'Hata Oluştu',
      'staticPage.retry': 'Tekrar Dene',
      'staticPage.loadFailed': 'Sayfa içeriği yüklenemedi. Lütfen daha sonra tekrar deneyin.',

      // Genel
      'last.updated': 'Son güncelleme: 8 Temmuz 2024',

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      'home.tabs.unlimited': 'Sınırsız eSIM’ler',
      'detail.unlimited': 'Sınırsız',
      'detail.unlimitedNote': 'Bu pakette veri limiti yoktur — geçerlilik süresi boyunca sınırsız internet kullanırsın.',
      'detail.notPriced': 'Bu paket şu an web’den satın alınamıyor.',
      'checkout.priceUpdated': 'Bu paketin fiyatı güncellendi. Lütfen mağazaya dönüp paketi yeniden seç.',
      'order.pending.title': 'eSIM’in hazırlanıyor',
      'order.pending.message': 'Ödemen alındı. Sınırsız paketlerde hattın açılması birkaç dakika sürebilir.',
      'order.pending.waiting': 'Sipariş durumun kontrol ediliyor…',
      'order.pending.ready': 'eSIM’in hazır!',
      'order.pending.timeout': 'Hazırlanma beklenenden uzun sürüyor. Ödemen güvende — eSIM’in hazır olduğunda “eSIM’lerim” bölümünde görünecek.',
      'order.pending.cta': 'eSIM’lerime git',
      'account.esims.unlimited': 'Sınırsız',
      'account.esims.unlimitedHint': 'Sınırsız veri — bu pakette veri limiti yoktur.',
      'esimDetail.unlimitedData': 'Bu pakette veri limiti yoktur; kalan süreyi aşağıda görebilirsin.',


      // Hesap silme sayfası (/hesap-sil · /account-deletion) — Google Play “Data deletion” şartı
      'del.eyebrow': 'Hesap silme',
      'del.title': 'Hesabımı sil',
      'del.intro': 'Utkan eSIM hesabını ve kişisel verilerini buradan kalıcı olarak silebilirsin. Uygulamanın kurulu olması gerekmez — silmek istediğin hesapla giriş yapman yeterli.',
      'del.deleted.title': 'Silinen veriler',
      'del.deleted.identity': 'Adın, soyadın, e-posta adresin ve telefon numaran',
      'del.deleted.credentials': 'Parolan ve oturum bilgilerin',
      'del.deleted.codes': 'E-posta doğrulama ve şifre sıfırlama kodların',
      'del.deleted.esim': 'eSIM hat numaran (MSISDN), QR/aktivasyon kodun ve kullanım verilerin',
      'del.kept.title': 'Saklanan veriler ve nedeni',
      'del.kept.orders': 'Satın alma kayıtları (sipariş numarası, tarih, tutar, ödeme durumu) mali mevzuat gereği saklanır. Bu kayıtlarda adın, e-postan veya ödeme bilgilerin yer almaz; yalnızca seninle ilişkilendirilemeyen bir numara bulunur.',
      'del.kept.period': 'Saklama süresi: 5 yıl (Vergi Usul Kanunu m. 253).',
      'del.warn.title': 'Silmeden önce bilmen gerekenler',
      'del.warn.irreversible': 'Bu işlem geri alınamaz.',
      'del.warn.esim': 'Aktif eSIM’lerin cihazında çalışmaya devam eder, ancak QR koduna ve kalan kullanımına bir daha erişemezsin. Silmeden önce QR kodunu kaydet.',
      'del.warn.rejoin': 'Aynı e-posta ile yeniden kayıt olabilirsin, ancak eski eSIM’lerin yeni hesapta görünmez.',
      'del.support': 'Giriş yapamıyorsan silme talebini e-posta ile de iletebilirsin:',
      'del.login.title': 'Önce giriş yap',
      'del.login.subtitle': 'Hesabın sana ait olduğunu doğrulamak için e-posta ve şifreni gir.',
      'del.login.action': 'Giriş yap',
      'del.login.loading': 'Giriş yapılıyor...',
      'del.forgot': 'Şifremi unuttum',
      'del.confirm.title': 'Emin misin?',
      'del.confirm.subtitle': '{{email}} hesabı ve kişisel verilerin kalıcı olarak silinecek.',
      'del.confirm.field': 'Onaylamak için e-posta adresini tekrar yaz',
      'del.confirm.action': 'Hesabımı kalıcı olarak sil',
      'del.confirm.deleting': 'Siliniyor...',
      'del.confirm.cancel': 'Vazgeç',
      'del.done.title': 'Hesabın silindi',
      'del.done.body': 'Kişisel verilerin kalıcı olarak silindi.',
      'del.done.retained': 'Kişisel verilerin kalıcı olarak silindi. {{n}} satın alma kaydın mali mevzuat gereği saklandı; bu kayıtlar seninle ilişkilendirilemez.',
      'del.done.home': 'Mağazaya dön',
      'del.error.required': 'Lütfen e-posta ve şifreni gir.',
      'del.error.credentials': 'E-posta veya şifre hatalı.',
      'del.error.suspended': 'Hesabın askıya alınmış. Lütfen destek ile iletişime geç.',
      'del.error.session': 'Oturumunun süresi doldu. Lütfen tekrar giriş yap.',
      'del.error.network': 'Bağlantı kurulamadı. İnternet bağlantını kontrol edip tekrar dene.',
      'del.error.generic': 'Bir sorun oluştu. Lütfen tekrar dene.',
      'footer.deleteAccount': 'Hesabımı sil',


      // Ses paketleri (veri + sınırsız konuşma & SMS) — docs/ses-paketleri.md
      'home.tabs.voice': 'Konuşmalı eSIM’ler',
      'detail.voice': 'Konuşma + SMS',
      'detail.voiceNote': 'Bu paket veriye ek olarak sınırsız konuşma ve SMS içerir; aynı eSIM ile hem internete bağlanır hem arama yaparsın.',
      'detail.calls': 'Konuşma',
      'detail.sms': 'SMS',
      'plan.unlimitedCalls': 'Sınırsız konuşma',
      'plan.unlimitedSms': 'Sınırsız SMS',
      'plan.minutes': '{{n}} dk konuşma',
      'plan.sms': '{{n}} SMS',

      // Hercules — Avrupa’da sınırsız konuşma (docs/hercules-sayfasi.md)
      'hercules.subtitle': '{{n}} Avrupa ülkesinde sınırsız konuşma, SMS ve veri — tek eSIM.',
      'hercules.coverageTitle': 'Kapsanan ülkeler ({{n}})',
      'hercules.promo.desc': '{{n}} ülkede sınırsız konuşma ve SMS, yanında 20–100 GB veri.',
      'hercules.promo.cta': 'İncele',
      'loading': 'Yükleniyor...',
    }
  },
  en: {
    translation: {
      "language.title": "Language",
      // Main page
      'hero.title': 'Utkan eSIM',
      'hero.subtitle': 'The Future of Digital Connectivity',
      'hero.description': 'We are removing boundaries with the new generation digital connectivity experience.',
      'hero.description2': 'Fast, secure and affordable eSIM solutions worldwide.',

      // Features
      'features.countries': '150+ Countries',
      'features.activation': 'Instant Activation',
      'features.support': '24/7 Support',

      // Countdown
      'countdown.title': 'Our Website is Coming Soon!',
      'countdown.days': 'Days',
      'countdown.hours': 'Hours',
      'countdown.minutes': 'Minutes',
      'countdown.seconds': 'Seconds',
      'countdown.launch': 'Our Website is Live!',
      'countdown.loading': 'Loading...',

      // Apps
      'apps.title': 'Our Mobile Applications',
      'apps.ios.label': 'Download on the',
      'apps.ios.name': 'App Store',
      'apps.android.label': 'GET IT ON',
      'apps.android.name': 'Google Play',

      // Contact
      'contact.title': 'Contact Us Until Launch',
      'contact.whatsapp': 'WhatsApp: +90 540 155 13 33',
      'contact.email': 'Email: info@utkanesim.com',

      // About page
      'about.hero.title': 'About Utkan eSIM',
      'about.hero.description': 'Your trusted partner for staying connected wherever you go. We believe that global travel should be seamless and affordable, without the hassle of physical SIM cards and expensive roaming charges.',
      'about.story.title': 'Our Story',
      'about.story.content': 'Founded in 2024 by a team of passionate travelers and tech enthusiasts, our goal is to revolutionize the way people connect to the internet abroad. We provide high-quality, reliable eSIM data plans for over 190 countries and regions, ensuring you have fast internet access from the moment you land.',
      'about.mission.title': 'Our Mission',
      'about.mission.content': 'To provide travelers with simple, affordable, and instant connectivity worldwide, empowering them to explore, work, and stay in touch without boundaries.',
      'about.vision.title': 'Our Vision',
      'about.vision.content': 'To be the leading global platform for digital connectivity solutions, making the world a smaller, more connected place for everyone.',
      'about.features.title': 'Why Choose Us?',
      'about.features.instant.title': 'Instant Delivery',
      'about.features.instant.content': 'Receive your eSIM via QR code immediately after purchase.',
      'about.features.global.title': 'Global Coverage',
      'about.features.global.content': 'Data plans for over 190 countries and regions.',
      'about.features.affordable.title': 'Affordable Rates',
      'about.features.affordable.content': 'Save up to 90% on roaming charges.',
      'about.features.support.title': '24/7 Support',
      'about.features.support.content': 'Our dedicated support team is always here to help.',
      'about.features.secure.title': 'Secure Connection',
      'about.features.secure.content': 'Connection protected with the latest security protocols.',
      'about.features.fast.title': 'Fast Internet',
      'about.features.fast.content': 'Seamless internet experience at 4G/5G speeds.',
      'about.cta.title': 'Join the Future of Digital Connectivity',
      'about.cta.content': 'Thank you for choosing Utkan eSIM. Happy travels!',
      'about.cta.whatsapp': 'Contact via WhatsApp',
      'about.cta.email': 'Send Email',

      // Contact page
      'contact.hero.title': 'Contact Us',
      'contact.hero.description': 'We\'re here to help! Whether you have a question about our eSIMs, need technical support, or just want to give us feedback, we\'d love to hear from you.',
      'contact.info.title': 'Contact Information',
      'contact.whatsapp.title': 'WhatsApp',
      'contact.whatsapp.subtitle': '24/7 Quick Support',
      'contact.email.title': 'Email',
      'contact.email.subtitle': 'General Contact',
      'contact.support.title': 'Technical Support',
      'contact.support.subtitle': 'eSIM Issues',
      'contact.business.title': 'Partnership',
      'contact.business.subtitle': 'Corporate Contact',
      'contact.hours.title': 'Support Hours',
      'contact.hours.subtitle': '24/7 Technical Support',
      'contact.hours.detail': 'Monday - Sunday: 00:00 - 23:59',
      'contact.form.title': 'Send Us a Message',
      'contact.form.name': 'Your Name',
      'contact.form.name.placeholder': 'Enter your name and surname',
      'contact.form.email': 'Your Email',
      'contact.form.email.placeholder': 'example@email.com',
      'contact.form.subject': 'Subject',
      'contact.form.subject.placeholder': 'Select subject',
      'contact.form.subject.general': 'General Information',
      'contact.form.subject.technical': 'Technical Support',
      'contact.form.subject.billing': 'Billing Questions',
      'contact.form.subject.partnership': 'Partnership',
      'contact.form.subject.feedback': 'Feedback',
      'contact.form.message': 'Your Message',
      'contact.form.message.placeholder': 'Write your message here...',
      'contact.form.submit': 'Send Message',
      'contact.faq.title': 'Frequently Asked Questions',
      'contact.faq.esim.title': 'How does eSIM work?',
      'contact.faq.esim.content': 'eSIM is a digital SIM card that works in your phone without needing a physical SIM card. It is activated instantly via QR code.',
      'contact.faq.phones.title': 'Which phones support eSIM?',
      'contact.faq.phones.content': 'iPhone XS and above, Samsung Galaxy S20 and above, Google Pixel 3 and above models support eSIM.',
      'contact.faq.validity.title': 'How long is my data package valid?',
      'contact.faq.validity.content': 'Package validity period varies between 1-30 days depending on the plan you choose.',
      'contact.faq.payment.title': 'How can I pay?',
      'contact.faq.payment.content': 'You can make secure payments with credit card, PayPal and bank transfer.',

      // Privacy page
      'privacy.hero.title': 'Privacy Policy',
      'privacy.hero.description': 'The security of your personal data is very important to us. This policy explains how your data is collected, used and protected.',
      'privacy.overview.title': 'Overview',
      'privacy.overview.content': 'This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.',
      'privacy.data.title': 'Data We Collect',
      'privacy.data.personal.title': 'Personal Information',
      'privacy.data.personal.name': 'Name and surname',
      'privacy.data.personal.email': 'Email address',
      'privacy.data.personal.phone': 'Phone number',
      'privacy.data.personal.payment': 'Payment information',
      'privacy.data.usage.title': 'Usage Data',
      'privacy.data.usage.ip': 'IP address',
      'privacy.data.usage.browser': 'Browser type',
      'privacy.data.usage.device': 'Device information',
      'privacy.data.usage.stats': 'Usage statistics',
      'privacy.security.title': 'Data Security',
      'privacy.security.ssl.title': 'SSL Encryption',
      'privacy.security.ssl.content': 'All data transfers are protected with 256-bit SSL encryption.',
      'privacy.security.servers.title': 'Secure Servers',
      'privacy.security.servers.content': 'Your data is stored on ISO 27001 certified secure servers.',
      'privacy.security.access.title': 'Access Control',
      'privacy.security.access.content': 'Only authorized personnel can access your data.',
      'privacy.usage.title': 'Data Usage',
      'privacy.usage.intro': 'We use the data we collect for the following purposes:',
      'privacy.usage.service.title': 'Service Provision',
      'privacy.usage.service.content': 'To provide and manage our eSIM services to you',
      'privacy.usage.support.title': 'Customer Support',
      'privacy.usage.support.content': 'To provide technical support and customer service',
      'privacy.usage.security.title': 'Security',
      'privacy.usage.security.content': 'To protect your account and our services',
      'privacy.usage.improvement.title': 'Improvement',
      'privacy.usage.improvement.content': 'To improve our services and add new features',
      'privacy.sharing.title': 'Data Sharing',
      'privacy.sharing.intro': 'We do not share your personal data with third parties, but sharing may be required in the following cases:',
      'privacy.sharing.legal': 'In case of legal obligation',
      'privacy.sharing.providers': 'With our service providers (such as payment processors)',
      'privacy.sharing.threats': 'To prevent security threats',
      'privacy.sharing.consent': 'When you give explicit consent',
      'privacy.rights.title': 'Your Rights',
      'privacy.rights.access.title': 'Right of Access',
      'privacy.rights.access.content': 'You can request access to the data we store about you.',
      'privacy.rights.correction.title': 'Right of Correction',
      'privacy.rights.correction.content': 'We can correct your incorrect or incomplete data.',
      'privacy.rights.deletion.title': 'Right of Deletion',
      'privacy.rights.deletion.content': 'We can delete your data under certain conditions.',
      'privacy.rights.objection.title': 'Right of Objection',
      'privacy.rights.objection.content': 'You can object to our data processing activities.',
      'privacy.contact.title': 'Contact',
      'privacy.contact.intro': 'If you have any questions about this Privacy Policy, you can contact us through the following channels:',

      // Navigation
      'nav.about': 'About',
      'nav.contact': 'Contact',
      'nav.privacy': 'Privacy',
      'nav.login': 'Sign in',
      'nav.account': 'Account',
      'nav.logout': 'Log out',

      // Auth - brand panel
      'auth.brand.eyebrow': 'GLOBAL COVERAGE',
      'auth.brand.title': 'Online the moment you land, in 150+ countries.',
      'auth.brand.subtitle': 'No physical SIM, no roaming bills. Activate your eSIM in seconds.',

      // Auth - login
      'auth.login.eyebrow': 'SIGN IN',
      'auth.login.title': 'Welcome back',
      'auth.login.subtitle': 'Manage your eSIMs and discover new ones.',

      // Auth - signup
      'auth.signup.eyebrow': 'NEW ACCOUNT',
      'auth.signup.title': 'Create your account',
      'auth.signup.subtitle': 'A few steps to your first eSIM.',

      // Auth - fields
      'auth.field.identifier': 'Email or phone',
      'auth.field.identifier.ph': 'you@email.com or +1…',
      'auth.field.email': 'Email',
      'auth.field.email.ph': 'you@email.com',
      'auth.field.fullName': 'Full name',
      'auth.field.fullName.ph': 'Your full name',
      'auth.field.password': 'Password',
      'auth.field.password.ph': '••••••••',

      // Auth - actions
      'auth.action.login': 'Sign in',
      'auth.action.loggingIn': 'Signing in…',
      'auth.action.signup': 'Create account',
      'auth.action.signingUp': 'Creating account…',
      'auth.toSignup.q': "Don't have an account?",
      'auth.toSignup.link': 'Sign up',
      'auth.toLogin.q': 'Already have an account?',
      'auth.toLogin.link': 'Sign in',
      'auth.password.show': 'Show password',
      'auth.password.hide': 'Hide password',

      // Auth - terms & errors
      'auth.terms.prefix': 'By continuing, I agree to the ',
      'auth.terms.link': 'Terms of Use and Privacy Policy',
      'auth.terms.suffix': '.',
      'auth.error.required': 'Please fill in the required fields.',
      'auth.error.terms': 'Please accept the terms to continue.',

      // Email verification
      'verify.eyebrow': 'EMAIL VERIFICATION',
      'verify.title': 'Verify your email',
      'verify.subtitle': 'We sent a 6-digit code to {{email}}. Enter it to verify.',
      'verify.code': 'Verification code',
      'verify.code.ph': '••••••',
      'verify.action': 'Verify',
      'verify.verifying': 'Verifying…',
      'verify.resend': 'Resend code',
      'verify.resendIn': 'Resend in {{seconds}}s',
      'verify.resent': 'A new code was sent.',
      'verify.skip': 'Skip for now',

      // Forgot password
      'auth.forgot.link': 'Forgot your password?',
      'forgot.eyebrow': 'PASSWORD RESET',
      'forgot.email.title': 'Reset your password',
      'forgot.email.subtitle':
        "Enter your account email and we'll send you a 6-digit reset code.",
      'forgot.email.action': 'Send code',
      'forgot.email.sending': 'Sending…',
      'forgot.reset.title': 'Set a new password',
      'forgot.reset.subtitle':
        'Enter the 6-digit code we sent to {{email}} and your new password.',
      'forgot.reset.action': 'Update password',
      'forgot.reset.updating': 'Updating…',
      'forgot.field.code': 'Reset code',
      'forgot.field.code.ph': '••••••',
      'forgot.field.newPassword': 'New password',
      'forgot.field.newPassword.ph': 'At least 6 characters',
      'forgot.resend': 'Resend code',
      'forgot.resendIn': 'Resend in {{seconds}}s',
      'forgot.resent': 'A new code was sent.',
      'forgot.backToLogin': 'Back to sign in',
      'forgot.changeEmail': 'Change email',
      'forgot.help.noMail':
        "If the code didn't arrive, check your spam folder or confirm your email address.",
      // Server result codes → user text
      'reset.RESET_CODE_SENT': 'Code sent. Please check your email.',
      'reset.RATE_LIMITED':
        'Too many requests. Please wait a while and try again.',
      'reset.MAIL_SEND_FAILED': 'Something went wrong. Please try again later.',
      'reset.RESET_CODE_VALID': 'Code verified.',
      'reset.INVALID_RESET_CODE': 'Invalid code. Please try again.',
      'reset.EXPIRED_RESET_CODE':
        'The code has expired. Please request a new code.',
      'reset.WEAK_PASSWORD': 'Password must be at least 6 characters long.',
      'reset.PASSWORD_RESET_SUCCESS':
        'Your password has been updated. Please sign in with your new password.',
      'reset.generic': 'Something went wrong. Please try again.',
      'login.resetSuccess':
        'Your password has been updated. Please sign in with your new password.',

      // Store navigation
      'store.nav.shop': 'Store',

      // Home (store)
      'home.hero.title1': 'Connect in minutes,',
      'home.hero.title2': 'stay online across borders.',
      'home.hero.subtitle': 'Reliable eSIM plans valid in 190+ countries. No physical SIM, no roaming bills.',
      'home.search.placeholder': 'Where are you traveling?',
      'home.tabs.local': 'Local eSIMs',
      'home.tabs.regional': 'Regional eSIMs',
      'home.tabs.lifetime': 'Lifetime eSIMs',
      'home.empty': 'No results match your search.',
      'home.error.title': 'Could not load content',
      'home.error.retry': 'Try again',
      'home.from': 'from',
      'home.popular': 'Popular destinations',
      'home.coverage': '190+ countries · instant activation',
      'home.detail.soon': 'Plans for this selection will be listed here very soon.',
      'home.detail.back': 'Back to store',

      // eSIM detail / plans
      'detail.plans': 'Plans',
      'detail.count': '{{count}} plans',
      'detail.validity': '{{days}} days',
      'detail.validityLifetime': 'No expiry',
      'detail.buy': 'Buy',
      'detail.empty': 'No plans available for this selection right now.',
      'detail.checkoutSoon': 'Checkout is coming very soon.',
      'detail.loginToBuy': 'Please sign in to buy.',
      'detail.basicFeatures': 'Basic features',
      'detail.dataAmount': 'Data amount',
      'detail.validityLabel': 'Validity',
      'detail.coverageArea': 'Coverage',
      'detail.activationNetworks': 'Activation & networks',
      'detail.activationMethod': 'Activation method',
      'detail.esimActivation': 'eSIM — instant via QR code',
      'detail.supportedNetworks': 'Supported networks',
      'detail.description': 'Description',
      'detail.price': 'Price',

      // Auth prompt modal
      'authprompt.title': 'Sign in to continue',
      'authprompt.message': 'Sign in to your account to buy an eSIM, or create one in seconds.',
      'authprompt.close': 'Close',

      // Footer
      'footer.tagline': 'Fast, secure and affordable eSIM worldwide. Get online the moment you land.',
      'footer.explore': 'Explore',
      'footer.support': 'Support',
      'footer.legal': 'Legal',
      'footer.shop': 'Store',
      'footer.help': 'Frequently Asked Questions',
      'footer.terms': 'Terms of Use',
      'footer.rights': '© {{year}} Utkan eSIM. All rights reserved.',
      'footer.apps': 'Get the app',

      // WhatsApp support button
      'whatsapp.label': 'Chat on WhatsApp',
      'whatsapp.message': 'Hello, I have an eSIM support request.',

      // 404
      'notfound.eyebrow': 'NO SIGNAL',
      'notfound.title': 'This page is out of reach',
      'notfound.message': 'The page you’re looking for moved or never existed. Let’s get you back into coverage.',

      // Order success
      'order.congrats': 'Congratulations!',
      'order.message': 'Your eSIM is ready. Set it up in a few steps with the QR code below.',
      'order.details': 'Order summary',
      'order.activation': 'Activation',
      'order.activationDesc': 'To set up your eSIM, scan the QR code with your device camera or enter the activation code manually.',
      'order.qrTitle': 'eSIM QR code',
      'order.manualLabel': 'Activation code',
      'order.copy': 'Copy',
      'order.copied': 'Copied',
      'order.howTo': 'How to activate',
      'order.step1': 'On your device, go to Settings > Cellular / Mobile Data > Add eSIM.',
      'order.step2': 'Choose “Use QR code” and scan the QR above (or enter the activation code manually).',
      'order.step3': 'Once setup finishes, enable the eSIM plan.',
      'order.step4': 'Make sure data roaming is on — you’re connected!',
      'order.cta': 'Back to home',

      // Checkout
      'checkout.title': 'Checkout',
      'checkout.summary': 'Order summary',
      'checkout.total': 'Total',
      'checkout.eurNote': 'You’ll be charged in euro (€) via PayPal.',
      'checkout.processing': 'Verifying your payment…',
      'checkout.error': 'Payment could not be completed. Please try again.',
      'checkout.cancelled': 'Payment cancelled.',

      // Account
      'account.title': 'My account',
      'account.tab.profile': 'Profile',
      'account.tab.esims': 'My eSIMs',
      'account.tab.security': 'Security',
      'account.profile.title': 'Profile information',
      'account.field.phone': 'Phone',
      'account.field.phone.ph': '+1…',
      'account.memberSince': 'Member since',
      'account.save': 'Save',
      'account.saving': 'Saving…',
      'account.saved': 'Your details were updated.',
      'account.esims.title': 'My eSIMs',
      'account.esims.empty': 'You don’t have any eSIMs yet.',
      'account.esims.emptyCta': 'Browse the store',
      'account.esims.data': 'Data',
      'account.esims.expires': 'Expires',
      'account.esims.viewQr': 'Show QR code',
      'account.esims.hideQr': 'Hide QR code',
      'account.esims.active': 'Active',
      'account.esims.passive': 'Inactive',
      'account.esims.noActive': 'You have no active eSIMs.',
      'account.esims.noPassive': 'You have no inactive eSIMs.',
      'account.esims.readyHint': 'Ready to use — validity starts on first use.',
      'account.esims.unavailableHint': 'Status unavailable right now. Please try again later.',
      'esimStatus.active': 'Active',
      'esimStatus.readyToUse': 'Ready to use',
      'esimStatus.inactive': 'Inactive',
      'esimStatus.unavailable': 'Status unavailable',
      'account.security.title': 'Change password',
      'account.field.oldPassword': 'Current password',
      'account.field.newPassword': 'New password',
      'account.field.confirmPassword': 'New password (again)',
      'account.changePassword': 'Update password',
      'account.passwordChanged': 'Your password was updated.',
      'account.error.passwordMismatch': 'New passwords don’t match.',
      'account.danger.title': 'Account actions',
      'account.delete': 'Delete account',
      'account.delete.confirm': 'You’re about to permanently delete your account. This cannot be undone.',
      'account.delete.confirmBtn': 'Yes, delete',
      'account.cancel': 'Cancel',

      // Purchased eSIM detail
      'esimDetail.back': 'Back',
      'esimDetail.dataUsage': 'Data usage',
      'esimDetail.left': 'left',
      'esimDetail.leftData': 'Remaining data',
      'esimDetail.usedData': 'Used',
      'esimDetail.totalData': 'Total data',
      'esimDetail.qrDesc': 'Scan this QR code with your device camera to set up your eSIM.',
      'esimDetail.validity': 'Validity',
      'esimDetail.daysLeft': '{{days}} days left',
      'esimDetail.expired': 'Expired',
      'esimDetail.notYetActive': 'Not active yet',
      'esimDetail.leftDate': 'Time left',
      'esimDetail.activationDate': 'Activation date',
      'esimDetail.endDate': 'End date',
      'esimDetail.technical': 'Technical details',
      'esimDetail.activationCode': 'Activation code (Android)',
      'esimDetail.smdp': 'SM-DP+ address (iOS)',
      'esimDetail.matchingId': 'Matching ID (iOS)',
      'esimDetail.support': 'Technical support',
      'esimDetail.supportDesc': 'Something wrong? We’re here to help.',
      'esimDetail.email': 'Send email',

      // eSIM guide
      'guide.eyebrow': 'eSIM GUIDE',
      'guide.title': 'What is an eSIM and how to set it up?',
      'guide.intro.title': 'What is an eSIM?',
      'guide.intro.body': 'An eSIM is a digital SIM embedded in your device — no physical card needed. Scan a QR code and your line is set up in seconds, so you can get online in 190+ countries with no card swaps and no roaming bills.',
      'guide.steps.title': 'How to activate',
      'guide.devices.title': 'Supported devices',
      'guide.devices.desc': 'Your device must support eSIM for it to work. Find your brand below.',
      'guide.faq.title': 'Frequently asked questions',
      'nav.guide': 'eSIM Guide',
      'currency.label': 'Currency',

      // Static pages (About/Contact/Privacy) — loading & error states
      'staticPage.loading': 'Loading page...',
      'staticPage.errorTitle': 'An Error Occurred',
      'staticPage.retry': 'Try Again',
      'staticPage.loadFailed': 'Page content could not be loaded. Please try again later.',

      // General
      'last.updated': 'Last updated: July 8, 2024',

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      'home.tabs.unlimited': 'Unlimited eSIMs',
      'detail.unlimited': 'Unlimited',
      'detail.unlimitedNote': 'This bundle has no data cap — enjoy unlimited internet for the whole validity period.',
      'detail.notPriced': 'This bundle is not available for purchase on the web right now.',
      'checkout.priceUpdated': 'The price of this bundle has changed. Please go back to the store and select it again.',
      'order.pending.title': 'Your eSIM is being prepared',
      'order.pending.message': 'Your payment went through. Unlimited bundles can take a few minutes to activate.',
      'order.pending.waiting': 'Checking your order status…',
      'order.pending.ready': 'Your eSIM is ready!',
      'order.pending.timeout': 'This is taking longer than expected. Your payment is safe — your eSIM will appear under “My eSIMs” as soon as it is ready.',
      'order.pending.cta': 'Go to My eSIMs',
      'account.esims.unlimited': 'Unlimited',
      'account.esims.unlimitedHint': 'Unlimited data — this bundle has no data cap.',
      'esimDetail.unlimitedData': 'This bundle has no data cap; see the remaining time below.',


      // Account deletion page (/hesap-sil · /account-deletion) — Google Play “Data deletion” requirement
      'del.eyebrow': 'Account deletion',
      'del.title': 'Delete my account',
      'del.intro': 'You can permanently delete your Utkan eSIM account and personal data here. You don’t need the app installed — just sign in with the account you want to delete.',
      'del.deleted.title': 'Data that is deleted',
      'del.deleted.identity': 'Your first name, last name, email address and phone number',
      'del.deleted.credentials': 'Your password and session data',
      'del.deleted.codes': 'Your email verification and password reset codes',
      'del.deleted.esim': 'Your eSIM number (MSISDN), QR/activation code and usage data',
      'del.kept.title': 'Data we keep, and why',
      'del.kept.orders': 'Purchase records (order number, date, amount, payment status) are kept to meet tax and accounting obligations. They contain no name, email address or payment details — only an identifier that cannot be linked back to you.',
      'del.kept.period': 'Retention period: 5 years (Turkish Tax Procedure Law, art. 253).',
      'del.warn.title': 'Before you delete',
      'del.warn.irreversible': 'This action cannot be undone.',
      'del.warn.esim': 'Active eSIMs keep working on your device, but you will no longer be able to access your QR code or your remaining data. Save your QR code before deleting.',
      'del.warn.rejoin': 'You can sign up again with the same email address, but your previous eSIMs will not appear in the new account.',
      'del.support': 'If you cannot sign in, you can also request deletion by email:',
      'del.login.title': 'Sign in first',
      'del.login.subtitle': 'Enter your email and password so we can confirm the account is yours.',
      'del.login.action': 'Sign in',
      'del.login.loading': 'Signing in...',
      'del.forgot': 'Forgot your password?',
      'del.confirm.title': 'Are you sure?',
      'del.confirm.subtitle': 'The account {{email}} and your personal data will be permanently deleted.',
      'del.confirm.field': 'Type your email address again to confirm',
      'del.confirm.action': 'Permanently delete my account',
      'del.confirm.deleting': 'Deleting...',
      'del.confirm.cancel': 'Cancel',
      'del.done.title': 'Your account has been deleted',
      'del.done.body': 'Your personal data has been permanently deleted.',
      'del.done.retained': 'Your personal data has been permanently deleted. {{n}} purchase record(s) were kept to meet legal obligations; they cannot be linked to you.',
      'del.done.home': 'Back to the store',
      'del.error.required': 'Please enter your email and password.',
      'del.error.credentials': 'Incorrect email or password.',
      'del.error.suspended': 'Your account has been suspended. Please contact support.',
      'del.error.session': 'Your session has expired. Please sign in again.',
      'del.error.network': 'Could not connect. Check your internet connection and try again.',
      'del.error.generic': 'Something went wrong. Please try again.',
      'footer.deleteAccount': 'Delete account',


      // Voice bundles (data + unlimited calls & SMS) — docs/ses-paketleri.md
      'home.tabs.voice': 'Voice eSIMs',
      'detail.voice': 'Calls + SMS',
      'detail.voiceNote': 'This plan includes unlimited calls and SMS on top of its data — one eSIM for both internet and calls.',
      'detail.calls': 'Calls',
      'detail.sms': 'SMS',
      'plan.unlimitedCalls': 'Unlimited calls',
      'plan.unlimitedSms': 'Unlimited SMS',
      'plan.minutes': '{{n}} min of calls',
      'plan.sms': '{{n}} SMS',

      // Hercules — unlimited calls across Europe (docs/hercules-sayfasi.md)
      'hercules.subtitle': 'Unlimited calls, SMS and data across {{n}} European countries — one eSIM.',
      'hercules.coverageTitle': 'Countries covered ({{n}})',
      'hercules.promo.desc': 'Unlimited calls and SMS in {{n}} countries, with 20–100 GB of data.',
      'hercules.promo.cta': 'View plan',
      'loading': 'Loading...',
    }
  },
  de: {
    translation: {
      "language.title": "Sprache",
      // Hauptseite
      'hero.title': 'Utkan eSIM',
      'hero.subtitle': 'Die Zukunft der digitalen Konnektivität',
      'hero.description': 'Wir entfernen Grenzen mit der neuen Generation digitaler Konnektivitätserfahrung.',
      'hero.description2': 'Schnelle, sichere und erschwingliche eSIM-Lösungen weltweit.',

      // Funktionen
      'features.countries': '150+ Länder',
      'features.activation': 'Sofortige Aktivierung',
      'features.support': '24/7 Support',

      // Countdown
      'countdown.title': 'Unsere Website kommt bald!',
      'countdown.days': 'Tage',
      'countdown.hours': 'Stunden',
      'countdown.minutes': 'Minuten',
      'countdown.seconds': 'Sekunden',
      'countdown.launch': 'Unsere Website ist live!',
      'countdown.loading': 'Lädt...',

      // Apps
      'apps.title': 'Unsere mobilen Anwendungen',
      'apps.ios.label': 'Download im',
      'apps.ios.name': 'App Store',
      'apps.android.label': 'JETZT BEI',
      'apps.android.name': 'Google Play',

      // Kontakt
      'contact.title': 'Kontaktieren Sie uns bis zum Launch',
      'contact.whatsapp': 'WhatsApp: +90 540 155 13 33',
      'contact.email': 'E-Mail: info@utkanesim.com',

      // Über uns Seite
      'about.hero.title': 'Über Utkan eSIM',
      'about.hero.description': 'Ihr vertrauensvoller Partner für die Verbindung, wo immer Sie sind. Wir glauben, dass globales Reisen nahtlos und erschwinglich sein sollte, ohne die Mühe physischer SIM-Karten und teurer Roaming-Gebühren.',
      'about.story.title': 'Unsere Geschichte',
      'about.story.content': 'Gegründet 2024 von einem Team leidenschaftlicher Reisender und Technologie-Enthusiasten, ist unser Ziel, die Art und Weise zu revolutionieren, wie Menschen im Ausland eine Internetverbindung herstellen. Wir bieten hochwertige, zuverlässige eSIM-Datenpläne für über 190 Länder und Regionen und stellen sicher, dass Sie vom Moment der Landung an schnellen Internetzugang haben.',
      'about.mission.title': 'Unsere Mission',
      'about.mission.content': 'Reisenden weltweit einfache, erschwingliche und sofortige Konnektivität zu bieten und sie zu befähigen, grenzenlos zu erkunden, zu arbeiten und in Kontakt zu bleiben.',
      'about.vision.title': 'Unsere Vision',
      'about.vision.content': 'Die führende globale Plattform für digitale Konnektivitätslösungen zu sein und die Welt für alle zu einem kleineren, vernetzteren Ort zu machen.',
      'about.features.title': 'Warum uns wählen?',
      'about.features.instant.title': 'Sofortige Lieferung',
      'about.features.instant.content': 'Erhalten Sie Ihre eSIM sofort nach dem Kauf über QR-Code.',
      'about.features.global.title': 'Globale Abdeckung',
      'about.features.global.content': 'Datenpläne für über 190 Länder und Regionen.',
      'about.features.affordable.title': 'Erschwingliche Preise',
      'about.features.affordable.content': 'Sparen Sie bis zu 90% bei Roaming-Gebühren.',
      'about.features.support.title': '24/7 Support',
      'about.features.support.content': 'Unser engagiertes Support-Team ist immer für Sie da.',
      'about.features.secure.title': 'Sichere Verbindung',
      'about.features.secure.content': 'Verbindung geschützt mit den neuesten Sicherheitsprotokollen.',
      'about.features.fast.title': 'Schnelles Internet',
      'about.features.fast.content': 'Nahtlose Internet-Erfahrung mit 4G/5G-Geschwindigkeiten.',
      'about.cta.title': 'Werden Sie Teil der Zukunft der digitalen Konnektivität',
      'about.cta.content': 'Vielen Dank, dass Sie Utkan eSIM gewählt haben. Gute Reise!',
      'about.cta.whatsapp': 'Kontakt über WhatsApp',
      'about.cta.email': 'E-Mail senden',

      // Kontakt Seite
      'contact.hero.title': 'Kontaktieren Sie uns',
      'contact.hero.description': 'Wir sind hier, um zu helfen! Ob Sie eine Frage zu unseren eSIMs haben, technischen Support benötigen oder uns einfach Feedback geben möchten - wir freuen uns, von Ihnen zu hören.',
      'contact.info.title': 'Kontaktinformationen',
      'contact.whatsapp.title': 'WhatsApp',
      'contact.whatsapp.subtitle': '24/7 Schneller Support',
      'contact.email.title': 'E-Mail',
      'contact.email.subtitle': 'Allgemeiner Kontakt',
      'contact.support.title': 'Technischer Support',
      'contact.support.subtitle': 'eSIM-Probleme',
      'contact.business.title': 'Partnerschaft',
      'contact.business.subtitle': 'Unternehmenskontakt',
      'contact.hours.title': 'Support-Zeiten',
      'contact.hours.subtitle': '24/7 Technischer Support',
      'contact.hours.detail': 'Montag - Sonntag: 00:00 - 23:59',
      'contact.form.title': 'Senden Sie uns eine Nachricht',
      'contact.form.name': 'Ihr Name',
      'contact.form.name.placeholder': 'Geben Sie Ihren Vor- und Nachnamen ein',
      'contact.form.email': 'Ihre E-Mail',
      'contact.form.email.placeholder': 'beispiel@email.com',
      'contact.form.subject': 'Betreff',
      'contact.form.subject.placeholder': 'Betreff auswählen',
      'contact.form.subject.general': 'Allgemeine Informationen',
      'contact.form.subject.technical': 'Technischer Support',
      'contact.form.subject.billing': 'Abrechnungsfragen',
      'contact.form.subject.partnership': 'Partnerschaft',
      'contact.form.subject.feedback': 'Feedback',
      'contact.form.message': 'Ihre Nachricht',
      'contact.form.message.placeholder': 'Schreiben Sie Ihre Nachricht hier...',
      'contact.form.submit': 'Nachricht senden',
      'contact.faq.title': 'Häufig gestellte Fragen',
      'contact.faq.esim.title': 'Wie funktioniert eSIM?',
      'contact.faq.esim.content': 'eSIM ist eine digitale SIM-Karte, die in Ihrem Telefon funktioniert, ohne eine physische SIM-Karte zu benötigen. Sie wird sofort über QR-Code aktiviert.',
      'contact.faq.phones.title': 'Welche Telefone unterstützen eSIM?',
      'contact.faq.phones.content': 'iPhone XS und höher, Samsung Galaxy S20 und höher, Google Pixel 3 und höhere Modelle unterstützen eSIM.',
      'contact.faq.validity.title': 'Wie lange ist mein Datenpaket gültig?',
      'contact.faq.validity.content': 'Die Gültigkeitsdauer des Pakets variiert je nach gewähltem Plan zwischen 1-30 Tagen.',
      'contact.faq.payment.title': 'Wie kann ich bezahlen?',
      'contact.faq.payment.content': 'Sie können sicher mit Kreditkarte, PayPal und Banküberweisung bezahlen.',

      // Datenschutz Seite
      'privacy.hero.title': 'Datenschutzerklärung',
      'privacy.hero.description': 'Die Sicherheit Ihrer persönlichen Daten ist uns sehr wichtig. Diese Richtlinie erklärt, wie Ihre Daten gesammelt, verwendet und geschützt werden.',
      'privacy.overview.title': 'Übersicht',
      'privacy.overview.content': 'Diese Datenschutzerklärung beschreibt unsere Richtlinien und Verfahren zur Sammlung, Verwendung und Offenlegung Ihrer Informationen, wenn Sie den Service nutzen, und informiert Sie über Ihre Datenschutzrechte und wie das Gesetz Sie schützt.',
      'privacy.data.title': 'Daten, die wir sammeln',
      'privacy.data.personal.title': 'Persönliche Informationen',
      'privacy.data.personal.name': 'Vor- und Nachname',
      'privacy.data.personal.email': 'E-Mail-Adresse',
      'privacy.data.personal.phone': 'Telefonnummer',
      'privacy.data.personal.payment': 'Zahlungsinformationen',
      'privacy.data.usage.title': 'Nutzungsdaten',
      'privacy.data.usage.ip': 'IP-Adresse',
      'privacy.data.usage.browser': 'Browsertyp',
      'privacy.data.usage.device': 'Geräteinformationen',
      'privacy.data.usage.stats': 'Nutzungsstatistiken',
      'privacy.security.title': 'Datensicherheit',
      'privacy.security.ssl.title': 'SSL-Verschlüsselung',
      'privacy.security.ssl.content': 'Alle Datenübertragungen sind mit 256-Bit-SSL-Verschlüsselung geschützt.',
      'privacy.security.servers.title': 'Sichere Server',
      'privacy.security.servers.content': 'Ihre Daten werden auf ISO 27001-zertifizierten sicheren Servern gespeichert.',
      'privacy.security.access.title': 'Zugriffskontrolle',
      'privacy.security.access.content': 'Nur autorisiertes Personal kann auf Ihre Daten zugreifen.',
      'privacy.usage.title': 'Datenverwendung',
      'privacy.usage.intro': 'Wir verwenden die gesammelten Daten für folgende Zwecke:',
      'privacy.usage.service.title': 'Dienstleistungserbringung',
      'privacy.usage.service.content': 'Um Ihnen unsere eSIM-Dienste bereitzustellen und zu verwalten',
      'privacy.usage.support.title': 'Kundensupport',
      'privacy.usage.support.content': 'Um technischen Support und Kundenservice zu bieten',
      'privacy.usage.security.title': 'Sicherheit',
      'privacy.usage.security.content': 'Um Ihr Konto und unsere Dienste zu schützen',
      'privacy.usage.improvement.title': 'Verbesserung',
      'privacy.usage.improvement.content': 'Um unsere Dienste zu verbessern und neue Funktionen hinzuzufügen',
      'privacy.sharing.title': 'Datenweitergabe',
      'privacy.sharing.intro': 'Wir geben Ihre persönlichen Daten nicht an Dritte weiter, aber eine Weitergabe kann in folgenden Fällen erforderlich sein:',
      'privacy.sharing.legal': 'Bei gesetzlicher Verpflichtung',
      'privacy.sharing.providers': 'Mit unseren Dienstleistern (wie Zahlungsabwicklern)',
      'privacy.sharing.threats': 'Um Sicherheitsbedrohungen zu verhindern',
      'privacy.sharing.consent': 'Wenn Sie ausdrückliche Zustimmung geben',
      'privacy.rights.title': 'Ihre Rechte',
      'privacy.rights.access.title': 'Recht auf Zugang',
      'privacy.rights.access.content': 'Sie können Zugang zu den über Sie gespeicherten Daten beantragen.',
      'privacy.rights.correction.title': 'Recht auf Berichtigung',
      'privacy.rights.correction.content': 'Wir können Ihre falschen oder unvollständigen Daten berichtigen.',
      'privacy.rights.deletion.title': 'Recht auf Löschung',
      'privacy.rights.deletion.content': 'Wir können Ihre Daten unter bestimmten Bedingungen löschen.',
      'privacy.rights.objection.title': 'Widerspruchsrecht',
      'privacy.rights.objection.content': 'Sie können unseren Datenverarbeitungsaktivitäten widersprechen.',
      'privacy.contact.title': 'Kontakt',
      'privacy.contact.intro': 'Wenn Sie Fragen zu dieser Datenschutzerklärung haben, können Sie uns über folgende Kanäle kontaktieren:',

      // Navigation
      'nav.about': 'Über uns',
      'nav.contact': 'Kontakt',
      'nav.privacy': 'Datenschutz',
      'nav.login': 'Anmelden',
      'nav.account': 'Konto',
      'nav.logout': 'Abmelden',

      // Auth - Markenpanel
      'auth.brand.eyebrow': 'WELTWEITE ABDECKUNG',
      'auth.brand.title': 'In über 150 Ländern online, sobald du landest.',
      'auth.brand.subtitle': 'Keine physische SIM, keine Roaming-Rechnungen. Aktiviere deine eSIM in Sekunden.',

      // Auth - Anmeldung
      'auth.login.eyebrow': 'ANMELDEN',
      'auth.login.title': 'Willkommen zurück',
      'auth.login.subtitle': 'Verwalte deine eSIMs und entdecke neue.',

      // Auth - Registrierung
      'auth.signup.eyebrow': 'NEUES KONTO',
      'auth.signup.title': 'Konto erstellen',
      'auth.signup.subtitle': 'Wenige Schritte bis zu deiner ersten eSIM.',

      // Auth - Felder
      'auth.field.identifier': 'E-Mail oder Telefon',
      'auth.field.identifier.ph': 'du@email.com oder +49…',
      'auth.field.email': 'E-Mail',
      'auth.field.email.ph': 'du@email.com',
      'auth.field.fullName': 'Vollständiger Name',
      'auth.field.fullName.ph': 'Dein vollständiger Name',
      'auth.field.password': 'Passwort',
      'auth.field.password.ph': '••••••••',

      // Auth - Aktionen
      'auth.action.login': 'Anmelden',
      'auth.action.loggingIn': 'Anmeldung läuft…',
      'auth.action.signup': 'Konto erstellen',
      'auth.action.signingUp': 'Konto wird erstellt…',
      'auth.toSignup.q': 'Noch kein Konto?',
      'auth.toSignup.link': 'Registrieren',
      'auth.toLogin.q': 'Bereits ein Konto?',
      'auth.toLogin.link': 'Anmelden',
      'auth.password.show': 'Passwort anzeigen',
      'auth.password.hide': 'Passwort verbergen',

      // Auth - Bedingungen & Fehler
      'auth.terms.prefix': 'Mit dem Fortfahren stimme ich den ',
      'auth.terms.link': 'Nutzungsbedingungen und der Datenschutzerklärung',
      'auth.terms.suffix': ' zu.',
      'auth.error.required': 'Bitte fülle die erforderlichen Felder aus.',
      'auth.error.terms': 'Bitte akzeptiere die Bedingungen, um fortzufahren.',

      // E-Mail-Bestätigung
      'verify.eyebrow': 'E-MAIL-BESTÄTIGUNG',
      'verify.title': 'Bestätige deine E-Mail',
      'verify.subtitle': 'Wir haben einen 6-stelligen Code an {{email}} gesendet. Gib ihn zur Bestätigung ein.',
      'verify.code': 'Bestätigungscode',
      'verify.code.ph': '••••••',
      'verify.action': 'Bestätigen',
      'verify.verifying': 'Wird bestätigt…',
      'verify.resend': 'Code erneut senden',
      'verify.resendIn': 'Erneut senden in {{seconds}}s',
      'verify.resent': 'Ein neuer Code wurde gesendet.',
      'verify.skip': 'Vorerst überspringen',

      // Passwort vergessen
      'auth.forgot.link': 'Passwort vergessen?',
      'forgot.eyebrow': 'PASSWORT ZURÜCKSETZEN',
      'forgot.email.title': 'Passwort zurücksetzen',
      'forgot.email.subtitle':
        'Gib die E-Mail-Adresse deines Kontos ein; wir senden dir einen 6-stelligen Code.',
      'forgot.email.action': 'Code senden',
      'forgot.email.sending': 'Wird gesendet…',
      'forgot.reset.title': 'Neues Passwort festlegen',
      'forgot.reset.subtitle':
        'Gib den 6-stelligen Code, den wir an {{email}} gesendet haben, und dein neues Passwort ein.',
      'forgot.reset.action': 'Passwort aktualisieren',
      'forgot.reset.updating': 'Wird aktualisiert…',
      'forgot.field.code': 'Zurücksetzungscode',
      'forgot.field.code.ph': '••••••',
      'forgot.field.newPassword': 'Neues Passwort',
      'forgot.field.newPassword.ph': 'Mindestens 6 Zeichen',
      'forgot.resend': 'Code erneut senden',
      'forgot.resendIn': 'Erneut senden in {{seconds}}s',
      'forgot.resent': 'Ein neuer Code wurde gesendet.',
      'forgot.backToLogin': 'Zurück zur Anmeldung',
      'forgot.changeEmail': 'E-Mail ändern',
      'forgot.help.noMail':
        'Falls der Code nicht angekommen ist, prüfe deinen Spam-Ordner oder bestätige deine E-Mail-Adresse.',
      // Server-Ergebniscodes → Nutzertext
      'reset.RESET_CODE_SENT': 'Code gesendet. Bitte prüfe deine E-Mails.',
      'reset.RATE_LIMITED':
        'Zu viele Anfragen. Bitte warte eine Weile und versuche es erneut.',
      'reset.MAIL_SEND_FAILED':
        'Etwas ist schiefgelaufen. Bitte versuche es später erneut.',
      'reset.RESET_CODE_VALID': 'Code bestätigt.',
      'reset.INVALID_RESET_CODE':
        'Ungültiger Code. Bitte versuche es erneut.',
      'reset.EXPIRED_RESET_CODE':
        'Der Code ist abgelaufen. Bitte fordere einen neuen Code an.',
      'reset.WEAK_PASSWORD': 'Das Passwort muss mindestens 6 Zeichen lang sein.',
      'reset.PASSWORD_RESET_SUCCESS':
        'Dein Passwort wurde aktualisiert. Bitte melde dich mit deinem neuen Passwort an.',
      'reset.generic': 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
      'login.resetSuccess':
        'Dein Passwort wurde aktualisiert. Bitte melde dich mit deinem neuen Passwort an.',

      // Store-Navigation
      'store.nav.shop': 'Shop',

      // Startseite (Shop)
      'home.hero.title1': 'In Minuten verbunden,',
      'home.hero.title2': 'über Grenzen hinweg online.',
      'home.hero.subtitle': 'Zuverlässige eSIM-Tarife, gültig in über 190 Ländern. Keine physische SIM, keine Roaming-Rechnungen.',
      'home.search.placeholder': 'Wohin reist du?',
      'home.tabs.local': 'Lokale eSIMs',
      'home.tabs.regional': 'Regionale eSIMs',
      'home.tabs.lifetime': 'Lebenslange eSIMs',
      'home.empty': 'Keine Ergebnisse für deine Suche.',
      'home.error.title': 'Inhalt konnte nicht geladen werden',
      'home.error.retry': 'Erneut versuchen',
      'home.from': 'ab',
      'home.popular': 'Beliebte Reiseziele',
      'home.coverage': '190+ Länder · sofortige Aktivierung',
      'home.detail.soon': 'Tarife für diese Auswahl werden hier in Kürze aufgelistet.',
      'home.detail.back': 'Zurück zum Shop',

      // eSIM-Detail / Tarife
      'detail.plans': 'Tarife',
      'detail.count': '{{count}} Tarife',
      'detail.validity': '{{days}} Tage',
      'detail.validityLifetime': 'Unbegrenzt',
      'detail.buy': 'Kaufen',
      'detail.empty': 'Für diese Auswahl sind derzeit keine Tarife verfügbar.',
      'detail.checkoutSoon': 'Die Bezahlung folgt in Kürze.',
      'detail.loginToBuy': 'Zum Kauf bitte anmelden.',
      'detail.basicFeatures': 'Grundfunktionen',
      'detail.dataAmount': 'Datenvolumen',
      'detail.validityLabel': 'Gültigkeit',
      'detail.coverageArea': 'Abdeckung',
      'detail.activationNetworks': 'Aktivierung & Netze',
      'detail.activationMethod': 'Aktivierungsmethode',
      'detail.esimActivation': 'eSIM — sofort per QR-Code',
      'detail.supportedNetworks': 'Unterstützte Netze',
      'detail.description': 'Beschreibung',
      'detail.price': 'Preis',

      // Anmelde-Dialog
      'authprompt.title': 'Zum Fortfahren anmelden',
      'authprompt.message': 'Melde dich an, um eine eSIM zu kaufen, oder erstelle in Sekunden ein Konto.',
      'authprompt.close': 'Schließen',

      // Footer
      'footer.tagline': 'Schnelle, sichere und günstige eSIM weltweit. Online, sobald du landest.',
      'footer.explore': 'Entdecken',
      'footer.support': 'Support',
      'footer.legal': 'Rechtliches',
      'footer.shop': 'Shop',
      'footer.help': 'Häufige Fragen',
      'footer.terms': 'Nutzungsbedingungen',
      'footer.rights': '© {{year}} Utkan eSIM. Alle Rechte vorbehalten.',
      'footer.apps': 'App herunterladen',

      // WhatsApp-Support-Button
      'whatsapp.label': 'Per WhatsApp schreiben',
      'whatsapp.message': 'Hallo, ich habe eine eSIM-Supportanfrage.',

      // 404
      'notfound.eyebrow': 'KEIN SIGNAL',
      'notfound.title': 'Diese Seite ist nicht erreichbar',
      'notfound.message': 'Die gesuchte Seite wurde verschoben oder hat nie existiert. Zurück ins Netz!',

      // Bestellung erfolgreich
      'order.congrats': 'Glückwunsch!',
      'order.message': 'Deine eSIM ist bereit. Richte sie in wenigen Schritten mit dem QR-Code unten ein.',
      'order.details': 'Bestellübersicht',
      'order.activation': 'Aktivierung',
      'order.activationDesc': 'Scanne zum Einrichten den QR-Code mit deiner Gerätekamera oder gib den Aktivierungscode manuell ein.',
      'order.qrTitle': 'eSIM-QR-Code',
      'order.manualLabel': 'Aktivierungscode',
      'order.copy': 'Kopieren',
      'order.copied': 'Kopiert',
      'order.howTo': 'So aktivierst du',
      'order.step1': 'Gehe am Gerät zu Einstellungen > Mobilfunk > eSIM hinzufügen.',
      'order.step2': 'Wähle „QR-Code verwenden“ und scanne den QR oben (oder gib den Code manuell ein).',
      'order.step3': 'Aktiviere nach der Einrichtung den eSIM-Tarif.',
      'order.step4': 'Stelle sicher, dass Daten-Roaming aktiviert ist — du bist verbunden!',
      'order.cta': 'Zur Startseite',

      // Kasse (Checkout)
      'checkout.title': 'Kasse',
      'checkout.summary': 'Bestellübersicht',
      'checkout.total': 'Gesamt',
      'checkout.eurNote': 'Die Abbuchung erfolgt in Euro (€) über PayPal.',
      'checkout.processing': 'Zahlung wird überprüft…',
      'checkout.error': 'Zahlung konnte nicht abgeschlossen werden. Bitte erneut versuchen.',
      'checkout.cancelled': 'Zahlung abgebrochen.',

      // Konto
      'account.title': 'Mein Konto',
      'account.tab.profile': 'Profil',
      'account.tab.esims': 'Meine eSIMs',
      'account.tab.security': 'Sicherheit',
      'account.profile.title': 'Profilinformationen',
      'account.field.phone': 'Telefon',
      'account.field.phone.ph': '+49…',
      'account.memberSince': 'Mitglied seit',
      'account.save': 'Speichern',
      'account.saving': 'Wird gespeichert…',
      'account.saved': 'Deine Daten wurden aktualisiert.',
      'account.esims.title': 'Meine eSIMs',
      'account.esims.empty': 'Du hast noch keine eSIMs.',
      'account.esims.emptyCta': 'Zum Shop',
      'account.esims.data': 'Daten',
      'account.esims.expires': 'Läuft ab',
      'account.esims.viewQr': 'QR-Code anzeigen',
      'account.esims.hideQr': 'QR-Code ausblenden',
      'account.esims.active': 'Aktiv',
      'account.esims.passive': 'Inaktiv',
      'account.esims.noActive': 'Du hast keine aktiven eSIMs.',
      'account.esims.noPassive': 'Du hast keine inaktiven eSIMs.',
      'account.esims.readyHint': 'Einsatzbereit — die Laufzeit beginnt bei der ersten Nutzung.',
      'account.esims.unavailableHint': 'Status derzeit nicht verfügbar. Bitte später erneut versuchen.',
      'esimStatus.active': 'Aktiv',
      'esimStatus.readyToUse': 'Einsatzbereit',
      'esimStatus.inactive': 'Inaktiv',
      'esimStatus.unavailable': 'Status nicht verfügbar',
      'account.security.title': 'Passwort ändern',
      'account.field.oldPassword': 'Aktuelles Passwort',
      'account.field.newPassword': 'Neues Passwort',
      'account.field.confirmPassword': 'Neues Passwort (wiederholen)',
      'account.changePassword': 'Passwort aktualisieren',
      'account.passwordChanged': 'Dein Passwort wurde aktualisiert.',
      'account.error.passwordMismatch': 'Die neuen Passwörter stimmen nicht überein.',
      'account.danger.title': 'Kontoaktionen',
      'account.delete': 'Konto löschen',
      'account.delete.confirm': 'Du bist dabei, dein Konto dauerhaft zu löschen. Das kann nicht rückgängig gemacht werden.',
      'account.delete.confirmBtn': 'Ja, löschen',
      'account.cancel': 'Abbrechen',

      // Detail der gekauften eSIM
      'esimDetail.back': 'Zurück',
      'esimDetail.dataUsage': 'Datennutzung',
      'esimDetail.left': 'übrig',
      'esimDetail.leftData': 'Verbleibende Daten',
      'esimDetail.usedData': 'Verbraucht',
      'esimDetail.totalData': 'Gesamtdaten',
      'esimDetail.qrDesc': 'Scanne diesen QR-Code mit deiner Gerätekamera, um deine eSIM einzurichten.',
      'esimDetail.validity': 'Gültigkeit',
      'esimDetail.daysLeft': 'Noch {{days}} Tage',
      'esimDetail.expired': 'Abgelaufen',
      'esimDetail.notYetActive': 'Noch nicht aktiv',
      'esimDetail.leftDate': 'Verbleibende Zeit',
      'esimDetail.activationDate': 'Aktivierungsdatum',
      'esimDetail.endDate': 'Enddatum',
      'esimDetail.technical': 'Technische Details',
      'esimDetail.activationCode': 'Aktivierungscode (Android)',
      'esimDetail.smdp': 'SM-DP+-Adresse (iOS)',
      'esimDetail.matchingId': 'Matching-ID (iOS)',
      'esimDetail.support': 'Technischer Support',
      'esimDetail.supportDesc': 'Etwas stimmt nicht? Wir helfen dir.',
      'esimDetail.email': 'E-Mail senden',

      // eSIM-Leitfaden
      'guide.eyebrow': 'eSIM-LEITFADEN',
      'guide.title': 'Was ist eine eSIM und wie richte ich sie ein?',
      'guide.intro.title': 'Was ist eine eSIM?',
      'guide.intro.body': 'Eine eSIM ist eine digitale, im Gerät eingebettete SIM — ganz ohne physische Karte. Scanne einen QR-Code und deine Leitung ist in Sekunden eingerichtet: online in über 190 Ländern, ohne Kartenwechsel und ohne Roaming-Rechnungen.',
      'guide.steps.title': 'So aktivierst du',
      'guide.devices.title': 'Unterstützte Geräte',
      'guide.devices.desc': 'Dein Gerät muss eSIM unterstützen. Finde unten deine Marke.',
      'guide.faq.title': 'Häufig gestellte Fragen',
      'nav.guide': 'eSIM-Leitfaden',
      'currency.label': 'Währung',

      // Statische Seiten (About/Contact/Privacy) — Lade- & Fehlerzustände
      'staticPage.loading': 'Seite wird geladen...',
      'staticPage.errorTitle': 'Ein Fehler ist aufgetreten',
      'staticPage.retry': 'Erneut versuchen',
      'staticPage.loadFailed': 'Seiteninhalt konnte nicht geladen werden. Bitte versuche es später erneut.',

      // Allgemein
      'last.updated': 'Zuletzt aktualisiert: 8. Juli 2024',

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      'home.tabs.unlimited': 'Unbegrenzte eSIMs',
      'detail.unlimited': 'Unbegrenzt',
      'detail.unlimitedNote': 'Dieses Paket hat kein Datenlimit — unbegrenztes Internet für die gesamte Laufzeit.',
      'detail.notPriced': 'Dieses Paket ist derzeit im Web nicht kaufbar.',
      'checkout.priceUpdated': 'Der Preis dieses Pakets hat sich geändert. Bitte kehre zum Shop zurück und wähle es erneut aus.',
      'order.pending.title': 'Deine eSIM wird vorbereitet',
      'order.pending.message': 'Deine Zahlung war erfolgreich. Bei unbegrenzten Paketen kann die Aktivierung einige Minuten dauern.',
      'order.pending.waiting': 'Bestellstatus wird geprüft…',
      'order.pending.ready': 'Deine eSIM ist bereit!',
      'order.pending.timeout': 'Das dauert länger als erwartet. Deine Zahlung ist sicher — deine eSIM erscheint unter „Meine eSIMs“, sobald sie bereit ist.',
      'order.pending.cta': 'Zu meinen eSIMs',
      'account.esims.unlimited': 'Unbegrenzt',
      'account.esims.unlimitedHint': 'Unbegrenzte Daten — dieses Paket hat kein Datenlimit.',
      'esimDetail.unlimitedData': 'Dieses Paket hat kein Datenlimit; die Restlaufzeit siehst du unten.',


      // Kontolöschung (/hesap-sil · /account-deletion) — Google-Play-Anforderung „Data deletion“
      'del.eyebrow': 'Kontolöschung',
      'del.title': 'Mein Konto löschen',
      'del.intro': 'Hier kannst du dein Utkan eSIM-Konto und deine personenbezogenen Daten dauerhaft löschen. Du brauchst die App dafür nicht — melde dich einfach mit dem Konto an, das gelöscht werden soll.',
      'del.deleted.title': 'Daten, die gelöscht werden',
      'del.deleted.identity': 'Vorname, Nachname, E-Mail-Adresse und Telefonnummer',
      'del.deleted.credentials': 'Passwort und Sitzungsdaten',
      'del.deleted.codes': 'Codes zur E-Mail-Bestätigung und zum Zurücksetzen des Passworts',
      'del.deleted.esim': 'eSIM-Rufnummer (MSISDN), QR-/Aktivierungscode und Nutzungsdaten',
      'del.kept.title': 'Daten, die wir aufbewahren – und warum',
      'del.kept.orders': 'Kaufbelege (Bestellnummer, Datum, Betrag, Zahlungsstatus) werden aufgrund steuerrechtlicher Pflichten aufbewahrt. Sie enthalten weder deinen Namen noch deine E-Mail-Adresse oder Zahlungsdaten – nur eine Kennung, die sich dir nicht zuordnen lässt.',
      'del.kept.period': 'Aufbewahrungsfrist: 5 Jahre (türkisches Steuerverfahrensgesetz, Art. 253).',
      'del.warn.title': 'Vor dem Löschen',
      'del.warn.irreversible': 'Dieser Vorgang kann nicht rückgängig gemacht werden.',
      'del.warn.esim': 'Aktive eSIMs funktionieren auf deinem Gerät weiter, aber du hast keinen Zugriff mehr auf deinen QR-Code und dein verbleibendes Datenvolumen. Sichere deinen QR-Code vorher.',
      'del.warn.rejoin': 'Du kannst dich mit derselben E-Mail-Adresse erneut registrieren, deine bisherigen eSIMs erscheinen jedoch nicht im neuen Konto.',
      'del.support': 'Wenn du dich nicht anmelden kannst, kannst du die Löschung auch per E-Mail beantragen:',
      'del.login.title': 'Zuerst anmelden',
      'del.login.subtitle': 'Gib E-Mail und Passwort ein, damit wir bestätigen können, dass es dein Konto ist.',
      'del.login.action': 'Anmelden',
      'del.login.loading': 'Anmeldung läuft...',
      'del.forgot': 'Passwort vergessen?',
      'del.confirm.title': 'Bist du sicher?',
      'del.confirm.subtitle': 'Das Konto {{email}} und deine personenbezogenen Daten werden dauerhaft gelöscht.',
      'del.confirm.field': 'Gib deine E-Mail-Adresse zur Bestätigung erneut ein',
      'del.confirm.action': 'Mein Konto dauerhaft löschen',
      'del.confirm.deleting': 'Wird gelöscht...',
      'del.confirm.cancel': 'Abbrechen',
      'del.done.title': 'Dein Konto wurde gelöscht',
      'del.done.body': 'Deine personenbezogenen Daten wurden dauerhaft gelöscht.',
      'del.done.retained': 'Deine personenbezogenen Daten wurden dauerhaft gelöscht. {{n}} Kaufbeleg(e) werden aufgrund gesetzlicher Pflichten aufbewahrt; sie lassen sich dir nicht zuordnen.',
      'del.done.home': 'Zurück zum Shop',
      'del.error.required': 'Bitte gib E-Mail und Passwort ein.',
      'del.error.credentials': 'E-Mail oder Passwort ist falsch.',
      'del.error.suspended': 'Dein Konto wurde gesperrt. Bitte wende dich an den Support.',
      'del.error.session': 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
      'del.error.network': 'Keine Verbindung. Prüfe deine Internetverbindung und versuche es erneut.',
      'del.error.generic': 'Es ist ein Fehler aufgetreten. Bitte versuche es erneut.',
      'footer.deleteAccount': 'Konto löschen',


      // Sprach-Pakete (Daten + unbegrenzte Anrufe & SMS) — docs/ses-paketleri.md
      'home.tabs.voice': 'eSIMs mit Telefonie',
      'detail.voice': 'Anrufe + SMS',
      'detail.voiceNote': 'Dieser Tarif enthält zusätzlich zum Datenvolumen unbegrenzte Anrufe und SMS – eine eSIM für Internet und Telefonie.',
      'detail.calls': 'Anrufe',
      'detail.sms': 'SMS',
      'plan.unlimitedCalls': 'Unbegrenzte Anrufe',
      'plan.unlimitedSms': 'Unbegrenzte SMS',
      'plan.minutes': '{{n}} Gesprächsminuten',
      'plan.sms': '{{n}} SMS',

      // Hercules — unbegrenzte Anrufe in Europa (docs/hercules-sayfasi.md)
      'hercules.subtitle': 'Unbegrenzte Anrufe, SMS und Daten in {{n}} europäischen Ländern – eine eSIM.',
      'hercules.coverageTitle': 'Abgedeckte Länder ({{n}})',
      'hercules.promo.desc': 'Unbegrenzte Anrufe und SMS in {{n}} Ländern, dazu 20–100 GB Daten.',
      'hercules.promo.cta': 'Ansehen',
      'loading': 'Lädt...',
    }
  },
  fr: {
    translation: {
      "language.title": "Langue",
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "L'Avenir de la Connectivité Numérique",
      "hero.description": "Nous repoussons les limites avec une expérience de connectivité numérique de nouvelle génération.",
      "hero.description2": "Des solutions eSIM rapides, sécurisées et abordables dans le monde entier.",
      "features.countries": "150+ Pays",
      "features.activation": "Activation Instantanée",
      "features.support": "Support 24/7",
      "countdown.title": "Notre Site Web Arrive Bientôt !",
      "countdown.days": "Jours",
      "countdown.hours": "Heures",
      "countdown.minutes": "Minutes",
      "countdown.seconds": "Secondes",
      "countdown.launch": "Notre Site Web Est Ouvert !",
      "countdown.loading": "Chargement...",
      "apps.title": "Nos Applications Mobiles",
      "apps.ios.label": "Télécharger dans l'",
      "apps.ios.name": "App Store",
      "apps.android.label": "DISPONIBLE SUR",
      "apps.android.name": "Google Play",
      "contact.title": "Contactez-nous avant le lancement",
      "contact.whatsapp": "WhatsApp : +90 540 155 13 33",
      "contact.email": "E-mail : info@utkanesim.com",
      "about.hero.title": "À propos d'Utkan eSIM",
      "about.hero.description": "La sécurité de vos données personnelles est très importante pour nous. Cette politique explique comment vos données sont collectées, utilisées et protégées.",
      "about.story.title": "Notre Histoire",
      "about.story.content": "Fondée en 2024 par une équipe de voyageurs passionnés et de technophiles, Utkan eSIM vise à révolutionner la façon dont les gens se connectent à Internet à l'étranger. En proposant des forfaits de données eSIM fiables et de haute qualité pour plus de 190 pays et régions, nous garantissons votre accès rapide à Internet dès votre atterrissage.",
      "about.mission.title": "Notre Mission",
      "about.mission.content": "Fournir aux voyageurs une connectivité simple, abordable et instantanée dans le monde entier, leur permettant d'explorer, de travailler et de rester en contact sans frontières.",
      "about.vision.title": "Notre Vision",
      "about.vision.content": "Être la principale plateforme mondiale de solutions de connectivité numérique, rendant le monde plus petit et plus connecté pour tous.",
      "about.features.title": "Pourquoi Nous Choisir ?",
      "about.features.instant.title": "Livraison Instantanée",
      "about.features.instant.content": "Obtenez votre eSIM instantanément avec un code QR après l'achat.",
      "about.features.global.title": "Couverture Mondiale",
      "about.features.global.content": "Des forfaits de données pour plus de 190 pays et régions.",
      "about.features.affordable.title": "Prix Abordables",
      "about.features.affordable.content": "Économisez jusqu'à 90 % sur les frais d'itinérance.",
      "about.features.support.title": "Support 24/7",
      "about.features.support.content": "Notre équipe de support dédiée est toujours à votre disposition.",
      "about.features.secure.title": "Connexion Sécurisée",
      "about.features.secure.content": "Une connexion protégée par les derniers protocoles de sécurité.",
      "about.features.fast.title": "Internet Rapide",
      "about.features.fast.content": "Expérience Internet ininterrompue à des vitesses 4G/5G.",
      "about.cta.title": "Rejoignez l'Avenir de la Connectivité Numérique",
      "about.cta.content": "Merci d'avoir choisi Utkan eSIM. Bon voyage !",
      "about.cta.whatsapp": "Contacter via WhatsApp",
      "about.cta.email": "Envoyer un E-mail",
      "contact.hero.title": "Contactez-nous",
      "contact.hero.description": "Si vous avez des questions sur nos eSIM, besoin d'un support technique ou si vous souhaitez simplement donner votre avis, nous serions ravis de vous entendre.",
      "contact.info.title": "Nos Coordonnées",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "Support Rapide 24/7",
      "contact.email.title": "E-mail",
      "contact.email.subtitle": "Contact Général",
      "contact.support.title": "Support Technique",
      "contact.support.subtitle": "Problèmes d'eSIM",
      "contact.business.title": "Partenariat Commercial",
      "contact.business.subtitle": "Contact Entreprise",
      "contact.hours.title": "Heures de Support",
      "contact.hours.subtitle": "Support Technique 24/7",
      "contact.hours.detail": "Lundi - Dimanche : 00:00 - 23:59",
      "contact.form.title": "Envoyer un Message",
      "contact.form.name": "Nom et Prénom",
      "contact.form.name.placeholder": "Entrez votre nom et prénom",
      "contact.form.email": "Votre Adresse E-mail",
      "contact.form.email.placeholder": "exemple@email.com",
      "contact.form.subject": "Sujet",
      "contact.form.subject.placeholder": "Sélectionnez un sujet",
      "contact.form.subject.general": "Informations Générales",
      "contact.form.subject.technical": "Support Technique",
      "contact.form.subject.billing": "Questions de Facturation",
      "contact.form.subject.partnership": "Partenariat Commercial",
      "contact.form.subject.feedback": "Commentaires",
      "contact.form.message": "Votre Message",
      "contact.form.message.placeholder": "Écrivez votre message ici...",
      "contact.form.submit": "Envoyer le Message",
      "contact.faq.title": "Foire Aux Questions",
      "contact.faq.esim.title": "Comment fonctionne une eSIM ?",
      "contact.faq.esim.content": "L'eSIM est une carte SIM numérique qui fonctionne sur votre téléphone sans avoir besoin d'une carte SIM physique. Elle est activée instantanément avec un code QR.",
      "contact.faq.phones.title": "Quels téléphones sont compatibles avec l'eSIM ?",
      "contact.faq.phones.content": "Les modèles iPhone XS et ultérieurs, Samsung Galaxy S20 et ultérieurs, Google Pixel 3 et ultérieurs sont compatibles avec l'eSIM.",
      "contact.faq.validity.title": "Combien de temps mon forfait de données est-il valide ?",
      "contact.faq.validity.content": "La période de validité des forfaits varie de 1 à 30 jours selon le plan que vous choisissez.",
      "contact.faq.payment.title": "Comment s'effectue le paiement ?",
      "contact.faq.payment.content": "Vous pouvez payer en toute sécurité par carte de crédit, PayPal et virement bancaire.",
      "privacy.hero.title": "Politique de Confidentialité",
      "privacy.hero.description": "La sécurité de vos données personnelles est très importante pour nous. Cette politique explique comment vos données sont collectées, utilisées et protégées.",
      "privacy.overview.title": "Aperçu",
      "privacy.overview.content": "Cette Politique de confidentialité décrit nos politiques et procédures concernant la collecte, l'utilisation et la divulgation de vos informations lorsque vous utilisez notre Service. Elle vous informe également sur vos droits en matière de confidentialité et sur la manière dont la loi vous protège.",
      "privacy.data.title": "Données Que Nous Collectons",
      "privacy.data.personal.title": "Informations Personnelles",
      "privacy.data.personal.name": "Nom et prénom",
      "privacy.data.personal.email": "Adresse e-mail",
      "privacy.data.personal.phone": "Numéro de téléphone",
      "privacy.data.personal.payment": "Informations de paiement",
      "privacy.data.usage.title": "Données d'Utilisation",
      "privacy.data.usage.ip": "Adresse IP",
      "privacy.data.usage.browser": "Type de navigateur",
      "privacy.data.usage.device": "Informations sur l'appareil",
      "privacy.data.usage.stats": "Statistiques d'utilisation",
      "privacy.security.title": "Sécurité des Données",
      "privacy.security.ssl.title": "Cryptage SSL",
      "privacy.security.ssl.content": "Tous les transferts de données sont protégés par un cryptage SSL 256 bits.",
      "privacy.security.servers.title": "Serveurs Sécurisés",
      "privacy.security.servers.content": "Vos données sont stockées sur des serveurs sécurisés certifiés ISO 27001.",
      "privacy.security.access.title": "Contrôle d'Accès",
      "privacy.security.access.content": "Seul le personnel autorisé peut accéder à vos données.",
      "privacy.usage.title": "Utilisation des Données",
      "privacy.usage.intro": "Nous utilisons les données que nous collectons aux fins suivantes :",
      "privacy.usage.service.title": "Fourniture de Service",
      "privacy.usage.service.content": "Pour fournir et gérer nos services eSIM",
      "privacy.usage.support.title": "Support Client",
      "privacy.usage.support.content": "Pour fournir un support technique et un service client",
      "privacy.usage.security.title": "Sécurité",
      "privacy.usage.security.content": "Pour protéger votre compte et nos services",
      "privacy.usage.improvement.title": "Amélioration",
      "privacy.usage.improvement.content": "Pour améliorer nos services et ajouter de nouvelles fonctionnalités",
      "privacy.sharing.title": "Partage de Données",
      "privacy.sharing.intro": "Nous ne partageons pas vos données personnelles avec des tiers, mais un partage peut être nécessaire dans les cas suivants :",
      "privacy.sharing.legal": "En cas d'obligation légale",
      "privacy.sharing.providers": "Avec nos prestataires de services (comme les processeurs de paiement)",
      "privacy.sharing.threats": "Pour prévenir les menaces de sécurité",
      "privacy.sharing.consent": "Avec votre consentement explicite",
      "privacy.rights.title": "Vos Droits",
      "privacy.rights.access.title": "Droit d'Accès",
      "privacy.rights.access.content": "Vous pouvez demander l'accès aux données que nous détenons à votre sujet.",
      "privacy.rights.correction.title": "Droit de Rectification",
      "privacy.rights.correction.content": "Nous pouvons corriger vos données inexactes ou incomplètes.",
      "privacy.rights.deletion.title": "Droit de Suppression",
      "privacy.rights.deletion.content": "Nous pouvons supprimer vos données sous certaines conditions.",
      "privacy.rights.objection.title": "Droit d'Opposition",
      "privacy.rights.objection.content": "Vous pouvez vous opposer à nos activités de traitement de données.",
      "privacy.contact.title": "Contact",
      "privacy.contact.intro": "Si vous avez des questions concernant cette Politique de confidentialité, vous pouvez nous contacter via les canaux suivants :",
      "nav.about": "À propos",
      "nav.contact": "Contact",
      "nav.privacy": "Confidentialité",
      "nav.login": "Connexion",
      "nav.account": "Mon Compte",
      "nav.logout": "Se déconnecter",
      "auth.brand.eyebrow": "COUVERTURE MONDIALE",
      "auth.brand.title": "Internet dès votre atterrissage dans plus de 150 pays.",
      "auth.brand.subtitle": "Pas de SIM physique, pas de frais d'itinérance. Activez votre eSIM en quelques secondes.",
      "auth.login.eyebrow": "CONNEXION AU COMPTE",
      "auth.login.title": "Bon retour",
      "auth.login.subtitle": "Gérez vos eSIM et découvrez-en de nouvelles.",
      "auth.signup.eyebrow": "NOUVEAU COMPTE",
      "auth.signup.title": "Rejoignez-nous",
      "auth.signup.subtitle": "Préparez votre première eSIM en quelques étapes.",
      "auth.field.identifier": "E-mail ou téléphone",
      "auth.field.identifier.ph": "exemple@email.com ou +90…",
      "auth.field.email": "E-mail",
      "auth.field.email.ph": "exemple@email.com",
      "auth.field.fullName": "Nom et prénom",
      "auth.field.fullName.ph": "Votre nom et prénom",
      "auth.field.password": "Mot de passe",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "Se connecter",
      "auth.action.loggingIn": "Connexion en cours…",
      "auth.action.signup": "Créer un compte",
      "auth.action.signingUp": "Création du compte…",
      "auth.toSignup.q": "Vous n'avez pas de compte ?",
      "auth.toSignup.link": "S'inscrire",
      "auth.toLogin.q": "Vous avez déjà un compte ?",
      "auth.toLogin.link": "Se connecter",
      "auth.password.show": "Afficher le mot de passe",
      "auth.password.hide": "Masquer le mot de passe",
      "auth.terms.prefix": "En continuant, j'accepte les ",
      "auth.terms.link": "Conditions d'Utilisation et la Politique de Confidentialité",
      "auth.terms.suffix": ".",
      "auth.error.required": "Veuillez remplir les champs obligatoires.",
      "auth.error.terms": "Vous devez accepter les conditions pour continuer.",
      "verify.eyebrow": "VÉRIFICATION DE L'E-MAIL",
      "verify.title": "Vérifiez votre e-mail",
      "verify.subtitle": "Nous avons envoyé un code à 6 chiffres à l'adresse {{email}}. Saisissez le code pour vérifier.",
      "verify.code": "Code de vérification",
      "verify.code.ph": "••••••",
      "verify.action": "Vérifier",
      "verify.verifying": "Vérification en cours…",
      "verify.resend": "Renvoyer le code",
      "verify.resendIn": "Renvoyer dans {{seconds}} s",
      "verify.resent": "Nouveau code envoyé.",
      "verify.skip": "Ignorer pour le moment",
      "auth.forgot.link": "Mot de passe oublié ?",
      "forgot.eyebrow": "RÉINITIALISATION DU MOT DE PASSE",
      "forgot.email.title": "Réinitialiser votre mot de passe",
      "forgot.email.subtitle": "Saisissez l'adresse e-mail de votre compte ; nous vous enverrons un code de réinitialisation à 6 chiffres.",
      "forgot.email.action": "Envoyer le code",
      "forgot.email.sending": "Envoi en cours…",
      "forgot.reset.title": "Définissez votre nouveau mot de passe",
      "forgot.reset.subtitle": "Saisissez le code à 6 chiffres que nous avons envoyé à {{email}} et votre nouveau mot de passe.",
      "forgot.reset.action": "Mettre à jour le mot de passe",
      "forgot.reset.updating": "Mise à jour en cours…",
      "forgot.field.code": "Code de réinitialisation",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "Nouveau mot de passe",
      "forgot.field.newPassword.ph": "Au moins 6 caractères",
      "forgot.resend": "Renvoyer le code",
      "forgot.resendIn": "Renvoyer dans {{seconds}} s",
      "forgot.resent": "Nouveau code envoyé.",
      "forgot.backToLogin": "Retour à la connexion",
      "forgot.changeEmail": "Changer d'e-mail",
      "forgot.help.noMail": "Si le code n'est pas arrivé, vérifiez vos spams ou vérifiez votre adresse e-mail.",
      "reset.RESET_CODE_SENT": "Code envoyé. Veuillez vérifier votre e-mail.",
      "reset.RATE_LIMITED": "Vous avez fait trop de tentatives. Veuillez patienter un moment et réessayer.",
      "reset.MAIL_SEND_FAILED": "Un problème est survenu. Veuillez réessayer plus tard.",
      "reset.RESET_CODE_VALID": "Code vérifié.",
      "reset.INVALID_RESET_CODE": "Code incorrect. Veuillez réessayer.",
      "reset.EXPIRED_RESET_CODE": "Le code a expiré. Veuillez demander un nouveau code.",
      "reset.WEAK_PASSWORD": "Le mot de passe doit comporter au moins 6 caractères.",
      "reset.PASSWORD_RESET_SUCCESS": "Votre mot de passe a été mis à jour. Vous pouvez vous connecter avec votre nouveau mot de passe.",
      "reset.generic": "Un problème est survenu. Veuillez réessayer.",
      "login.resetSuccess": "Votre mot de passe a été mis à jour. Vous pouvez vous connecter avec votre nouveau mot de passe.",
      "store.nav.shop": "Boutique",
      "home.hero.title1": "Connectez-vous en quelques minutes,",
      "home.hero.title2": "restez au-delà des frontières.",
      "home.hero.subtitle": "Des forfaits eSIM fiables valables dans plus de 190 pays. Pas de SIM physique, pas de frais d'itinérance.",
      "home.search.placeholder": "Où voyagez-vous ?",
      "home.tabs.local": "eSIM locales",
      "home.tabs.regional": "eSIM régionales",
      "home.tabs.lifetime": "eSIM à vie",
      "home.empty": "Aucun résultat ne correspond à votre recherche.",
      "home.error.title": "Impossible de charger le contenu",
      "home.error.retry": "Réessayer",
      "home.from": "à partir de",
      "home.popular": "Destinations populaires",
      "home.coverage": "190+ pays · activation instantanée",
      "home.detail.soon": "Les forfaits de cette sélection seront bientôt listés ici.",
      "home.detail.back": "Retour à la boutique",
      "detail.plans": "Forfaits",
      "detail.count": "{{count}} forfait(s)",
      "detail.validity": "{{days}} jours",
      "detail.validityLifetime": "Sans expiration",
      "detail.buy": "Acheter",
      "detail.empty": "Il n'y a actuellement aucun forfait pour cette sélection.",
      "detail.checkoutSoon": "Le flux de paiement sera ajouté très prochainement.",
      "detail.loginToBuy": "Vous devez vous connecter pour acheter.",
      "detail.basicFeatures": "Caractéristiques de base",
      "detail.dataAmount": "Quantité de données",
      "detail.validityLabel": "Période de validité",
      "detail.coverageArea": "Zone de couverture",
      "detail.activationNetworks": "Activation et Réseaux",
      "detail.activationMethod": "Méthode d'activation",
      "detail.esimActivation": "eSIM — instantané avec code QR",
      "detail.supportedNetworks": "Réseaux pris en charge",
      "detail.description": "Description",
      "detail.price": "Prix",
      "authprompt.title": "Connectez-vous pour continuer",
      "authprompt.message": "Connectez-vous à votre compte pour acheter une eSIM ou créez un nouveau compte en quelques secondes.",
      "authprompt.close": "Fermer",
      "footer.tagline": "Une eSIM mondiale rapide, sécurisée et abordable. Connectez-vous à Internet dès votre atterrissage.",
      "footer.explore": "Explorer",
      "footer.support": "Support",
      "footer.legal": "Légal",
      "footer.shop": "Boutique",
      "footer.help": "Foire Aux Questions",
      "footer.terms": "Conditions d'Utilisation",
      "footer.rights": "© {{year}} Utkan eSIM. Tous droits réservés.",
      "footer.apps": "Télécharger l'application",
      "whatsapp.label": "Écrire sur WhatsApp",
      "whatsapp.message": "Bonjour, j'ai une demande de support eSIM.",
      "notfound.eyebrow": "AUCUN SIGNAL",
      "notfound.title": "Cette page est inaccessible",
      "notfound.message": "La page que vous recherchez a peut-être été déplacée ou n'a jamais existé. Laissez-nous vous ramener dans la zone de couverture.",
      "order.congrats": "Félicitations !",
      "order.message": "Votre eSIM est prête. Vous pouvez la configurer en quelques étapes avec le code QR ci-dessous.",
      "order.details": "Résumé de la commande",
      "order.activation": "Activation",
      "order.activationDesc": "Pour configurer votre eSIM, scannez le code QR avec l'appareil photo de votre appareil ou saisissez manuellement le code de configuration.",
      "order.qrTitle": "Code QR eSIM",
      "order.manualLabel": "Code de configuration",
      "order.copy": "Copier",
      "order.copied": "Copié",
      "order.howTo": "Comment l'activer ?",
      "order.step1": "Allez dans Réglages > Données cellulaires / mobiles > Ajouter une eSIM sur votre appareil.",
      "order.step2": "Sélectionnez « Utiliser un code QR » et scannez le code QR ci-dessus (ou saisissez manuellement le code de configuration).",
      "order.step3": "Une fois l'installation terminée, activez votre forfait eSIM.",
      "order.step4": "Assurez-vous que l'itinérance des données est activée — vous êtes maintenant connecté !",
      "order.cta": "Retour à la page d'accueil",
      "checkout.title": "Paiement",
      "checkout.summary": "Résumé de la commande",
      "checkout.total": "Total",
      "checkout.eurNote": "Le montant est facturé en euros (€) sur PayPal.",
      "checkout.processing": "Vérification de votre paiement…",
      "checkout.error": "Le paiement n'a pas pu être effectué. Veuillez réessayer.",
      "checkout.cancelled": "Paiement annulé.",
      "account.title": "Mon Compte",
      "account.tab.profile": "Profil",
      "account.tab.esims": "Mes eSIM",
      "account.tab.security": "Sécurité",
      "account.profile.title": "Informations du profil",
      "account.field.phone": "Téléphone",
      "account.field.phone.ph": "+90…",
      "account.memberSince": "Membre depuis",
      "account.save": "Enregistrer",
      "account.saving": "Enregistrement en cours…",
      "account.saved": "Vos informations ont été mises à jour.",
      "account.esims.title": "Mes eSIM",
      "account.esims.empty": "Vous n'avez pas encore d'eSIM.",
      "account.esims.emptyCta": "Parcourir la boutique",
      "account.esims.data": "Données",
      "account.esims.expires": "Date de fin",
      "account.esims.viewQr": "Afficher le code QR",
      "account.esims.hideQr": "Masquer le code QR",
      "account.esims.active": "Actif",
      "account.esims.passive": "Inactif",
      "account.esims.noActive": "Vous n'avez pas d'eSIM active.",
      "account.esims.noPassive": "Vous n'avez pas d'eSIM inactive.",
      "account.esims.readyHint": "Prêt à l'emploi — la durée commence à la première utilisation.",
      "account.esims.unavailableHint": "Le statut n'a pas pu être chargé pour le moment. Veuillez réessayer plus tard.",
      "esimStatus.active": "Actif",
      "esimStatus.readyToUse": "Prêt à l'emploi",
      "esimStatus.inactive": "Inactif",
      "esimStatus.unavailable": "Impossible de charger le statut",
      "account.security.title": "Changer le mot de passe",
      "account.field.oldPassword": "Mot de passe actuel",
      "account.field.newPassword": "Nouveau mot de passe",
      "account.field.confirmPassword": "Nouveau mot de passe (répéter)",
      "account.changePassword": "Mettre à jour le mot de passe",
      "account.passwordChanged": "Votre mot de passe a été mis à jour.",
      "account.error.passwordMismatch": "Les nouveaux mots de passe ne correspondent pas.",
      "account.danger.title": "Actions du compte",
      "account.delete": "Supprimer le compte",
      "account.delete.confirm": "Vous êtes sur le point de supprimer définitivement votre compte. Cette action est irréversible.",
      "account.delete.confirmBtn": "Oui, supprimer",
      "account.cancel": "Annuler",
      "esimDetail.back": "Retour",
      "esimDetail.dataUsage": "Utilisation des données",
      "esimDetail.left": "restant",
      "esimDetail.leftData": "Données restantes",
      "esimDetail.usedData": "Utilisé",
      "esimDetail.totalData": "Données totales",
      "esimDetail.qrDesc": "Configurez votre eSIM en scannant ce code QR avec l'appareil photo de votre appareil.",
      "esimDetail.validity": "Validité",
      "esimDetail.daysLeft": "{{days}} jour(s) restant(s)",
      "esimDetail.expired": "Expiré",
      "esimDetail.notYetActive": "Pas encore actif",
      "esimDetail.leftDate": "Temps restant",
      "esimDetail.activationDate": "Date d'activation",
      "esimDetail.endDate": "Date de fin",
      "esimDetail.technical": "Informations techniques",
      "esimDetail.activationCode": "Code d'activation (Android)",
      "esimDetail.smdp": "Adresse SM-DP+ (iOS)",
      "esimDetail.matchingId": "ID de correspondance (iOS)",
      "esimDetail.support": "Support technique",
      "esimDetail.supportDesc": "Un problème ? Laissez-nous vous aider.",
      "esimDetail.email": "Envoyer un e-mail",
      "guide.eyebrow": "GUIDE eSIM",
      "guide.title": "Qu'est-ce qu'une eSIM et comment l'installer ?",
      "guide.intro.title": "Qu'est-ce qu'une eSIM ?",
      "guide.intro.body": "L'eSIM est une SIM numérique intégrée à votre appareil qui fonctionne sans avoir besoin d'une carte SIM physique. Elle configure votre ligne en quelques secondes en scannant un code QR ; vous vous connectez à Internet dans plus de 190 pays sans changer de carte et sans frais d'itinérance.",
      "guide.steps.title": "Comment l'activer ?",
      "guide.devices.title": "Appareils pris en charge",
      "guide.devices.desc": "Votre appareil doit être compatible avec l'eSIM pour que l'eSIM fonctionne. Vérifiez votre marque.",
      "guide.faq.title": "Foire aux questions",
      "nav.guide": "Guide eSIM",
      "currency.label": "Devise",
      "staticPage.loading": "Chargement de la page...",
      "staticPage.errorTitle": "Une Erreur est Survenue",
      "staticPage.retry": "Réessayer",
      "staticPage.loadFailed": "Le contenu de la page n'a pas pu être chargé. Veuillez réessayer plus tard.",
      "last.updated": "Dernière mise à jour : 8 juillet 2024",

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      "home.tabs.unlimited": "eSIM illimitées",
      "detail.unlimited": "Illimité",
      "detail.unlimitedNote": "Ce forfait n'a aucune limite de données — internet illimité pendant toute la durée de validité.",
      "detail.notPriced": "Ce forfait n'est pas disponible à l'achat sur le web pour le moment.",
      "checkout.priceUpdated": "Le prix de ce forfait a changé. Veuillez retourner à la boutique et le sélectionner à nouveau.",
      "order.pending.title": "Votre eSIM est en préparation",
      "order.pending.message": "Votre paiement a été accepté. Les forfaits illimités peuvent prendre quelques minutes à s'activer.",
      "order.pending.waiting": "Vérification du statut de votre commande…",
      "order.pending.ready": "Votre eSIM est prête !",
      "order.pending.timeout": "Cela prend plus de temps que prévu. Votre paiement est sécurisé — votre eSIM apparaîtra dans « Mes eSIM » dès qu'elle sera prête.",
      "order.pending.cta": "Aller à Mes eSIM",
      "account.esims.unlimited": "Illimité",
      "account.esims.unlimitedHint": "Données illimitées — ce forfait n'a aucune limite de données.",
      "esimDetail.unlimitedData": "Ce forfait n'a aucune limite de données ; voir le temps restant ci-dessous.",


      // Suppression de compte (/hesap-sil · /account-deletion) — exigence Google Play « Data deletion »
      "del.eyebrow": "Suppression de compte",
      "del.title": "Supprimer mon compte",
      "del.intro": "Vous pouvez supprimer définitivement votre compte Utkan eSIM et vos données personnelles ici. L'application n'est pas nécessaire — il suffit de vous connecter avec le compte à supprimer.",
      "del.deleted.title": "Données supprimées",
      "del.deleted.identity": "Vos nom, prénom, adresse e-mail et numéro de téléphone",
      "del.deleted.credentials": "Votre mot de passe et vos données de session",
      "del.deleted.codes": "Vos codes de vérification e-mail et de réinitialisation du mot de passe",
      "del.deleted.esim": "Votre numéro eSIM (MSISDN), votre code QR/d'activation et vos données d'utilisation",
      "del.kept.title": "Données conservées et pourquoi",
      "del.kept.orders": "Les justificatifs d'achat (numéro de commande, date, montant, statut du paiement) sont conservés pour répondre aux obligations fiscales et comptables. Ils ne contiennent ni votre nom, ni votre e-mail, ni vos informations de paiement — uniquement un identifiant qui ne peut pas vous être rattaché.",
      "del.kept.period": "Durée de conservation : 5 ans (loi turque sur la procédure fiscale, art. 253).",
      "del.warn.title": "Avant de supprimer",
      "del.warn.irreversible": "Cette action est irréversible.",
      "del.warn.esim": "Les eSIM actives continuent de fonctionner sur votre appareil, mais vous n'aurez plus accès à votre code QR ni à votre volume de données restant. Enregistrez votre code QR avant la suppression.",
      "del.warn.rejoin": "Vous pouvez vous réinscrire avec la même adresse e-mail, mais vos anciennes eSIM n'apparaîtront pas dans le nouveau compte.",
      "del.support": "Si vous ne parvenez pas à vous connecter, vous pouvez aussi demander la suppression par e-mail :",
      "del.login.title": "Connectez-vous d'abord",
      "del.login.subtitle": "Saisissez votre e-mail et votre mot de passe afin de confirmer que ce compte est bien le vôtre.",
      "del.login.action": "Se connecter",
      "del.login.loading": "Connexion...",
      "del.forgot": "Mot de passe oublié ?",
      "del.confirm.title": "Êtes-vous sûr ?",
      "del.confirm.subtitle": "Le compte {{email}} et vos données personnelles seront définitivement supprimés.",
      "del.confirm.field": "Saisissez à nouveau votre adresse e-mail pour confirmer",
      "del.confirm.action": "Supprimer définitivement mon compte",
      "del.confirm.deleting": "Suppression...",
      "del.confirm.cancel": "Annuler",
      "del.done.title": "Votre compte a été supprimé",
      "del.done.body": "Vos données personnelles ont été définitivement supprimées.",
      "del.done.retained": "Vos données personnelles ont été définitivement supprimées. {{n}} justificatif(s) d'achat ont été conservés pour des raisons légales ; ils ne peuvent pas vous être rattachés.",
      "del.done.home": "Retour à la boutique",
      "del.error.required": "Veuillez saisir votre e-mail et votre mot de passe.",
      "del.error.credentials": "E-mail ou mot de passe incorrect.",
      "del.error.suspended": "Votre compte a été suspendu. Veuillez contacter le support.",
      "del.error.session": "Votre session a expiré. Veuillez vous reconnecter.",
      "del.error.network": "Connexion impossible. Vérifiez votre connexion Internet et réessayez.",
      "del.error.generic": "Une erreur s'est produite. Veuillez réessayer.",
      "footer.deleteAccount": "Supprimer mon compte",


      // Forfaits voix (données + appels et SMS illimités) — docs/ses-paketleri.md
      "home.tabs.voice": "eSIM avec appels",
      "detail.voice": "Appels + SMS",
      "detail.voiceNote": "Ce forfait inclut les appels et SMS illimités en plus des données : une seule eSIM pour Internet et les appels.",
      "detail.calls": "Appels",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "Appels illimités",
      "plan.unlimitedSms": "SMS illimités",
      "plan.minutes": "{{n}} min d'appels",
      "plan.sms": "{{n}} SMS",

      // Hercules — appels illimités en Europe (docs/hercules-sayfasi.md)
      "hercules.subtitle": "Appels, SMS et données illimités dans {{n}} pays européens — une seule eSIM.",
      "hercules.coverageTitle": "Pays couverts ({{n}})",
      "hercules.promo.desc": "Appels et SMS illimités dans {{n}} pays, avec 20 à 100 Go de données.",
      "hercules.promo.cta": "Découvrir",
      "loading": "Chargement..."
    }
  },
  es: {
    translation: {
      "language.title": "Idioma",

      "hero.title": "Utkan eSIM",
      "hero.subtitle": "El Futuro de la Conectividad Digital",
      "hero.description": "Eliminamos las fronteras con una experiencia de conectividad digital de nueva generación.",
      "hero.description2": "Soluciones eSIM rápidas, seguras y asequibles en todo el mundo.",
      "features.countries": "150+ Países",
      "features.activation": "Activación Instantánea",
      "features.support": "Soporte 24/7",
      "countdown.title": "¡Nuestro Sitio Web Próximamente!",
      "countdown.days": "Días",
      "countdown.hours": "Horas",
      "countdown.minutes": "Minutos",
      "countdown.seconds": "Segundos",
      "countdown.launch": "¡Nuestro Sitio Web Está Abierto!",
      "countdown.loading": "Cargando...",
      "apps.title": "Nuestras Aplicaciones Móviles",
      "apps.ios.label": "Descárgalo en la",
      "apps.ios.name": "App Store",
      "apps.android.label": "DISPONIBLE EN",
      "apps.android.name": "Google Play",
      "contact.title": "Contáctenos antes del lanzamiento",
      "contact.whatsapp": "WhatsApp: +90 540 155 13 33",
      "contact.email": "Correo electrónico: info@utkanesim.com",
      "about.hero.title": "Acerca de Utkan eSIM",
      "about.hero.description": "La seguridad de sus datos personales es muy importante para nosotros. Esta política explica cómo se recopilan, utilizan y protegen sus datos.",
      "about.story.title": "Nuestra Historia",
      "about.story.content": "Fundada en 2024 por un equipo de viajeros apasionados y entusiastas de la tecnología, Utkan eSIM tiene como objetivo revolucionar la forma en que las personas se conectan a Internet en el extranjero. Al ofrecer planes de datos eSIM confiables y de alta calidad para más de 190 países y regiones, garantizamos su acceso rápido a Internet desde el momento en que aterriza.",
      "about.mission.title": "Nuestra Misión",
      "about.mission.content": "Proporcionar a los viajeros una conectividad global simple, asequible e instantánea, permitiéndoles explorar, trabajar y mantenerse conectados sin fronteras.",
      "about.vision.title": "Nuestra Visión",
      "about.vision.content": "Ser la principal plataforma global de soluciones de conectividad digital, haciendo del mundo un lugar más pequeño y más conectado para todos.",
      "about.features.title": "¿Por Qué Elegirnos?",
      "about.features.instant.title": "Entrega Instantánea",
      "about.features.instant.content": "Obtenga su eSIM al instante con un código QR después de la compra.",
      "about.features.global.title": "Cobertura Global",
      "about.features.global.content": "Planes de datos para más de 190 países y regiones.",
      "about.features.affordable.title": "Precios Asequibles",
      "about.features.affordable.content": "Ahorre hasta un 90% en tarifas de roaming.",
      "about.features.support.title": "Soporte 24/7",
      "about.features.support.content": "Nuestro equipo de soporte dedicado siempre está a su disposición.",
      "about.features.secure.title": "Conexión Segura",
      "about.features.secure.content": "Conexión protegida por los últimos protocolos de seguridad.",
      "about.features.fast.title": "Internet Rápido",
      "about.features.fast.content": "Experiencia de Internet ininterrumpida a velocidades 4G/5G.",
      "about.cta.title": "Únase al Futuro de la Conectividad Digital",
      "about.cta.content": "Gracias por elegir Utkan eSIM. ¡Buen viaje!",
      "about.cta.whatsapp": "Contactar vía WhatsApp",
      "about.cta.email": "Enviar un Correo Electrónico",
      "contact.hero.title": "Contáctenos",
      "contact.hero.description": "Si tiene preguntas sobre nuestras eSIM, necesita soporte técnico o simplemente desea dejar un comentario, estaremos encantados de escucharle.",
      "contact.info.title": "Nuestra Información de Contacto",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "Soporte Rápido 24/7",
      "contact.email.title": "Correo Electrónico",
      "contact.email.subtitle": "Contacto General",
      "contact.support.title": "Soporte Técnico",
      "contact.support.subtitle": "Problemas con eSIM",
      "contact.business.title": "Asociación Comercial",
      "contact.business.subtitle": "Contacto Corporativo",
      "contact.hours.title": "Horario de Soporte",
      "contact.hours.subtitle": "Soporte Técnico 24/7",
      "contact.hours.detail": "Lunes - Domingo: 00:00 - 23:59",
      "contact.form.title": "Enviar un Mensaje",
      "contact.form.name": "Nombre y Apellido",
      "contact.form.name.placeholder": "Ingrese su nombre y apellido",
      "contact.form.email": "Su Dirección de Correo Electrónico",
      "contact.form.email.placeholder": "ejemplo@email.com",
      "contact.form.subject": "Asunto",
      "contact.form.subject.placeholder": "Seleccione un asunto",
      "contact.form.subject.general": "Información General",
      "contact.form.subject.technical": "Soporte Técnico",
      "contact.form.subject.billing": "Preguntas de Facturación",
      "contact.form.subject.partnership": "Asociación Comercial",
      "contact.form.subject.feedback": "Comentarios",
      "contact.form.message": "Su Mensaje",
      "contact.form.message.placeholder": "Escriba su mensaje aquí...",
      "contact.form.submit": "Enviar Mensaje",
      "contact.faq.title": "Preguntas Frecuentes",
      "contact.faq.esim.title": "¿Cómo funciona la eSIM?",
      "contact.faq.esim.content": "La eSIM es una tarjeta SIM digital que funciona en su teléfono sin necesidad de una tarjeta SIM física. Se activa al instante con un código QR.",
      "contact.faq.phones.title": "¿Qué teléfonos son compatibles con eSIM?",
      "contact.faq.phones.content": "Los modelos iPhone XS y superiores, Samsung Galaxy S20 y superiores, y Google Pixel 3 y superiores son compatibles con eSIM.",
      "contact.faq.validity.title": "¿Por cuánto tiempo es válido mi plan de datos?",
      "contact.faq.validity.content": "El período de validez de los planes varía de 1 a 30 días según el plan que elija.",
      "contact.faq.payment.title": "¿Cómo se realiza el pago?",
      "contact.faq.payment.content": "Puede pagar de forma segura con tarjeta de crédito, PayPal y transferencia bancaria.",
      "privacy.hero.title": "Política de Privacidad",
      "privacy.hero.description": "La seguridad de sus datos personales es muy importante para nosotros. Esta política explica cómo se recopilan, utilizan y protegen sus datos.",
      "privacy.overview.title": "Descripción General",
      "privacy.overview.content": "Esta Política de Privacidad describe nuestras políticas y procedimientos sobre la recopilación, el uso y la divulgación de su información cuando utiliza nuestro Servicio. También le informa sobre sus derechos de privacidad y cómo la ley lo protege.",
      "privacy.data.title": "Datos que Recopilamos",
      "privacy.data.personal.title": "Información Personal",
      "privacy.data.personal.name": "Nombre y apellido",
      "privacy.data.personal.email": "Dirección de correo electrónico",
      "privacy.data.personal.phone": "Número de teléfono",
      "privacy.data.personal.payment": "Información de pago",
      "privacy.data.usage.title": "Datos de Uso",
      "privacy.data.usage.ip": "Dirección IP",
      "privacy.data.usage.browser": "Tipo de navegador",
      "privacy.data.usage.device": "Información del dispositivo",
      "privacy.data.usage.stats": "Estadísticas de uso",
      "privacy.security.title": "Seguridad de los Datos",
      "privacy.security.ssl.title": "Cifrado SSL",
      "privacy.security.ssl.content": "Todas las transferencias de datos están protegidas con cifrado SSL de 256 bits.",
      "privacy.security.servers.title": "Servidores Seguros",
      "privacy.security.servers.content": "Sus datos se almacenan en servidores seguros con certificación ISO 27001.",
      "privacy.security.access.title": "Control de Acceso",
      "privacy.security.access.content": "Solo el personal autorizado puede acceder a sus datos.",
      "privacy.usage.title": "Uso de los Datos",
      "privacy.usage.intro": "Utilizamos los datos que recopilamos para los siguientes propósitos:",
      "privacy.usage.service.title": "Prestación de Servicios",
      "privacy.usage.service.content": "Para proporcionar y gestionar nuestros servicios eSIM",
      "privacy.usage.support.title": "Soporte al Cliente",
      "privacy.usage.support.content": "Para proporcionar soporte técnico y servicio al cliente",
      "privacy.usage.security.title": "Seguridad",
      "privacy.usage.security.content": "Para proteger su cuenta y nuestros servicios",
      "privacy.usage.improvement.title": "Mejora",
      "privacy.usage.improvement.content": "Para mejorar nuestros servicios y añadir nuevas funciones",
      "privacy.sharing.title": "Intercambio de Datos",
      "privacy.sharing.intro": "No compartimos sus datos personales con terceros, pero puede ser necesario compartirlos en los siguientes casos:",
      "privacy.sharing.legal": "En caso de obligación legal",
      "privacy.sharing.providers": "Con nuestros proveedores de servicios (como procesadores de pagos)",
      "privacy.sharing.threats": "Para prevenir amenazas a la seguridad",
      "privacy.sharing.consent": "Con su consentimiento explícito",
      "privacy.rights.title": "Sus Derechos",
      "privacy.rights.access.title": "Derecho de Acceso",
      "privacy.rights.access.content": "Puede solicitar acceso a los datos que tenemos sobre usted.",
      "privacy.rights.correction.title": "Derecho de Rectificación",
      "privacy.rights.correction.content": "Podemos corregir sus datos inexactos o incompletos.",
      "privacy.rights.deletion.title": "Derecho de Supresión",
      "privacy.rights.deletion.content": "Podemos eliminar sus datos bajo ciertas condiciones.",
      "privacy.rights.objection.title": "Derecho de Oposición",
      "privacy.rights.objection.content": "Puede oponerse a nuestras actividades de procesamiento de datos.",
      "privacy.contact.title": "Contacto",
      "privacy.contact.intro": "Si tiene alguna pregunta sobre esta Política de Privacidad, puede contactarnos a través de los siguientes canales:",
      "nav.about": "Acerca de",
      "nav.contact": "Contacto",
      "nav.privacy": "Privacidad",
      "nav.login": "Iniciar Sesión",
      "nav.account": "Mi Cuenta",
      "nav.logout": "Cerrar Sesión",
      "auth.brand.eyebrow": "COBERTURA GLOBAL",
      "auth.brand.title": "Internet en el momento en que aterrizas en más de 150 países.",
      "auth.brand.subtitle": "Sin SIM física, sin facturas de roaming. Activa tu eSIM en segundos.",
      "auth.login.eyebrow": "INICIAR SESIÓN EN LA CUENTA",
      "auth.login.title": "Bienvenido de nuevo",
      "auth.login.subtitle": "Gestiona tus eSIM y descubre nuevas.",
      "auth.signup.eyebrow": "NUEVA CUENTA",
      "auth.signup.title": "Únete a nosotros",
      "auth.signup.subtitle": "Prepara tu primera eSIM en unos pocos pasos.",
      "auth.field.identifier": "Correo electrónico o teléfono",
      "auth.field.identifier.ph": "ejemplo@email.com o +34…",
      "auth.field.email": "Correo electrónico",
      "auth.field.email.ph": "ejemplo@email.com",
      "auth.field.fullName": "Nombre y apellido",
      "auth.field.fullName.ph": "Tu nombre y apellido",
      "auth.field.password": "Contraseña",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "Iniciar sesión",
      "auth.action.loggingIn": "Iniciando sesión…",
      "auth.action.signup": "Crear cuenta",
      "auth.action.signingUp": "Creando cuenta…",
      "auth.toSignup.q": "¿No tienes cuenta?",
      "auth.toSignup.link": "Regístrate",
      "auth.toLogin.q": "¿Ya tienes una cuenta?",
      "auth.toLogin.link": "Inicia sesión",
      "auth.password.show": "Mostrar contraseña",
      "auth.password.hide": "Ocultar contraseña",
      "auth.terms.prefix": "Al continuar, acepto los ",
      "auth.terms.link": "Términos de Uso y la Política de Privacidad",
      "auth.terms.suffix": ".",
      "auth.error.required": "Por favor, completa los campos requeridos.",
      "auth.error.terms": "Debes aceptar los términos para continuar.",
      "verify.eyebrow": "VERIFICACIÓN DE CORREO ELECTRÓNICO",
      "verify.title": "Verifica tu correo electrónico",
      "verify.subtitle": "Hemos enviado un código de 6 dígitos a {{email}}. Ingresa el código para verificar.",
      "verify.code": "Código de verificación",
      "verify.code.ph": "••••••",
      "verify.action": "Verificar",
      "verify.verifying": "Verificando…",
      "verify.resend": "Reenviar código",
      "verify.resendIn": "Reenviar en {{seconds}} s",
      "verify.resent": "Nuevo código enviado.",
      "verify.skip": "Omitir por ahora",
      "auth.forgot.link": "¿Olvidaste tu contraseña?",
      "forgot.eyebrow": "RESTABLECIMIENTO DE CONTRASEÑA",
      "forgot.email.title": "Restablece tu contraseña",
      "forgot.email.subtitle": "Ingresa la dirección de correo electrónico de tu cuenta; te enviaremos un código de restablecimiento de 6 dígitos.",
      "forgot.email.action": "Enviar código",
      "forgot.email.sending": "Enviando…",
      "forgot.reset.title": "Establece tu nueva contraseña",
      "forgot.reset.subtitle": "Ingresa el código de 6 dígitos que enviamos a {{email}} y tu nueva contraseña.",
      "forgot.reset.action": "Actualizar contraseña",
      "forgot.reset.updating": "Actualizando…",
      "forgot.field.code": "Código de restablecimiento",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "Nueva contraseña",
      "forgot.field.newPassword.ph": "Al menos 6 caracteres",
      "forgot.resend": "Reenviar código",
      "forgot.resendIn": "Reenviar en {{seconds}} s",
      "forgot.resent": "Nuevo código enviado.",
      "forgot.backToLogin": "Volver al inicio de sesión",
      "forgot.changeEmail": "Cambiar correo electrónico",
      "forgot.help.noMail": "Si no llegó el código, revisa tu carpeta de spam o verifica tu dirección de correo electrónico.",
      "reset.RESET_CODE_SENT": "Código enviado. Por favor, revisa tu correo electrónico.",
      "reset.RATE_LIMITED": "Has realizado demasiados intentos. Por favor, espera un momento y vuelve a intentarlo.",
      "reset.MAIL_SEND_FAILED": "Algo salió mal. Por favor, inténtalo de nuevo más tarde.",
      "reset.RESET_CODE_VALID": "Código verificado.",
      "reset.INVALID_RESET_CODE": "Código incorrecto. Por favor, inténtalo de nuevo.",
      "reset.EXPIRED_RESET_CODE": "El código ha expirado. Por favor, solicita un nuevo código.",
      "reset.WEAK_PASSWORD": "La contraseña debe tener al menos 6 caracteres.",
      "reset.PASSWORD_RESET_SUCCESS": "Tu contraseña ha sido actualizada. Puedes iniciar sesión con tu nueva contraseña.",
      "reset.generic": "Algo salió mal. Por favor, inténtalo de nuevo.",
      "login.resetSuccess": "Tu contraseña ha sido actualizada. Puedes iniciar sesión con tu nueva contraseña.",
      "store.nav.shop": "Tienda",
      "home.hero.title1": "Conéctate en unos minutos,",
      "home.hero.title2": "mantente más allá de las fronteras.",
      "home.hero.subtitle": "Planes eSIM confiables válidos en más de 190 países. Sin SIM física, sin facturas de roaming.",
      "home.search.placeholder": "¿A dónde viajas?",
      "home.tabs.local": "eSIMs locales",
      "home.tabs.regional": "eSIMs regionales",
      "home.tabs.lifetime": "eSIMs de por vida",
      "home.empty": "No se encontraron resultados que coincidan con su búsqueda.",
      "home.error.title": "No se pudo cargar el contenido",
      "home.error.retry": "Reintentar",
      "home.from": "desde",
      "home.popular": "Destinos populares",
      "home.coverage": "190+ países · activación instantánea",
      "home.detail.soon": "Los planes para esta selección se listarán aquí muy pronto.",
      "home.detail.back": "Volver a la tienda",
      "detail.plans": "Planes",
      "detail.count": "{{count}} plan(es)",
      "detail.validity": "{{days}} días",
      "detail.validityLifetime": "Sin caducidad",
      "detail.buy": "Comprar",
      "detail.empty": "Actualmente no hay planes para esta selección.",
      "detail.checkoutSoon": "El flujo de pago se añadirá muy pronto.",
      "detail.loginToBuy": "Debes iniciar sesión para comprar.",
      "detail.basicFeatures": "Características básicas",
      "detail.dataAmount": "Cantidad de datos",
      "detail.validityLabel": "Período de validez",
      "detail.coverageArea": "Área de cobertura",
      "detail.activationNetworks": "Activación y Redes",
      "detail.activationMethod": "Método de activación",
      "detail.esimActivation": "eSIM — instantáneo con código QR",
      "detail.supportedNetworks": "Redes compatibles",
      "detail.description": "Descripción",
      "detail.price": "Precio",
      "authprompt.title": "Inicia sesión para continuar",
      "authprompt.message": "Inicia sesión en tu cuenta para comprar una eSIM o crea una cuenta nueva en segundos.",
      "authprompt.close": "Cerrar",
      "footer.tagline": "eSIM rápida, segura y asequible en todo el mundo. Conéctate a Internet en cuanto aterrices.",
      "footer.explore": "Explorar",
      "footer.support": "Soporte",
      "footer.legal": "Legal",
      "footer.shop": "Tienda",
      "footer.help": "Preguntas Frecuentes",
      "footer.terms": "Términos de Uso",
      "footer.rights": "© {{year}} Utkan eSIM. Todos los derechos reservados.",
      "footer.apps": "Descargar la aplicación",
      "whatsapp.label": "Escribir por WhatsApp",
      "whatsapp.message": "Hola, tengo una solicitud de soporte para eSIM.",
      "notfound.eyebrow": "SIN SEÑAL",
      "notfound.title": "Esta página no está disponible",
      "notfound.message": "La página que buscas puede haber sido movida o nunca existió. Te llevaremos de vuelta al área de cobertura.",
      "order.congrats": "¡Felicidades!",
      "order.message": "Tu eSIM está lista. Puedes configurarla en unos pocos pasos con el código QR a continuación.",
      "order.details": "Resumen del pedido",
      "order.activation": "Activación",
      "order.activationDesc": "Para configurar tu eSIM, escanea el código QR con la cámara de tu dispositivo o ingresa manualmente el código de configuración.",
      "order.qrTitle": "Código QR de eSIM",
      "order.manualLabel": "Código de configuración",
      "order.copy": "Copiar",
      "order.copied": "Copiado",
      "order.howTo": "¿Cómo activarlo?",
      "order.step1": "Ve a Configuración > Datos celulares / móviles > Agregar eSIM en tu dispositivo.",
      "order.step2": "Selecciona \"Usar código QR\" y escanea el código QR de arriba (o ingresa manualmente el código de configuración).",
      "order.step3": "Una vez completada la instalación, activa tu plan eSIM.",
      "order.step4": "Asegúrate de que la itinerancia de datos esté activada — ¡ya estás conectado!",
      "order.cta": "Volver a la página principal",
      "checkout.title": "Pago",
      "checkout.summary": "Resumen del pedido",
      "checkout.total": "Total",
      "checkout.eurNote": "El monto se cobra en euros (€) en PayPal.",
      "checkout.processing": "Verificando tu pago…",
      "checkout.error": "No se pudo completar el pago. Por favor, inténtalo de nuevo.",
      "checkout.cancelled": "Pago cancelado.",
      "account.title": "Mi Cuenta",
      "account.tab.profile": "Perfil",
      "account.tab.esims": "Mis eSIMs",
      "account.tab.security": "Seguridad",
      "account.profile.title": "Información del perfil",
      "account.field.phone": "Teléfono",
      "account.field.phone.ph": "+34…",
      "account.memberSince": "Miembro desde",
      "account.save": "Guardar",
      "account.saving": "Guardando…",
      "account.saved": "Tu información ha sido actualizada.",
      "account.esims.title": "Mis eSIMs",
      "account.esims.empty": "Aún no tienes una eSIM.",
      "account.esims.emptyCta": "Explorar la tienda",
      "account.esims.data": "Datos",
      "account.esims.expires": "Fecha de finalización",
      "account.esims.viewQr": "Mostrar código QR",
      "account.esims.hideQr": "Ocultar código QR",
      "account.esims.active": "Activo",
      "account.esims.passive": "Inactivo",
      "account.esims.noActive": "No tienes eSIMs activas.",
      "account.esims.noPassive": "No tienes eSIMs inactivas.",
      "account.esims.readyHint": "Listo para usar — la duración comienza en el primer uso.",
      "account.esims.unavailableHint": "No se pudo cargar el estado en este momento. Inténtalo de nuevo más tarde.",
      "esimStatus.active": "Activo",
      "esimStatus.readyToUse": "Listo para usar",
      "esimStatus.inactive": "Inactivo",
      "esimStatus.unavailable": "No se pudo cargar el estado",
      "account.security.title": "Cambiar contraseña",
      "account.field.oldPassword": "Contraseña actual",
      "account.field.newPassword": "Nueva contraseña",
      "account.field.confirmPassword": "Nueva contraseña (repetir)",
      "account.changePassword": "Actualizar contraseña",
      "account.passwordChanged": "Tu contraseña ha sido actualizada.",
      "account.error.passwordMismatch": "Las nuevas contraseñas no coinciden.",
      "account.danger.title": "Acciones de la cuenta",
      "account.delete": "Eliminar cuenta",
      "account.delete.confirm": "Estás a punto de eliminar tu cuenta de forma permanente. Esta acción no se puede deshacer.",
      "account.delete.confirmBtn": "Sí, eliminar",
      "account.cancel": "Cancelar",
      "esimDetail.back": "Volver",
      "esimDetail.dataUsage": "Uso de datos",
      "esimDetail.left": "restante",
      "esimDetail.leftData": "Datos restantes",
      "esimDetail.usedData": "Usado",
      "esimDetail.totalData": "Datos totales",
      "esimDetail.qrDesc": "Configura tu eSIM escaneando este código QR con la cámara de tu dispositivo.",
      "esimDetail.validity": "Validez",
      "esimDetail.daysLeft": "{{days}} día(s) restante(s)",
      "esimDetail.expired": "Expirado",
      "esimDetail.notYetActive": "Aún no activo",
      "esimDetail.leftDate": "Tiempo restante",
      "esimDetail.activationDate": "Fecha de activación",
      "esimDetail.endDate": "Fecha de finalización",
      "esimDetail.technical": "Información técnica",
      "esimDetail.activationCode": "Código de activación (Android)",
      "esimDetail.smdp": "Dirección SM-DP+ (iOS)",
      "esimDetail.matchingId": "ID de coincidencia (iOS)",
      "esimDetail.support": "Soporte técnico",
      "esimDetail.supportDesc": "¿Tienes algún problema? Déjanos ayudarte.",
      "esimDetail.email": "Enviar un correo electrónico",
      "guide.eyebrow": "GUÍA DE eSIM",
      "guide.title": "¿Qué es una eSIM y cómo instalarla?",
      "guide.intro.title": "¿Qué es una eSIM?",
      "guide.intro.body": "Una eSIM es una SIM digital integrada en tu dispositivo que funciona sin necesidad de una tarjeta SIM física. Configura tu línea en segundos escaneando un código QR; te conectas a Internet en más de 190 países sin cambiar de tarjeta y sin facturas de roaming.",
      "guide.steps.title": "¿Cómo activarla?",
      "guide.devices.title": "Dispositivos compatibles",
      "guide.devices.desc": "Tu dispositivo debe ser compatible con eSIM para que funcione. Revisa tu marca.",
      "guide.faq.title": "Preguntas frecuentes",
      "nav.guide": "Guía de eSIM",
      "currency.label": "Moneda",
      "staticPage.loading": "Cargando página...",
      "staticPage.errorTitle": "Se Produjo un Error",
      "staticPage.retry": "Reintentar",
      "staticPage.loadFailed": "No se pudo cargar el contenido de la página. Por favor, inténtelo de nuevo más tarde.",
      "last.updated": "Última actualización: 8 de julio de 2024",

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      "home.tabs.unlimited": "eSIM ilimitadas",
      "detail.unlimited": "Ilimitado",
      "detail.unlimitedNote": "Este paquete no tiene límite de datos: internet ilimitado durante toda la validez.",
      "detail.notPriced": "Este paquete no está disponible para compra web en este momento.",
      "checkout.priceUpdated": "El precio de este paquete ha cambiado. Vuelve a la tienda y selecciónalo de nuevo.",
      "order.pending.title": "Tu eSIM se está preparando",
      "order.pending.message": "Tu pago se ha completado. Los paquetes ilimitados pueden tardar unos minutos en activarse.",
      "order.pending.waiting": "Comprobando el estado de tu pedido…",
      "order.pending.ready": "¡Tu eSIM está lista!",
      "order.pending.timeout": "Está tardando más de lo previsto. Tu pago está seguro: tu eSIM aparecerá en «Mis eSIM» en cuanto esté lista.",
      "order.pending.cta": "Ir a Mis eSIM",
      "account.esims.unlimited": "Ilimitado",
      "account.esims.unlimitedHint": "Datos ilimitados: este paquete no tiene límite de datos.",
      "esimDetail.unlimitedData": "Este paquete no tiene límite de datos; consulta el tiempo restante abajo.",


      // Eliminación de cuenta (/hesap-sil · /account-deletion) — requisito de Google Play «Data deletion»
      "del.eyebrow": "Eliminación de cuenta",
      "del.title": "Eliminar mi cuenta",
      "del.intro": "Aquí puedes eliminar de forma permanente tu cuenta de Utkan eSIM y tus datos personales. No necesitas tener la aplicación instalada: basta con iniciar sesión con la cuenta que quieres eliminar.",
      "del.deleted.title": "Datos que se eliminan",
      "del.deleted.identity": "Tu nombre, apellidos, dirección de correo electrónico y número de teléfono",
      "del.deleted.credentials": "Tu contraseña y los datos de sesión",
      "del.deleted.codes": "Tus códigos de verificación de correo y de restablecimiento de contraseña",
      "del.deleted.esim": "Tu número de eSIM (MSISDN), tu código QR/de activación y tus datos de uso",
      "del.kept.title": "Datos que conservamos y por qué",
      "del.kept.orders": "Los registros de compra (número de pedido, fecha, importe, estado del pago) se conservan por obligaciones fiscales y contables. No contienen tu nombre, tu correo ni tus datos de pago: solo un identificador que no puede vincularse contigo.",
      "del.kept.period": "Plazo de conservación: 5 años (Ley de Procedimiento Tributario de Turquía, art. 253).",
      "del.warn.title": "Antes de eliminar",
      "del.warn.irreversible": "Esta acción no se puede deshacer.",
      "del.warn.esim": "Las eSIM activas seguirán funcionando en tu dispositivo, pero ya no podrás acceder a tu código QR ni a los datos restantes. Guarda tu código QR antes de eliminar la cuenta.",
      "del.warn.rejoin": "Puedes registrarte de nuevo con el mismo correo, pero tus eSIM anteriores no aparecerán en la nueva cuenta.",
      "del.support": "Si no puedes iniciar sesión, también puedes solicitar la eliminación por correo electrónico:",
      "del.login.title": "Primero inicia sesión",
      "del.login.subtitle": "Introduce tu correo y contraseña para confirmar que la cuenta es tuya.",
      "del.login.action": "Iniciar sesión",
      "del.login.loading": "Iniciando sesión...",
      "del.forgot": "¿Olvidaste tu contraseña?",
      "del.confirm.title": "¿Estás seguro?",
      "del.confirm.subtitle": "La cuenta {{email}} y tus datos personales se eliminarán de forma permanente.",
      "del.confirm.field": "Escribe de nuevo tu correo electrónico para confirmar",
      "del.confirm.action": "Eliminar mi cuenta permanentemente",
      "del.confirm.deleting": "Eliminando...",
      "del.confirm.cancel": "Cancelar",
      "del.done.title": "Tu cuenta ha sido eliminada",
      "del.done.body": "Tus datos personales se han eliminado de forma permanente.",
      "del.done.retained": "Tus datos personales se han eliminado de forma permanente. Se conservaron {{n}} registro(s) de compra por obligaciones legales; no pueden vincularse contigo.",
      "del.done.home": "Volver a la tienda",
      "del.error.required": "Introduce tu correo y tu contraseña.",
      "del.error.credentials": "Correo o contraseña incorrectos.",
      "del.error.suspended": "Tu cuenta ha sido suspendida. Ponte en contacto con el soporte.",
      "del.error.session": "Tu sesión ha caducado. Inicia sesión de nuevo.",
      "del.error.network": "No se pudo conectar. Comprueba tu conexión a Internet e inténtalo de nuevo.",
      "del.error.generic": "Se ha producido un error. Inténtalo de nuevo.",
      "footer.deleteAccount": "Eliminar cuenta",


      // Planes de voz (datos + llamadas y SMS ilimitados) — docs/ses-paketleri.md
      "home.tabs.voice": "eSIM con llamadas",
      "detail.voice": "Llamadas + SMS",
      "detail.voiceNote": "Este plan incluye llamadas y SMS ilimitados además de los datos: una sola eSIM para internet y llamadas.",
      "detail.calls": "Llamadas",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "Llamadas ilimitadas",
      "plan.unlimitedSms": "SMS ilimitados",
      "plan.minutes": "{{n}} min de llamadas",
      "plan.sms": "{{n}} SMS",

      // Hercules — llamadas ilimitadas en Europa (docs/hercules-sayfasi.md)
      "hercules.subtitle": "Llamadas, SMS y datos ilimitados en {{n}} países europeos: una sola eSIM.",
      "hercules.coverageTitle": "Países incluidos ({{n}})",
      "hercules.promo.desc": "Llamadas y SMS ilimitados en {{n}} países, con 20–100 GB de datos.",
      "hercules.promo.cta": "Ver plan",
      "loading": "Cargando..."
    }
  },
  pt: {
    translation: {
      "language.title": "Idioma",
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "O Futuro da Conectividade Digital",
      "hero.description": "Eliminamos as fronteiras com uma experiência de conectividade digital de nova geração.",
      "hero.description2": "Soluções eSIM rápidas, seguras e acessíveis em todo o mundo.",
      "features.countries": "150+ Países",
      "features.activation": "Ativação Instantânea",
      "features.support": "Suporte 24/7",
      "countdown.title": "O Nosso Site Chegará em Breve!",
      "countdown.days": "Dias",
      "countdown.hours": "Horas",
      "countdown.minutes": "Minutos",
      "countdown.seconds": "Segundos",
      "countdown.launch": "O Nosso Site Foi Lançado!",
      "countdown.loading": "A carregar...",
      "apps.title": "As Nossas Aplicações Móveis",
      "apps.ios.label": "Descarregar na",
      "apps.ios.name": "App Store",
      "apps.android.label": "DISPONÍVEL NO",
      "apps.android.name": "Google Play",
      "contact.title": "Contacte-nos Antes do Lançamento",
      "contact.whatsapp": "WhatsApp: +90 540 155 13 33",
      "contact.email": "E-mail: info@utkanesim.com",
      "about.hero.title": "Sobre a Utkan eSIM",
      "about.hero.description": "A segurança dos seus dados pessoais é muito importante para nós. Esta política explica como os seus dados são recolhidos, utilizados e protegidos.",
      "about.story.title": "A Nossa História",
      "about.story.content": "Fundada em 2024 por uma equipa de viajantes apaixonados e entusiastas da tecnologia, a Utkan eSIM tem como objetivo revolucionar a forma como as pessoas se ligam à Internet no estrangeiro. Ao oferecer planos de dados eSIM fiáveis e de alta qualidade para mais de 190 países e regiões, garantimos o seu acesso rápido à Internet desde o momento em que aterra.",
      "about.mission.title": "A Nossa Missão",
      "about.mission.content": "Fornecer aos viajantes conectividade global simples, acessível e instantânea, permitindo-lhes explorar, trabalhar e manterem-se ligados sem fronteiras.",
      "about.vision.title": "A Nossa Visão",
      "about.vision.content": "Ser a principal plataforma global de soluções de conectividade digital, tornando o mundo num lugar mais pequeno e mais ligado para todos.",
      "about.features.title": "Porquê Escolher-nos?",
      "about.features.instant.title": "Entrega Instantânea",
      "about.features.instant.content": "Obtenha o seu eSIM instantaneamente com um código QR após a compra.",
      "about.features.global.title": "Cobertura Global",
      "about.features.global.content": "Planos de dados para mais de 190 países e regiões.",
      "about.features.affordable.title": "Preços Acessíveis",
      "about.features.affordable.content": "Poupe até 90% nas taxas de roaming.",
      "about.features.support.title": "Suporte 24/7",
      "about.features.support.content": "A nossa equipa de suporte dedicada está sempre à sua disposição.",
      "about.features.secure.title": "Ligação Segura",
      "about.features.secure.content": "Ligação protegida pelos mais recentes protocolos de segurança.",
      "about.features.fast.title": "Internet Rápida",
      "about.features.fast.content": "Experiência de Internet ininterrupta a velocidades 4G/5G.",
      "about.cta.title": "Junte-se ao Futuro da Conectividade Digital",
      "about.cta.content": "Obrigado por escolher a Utkan eSIM. Boa viagem!",
      "about.cta.whatsapp": "Contactar via WhatsApp",
      "about.cta.email": "Enviar E-mail",
      "contact.hero.title": "Contacte-nos",
      "contact.hero.description": "Se tiver dúvidas sobre os nossos eSIMs, precisar de suporte técnico ou apenas quiser deixar a sua opinião, teremos todo o gosto em ouvi-lo.",
      "contact.info.title": "As Nossas Informações de Contacto",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "Suporte Rápido 24/7",
      "contact.email.title": "E-mail",
      "contact.email.subtitle": "Contacto Geral",
      "contact.support.title": "Suporte Técnico",
      "contact.support.subtitle": "Problemas de eSIM",
      "contact.business.title": "Parceria Comercial",
      "contact.business.subtitle": "Contacto Empresarial",
      "contact.hours.title": "Horário de Suporte",
      "contact.hours.subtitle": "Suporte Técnico 24/7",
      "contact.hours.detail": "Segunda - Domingo: 00:00 - 23:59",
      "contact.form.title": "Enviar Mensagem",
      "contact.form.name": "Nome e Apelido",
      "contact.form.name.placeholder": "Introduza o seu nome e apelido",
      "contact.form.email": "O Seu Endereço de E-mail",
      "contact.form.email.placeholder": "exemplo@email.com",
      "contact.form.subject": "Assunto",
      "contact.form.subject.placeholder": "Selecione um assunto",
      "contact.form.subject.general": "Informação Geral",
      "contact.form.subject.technical": "Suporte Técnico",
      "contact.form.subject.billing": "Questões de Faturação",
      "contact.form.subject.partnership": "Parceria Comercial",
      "contact.form.subject.feedback": "Feedback",
      "contact.form.message": "A Sua Mensagem",
      "contact.form.message.placeholder": "Escreva a sua mensagem aqui...",
      "contact.form.submit": "Enviar Mensagem",
      "contact.faq.title": "Perguntas Frequentes",
      "contact.faq.esim.title": "Como funciona o eSIM?",
      "contact.faq.esim.content": "O eSIM é um cartão SIM digital que funciona no seu telemóvel sem a necessidade de um cartão SIM físico. É ativado instantaneamente com um código QR.",
      "contact.faq.phones.title": "Que telemóveis suportam eSIM?",
      "contact.faq.phones.content": "Os modelos iPhone XS e superiores, Samsung Galaxy S20 e superiores e Google Pixel 3 e superiores suportam eSIM.",
      "contact.faq.validity.title": "Durante quanto tempo é válido o meu plano de dados?",
      "contact.faq.validity.content": "O período de validade dos planos varia de 1 a 30 dias, dependendo do plano que escolher.",
      "contact.faq.payment.title": "Como é feito o pagamento?",
      "contact.faq.payment.content": "Pode pagar com segurança por cartão de crédito, PayPal e transferência bancária.",
      "privacy.hero.title": "Política de Privacidade",
      "privacy.hero.description": "A segurança dos seus dados pessoais é muito importante para nós. Esta política explica como os seus dados são recolhidos, utilizados e protegidos.",
      "privacy.overview.title": "Visão Geral",
      "privacy.overview.content": "Esta Política de Privacidade descreve as nossas políticas e procedimentos relativos à recolha, utilização e divulgação das suas informações quando utiliza o nosso Serviço. Também o informa sobre os seus direitos de privacidade e como a lei o protege.",
      "privacy.data.title": "Dados Que Recolhemos",
      "privacy.data.personal.title": "Informações Pessoais",
      "privacy.data.personal.name": "Nome e apelido",
      "privacy.data.personal.email": "Endereço de e-mail",
      "privacy.data.personal.phone": "Número de telemóvel",
      "privacy.data.personal.payment": "Informações de pagamento",
      "privacy.data.usage.title": "Dados de Utilização",
      "privacy.data.usage.ip": "Endereço IP",
      "privacy.data.usage.browser": "Tipo de navegador",
      "privacy.data.usage.device": "Informações do dispositivo",
      "privacy.data.usage.stats": "Estatísticas de utilização",
      "privacy.security.title": "Segurança de Dados",
      "privacy.security.ssl.title": "Encriptação SSL",
      "privacy.security.ssl.content": "Todas as transferências de dados estão protegidas por encriptação SSL de 256 bits.",
      "privacy.security.servers.title": "Servidores Seguros",
      "privacy.security.servers.content": "Os seus dados são armazenados em servidores seguros com certificação ISO 27001.",
      "privacy.security.access.title": "Controlo de Acesso",
      "privacy.security.access.content": "Apenas o pessoal autorizado pode aceder aos seus dados.",
      "privacy.usage.title": "Utilização de Dados",
      "privacy.usage.intro": "Utilizamos os dados que recolhemos para as seguintes finalidades:",
      "privacy.usage.service.title": "Prestação de Serviços",
      "privacy.usage.service.content": "Para fornecer e gerir os nossos serviços eSIM",
      "privacy.usage.support.title": "Apoio ao Cliente",
      "privacy.usage.support.content": "Para fornecer suporte técnico e serviço de apoio ao cliente",
      "privacy.usage.security.title": "Segurança",
      "privacy.usage.security.content": "Para proteger a sua conta e os nossos serviços",
      "privacy.usage.improvement.title": "Melhoria",
      "privacy.usage.improvement.content": "Para melhorar os nossos serviços e adicionar novas funcionalidades",
      "privacy.sharing.title": "Partilha de Dados",
      "privacy.sharing.intro": "Não partilhamos os seus dados pessoais com terceiros, mas a partilha pode ser necessária nos seguintes casos:",
      "privacy.sharing.legal": "Em caso de obrigação legal",
      "privacy.sharing.providers": "Com os nossos prestadores de serviços (como processadores de pagamento)",
      "privacy.sharing.threats": "Para prevenir ameaças de segurança",
      "privacy.sharing.consent": "Com o seu consentimento explícito",
      "privacy.rights.title": "Os Seus Direitos",
      "privacy.rights.access.title": "Direito de Acesso",
      "privacy.rights.access.content": "Pode solicitar acesso aos dados que mantemos sobre si.",
      "privacy.rights.correction.title": "Direito de Retificação",
      "privacy.rights.correction.content": "Podemos corrigir os seus dados imprecisos ou incompletos.",
      "privacy.rights.deletion.title": "Direito de Eliminação",
      "privacy.rights.deletion.content": "Podemos eliminar os seus dados sob determinadas condições.",
      "privacy.rights.objection.title": "Direito de Oposição",
      "privacy.rights.objection.content": "Pode opor-se às nossas atividades de processamento de dados.",
      "privacy.contact.title": "Contacto",
      "privacy.contact.intro": "Se tiver alguma dúvida sobre esta Política de Privacidade, pode contactar-nos através dos seguintes canais:",
      "nav.about": "Sobre Nós",
      "nav.contact": "Contacto",
      "nav.privacy": "Privacidade",
      "nav.login": "Iniciar Sessão",
      "nav.account": "A Minha Conta",
      "nav.logout": "Terminar Sessão",
      "auth.brand.eyebrow": "COBERTURA GLOBAL",
      "auth.brand.title": "Internet no momento em que aterra em mais de 150 países.",
      "auth.brand.subtitle": "Sem SIM físico, sem faturas de roaming. Ative o seu eSIM em segundos.",
      "auth.login.eyebrow": "INÍCIO DE SESSÃO",
      "auth.login.title": "Bem-vindo de volta",
      "auth.login.subtitle": "Faça a gestão dos seus eSIMs e descubra novos.",
      "auth.signup.eyebrow": "NOVA CONTA",
      "auth.signup.title": "Junte-se a nós",
      "auth.signup.subtitle": "Prepare o seu primeiro eSIM em poucos passos.",
      "auth.field.identifier": "E-mail ou telemóvel",
      "auth.field.identifier.ph": "exemplo@email.com ou +351…",
      "auth.field.email": "E-mail",
      "auth.field.email.ph": "exemplo@email.com",
      "auth.field.fullName": "Nome e apelido",
      "auth.field.fullName.ph": "O seu nome e apelido",
      "auth.field.password": "Palavra-passe",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "Iniciar sessão",
      "auth.action.loggingIn": "A iniciar sessão…",
      "auth.action.signup": "Criar conta",
      "auth.action.signingUp": "A criar conta…",
      "auth.toSignup.q": "Não tem conta?",
      "auth.toSignup.link": "Registe-se",
      "auth.toLogin.q": "Já tem uma conta?",
      "auth.toLogin.link": "Iniciar sessão",
      "auth.password.show": "Mostrar palavra-passe",
      "auth.password.hide": "Ocultar palavra-passe",
      "auth.terms.prefix": "Ao continuar, aceito os ",
      "auth.terms.link": "Termos de Utilização e a Política de Privacidade",
      "auth.terms.suffix": ".",
      "auth.error.required": "Por favor, preencha os campos obrigatórios.",
      "auth.error.terms": "Tem de aceitar os termos para continuar.",
      "verify.eyebrow": "VERIFICAÇÃO DE E-MAIL",
      "verify.title": "Verifique o seu e-mail",
      "verify.subtitle": "Enviámos um código de 6 dígitos para {{email}}. Introduza o código para verificar.",
      "verify.code": "Código de verificação",
      "verify.code.ph": "••••••",
      "verify.action": "Verificar",
      "verify.verifying": "A verificar…",
      "verify.resend": "Reenviar código",
      "verify.resendIn": "Reenviar em {{seconds}} s",
      "verify.resent": "Novo código enviado.",
      "verify.skip": "Ignorar por agora",
      "auth.forgot.link": "Esqueceu-se da palavra-passe?",
      "forgot.eyebrow": "REPOSIÇÃO DE PALAVRA-PASSE",
      "forgot.email.title": "Reponha a sua palavra-passe",
      "forgot.email.subtitle": "Introduza o endereço de e-mail da sua conta; iremos enviar-lhe um código de reposição de 6 dígitos.",
      "forgot.email.action": "Enviar código",
      "forgot.email.sending": "A enviar…",
      "forgot.reset.title": "Defina a sua nova palavra-passe",
      "forgot.reset.subtitle": "Introduza o código de 6 dígitos que enviámos para {{email}} e a sua nova palavra-passe.",
      "forgot.reset.action": "Atualizar palavra-passe",
      "forgot.reset.updating": "A atualizar…",
      "forgot.field.code": "Código de reposição",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "Nova palavra-passe",
      "forgot.field.newPassword.ph": "Pelo menos 6 carateres",
      "forgot.resend": "Reenviar código",
      "forgot.resendIn": "Reenviar em {{seconds}} s",
      "forgot.resent": "Novo código enviado.",
      "forgot.backToLogin": "Voltar ao início de sessão",
      "forgot.changeEmail": "Alterar e-mail",
      "forgot.help.noMail": "Se não recebeu o código, verifique a sua pasta de spam ou confirme o seu endereço de e-mail.",
      "reset.RESET_CODE_SENT": "Código enviado. Por favor, verifique o seu e-mail.",
      "reset.RATE_LIMITED": "Fez demasiadas tentativas. Por favor, aguarde um momento e tente novamente.",
      "reset.MAIL_SEND_FAILED": "Algo correu mal. Por favor, tente novamente mais tarde.",
      "reset.RESET_CODE_VALID": "Código verificado.",
      "reset.INVALID_RESET_CODE": "Código incorreto. Por favor, tente novamente.",
      "reset.EXPIRED_RESET_CODE": "O código expirou. Por favor, solicite um novo código.",
      "reset.WEAK_PASSWORD": "A palavra-passe deve ter pelo menos 6 carateres.",
      "reset.PASSWORD_RESET_SUCCESS": "A sua palavra-passe foi atualizada. Pode iniciar sessão com a nova palavra-passe.",
      "reset.generic": "Algo correu mal. Por favor, tente novamente.",
      "login.resetSuccess": "A sua palavra-passe foi atualizada. Pode iniciar sessão com a nova palavra-passe.",
      "store.nav.shop": "Loja",
      "home.hero.title1": "Ligue-se em poucos minutos,",
      "home.hero.title2": "mantenha-se além das fronteiras.",
      "home.hero.subtitle": "Planos eSIM fiáveis válidos em mais de 190 países. Sem SIM físico, sem faturas de roaming.",
      "home.search.placeholder": "Para onde viaja?",
      "home.tabs.local": "eSIMs locais",
      "home.tabs.regional": "eSIMs regionais",
      "home.tabs.lifetime": "eSIMs vitalícios",
      "home.empty": "Não foram encontrados resultados para a sua pesquisa.",
      "home.error.title": "Não foi possível carregar o conteúdo",
      "home.error.retry": "Tentar novamente",
      "home.from": "a partir de",
      "home.popular": "Destinos populares",
      "home.coverage": "190+ países · ativação instantânea",
      "home.detail.soon": "Os planos para esta seleção serão listados aqui muito em breve.",
      "home.detail.back": "Voltar à loja",
      "detail.plans": "Planos",
      "detail.count": "{{count}} plano(s)",
      "detail.validity": "{{days}} dias",
      "detail.validityLifetime": "Sem expiração",
      "detail.buy": "Comprar",
      "detail.empty": "Atualmente não existem planos para esta seleção.",
      "detail.checkoutSoon": "O fluxo de pagamento será adicionado muito em breve.",
      "detail.loginToBuy": "Tem de iniciar sessão para comprar.",
      "detail.basicFeatures": "Características Básicas",
      "detail.dataAmount": "Quantidade de dados",
      "detail.validityLabel": "Período de validade",
      "detail.coverageArea": "Área de cobertura",
      "detail.activationNetworks": "Ativação e Redes",
      "detail.activationMethod": "Método de ativação",
      "detail.esimActivation": "eSIM — instantâneo com código QR",
      "detail.supportedNetworks": "Redes suportadas",
      "detail.description": "Descrição",
      "detail.price": "Preço",
      "authprompt.title": "Inicie sessão para continuar",
      "authprompt.message": "Inicie sessão na sua conta para comprar um eSIM ou crie uma nova conta em segundos.",
      "authprompt.close": "Fechar",
      "footer.tagline": "eSIM rápido, seguro e acessível em todo o mundo. Ligue-se à Internet assim que aterrar.",
      "footer.explore": "Explorar",
      "footer.support": "Suporte",
      "footer.legal": "Legal",
      "footer.shop": "Loja",
      "footer.help": "Perguntas Frequentes",
      "footer.terms": "Termos de Utilização",
      "footer.rights": "© {{year}} Utkan eSIM. Todos os direitos reservados.",
      "footer.apps": "Descarregar a aplicação",
      "whatsapp.label": "Escrever no WhatsApp",
      "whatsapp.message": "Olá, tenho um pedido de suporte de eSIM.",
      "notfound.eyebrow": "SEM SINAL",
      "notfound.title": "Esta página não está disponível",
      "notfound.message": "A página que procura pode ter sido movida ou nunca existiu. Vamos levá-lo de volta à área de cobertura.",
      "order.congrats": "Parabéns!",
      "order.message": "O seu eSIM está pronto. Pode configurá-lo em poucos passos com o código QR abaixo.",
      "order.details": "Resumo da encomenda",
      "order.activation": "Ativação",
      "order.activationDesc": "Para configurar o seu eSIM, leia o código QR com a câmara do seu dispositivo ou introduza manualmente o código de configuração.",
      "order.qrTitle": "Código QR do eSIM",
      "order.manualLabel": "Código de configuração",
      "order.copy": "Copiar",
      "order.copied": "Copiado",
      "order.howTo": "Como ativar?",
      "order.step1": "Vá a Definições > Rede Móvel / Dados Móveis > Adicionar eSIM no seu dispositivo.",
      "order.step2": "Selecione \"Utilizar Código QR\" e leia o código QR acima (ou introduza manualmente o código de configuração).",
      "order.step3": "Quando a instalação estiver concluída, ative o seu plano eSIM.",
      "order.step4": "Certifique-se de que o roaming de dados está ativado — já está ligado!",
      "order.cta": "Voltar à página inicial",
      "checkout.title": "Pagamento",
      "checkout.summary": "Resumo da encomenda",
      "checkout.total": "Total",
      "checkout.eurNote": "O montante é cobrado em euros (€) no PayPal.",
      "checkout.processing": "A verificar o seu pagamento…",
      "checkout.error": "O pagamento não pôde ser concluído. Por favor, tente novamente.",
      "checkout.cancelled": "Pagamento cancelado.",
      "account.title": "A Minha Conta",
      "account.tab.profile": "Perfil",
      "account.tab.esims": "Os Meus eSIMs",
      "account.tab.security": "Segurança",
      "account.profile.title": "Informações do perfil",
      "account.field.phone": "Telemóvel",
      "account.field.phone.ph": "+351…",
      "account.memberSince": "Membro desde",
      "account.save": "Guardar",
      "account.saving": "A guardar…",
      "account.saved": "As suas informações foram atualizadas.",
      "account.esims.title": "Os Meus eSIMs",
      "account.esims.empty": "Ainda não tem um eSIM.",
      "account.esims.emptyCta": "Explorar a loja",
      "account.esims.data": "Dados",
      "account.esims.expires": "Data de fim",
      "account.esims.viewQr": "Mostrar código QR",
      "account.esims.hideQr": "Ocultar código QR",
      "account.esims.active": "Ativo",
      "account.esims.passive": "Inativo",
      "account.esims.noActive": "Não tem eSIMs ativos.",
      "account.esims.noPassive": "Não tem eSIMs inativos.",
      "account.esims.readyHint": "Pronto a utilizar — a duração começa na primeira utilização.",
      "account.esims.unavailableHint": "Não foi possível carregar o estado neste momento. Tente novamente mais tarde.",
      "esimStatus.active": "Ativo",
      "esimStatus.readyToUse": "Pronto a utilizar",
      "esimStatus.inactive": "Inativo",
      "esimStatus.unavailable": "Não foi possível carregar o estado",
      "account.security.title": "Alterar palavra-passe",
      "account.field.oldPassword": "Palavra-passe atual",
      "account.field.newPassword": "Nova palavra-passe",
      "account.field.confirmPassword": "Nova palavra-passe (repetir)",
      "account.changePassword": "Atualizar palavra-passe",
      "account.passwordChanged": "A sua palavra-passe foi atualizada.",
      "account.error.passwordMismatch": "As novas palavras-passe não coincidem.",
      "account.danger.title": "Ações da conta",
      "account.delete": "Eliminar conta",
      "account.delete.confirm": "Está prestes a eliminar a sua conta permanentemente. Esta ação não pode ser desfeita.",
      "account.delete.confirmBtn": "Sim, eliminar",
      "account.cancel": "Cancelar",
      "esimDetail.back": "Voltar",
      "esimDetail.dataUsage": "Utilização de dados",
      "esimDetail.left": "restantes",
      "esimDetail.leftData": "Dados restantes",
      "esimDetail.usedData": "Utilizados",
      "esimDetail.totalData": "Dados totais",
      "esimDetail.qrDesc": "Configure o seu eSIM lendo este código QR com a câmara do seu dispositivo.",
      "esimDetail.validity": "Validade",
      "esimDetail.daysLeft": "{{days}} dia(s) restante(s)",
      "esimDetail.expired": "Expirou",
      "esimDetail.notYetActive": "Ainda não ativo",
      "esimDetail.leftDate": "Tempo restante",
      "esimDetail.activationDate": "Data de ativação",
      "esimDetail.endDate": "Data de fim",
      "esimDetail.technical": "Informações técnicas",
      "esimDetail.activationCode": "Código de ativação (Android)",
      "esimDetail.smdp": "Endereço SM-DP+ (iOS)",
      "esimDetail.matchingId": "ID de correspondência (iOS)",
      "esimDetail.support": "Suporte técnico",
      "esimDetail.supportDesc": "Tem algum problema? Deixe-nos ajudar.",
      "esimDetail.email": "Enviar um e-mail",
      "guide.eyebrow": "GUIA eSIM",
      "guide.title": "O que é um eSIM e como instalá-lo?",
      "guide.intro.title": "O que é um eSIM?",
      "guide.intro.body": "O eSIM é um SIM digital integrado no seu dispositivo que funciona sem a necessidade de um cartão SIM físico. Configura a sua linha em segundos ao ler um código QR; liga-se à Internet em mais de 190 países sem trocar de cartão e sem faturas de roaming.",
      "guide.steps.title": "Como ativar?",
      "guide.devices.title": "Dispositivos suportados",
      "guide.devices.desc": "O seu dispositivo tem de ser compatível com eSIM para que este funcione. Verifique a sua marca.",
      "guide.faq.title": "Perguntas frequentes",
      "nav.guide": "Guia eSIM",
      "currency.label": "Moeda",
      "staticPage.loading": "A carregar página...",
      "staticPage.errorTitle": "Ocorreu um Erro",
      "staticPage.retry": "Tentar Novamente",
      "staticPage.loadFailed": "Não foi possível carregar o conteúdo da página. Por favor, tente novamente mais tarde.",
      "last.updated": "Última atualização: 8 de julho de 2024",

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      "home.tabs.unlimited": "eSIMs ilimitados",
      "detail.unlimited": "Ilimitado",
      "detail.unlimitedNote": "Este pacote não tem limite de dados — internet ilimitada durante toda a validade.",
      "detail.notPriced": "Este pacote não está disponível para compra na web neste momento.",
      "checkout.priceUpdated": "O preço deste pacote foi atualizado. Volte à loja e selecione-o novamente.",
      "order.pending.title": "O seu eSIM está a ser preparado",
      "order.pending.message": "O seu pagamento foi concluído. Os pacotes ilimitados podem demorar alguns minutos a ativar.",
      "order.pending.waiting": "A verificar o estado da sua encomenda…",
      "order.pending.ready": "O seu eSIM está pronto!",
      "order.pending.timeout": "Está a demorar mais do que o esperado. O seu pagamento está seguro — o seu eSIM aparecerá em «Os meus eSIMs» assim que estiver pronto.",
      "order.pending.cta": "Ir para Os meus eSIMs",
      "account.esims.unlimited": "Ilimitado",
      "account.esims.unlimitedHint": "Dados ilimitados — este pacote não tem limite de dados.",
      "esimDetail.unlimitedData": "Este pacote não tem limite de dados; veja o tempo restante abaixo.",


      // Eliminação de conta (/hesap-sil · /account-deletion) — requisito do Google Play «Data deletion»
      "del.eyebrow": "Eliminação de conta",
      "del.title": "Eliminar a minha conta",
      "del.intro": "Aqui pode eliminar permanentemente a sua conta Utkan eSIM e os seus dados pessoais. Não precisa de ter a aplicação instalada — basta iniciar sessão com a conta que pretende eliminar.",
      "del.deleted.title": "Dados eliminados",
      "del.deleted.identity": "Nome, apelido, endereço de e-mail e número de telefone",
      "del.deleted.credentials": "A sua palavra-passe e os dados de sessão",
      "del.deleted.codes": "Os códigos de verificação de e-mail e de reposição da palavra-passe",
      "del.deleted.esim": "O seu número eSIM (MSISDN), o código QR/de ativação e os dados de utilização",
      "del.kept.title": "Dados que mantemos e porquê",
      "del.kept.orders": "Os registos de compra (número de encomenda, data, valor, estado do pagamento) são mantidos por obrigações fiscais e contabilísticas. Não contêm o seu nome, e-mail ou dados de pagamento — apenas um identificador que não pode ser associado a si.",
      "del.kept.period": "Prazo de conservação: 5 anos (Lei do Procedimento Tributário da Turquia, art. 253.º).",
      "del.warn.title": "Antes de eliminar",
      "del.warn.irreversible": "Esta ação não pode ser anulada.",
      "del.warn.esim": "Os eSIM ativos continuam a funcionar no seu dispositivo, mas deixará de ter acesso ao código QR e aos dados restantes. Guarde o código QR antes de eliminar.",
      "del.warn.rejoin": "Pode registar-se novamente com o mesmo e-mail, mas os eSIM anteriores não aparecerão na nova conta.",
      "del.support": "Se não conseguir iniciar sessão, também pode pedir a eliminação por e-mail:",
      "del.login.title": "Inicie sessão primeiro",
      "del.login.subtitle": "Introduza o seu e-mail e palavra-passe para confirmarmos que a conta é sua.",
      "del.login.action": "Iniciar sessão",
      "del.login.loading": "A iniciar sessão...",
      "del.forgot": "Esqueceu-se da palavra-passe?",
      "del.confirm.title": "Tem a certeza?",
      "del.confirm.subtitle": "A conta {{email}} e os seus dados pessoais serão eliminados permanentemente.",
      "del.confirm.field": "Escreva novamente o seu e-mail para confirmar",
      "del.confirm.action": "Eliminar a minha conta permanentemente",
      "del.confirm.deleting": "A eliminar...",
      "del.confirm.cancel": "Cancelar",
      "del.done.title": "A sua conta foi eliminada",
      "del.done.body": "Os seus dados pessoais foram eliminados permanentemente.",
      "del.done.retained": "Os seus dados pessoais foram eliminados permanentemente. Foram mantidos {{n}} registo(s) de compra por obrigações legais; não podem ser associados a si.",
      "del.done.home": "Voltar à loja",
      "del.error.required": "Introduza o seu e-mail e palavra-passe.",
      "del.error.credentials": "E-mail ou palavra-passe incorretos.",
      "del.error.suspended": "A sua conta foi suspensa. Contacte o apoio ao cliente.",
      "del.error.session": "A sua sessão expirou. Inicie sessão novamente.",
      "del.error.network": "Não foi possível ligar. Verifique a sua ligação à Internet e tente novamente.",
      "del.error.generic": "Ocorreu um erro. Tente novamente.",
      "footer.deleteAccount": "Eliminar conta",


      // Planos de voz (dados + chamadas e SMS ilimitados) — docs/ses-paketleri.md
      "home.tabs.voice": "eSIM com chamadas",
      "detail.voice": "Chamadas + SMS",
      "detail.voiceNote": "Este plano inclui chamadas e SMS ilimitados além dos dados: um único eSIM para internet e chamadas.",
      "detail.calls": "Chamadas",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "Chamadas ilimitadas",
      "plan.unlimitedSms": "SMS ilimitados",
      "plan.minutes": "{{n}} min de chamadas",
      "plan.sms": "{{n}} SMS",

      // Hercules — chamadas ilimitadas na Europa (docs/hercules-sayfasi.md)
      "hercules.subtitle": "Chamadas, SMS e dados ilimitados em {{n}} países europeus — um só eSIM.",
      "hercules.coverageTitle": "Países abrangidos ({{n}})",
      "hercules.promo.desc": "Chamadas e SMS ilimitados em {{n}} países, com 20–100 GB de dados.",
      "hercules.promo.cta": "Ver plano",
      "loading": "A carregar..."
    }
  },
  ar: {
    translation: {
      "language.title": "اللغة",
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "مستقبل الاتصال الرقمي",
      "hero.description": "نحن نزيل الحدود من خلال تجربة اتصال رقمي من الجيل التالي.",
      "hero.description2": "حلول eSIM سريعة وآمنة وبأسعار معقولة في جميع أنحاء العالم.",
      "features.countries": "+150 دولة",
      "features.activation": "تفعيل فوري",
      "features.support": "دعم على مدار 24/7",
      "countdown.title": "موقعنا الإلكتروني قريباً جداً!",
      "countdown.days": "أيام",
      "countdown.hours": "ساعات",
      "countdown.minutes": "دقائق",
      "countdown.seconds": "ثواني",
      "countdown.launch": "تم إطلاق موقعنا الإلكتروني!",
      "countdown.loading": "جاري التحميل...",
      "apps.title": "تطبيقاتنا للهواتف المحمولة",
      "apps.ios.label": "تنزيل من",
      "apps.ios.name": "App Store",
      "apps.android.label": "احصل عليه من",
      "apps.android.name": "Google Play",
      "contact.title": "تواصل معنا قبل الإطلاق",
      "contact.whatsapp": "واتساب: 333 1 555 676 43+",
      "contact.email": "البريد الإلكتروني: info@utkanesim.com",
      "about.hero.title": "نبذة عن Utkan eSIM",
      "about.hero.description": "أمان بياناتك الشخصية مهم جداً بالنسبة لنا. توضح هذه السياسة كيف يتم جمع بياناتك واستخدامها وحمايتها.",
      "about.story.title": "قصتنا",
      "about.story.content": "تأسست Utkan eSIM في عام 2024 من قبل فريق من المسافرين الشغوفين وهواة التكنولوجيا، وتهدف إلى إحداث ثورة في طريقة اتصال الأشخاص بالإنترنت في الخارج. من خلال تقديم خطط بيانات eSIM موثوقة وعالية الجودة لأكثر من 190 دولة ومنطقة، نضمن لك وصولاً سريعاً إلى الإنترنت بمجرد هبوطك.",
      "about.mission.title": "مهمتنا",
      "about.mission.content": "تزويد المسافرين باتصال عالمي بسيط وبأسعار معقولة وفوري، مما يتيح لهم الاستكشاف والعمل والبقاء على اتصال بلا حدود.",
      "about.vision.title": "رؤيتنا",
      "about.vision.content": "أن نكون المنصة العالمية الرائدة لحلول الاتصال الرقمي، لنجعل العالم مكاناً أصغر وأكثر اتصالاً للجميع.",
      "about.features.title": "لماذا تختارنا؟",
      "about.features.instant.title": "تسليم فوري",
      "about.features.instant.content": "احصل على شريحة eSIM الخاصة بك فوراً مع رمز الاستجابة السريعة (QR) بعد الشراء.",
      "about.features.global.title": "تغطية عالمية",
      "about.features.global.content": "خطط بيانات لأكثر من 190 دولة ومنطقة.",
      "about.features.affordable.title": "أسعار معقولة",
      "about.features.affordable.content": "وفر حتى 90% من رسوم التجوال.",
      "about.features.support.title": "دعم على مدار 24/7",
      "about.features.support.content": "فريق الدعم المخصص لدينا متواجد دائماً لخدمتك.",
      "about.features.secure.title": "اتصال آمن",
      "about.features.secure.content": "اتصال محمي بأحدث بروتوكولات الأمان.",
      "about.features.fast.title": "إنترنت سريع",
      "about.features.fast.content": "تجربة إنترنت غير منقطعة بسرعات 4G/5G.",
      "about.cta.title": "انضم إلى مستقبل الاتصال الرقمي",
      "about.cta.content": "شكراً لاختيارك Utkan eSIM. رحلة سعيدة!",
      "about.cta.whatsapp": "تواصل عبر واتساب",
      "about.cta.email": "إرسال بريد إلكتروني",
      "contact.hero.title": "اتصل بنا",
      "contact.hero.description": "إذا كانت لديك أسئلة حول شرائح eSIM الخاصة بنا، أو تحتاج إلى دعم فني، أو ترغب فقط في تقديم ملاحظاتك، فسيسعدنا أن نسمع منك.",
      "contact.info.title": "معلومات الاتصال الخاصة بنا",
      "contact.whatsapp.title": "واتساب",
      "contact.whatsapp.subtitle": "دعم سريع 24/7",
      "contact.email.title": "البريد الإلكتروني",
      "contact.email.subtitle": "تواصل عام",
      "contact.support.title": "الدعم الفني",
      "contact.support.subtitle": "مشاكل eSIM",
      "contact.business.title": "شراكة تجارية",
      "contact.business.subtitle": "تواصل الشركات",
      "contact.hours.title": "ساعات الدعم",
      "contact.hours.subtitle": "دعم فني 24/7",
      "contact.hours.detail": "الإثنين - الأحد: 00:00 - 23:59",
      "contact.form.title": "أرسل رسالة",
      "contact.form.name": "الاسم واللقب",
      "contact.form.name.placeholder": "أدخل اسمك ولقبك",
      "contact.form.email": "عنوان بريدك الإلكتروني",
      "contact.form.email.placeholder": "example@email.com",
      "contact.form.subject": "الموضوع",
      "contact.form.subject.placeholder": "اختر موضوعاً",
      "contact.form.subject.general": "معلومات عامة",
      "contact.form.subject.technical": "الدعم الفني",
      "contact.form.subject.billing": "أسئلة الفواتير",
      "contact.form.subject.partnership": "شراكة تجارية",
      "contact.form.subject.feedback": "ملاحظات",
      "contact.form.message": "رسالتك",
      "contact.form.message.placeholder": "اكتب رسالتك هنا...",
      "contact.form.submit": "إرسال الرسالة",
      "contact.faq.title": "الأسئلة الشائعة",
      "contact.faq.esim.title": "كيف تعمل eSIM؟",
      "contact.faq.esim.content": "إن eSIM عبارة عن شريحة SIM رقمية تعمل في هاتفك دون الحاجة إلى بطاقة SIM فعلية. يتم تفعيلها فوراً باستخدام رمز الاستجابة السريعة (QR).",
      "contact.faq.phones.title": "ما هي الهواتف التي تدعم eSIM؟",
      "contact.faq.phones.content": "تدعم هواتف iPhone XS والأحدث، وSamsung Galaxy S20 والأحدث، وGoogle Pixel 3 والأحدث تقنية eSIM.",
      "contact.faq.validity.title": "ما هي مدة صلاحية باقة البيانات الخاصة بي؟",
      "contact.faq.validity.content": "تتراوح فترة صلاحية الباقات بين 1 إلى 30 يوماً بناءً على الخطة التي تختارها.",
      "contact.faq.payment.title": "كيف يتم الدفع؟",
      "contact.faq.payment.content": "يمكنك الدفع بأمان باستخدام بطاقة الائتمان، وPayPal، والتحويل المصرفي.",
      "privacy.hero.title": "سياسة الخصوصية",
      "privacy.hero.description": "أمان بياناتك الشخصية مهم جداً بالنسبة لنا. توضح هذه السياسة كيف يتم جمع بياناتك واستخدامها وحمايتها.",
      "privacy.overview.title": "نظرة عامة",
      "privacy.overview.content": "تصف سياسة الخصوصية هذه سياساتنا وإجراءاتنا المتعلقة بجمع معلوماتك واستخدامها والإفصاح عنها عند استخدامك لخدمتنا. كما تخبرك عن حقوق الخصوصية الخاصة بك وكيف يحميك القانون.",
      "privacy.data.title": "البيانات التي نجمعها",
      "privacy.data.personal.title": "المعلومات الشخصية",
      "privacy.data.personal.name": "الاسم واللقب",
      "privacy.data.personal.email": "عنوان البريد الإلكتروني",
      "privacy.data.personal.phone": "رقم الهاتف",
      "privacy.data.personal.payment": "معلومات الدفع",
      "privacy.data.usage.title": "بيانات الاستخدام",
      "privacy.data.usage.ip": "عنوان IP",
      "privacy.data.usage.browser": "نوع المتصفح",
      "privacy.data.usage.device": "معلومات الجهاز",
      "privacy.data.usage.stats": "إحصائيات الاستخدام",
      "privacy.security.title": "أمان البيانات",
      "privacy.security.ssl.title": "تشفير SSL",
      "privacy.security.ssl.content": "تتم حماية جميع عمليات نقل البيانات بتشفير SSL 256-bit.",
      "privacy.security.servers.title": "خوادم آمنة",
      "privacy.security.servers.content": "يتم تخزين بياناتك في خوادم آمنة معتمدة من ISO 27001.",
      "privacy.security.access.title": "التحكم في الوصول",
      "privacy.security.access.content": "يمكن للموظفين المصرح لهم فقط الوصول إلى بياناتك.",
      "privacy.usage.title": "استخدام البيانات",
      "privacy.usage.intro": "نستخدم البيانات التي نجمعها للأغراض التالية:",
      "privacy.usage.service.title": "تقديم الخدمة",
      "privacy.usage.service.content": "لتقديم وإدارة خدمات eSIM الخاصة بنا",
      "privacy.usage.support.title": "دعم العملاء",
      "privacy.usage.support.content": "لتقديم الدعم الفني وخدمة العملاء",
      "privacy.usage.security.title": "الأمان",
      "privacy.usage.security.content": "لحماية حسابك وخدماتنا",
      "privacy.usage.improvement.title": "التحسين",
      "privacy.usage.improvement.content": "لتحسين خدماتنا وإضافة ميزات جديدة",
      "privacy.sharing.title": "مشاركة البيانات",
      "privacy.sharing.intro": "نحن لا نشارك بياناتك الشخصية مع جهات خارجية، ولكن قد تكون المشاركة ضرورية في الحالات التالية:",
      "privacy.sharing.legal": "في حالة وجود التزام قانوني",
      "privacy.sharing.providers": "مع مزودي الخدمة لدينا (مثل معالجات الدفع)",
      "privacy.sharing.threats": "لمنع التهديدات الأمنية",
      "privacy.sharing.consent": "بموافقتك الصريحة",
      "privacy.rights.title": "حقوقك",
      "privacy.rights.access.title": "حق الوصول",
      "privacy.rights.access.content": "يمكنك طلب الوصول إلى البيانات التي نحتفظ بها عنك.",
      "privacy.rights.correction.title": "حق التصحيح",
      "privacy.rights.correction.content": "يمكننا تصحيح بياناتك غير الدقيقة أو غير المكتملة.",
      "privacy.rights.deletion.title": "حق الحذف",
      "privacy.rights.deletion.content": "يمكننا حذف بياناتك في ظل ظروف معينة.",
      "privacy.rights.objection.title": "حق الاعتراض",
      "privacy.rights.objection.content": "يمكنك الاعتراض على أنشطة معالجة البيانات الخاصة بنا.",
      "privacy.contact.title": "اتصل بنا",
      "privacy.contact.intro": "إذا كانت لديك أي أسئلة حول سياسة الخصوصية هذه، يمكنك الاتصال بنا عبر القنوات التالية:",
      "nav.about": "نبذة عنا",
      "nav.contact": "اتصل بنا",
      "nav.privacy": "الخصوصية",
      "nav.login": "تسجيل الدخول",
      "nav.account": "حسابي",
      "nav.logout": "تسجيل الخروج",
      "auth.brand.eyebrow": "تغطية عالمية",
      "auth.brand.title": "إنترنت بمجرد هبوطك في أكثر من 150 دولة.",
      "auth.brand.subtitle": "لا توجد شريحة SIM فعلية، ولا فواتير تجوال. قم بتفعيل eSIM الخاصة بك في ثوانٍ.",
      "auth.login.eyebrow": "تسجيل الدخول إلى الحساب",
      "auth.login.title": "مرحباً بعودتك",
      "auth.login.subtitle": "قم بإدارة شرائح eSIM الخاصة بك واكتشف شرائح جديدة.",
      "auth.signup.eyebrow": "حساب جديد",
      "auth.signup.title": "انضم إلينا",
      "auth.signup.subtitle": "قم بإعداد أول eSIM لك في خطوات قليلة.",
      "auth.field.identifier": "البريد الإلكتروني أو الهاتف",
      "auth.field.identifier.ph": "example@email.com أو +90…",
      "auth.field.email": "البريد الإلكتروني",
      "auth.field.email.ph": "example@email.com",
      "auth.field.fullName": "الاسم واللقب",
      "auth.field.fullName.ph": "اسمك ولقبك",
      "auth.field.password": "كلمة المرور",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "تسجيل الدخول",
      "auth.action.loggingIn": "جاري تسجيل الدخول…",
      "auth.action.signup": "إنشاء حساب",
      "auth.action.signingUp": "جاري إنشاء الحساب…",
      "auth.toSignup.q": "ليس لديك حساب؟",
      "auth.toSignup.link": "سجل الآن",
      "auth.toLogin.q": "هل لديك حساب بالفعل؟",
      "auth.toLogin.link": "تسجيل الدخول",
      "auth.password.show": "إظهار كلمة المرور",
      "auth.password.hide": "إخفاء كلمة المرور",
      "auth.terms.prefix": "بالمتابعة، أنا أوافق على ",
      "auth.terms.link": "شروط الاستخدام وسياسة الخصوصية",
      "auth.terms.suffix": ".",
      "auth.error.required": "يرجى ملء الحقول المطلوبة.",
      "auth.error.terms": "يجب عليك قبول الشروط للمتابعة.",
      "verify.eyebrow": "التحقق من البريد الإلكتروني",
      "verify.title": "تحقق من بريدك الإلكتروني",
      "verify.subtitle": "لقد أرسلنا رمزاً مكوناً من 6 أرقام إلى {{email}}. أدخل الرمز للتحقق.",
      "verify.code": "رمز التحقق",
      "verify.code.ph": "••••••",
      "verify.action": "تحقق",
      "verify.verifying": "جاري التحقق…",
      "verify.resend": "إعادة إرسال الرمز",
      "verify.resendIn": "إعادة الإرسال بعد {{seconds}} ثانية",
      "verify.resent": "تم إرسال رمز جديد.",
      "verify.skip": "تخطي الآن",
      "auth.forgot.link": "هل نسيت كلمة المرور؟",
      "forgot.eyebrow": "إعادة تعيين كلمة المرور",
      "forgot.email.title": "أعد تعيين كلمة المرور",
      "forgot.email.subtitle": "أدخل عنوان البريد الإلكتروني لحسابك؛ وسنرسل لك رمز إعادة تعيين مكون من 6 أرقام.",
      "forgot.email.action": "إرسال الرمز",
      "forgot.email.sending": "جاري الإرسال…",
      "forgot.reset.title": "تعيين كلمة مرور جديدة",
      "forgot.reset.subtitle": "أدخل الرمز المكون من 6 أرقام الذي أرسلناه إلى {{email}} وكلمة المرور الجديدة.",
      "forgot.reset.action": "تحديث كلمة المرور",
      "forgot.reset.updating": "جاري التحديث…",
      "forgot.field.code": "رمز إعادة التعيين",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "كلمة مرور جديدة",
      "forgot.field.newPassword.ph": "6 أحرف على الأقل",
      "forgot.resend": "إعادة إرسال الرمز",
      "forgot.resendIn": "إعادة الإرسال بعد {{seconds}} ثانية",
      "forgot.resent": "تم إرسال رمز جديد.",
      "forgot.backToLogin": "العودة إلى تسجيل الدخول",
      "forgot.changeEmail": "تغيير البريد الإلكتروني",
      "forgot.help.noMail": "إذا لم يصل الرمز، تحقق من مجلد الرسائل غير المرغوب فيها أو تأكد من عنوان بريدك الإلكتروني.",
      "reset.RESET_CODE_SENT": "تم إرسال الرمز. يرجى التحقق من بريدك الإلكتروني.",
      "reset.RATE_LIMITED": "لقد قمت بمحاولات كثيرة. يرجى الانتظار قليلاً والمحاولة مرة أخرى.",
      "reset.MAIL_SEND_FAILED": "حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقاً.",
      "reset.RESET_CODE_VALID": "تم التحقق من الرمز.",
      "reset.INVALID_RESET_CODE": "رمز غير صحيح. يرجى المحاولة مرة أخرى.",
      "reset.EXPIRED_RESET_CODE": "انتهت صلاحية الرمز. يرجى طلب رمز جديد.",
      "reset.WEAK_PASSWORD": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
      "reset.PASSWORD_RESET_SUCCESS": "تم تحديث كلمة المرور الخاصة بك. يمكنك تسجيل الدخول بكلمة المرور الجديدة.",
      "reset.generic": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
      "login.resetSuccess": "تم تحديث كلمة المرور الخاصة بك. يمكنك تسجيل الدخول بكلمة المرور الجديدة.",
      "store.nav.shop": "المتجر",
      "home.hero.title1": "اتصل في بضع دقائق،",
      "home.hero.title2": "ابق على اتصال خارج الحدود.",
      "home.hero.subtitle": "باقات eSIM موثوقة صالحة في أكثر من 190 دولة. لا توجد بطاقة SIM فعلية، ولا فواتير تجوال.",
      "home.search.placeholder": "إلى أين تسافر؟",
      "home.tabs.local": "eSIM محلية",
      "home.tabs.regional": "eSIM إقليمية",
      "home.tabs.lifetime": "eSIM مدى الحياة",
      "home.empty": "لم يتم العثور على نتائج تطابق بحثك.",
      "home.error.title": "تعذر تحميل المحتوى",
      "home.error.retry": "حاول مرة أخرى",
      "home.from": "تبدأ من",
      "home.popular": "الوجهات الشهيرة",
      "home.coverage": "+190 دولة · تفعيل فوري",
      "home.detail.soon": "سيتم إدراج باقات هذا التحديد هنا قريباً جداً.",
      "home.detail.back": "العودة إلى المتجر",
      "detail.plans": "الباقات",
      "detail.count": "{{count}} باقة",
      "detail.validity": "{{days}} يوم",
      "detail.validityLifetime": "بلا انتهاء",
      "detail.buy": "شراء",
      "detail.empty": "لا توجد باقات متاحة لهذا التحديد حالياً.",
      "detail.checkoutSoon": "سيتم إضافة عملية الدفع قريباً جداً.",
      "detail.loginToBuy": "يجب عليك تسجيل الدخول للشراء.",
      "detail.basicFeatures": "الميزات الأساسية",
      "detail.dataAmount": "حجم البيانات",
      "detail.validityLabel": "فترة الصلاحية",
      "detail.coverageArea": "منطقة التغطية",
      "detail.activationNetworks": "التفعيل والشبكات",
      "detail.activationMethod": "طريقة التفعيل",
      "detail.esimActivation": "eSIM — فوري باستخدام رمز QR",
      "detail.supportedNetworks": "الشبكات المدعومة",
      "detail.description": "الوصف",
      "detail.price": "السعر",
      "authprompt.title": "قم بتسجيل الدخول للمتابعة",
      "authprompt.message": "قم بتسجيل الدخول إلى حسابك لشراء eSIM أو قم بإنشاء حساب جديد في ثوانٍ.",
      "authprompt.close": "إغلاق",
      "footer.tagline": "eSIM سريع وآمن وبأسعار معقولة حول العالم. اتصل بالإنترنت بمجرد هبوطك.",
      "footer.explore": "استكشف",
      "footer.support": "الدعم",
      "footer.legal": "قانوني",
      "footer.shop": "المتجر",
      "footer.help": "الأسئلة الشائعة",
      "footer.terms": "شروط الاستخدام",
      "footer.rights": "© {{year}} Utkan eSIM. جميع الحقوق محفوظة.",
      "footer.apps": "تنزيل التطبيق",
      "whatsapp.label": "راسلنا عبر واتساب",
      "whatsapp.message": "مرحباً، لدي طلب دعم لـ eSIM.",
      "notfound.eyebrow": "لا توجد إشارة",
      "notfound.title": "هذه الصفحة غير متوفرة",
      "notfound.message": "ربما تم نقل الصفحة التي تبحث عنها أو أنها لم تكن موجودة أبداً. دعنا نعيدك إلى منطقة التغطية.",
      "order.congrats": "تهانينا!",
      "order.message": "شريحة eSIM الخاصة بك جاهزة. يمكنك إعدادها في بضع خطوات باستخدام رمز QR أدناه.",
      "order.details": "ملخص الطلب",
      "order.activation": "التفعيل",
      "order.activationDesc": "لإعداد eSIM الخاصة بك، قم بمسح رمز QR باستخدام كاميرا جهازك أو أدخل رمز الإعداد يدوياً.",
      "order.qrTitle": "رمز الاستجابة السريعة (QR) لـ eSIM",
      "order.manualLabel": "رمز الإعداد",
      "order.copy": "نسخ",
      "order.copied": "تم النسخ",
      "order.howTo": "كيفية التفعيل؟",
      "order.step1": "اذهب إلى الإعدادات > البيانات الخلوية / بيانات الجوال > إضافة eSIM على جهازك.",
      "order.step2": "اختر \"استخدام رمز QR\" وقم بمسح رمز QR أعلاه (أو أدخل رمز الإعداد يدوياً).",
      "order.step3": "بمجرد اكتمال الإعداد، قم بتفعيل خطة eSIM الخاصة بك.",
      "order.step4": "تأكد من تشغيل تجوال البيانات — أنت الآن متصل!",
      "order.cta": "العودة إلى الصفحة الرئيسية",
      "checkout.title": "الدفع",
      "checkout.summary": "ملخص الطلب",
      "checkout.total": "الإجمالي",
      "checkout.eurNote": "يتم تحصيل المبلغ باليورو (€) على PayPal.",
      "checkout.processing": "جاري التحقق من الدفع…",
      "checkout.error": "تعذر إكمال الدفع. يرجى المحاولة مرة أخرى.",
      "checkout.cancelled": "تم إلغاء الدفع.",
      "account.title": "حسابي",
      "account.tab.profile": "الملف الشخصي",
      "account.tab.esims": "شرائح eSIM الخاصة بي",
      "account.tab.security": "الأمان",
      "account.profile.title": "معلومات الملف الشخصي",
      "account.field.phone": "الهاتف",
      "account.field.phone.ph": "+90…",
      "account.memberSince": "عضو منذ",
      "account.save": "حفظ",
      "account.saving": "جاري الحفظ…",
      "account.saved": "تم تحديث معلوماتك.",
      "account.esims.title": "شرائح eSIM الخاصة بي",
      "account.esims.empty": "ليس لديك شريحة eSIM بعد.",
      "account.esims.emptyCta": "تصفح المتجر",
      "account.esims.data": "البيانات",
      "account.esims.expires": "تاريخ الانتهاء",
      "account.esims.viewQr": "إظهار رمز QR",
      "account.esims.hideQr": "إخفاء رمز QR",
      "account.esims.active": "نشط",
      "account.esims.passive": "غير نشط",
      "account.esims.noActive": "ليس لديك شرائح eSIM نشطة.",
      "account.esims.noPassive": "ليس لديك شرائح eSIM غير نشطة.",
      "account.esims.readyHint": "جاهز للاستخدام — تبدأ المدة عند الاستخدام الأول.",
      "account.esims.unavailableHint": "تعذر تحميل الحالة في الوقت الحالي. حاول مرة أخرى لاحقاً.",
      "esimStatus.active": "نشط",
      "esimStatus.readyToUse": "جاهز للاستخدام",
      "esimStatus.inactive": "غير نشط",
      "esimStatus.unavailable": "تعذر تحميل الحالة",
      "account.security.title": "تغيير كلمة المرور",
      "account.field.oldPassword": "كلمة المرور الحالية",
      "account.field.newPassword": "كلمة مرور جديدة",
      "account.field.confirmPassword": "كلمة مرور جديدة (تأكيد)",
      "account.changePassword": "تحديث كلمة المرور",
      "account.passwordChanged": "تم تحديث كلمة المرور الخاصة بك.",
      "account.error.passwordMismatch": "كلمات المرور الجديدة غير متطابقة.",
      "account.danger.title": "إجراءات الحساب",
      "account.delete": "حذف الحساب",
      "account.delete.confirm": "أنت على وشك حذف حسابك بشكل دائم. لا يمكن التراجع عن هذا الإجراء.",
      "account.delete.confirmBtn": "نعم، احذف",
      "account.cancel": "إلغاء",
      "esimDetail.back": "رجوع",
      "esimDetail.dataUsage": "استخدام البيانات",
      "esimDetail.left": "متبقي",
      "esimDetail.leftData": "البيانات المتبقية",
      "esimDetail.usedData": "المستخدم",
      "esimDetail.totalData": "إجمالي البيانات",
      "esimDetail.qrDesc": "قم بإعداد eSIM الخاص بك عن طريق مسح رمز QR هذا باستخدام كاميرا جهازك.",
      "esimDetail.validity": "الصلاحية",
      "esimDetail.daysLeft": "باقي {{days}} يوم",
      "esimDetail.expired": "منتهي الصلاحية",
      "esimDetail.notYetActive": "غير نشط بعد",
      "esimDetail.leftDate": "الوقت المتبقي",
      "esimDetail.activationDate": "تاريخ التفعيل",
      "esimDetail.endDate": "تاريخ الانتهاء",
      "esimDetail.technical": "معلومات فنية",
      "esimDetail.activationCode": "رمز التفعيل (Android)",
      "esimDetail.smdp": "عنوان SM-DP+ (iOS)",
      "esimDetail.matchingId": "معرف المطابقة (iOS)",
      "esimDetail.support": "الدعم الفني",
      "esimDetail.supportDesc": "هل تواجه مشكلة؟ دعنا نساعدك.",
      "esimDetail.email": "إرسال بريد إلكتروني",
      "guide.eyebrow": "دليل eSIM",
      "guide.title": "ما هي eSIM وكيف يتم تثبيتها؟",
      "guide.intro.title": "ما هي eSIM؟",
      "guide.intro.body": "إن eSIM عبارة عن شريحة SIM رقمية مدمجة في جهازك وتعمل دون الحاجة إلى بطاقة SIM فعلية. تقوم بإعداد خطك في ثوانٍ عن طريق مسح رمز QR؛ وتتيح لك الاتصال بالإنترنت في أكثر من 190 دولة دون تغيير البطاقات ودون فواتير تجوال.",
      "guide.steps.title": "كيفية التفعيل؟",
      "guide.devices.title": "الأجهزة المدعومة",
      "guide.devices.desc": "يجب أن يكون جهازك متوافقاً مع eSIM لكي تعمل. تحقق من العلامة التجارية لجهازك.",
      "guide.faq.title": "الأسئلة الشائعة",
      "nav.guide": "دليل eSIM",
      "currency.label": "العملة",
      "staticPage.loading": "جاري تحميل الصفحة...",
      "staticPage.errorTitle": "حدث خطأ",
      "staticPage.retry": "حاول مرة أخرى",
      "staticPage.loadFailed": "تعذر تحميل محتوى الصفحة. يرجى المحاولة مرة أخرى لاحقاً.",
      "last.updated": "آخر تحديث: 8 يوليو 2024",

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      "home.tabs.unlimited": "شرائح eSIM غير محدودة",
      "detail.unlimited": "غير محدود",
      "detail.unlimitedNote": "لا يوجد حد للبيانات في هذه الباقة — إنترنت غير محدود طوال مدة الصلاحية.",
      "detail.notPriced": "هذه الباقة غير متاحة للشراء عبر الويب حالياً.",
      "checkout.priceUpdated": "تم تحديث سعر هذه الباقة. يرجى العودة إلى المتجر واختيارها مرة أخرى.",
      "order.pending.title": "يتم تجهيز شريحة eSIM الخاصة بك",
      "order.pending.message": "تم استلام دفعتك. قد يستغرق تفعيل الباقات غير المحدودة بضع دقائق.",
      "order.pending.waiting": "جاري التحقق من حالة طلبك…",
      "order.pending.ready": "شريحة eSIM جاهزة!",
      "order.pending.timeout": "يستغرق الأمر وقتاً أطول من المتوقع. دفعتك آمنة — ستظهر شريحة eSIM في «شرائحي» بمجرد أن تصبح جاهزة.",
      "order.pending.cta": "الذهاب إلى شرائحي",
      "account.esims.unlimited": "غير محدود",
      "account.esims.unlimitedHint": "بيانات غير محدودة — لا يوجد حد للبيانات في هذه الباقة.",
      "esimDetail.unlimitedData": "لا يوجد حد للبيانات في هذه الباقة؛ اطلع على المدة المتبقية أدناه.",


      // صفحة حذف الحساب (/hesap-sil · /account-deletion) — متطلب Google Play «Data deletion»
      "del.eyebrow": "حذف الحساب",
      "del.title": "حذف حسابي",
      "del.intro": "يمكنك من هنا حذف حسابك في Utkan eSIM وبياناتك الشخصية نهائيًا. لا حاجة لتثبيت التطبيق — يكفي تسجيل الدخول بالحساب الذي تريد حذفه.",
      "del.deleted.title": "البيانات التي يتم حذفها",
      "del.deleted.identity": "الاسم واللقب وعنوان البريد الإلكتروني ورقم الهاتف",
      "del.deleted.credentials": "كلمة المرور وبيانات الجلسة",
      "del.deleted.codes": "رموز تأكيد البريد الإلكتروني وإعادة تعيين كلمة المرور",
      "del.deleted.esim": "رقم شريحة eSIM (MSISDN) ورمز QR/التفعيل وبيانات الاستخدام",
      "del.kept.title": "البيانات التي نحتفظ بها وسببها",
      "del.kept.orders": "يتم الاحتفاظ بسجلات الشراء (رقم الطلب والتاريخ والمبلغ وحالة الدفع) للوفاء بالالتزامات الضريبية والمحاسبية. لا تتضمن هذه السجلات اسمك أو بريدك الإلكتروني أو بيانات الدفع، بل معرّفًا لا يمكن ربطه بك.",
      "del.kept.period": "مدة الاحتفاظ: 5 سنوات (قانون الإجراءات الضريبية التركي، المادة 253).",
      "del.warn.title": "قبل الحذف",
      "del.warn.irreversible": "لا يمكن التراجع عن هذا الإجراء.",
      "del.warn.esim": "تستمر شرائح eSIM النشطة في العمل على جهازك، لكن لن تتمكن بعد الآن من الوصول إلى رمز QR أو رصيدك المتبقي. احفظ رمز QR قبل الحذف.",
      "del.warn.rejoin": "يمكنك التسجيل مرة أخرى بالبريد الإلكتروني نفسه، لكن شرائح eSIM السابقة لن تظهر في الحساب الجديد.",
      "del.support": "إذا تعذّر عليك تسجيل الدخول، يمكنك أيضًا طلب الحذف عبر البريد الإلكتروني:",
      "del.login.title": "سجّل الدخول أولًا",
      "del.login.subtitle": "أدخل بريدك الإلكتروني وكلمة المرور للتأكد من أن الحساب يخصّك.",
      "del.login.action": "تسجيل الدخول",
      "del.login.loading": "جاري تسجيل الدخول...",
      "del.forgot": "هل نسيت كلمة المرور؟",
      "del.confirm.title": "هل أنت متأكد؟",
      "del.confirm.subtitle": "سيتم حذف الحساب {{email}} وبياناتك الشخصية نهائيًا.",
      "del.confirm.field": "اكتب بريدك الإلكتروني مرة أخرى للتأكيد",
      "del.confirm.action": "حذف حسابي نهائيًا",
      "del.confirm.deleting": "جاري الحذف...",
      "del.confirm.cancel": "إلغاء",
      "del.done.title": "تم حذف حسابك",
      "del.done.body": "تم حذف بياناتك الشخصية نهائيًا.",
      "del.done.retained": "تم حذف بياناتك الشخصية نهائيًا. تم الاحتفاظ بـ {{n}} من سجلات الشراء للوفاء بالالتزامات القانونية، ولا يمكن ربطها بك.",
      "del.done.home": "العودة إلى المتجر",
      "del.error.required": "يرجى إدخال بريدك الإلكتروني وكلمة المرور.",
      "del.error.credentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
      "del.error.suspended": "تم تعليق حسابك. يرجى التواصل مع الدعم.",
      "del.error.session": "انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى.",
      "del.error.network": "تعذّر الاتصال. تحقق من اتصالك بالإنترنت وحاول مرة أخرى.",
      "del.error.generic": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
      "footer.deleteAccount": "حذف الحساب",


      // باقات الصوت (بيانات + مكالمات ورسائل غير محدودة) — docs/ses-paketleri.md
      "home.tabs.voice": "شرائح eSIM مع المكالمات",
      "detail.voice": "مكالمات + رسائل",
      "detail.voiceNote": "تتضمن هذه الباقة مكالمات ورسائل SMS غير محدودة إضافة إلى الإنترنت — شريحة واحدة للإنترنت والمكالمات.",
      "detail.calls": "المكالمات",
      "detail.sms": "الرسائل",
      "plan.unlimitedCalls": "مكالمات غير محدودة",
      "plan.unlimitedSms": "رسائل SMS غير محدودة",
      "plan.minutes": "{{n}} دقيقة مكالمات",
      "plan.sms": "{{n}} رسالة SMS",

      // Hercules — مكالمات غير محدودة في أوروبا (docs/hercules-sayfasi.md)
      "hercules.subtitle": "مكالمات ورسائل وبيانات غير محدودة في {{n}} دولة أوروبية — شريحة eSIM واحدة.",
      "hercules.coverageTitle": "الدول المشمولة ({{n}})",
      "hercules.promo.desc": "مكالمات ورسائل غير محدودة في {{n}} دولة، مع بيانات من 20 إلى 100 جيجابايت.",
      "hercules.promo.cta": "عرض الباقة",
      "loading": "جاري التحميل..."
    }
  },
  it: {
    translation: {
      "language.title": "Lingua",

      "hero.title": "Utkan eSIM",
      "hero.subtitle": "Il Futuro della Connettività Digitale",
      "hero.description": "Eliminiamo i confini con un'esperienza di connettività digitale di nuova generazione.",
      "hero.description2": "Soluzioni eSIM veloci, sicure e convenienti in tutto il mondo.",
      "features.countries": "150+ Paesi",
      "features.activation": "Attivazione Istantanea",
      "features.support": "Supporto 24/7",
      "countdown.title": "Il Nostro Sito Web Arriverà Presto!",
      "countdown.days": "Giorni",
      "countdown.hours": "Ore",
      "countdown.minutes": "Minuti",
      "countdown.seconds": "Secondi",
      "countdown.launch": "Il Nostro Sito Web È Aperto!",
      "countdown.loading": "Caricamento...",
      "apps.title": "Le Nostre Applicazioni Mobili",
      "apps.ios.label": "Scarica su",
      "apps.ios.name": "App Store",
      "apps.android.label": "DISPONIBILE SU",
      "apps.android.name": "Google Play",
      "contact.title": "Contattaci Prima del Lancio",
      "contact.whatsapp": "WhatsApp: +90 540 155 13 33",
      "contact.email": "E-mail: info@utkanesim.com",
      "about.hero.title": "Informazioni su Utkan eSIM",
      "about.hero.description": "La sicurezza dei tuoi dati personali è molto importante per noi. Questa politica spiega come i tuoi dati vengono raccolti, utilizzati e protetti.",
      "about.story.title": "La Nostra Storia",
      "about.story.content": "Fondata nel 2024 da un team di viaggiatori appassionati e appassionati di tecnologia, Utkan eSIM mira a rivoluzionare il modo in cui le persone si connettono a Internet all'estero. Offrendo piani dati eSIM affidabili e di alta qualità per oltre 190 paesi e regioni, garantiamo il tuo accesso rapido a Internet dal momento in cui atterri.",
      "about.mission.title": "La Nostra Missione",
      "about.mission.content": "Fornire ai viaggiatori una connettività globale semplice, conveniente e istantanea, consentendo loro di esplorare, lavorare e rimanere in contatto senza confini.",
      "about.vision.title": "La Nostra Visione",
      "about.vision.content": "Essere la piattaforma globale leader per le soluzioni di connettività digitale, rendendo il mondo un posto più piccolo e più connesso per tutti.",
      "about.features.title": "Perché Sceglierci?",
      "about.features.instant.title": "Consegna Istantanea",
      "about.features.instant.content": "Ottieni la tua eSIM istantaneamente con un codice QR dopo l'acquisto.",
      "about.features.global.title": "Copertura Globale",
      "about.features.global.content": "Piani dati per oltre 190 paesi e regioni.",
      "about.features.affordable.title": "Prezzi Convenienti",
      "about.features.affordable.content": "Risparmia fino al 90% sulle tariffe di roaming.",
      "about.features.support.title": "Supporto 24/7",
      "about.features.support.content": "Il nostro team di supporto dedicato è sempre a tua disposizione.",
      "about.features.secure.title": "Connessione Sicura",
      "about.features.secure.content": "Connessione protetta dagli ultimi protocolli di sicurezza.",
      "about.features.fast.title": "Internet Veloce",
      "about.features.fast.content": "Esperienza Internet ininterrotta a velocità 4G/5G.",
      "about.cta.title": "Unisciti al Futuro della Connettività Digitale",
      "about.cta.content": "Grazie per aver scelto Utkan eSIM. Buon viaggio!",
      "about.cta.whatsapp": "Contatta tramite WhatsApp",
      "about.cta.email": "Invia un'E-mail",
      "contact.hero.title": "Contattaci",
      "contact.hero.description": "Se hai domande sulle nostre eSIM, hai bisogno di supporto tecnico o vuoi semplicemente lasciare un feedback, saremo felici di ascoltarti.",
      "contact.info.title": "Le Nostre Informazioni di Contatto",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "Supporto Rapido 24/7",
      "contact.email.title": "E-mail",
      "contact.email.subtitle": "Contatto Generale",
      "contact.support.title": "Supporto Tecnico",
      "contact.support.subtitle": "Problemi eSIM",
      "contact.business.title": "Partnership Commerciale",
      "contact.business.subtitle": "Contatto Aziendale",
      "contact.hours.title": "Orari di Supporto",
      "contact.hours.subtitle": "Supporto Tecnico 24/7",
      "contact.hours.detail": "Lunedì - Domenica: 00:00 - 23:59",
      "contact.form.title": "Invia un Messaggio",
      "contact.form.name": "Nome e Cognome",
      "contact.form.name.placeholder": "Inserisci il tuo nome e cognome",
      "contact.form.email": "Il Tuo Indirizzo E-mail",
      "contact.form.email.placeholder": "esempio@email.com",
      "contact.form.subject": "Oggetto",
      "contact.form.subject.placeholder": "Seleziona un oggetto",
      "contact.form.subject.general": "Informazioni Generali",
      "contact.form.subject.technical": "Supporto Tecnico",
      "contact.form.subject.billing": "Domande sulla Fatturazione",
      "contact.form.subject.partnership": "Partnership Commerciale",
      "contact.form.subject.feedback": "Feedback",
      "contact.form.message": "Il Tuo Messaggio",
      "contact.form.message.placeholder": "Scrivi qui il tuo messaggio...",
      "contact.form.submit": "Invia Messaggio",
      "contact.faq.title": "Domande Frequenti",
      "contact.faq.esim.title": "Come funziona la eSIM?",
      "contact.faq.esim.content": "La eSIM è una scheda SIM digitale che funziona nel tuo telefono senza la necessità di una scheda SIM fisica. Viene attivata istantaneamente con un codice QR.",
      "contact.faq.phones.title": "Quali telefoni supportano la eSIM?",
      "contact.faq.phones.content": "I modelli iPhone XS e successivi, Samsung Galaxy S20 e successivi, Google Pixel 3 e successivi supportano la eSIM.",
      "contact.faq.validity.title": "Per quanto tempo è valido il mio piano dati?",
      "contact.faq.validity.content": "Il periodo di validità dei piani varia da 1 a 30 giorni a seconda del piano scelto.",
      "contact.faq.payment.title": "Come si effettua il pagamento?",
      "contact.faq.payment.content": "Puoi pagare in modo sicuro con carta di credito, PayPal e bonifico bancario.",
      "privacy.hero.title": "Informativa sulla Privacy",
      "privacy.hero.description": "La sicurezza dei tuoi dati personali è molto importante per noi. Questa politica spiega come i tuoi dati vengono raccolti, utilizzati e protetti.",
      "privacy.overview.title": "Panoramica",
      "privacy.overview.content": "Questa Informativa sulla Privacy descrive le nostre politiche e procedure sulla raccolta, l'uso e la divulgazione delle tue informazioni quando utilizzi il nostro Servizio. Ti informa inoltre sui tuoi diritti alla privacy e su come la legge ti protegge.",
      "privacy.data.title": "Dati che Raccogliamo",
      "privacy.data.personal.title": "Informazioni Personali",
      "privacy.data.personal.name": "Nome e cognome",
      "privacy.data.personal.email": "Indirizzo e-mail",
      "privacy.data.personal.phone": "Numero di telefono",
      "privacy.data.personal.payment": "Informazioni di pagamento",
      "privacy.data.usage.title": "Dati di Utilizzo",
      "privacy.data.usage.ip": "Indirizzo IP",
      "privacy.data.usage.browser": "Tipo di browser",
      "privacy.data.usage.device": "Informazioni sul dispositivo",
      "privacy.data.usage.stats": "Statistiche di utilizzo",
      "privacy.security.title": "Sicurezza dei Dati",
      "privacy.security.ssl.title": "Crittografia SSL",
      "privacy.security.ssl.content": "Tutti i trasferimenti di dati sono protetti da crittografia SSL a 256 bit.",
      "privacy.security.servers.title": "Server Sicuri",
      "privacy.security.servers.content": "I tuoi dati sono archiviati su server sicuri certificati ISO 27001.",
      "privacy.security.access.title": "Controllo degli Accessi",
      "privacy.security.access.content": "Solo il personale autorizzato può accedere ai tuoi dati.",
      "privacy.usage.title": "Utilizzo dei Dati",
      "privacy.usage.intro": "Utilizziamo i dati che raccogliamo per i seguenti scopi:",
      "privacy.usage.service.title": "Fornitura del Servizio",
      "privacy.usage.service.content": "Per fornire e gestire i nostri servizi eSIM",
      "privacy.usage.support.title": "Assistenza Clienti",
      "privacy.usage.support.content": "Per fornire supporto tecnico e servizio clienti",
      "privacy.usage.security.title": "Sicurezza",
      "privacy.usage.security.content": "Per proteggere il tuo account e i nostri servizi",
      "privacy.usage.improvement.title": "Miglioramento",
      "privacy.usage.improvement.content": "Per migliorare i nostri servizi e aggiungere nuove funzionalità",
      "privacy.sharing.title": "Condivisione dei Dati",
      "privacy.sharing.intro": "Non condividiamo i tuoi dati personali con terze parti, ma la condivisione potrebbe essere necessaria nei seguenti casi:",
      "privacy.sharing.legal": "In caso di obbligo legale",
      "privacy.sharing.providers": "Con i nostri fornitori di servizi (come i processori di pagamento)",
      "privacy.sharing.threats": "Per prevenire minacce alla sicurezza",
      "privacy.sharing.consent": "Con il tuo esplicito consenso",
      "privacy.rights.title": "I Tuoi Diritti",
      "privacy.rights.access.title": "Diritto di Accesso",
      "privacy.rights.access.content": "Puoi richiedere l'accesso ai dati che conserviamo su di te.",
      "privacy.rights.correction.title": "Diritto di Rettifica",
      "privacy.rights.correction.content": "Possiamo correggere i tuoi dati inesatti o incompleti.",
      "privacy.rights.deletion.title": "Diritto di Cancellazione",
      "privacy.rights.deletion.content": "Possiamo cancellare i tuoi dati a determinate condizioni.",
      "privacy.rights.objection.title": "Diritto di Opposizione",
      "privacy.rights.objection.content": "Puoi opporti alle nostre attività di trattamento dei dati.",
      "privacy.contact.title": "Contatto",
      "privacy.contact.intro": "In caso di domande sulla presente Informativa sulla Privacy, è possibile contattarci tramite i seguenti canali:",
      "nav.about": "Chi Siamo",
      "nav.contact": "Contatti",
      "nav.privacy": "Privacy",
      "nav.login": "Accedi",
      "nav.account": "Il Mio Account",
      "nav.logout": "Esci",
      "auth.brand.eyebrow": "COPERTURA GLOBALE",
      "auth.brand.title": "Internet dal momento in cui atterri in più di 150 paesi.",
      "auth.brand.subtitle": "Nessuna SIM fisica, nessuna bolletta di roaming. Attiva la tua eSIM in pochi secondi.",
      "auth.login.eyebrow": "ACCESSO ALL'ACCOUNT",
      "auth.login.title": "Bentornato",
      "auth.login.subtitle": "Gestisci le tue eSIM e scoprine di nuove.",
      "auth.signup.eyebrow": "NUOVO ACCOUNT",
      "auth.signup.title": "Unisciti a noi",
      "auth.signup.subtitle": "Prepara la tua prima eSIM in pochi passaggi.",
      "auth.field.identifier": "E-mail o telefono",
      "auth.field.identifier.ph": "esempio@email.com o +39…",
      "auth.field.email": "E-mail",
      "auth.field.email.ph": "esempio@email.com",
      "auth.field.fullName": "Nome e cognome",
      "auth.field.fullName.ph": "Il tuo nome e cognome",
      "auth.field.password": "Password",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "Accedi",
      "auth.action.loggingIn": "Accesso in corso…",
      "auth.action.signup": "Crea account",
      "auth.action.signingUp": "Creazione account…",
      "auth.toSignup.q": "Non hai un account?",
      "auth.toSignup.link": "Registrati",
      "auth.toLogin.q": "Hai già un account?",
      "auth.toLogin.link": "Accedi",
      "auth.password.show": "Mostra password",
      "auth.password.hide": "Nascondi password",
      "auth.terms.prefix": "Continuando, accetto i ",
      "auth.terms.link": "Termini di Utilizzo e l'Informativa sulla Privacy",
      "auth.terms.suffix": ".",
      "auth.error.required": "Si prega di compilare i campi richiesti.",
      "auth.error.terms": "Devi accettare i termini per continuare.",
      "verify.eyebrow": "VERIFICA E-MAIL",
      "verify.title": "Verifica la tua e-mail",
      "verify.subtitle": "Abbiamo inviato un codice a 6 cifre a {{email}}. Inserisci il codice per verificare.",
      "verify.code": "Codice di verifica",
      "verify.code.ph": "••••••",
      "verify.action": "Verifica",
      "verify.verifying": "Verifica in corso…",
      "verify.resend": "Invia di nuovo il codice",
      "verify.resendIn": "Invia di nuovo in {{seconds}} s",
      "verify.resent": "Nuovo codice inviato.",
      "verify.skip": "Salta per ora",
      "auth.forgot.link": "Hai dimenticato la password?",
      "forgot.eyebrow": "REIMPOSTA PASSWORD",
      "forgot.email.title": "Reimposta la tua password",
      "forgot.email.subtitle": "Inserisci l'indirizzo e-mail del tuo account; ti invieremo un codice di ripristino a 6 cifre.",
      "forgot.email.action": "Invia codice",
      "forgot.email.sending": "Invio in corso…",
      "forgot.reset.title": "Imposta la tua nuova password",
      "forgot.reset.subtitle": "Inserisci il codice a 6 cifre che abbiamo inviato a {{email}} e la tua nuova password.",
      "forgot.reset.action": "Aggiorna password",
      "forgot.reset.updating": "Aggiornamento in corso…",
      "forgot.field.code": "Codice di ripristino",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "Nuova password",
      "forgot.field.newPassword.ph": "Almeno 6 caratteri",
      "forgot.resend": "Invia di nuovo il codice",
      "forgot.resendIn": "Invia di nuovo in {{seconds}} s",
      "forgot.resent": "Nuovo codice inviato.",
      "forgot.backToLogin": "Torna all'accesso",
      "forgot.changeEmail": "Cambia e-mail",
      "forgot.help.noMail": "Se il codice non è arrivato, controlla la cartella spam o verifica il tuo indirizzo e-mail.",
      "reset.RESET_CODE_SENT": "Codice inviato. Controlla la tua e-mail.",
      "reset.RATE_LIMITED": "Hai effettuato troppi tentativi. Attendi un momento e riprova.",
      "reset.MAIL_SEND_FAILED": "Qualcosa è andato storto. Riprova più tardi.",
      "reset.RESET_CODE_VALID": "Codice verificato.",
      "reset.INVALID_RESET_CODE": "Codice errato. Riprova.",
      "reset.EXPIRED_RESET_CODE": "Il codice è scaduto. Richiedi un nuovo codice.",
      "reset.WEAK_PASSWORD": "La password deve contenere almeno 6 caratteri.",
      "reset.PASSWORD_RESET_SUCCESS": "La tua password è stata aggiornata. Puoi accedere con la tua nuova password.",
      "reset.generic": "Qualcosa è andato storto. Riprova.",
      "login.resetSuccess": "La tua password è stata aggiornata. Puoi accedere con la tua nuova password.",
      "store.nav.shop": "Negozio",
      "home.hero.title1": "Connettiti in pochi minuti,",
      "home.hero.title2": "rimani oltre i confini.",
      "home.hero.subtitle": "Piani eSIM affidabili validi in oltre 190 paesi. Nessuna SIM fisica, nessuna bolletta di roaming.",
      "home.search.placeholder": "Dove viaggi?",
      "home.tabs.local": "eSIM locali",
      "home.tabs.regional": "eSIM regionali",
      "home.tabs.lifetime": "eSIM a vita",
      "home.empty": "Nessun risultato trovato per la tua ricerca.",
      "home.error.title": "Impossibile caricare i contenuti",
      "home.error.retry": "Riprova",
      "home.from": "da",
      "home.popular": "Destinazioni popolari",
      "home.coverage": "190+ paesi · attivazione istantanea",
      "home.detail.soon": "I piani per questa selezione verranno elencati qui a breve.",
      "home.detail.back": "Torna al negozio",
      "detail.plans": "Piani",
      "detail.count": "{{count}} piano/i",
      "detail.validity": "{{days}} giorni",
      "detail.validityLifetime": "Senza scadenza",
      "detail.buy": "Acquista",
      "detail.empty": "Al momento non ci sono piani per questa selezione.",
      "detail.checkoutSoon": "Il flusso di pagamento verrà aggiunto a breve.",
      "detail.loginToBuy": "Devi accedere per acquistare.",
      "detail.basicFeatures": "Caratteristiche di base",
      "detail.dataAmount": "Quantità di dati",
      "detail.validityLabel": "Periodo di validità",
      "detail.coverageArea": "Area di copertura",
      "detail.activationNetworks": "Attivazione e Reti",
      "detail.activationMethod": "Metodo di attivazione",
      "detail.esimActivation": "eSIM — istantaneo con codice QR",
      "detail.supportedNetworks": "Reti supportate",
      "detail.description": "Descrizione",
      "detail.price": "Prezzo",
      "authprompt.title": "Accedi per continuare",
      "authprompt.message": "Accedi al tuo account per acquistare una eSIM o crea un nuovo account in pochi secondi.",
      "authprompt.close": "Chiudi",
      "footer.tagline": "eSIM veloce, sicura e conveniente in tutto il mondo. Connettiti a Internet non appena atterri.",
      "footer.explore": "Esplora",
      "footer.support": "Supporto",
      "footer.legal": "Legale",
      "footer.shop": "Negozio",
      "footer.help": "Domande Frequenti",
      "footer.terms": "Termini di Utilizzo",
      "footer.rights": "© {{year}} Utkan eSIM. Tutti i diritti riservati.",
      "footer.apps": "Scarica l'app",
      "whatsapp.label": "Scrivici su WhatsApp",
      "whatsapp.message": "Ciao, ho una richiesta di supporto per la eSIM.",
      "notfound.eyebrow": "NESSUN SEGNALE",
      "notfound.title": "Questa pagina non è disponibile",
      "notfound.message": "La pagina che stai cercando potrebbe essere stata spostata o non è mai esistita. Ti riportiamo nell'area di copertura.",
      "order.congrats": "Congratulazioni!",
      "order.message": "La tua eSIM è pronta. Puoi configurarla in pochi passaggi con il codice QR qui sotto.",
      "order.details": "Riepilogo dell'ordine",
      "order.activation": "Attivazione",
      "order.activationDesc": "Per configurare la tua eSIM, scansiona il codice QR con la fotocamera del tuo dispositivo o inserisci manualmente il codice di configurazione.",
      "order.qrTitle": "Codice QR eSIM",
      "order.manualLabel": "Codice di configurazione",
      "order.copy": "Copia",
      "order.copied": "Copiato",
      "order.howTo": "Come attivare?",
      "order.step1": "Vai su Impostazioni > Cellulare / Dati mobili > Aggiungi eSIM sul tuo dispositivo.",
      "order.step2": "Seleziona \"Usa codice QR\" e scansiona il codice QR sopra (o inserisci manualmente il codice di configurazione).",
      "order.step3": "Una volta completata l'installazione, attiva il tuo piano eSIM.",
      "order.step4": "Assicurati che il roaming dati sia attivo — ora sei connesso!",
      "order.cta": "Torna alla home page",
      "checkout.title": "Pagamento",
      "checkout.summary": "Riepilogo dell'ordine",
      "checkout.total": "Totale",
      "checkout.eurNote": "L'importo viene addebitato in euro (€) su PayPal.",
      "checkout.processing": "Verifica del pagamento in corso…",
      "checkout.error": "Non è stato possibile completare il pagamento. Riprova.",
      "checkout.cancelled": "Pagamento annullato.",
      "account.title": "Il Mio Account",
      "account.tab.profile": "Profilo",
      "account.tab.esims": "Le Mie eSIM",
      "account.tab.security": "Sicurezza",
      "account.profile.title": "Informazioni del profilo",
      "account.field.phone": "Telefono",
      "account.field.phone.ph": "+39…",
      "account.memberSince": "Membro dal",
      "account.save": "Salva",
      "account.saving": "Salvataggio in corso…",
      "account.saved": "Le tue informazioni sono state aggiornate.",
      "account.esims.title": "Le Mie eSIM",
      "account.esims.empty": "Non hai ancora una eSIM.",
      "account.esims.emptyCta": "Esplora il negozio",
      "account.esims.data": "Dati",
      "account.esims.expires": "Data di fine",
      "account.esims.viewQr": "Mostra codice QR",
      "account.esims.hideQr": "Nascondi codice QR",
      "account.esims.active": "Attivo",
      "account.esims.passive": "Inattivo",
      "account.esims.noActive": "Non hai eSIM attive.",
      "account.esims.noPassive": "Non hai eSIM inattive.",
      "account.esims.readyHint": "Pronto per l'uso — la durata inizia al primo utilizzo.",
      "account.esims.unavailableHint": "Al momento non è stato possibile caricare lo stato. Riprova più tardi.",
      "esimStatus.active": "Attivo",
      "esimStatus.readyToUse": "Pronto per l'uso",
      "esimStatus.inactive": "Inattivo",
      "esimStatus.unavailable": "Impossibile caricare lo stato",
      "account.security.title": "Cambia password",
      "account.field.oldPassword": "Password attuale",
      "account.field.newPassword": "Nuova password",
      "account.field.confirmPassword": "Nuova password (ripeti)",
      "account.changePassword": "Aggiorna password",
      "account.passwordChanged": "La tua password è stata aggiornata.",
      "account.error.passwordMismatch": "Le nuove password non corrispondono.",
      "account.danger.title": "Azioni sull'account",
      "account.delete": "Elimina account",
      "account.delete.confirm": "Stai per eliminare definitivamente il tuo account. Questa azione non può essere annullata.",
      "account.delete.confirmBtn": "Sì, elimina",
      "account.cancel": "Annulla",
      "esimDetail.back": "Indietro",
      "esimDetail.dataUsage": "Utilizzo dati",
      "esimDetail.left": "rimanente",
      "esimDetail.leftData": "Dati rimanenti",
      "esimDetail.usedData": "Utilizzato",
      "esimDetail.totalData": "Dati totali",
      "esimDetail.qrDesc": "Configura la tua eSIM scansionando questo codice QR con la fotocamera del tuo dispositivo.",
      "esimDetail.validity": "Validità",
      "esimDetail.daysLeft": "{{days}} giorno/i rimanente/i",
      "esimDetail.expired": "Scaduto",
      "esimDetail.notYetActive": "Non ancora attivo",
      "esimDetail.leftDate": "Tempo rimanente",
      "esimDetail.activationDate": "Data di attivazione",
      "esimDetail.endDate": "Data di fine",
      "esimDetail.technical": "Informazioni tecniche",
      "esimDetail.activationCode": "Codice di attivazione (Android)",
      "esimDetail.smdp": "Indirizzo SM-DP+ (iOS)",
      "esimDetail.matchingId": "ID di corrispondenza (iOS)",
      "esimDetail.support": "Supporto tecnico",
      "esimDetail.supportDesc": "Hai qualche problema? Lasciati aiutare.",
      "esimDetail.email": "Invia un'e-mail",
      "guide.eyebrow": "GUIDA eSIM",
      "guide.title": "Cos'è una eSIM e come installarla?",
      "guide.intro.title": "Cos'è una eSIM?",
      "guide.intro.body": "La eSIM è una SIM digitale integrata nel tuo dispositivo che funziona senza la necessità di una scheda SIM fisica. Configura la tua linea in pochi secondi scansionando un codice QR; ti connetti a Internet in oltre 190 paesi senza cambiare scheda e senza bollette di roaming.",
      "guide.steps.title": "Come attivarla?",
      "guide.devices.title": "Dispositivi supportati",
      "guide.devices.desc": "Il tuo dispositivo deve essere compatibile con eSIM affinché funzioni. Controlla il tuo marchio.",
      "guide.faq.title": "Domande frequenti",
      "nav.guide": "Guida eSIM",
      "currency.label": "Valuta",
      "staticPage.loading": "Caricamento della pagina...",
      "staticPage.errorTitle": "Si È Verificato Un Errore",
      "staticPage.retry": "Riprova",
      "staticPage.loadFailed": "Impossibile caricare il contenuto della pagina. Riprova più tardi.",
      "last.updated": "Ultimo aggiornamento: 8 luglio 2024",

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      "home.tabs.unlimited": "eSIM illimitate",
      "detail.unlimited": "Illimitato",
      "detail.unlimitedNote": "Questo pacchetto non ha limiti di dati: internet illimitato per tutta la durata di validità.",
      "detail.notPriced": "Questo pacchetto non è al momento acquistabile dal web.",
      "checkout.priceUpdated": "Il prezzo di questo pacchetto è cambiato. Torna al negozio e selezionalo di nuovo.",
      "order.pending.title": "La tua eSIM è in preparazione",
      "order.pending.message": "Il pagamento è andato a buon fine. I pacchetti illimitati possono richiedere qualche minuto per l'attivazione.",
      "order.pending.waiting": "Verifica dello stato dell'ordine…",
      "order.pending.ready": "La tua eSIM è pronta!",
      "order.pending.timeout": "Sta impiegando più tempo del previsto. Il pagamento è al sicuro: la tua eSIM comparirà in «Le mie eSIM» non appena sarà pronta.",
      "order.pending.cta": "Vai a Le mie eSIM",
      "account.esims.unlimited": "Illimitato",
      "account.esims.unlimitedHint": "Dati illimitati: questo pacchetto non ha limiti di dati.",
      "esimDetail.unlimitedData": "Questo pacchetto non ha limiti di dati; vedi il tempo rimanente qui sotto.",


      // Eliminazione account (/hesap-sil · /account-deletion) — requisito Google Play «Data deletion»
      "del.eyebrow": "Eliminazione account",
      "del.title": "Elimina il mio account",
      "del.intro": "Qui puoi eliminare definitivamente il tuo account Utkan eSIM e i tuoi dati personali. Non serve avere l'app installata: basta accedere con l'account che vuoi eliminare.",
      "del.deleted.title": "Dati che vengono eliminati",
      "del.deleted.identity": "Nome, cognome, indirizzo e-mail e numero di telefono",
      "del.deleted.credentials": "La tua password e i dati di sessione",
      "del.deleted.codes": "I codici di verifica e-mail e di reimpostazione della password",
      "del.deleted.esim": "Il numero eSIM (MSISDN), il codice QR/di attivazione e i dati di utilizzo",
      "del.kept.title": "Dati che conserviamo e perché",
      "del.kept.orders": "I documenti di acquisto (numero d'ordine, data, importo, stato del pagamento) vengono conservati per obblighi fiscali e contabili. Non contengono nome, e-mail o dati di pagamento: solo un identificativo che non può essere ricondotto a te.",
      "del.kept.period": "Periodo di conservazione: 5 anni (legge turca sulla procedura fiscale, art. 253).",
      "del.warn.title": "Prima di eliminare",
      "del.warn.irreversible": "Questa operazione non può essere annullata.",
      "del.warn.esim": "Le eSIM attive continuano a funzionare sul tuo dispositivo, ma non potrai più accedere al codice QR né ai dati residui. Salva il codice QR prima di procedere.",
      "del.warn.rejoin": "Puoi registrarti di nuovo con la stessa e-mail, ma le eSIM precedenti non compariranno nel nuovo account.",
      "del.support": "Se non riesci ad accedere, puoi richiedere la cancellazione anche via e-mail:",
      "del.login.title": "Prima accedi",
      "del.login.subtitle": "Inserisci e-mail e password per confermare che l'account è tuo.",
      "del.login.action": "Accedi",
      "del.login.loading": "Accesso in corso...",
      "del.forgot": "Password dimenticata?",
      "del.confirm.title": "Sei sicuro?",
      "del.confirm.subtitle": "L'account {{email}} e i tuoi dati personali verranno eliminati definitivamente.",
      "del.confirm.field": "Digita di nuovo il tuo indirizzo e-mail per confermare",
      "del.confirm.action": "Elimina definitivamente il mio account",
      "del.confirm.deleting": "Eliminazione...",
      "del.confirm.cancel": "Annulla",
      "del.done.title": "Il tuo account è stato eliminato",
      "del.done.body": "I tuoi dati personali sono stati eliminati definitivamente.",
      "del.done.retained": "I tuoi dati personali sono stati eliminati definitivamente. {{n}} documento/i di acquisto sono stati conservati per obblighi di legge e non possono essere ricondotti a te.",
      "del.done.home": "Torna allo store",
      "del.error.required": "Inserisci e-mail e password.",
      "del.error.credentials": "E-mail o password non corretti.",
      "del.error.suspended": "Il tuo account è stato sospeso. Contatta il supporto.",
      "del.error.session": "La tua sessione è scaduta. Accedi di nuovo.",
      "del.error.network": "Impossibile connettersi. Controlla la connessione a Internet e riprova.",
      "del.error.generic": "Si è verificato un errore. Riprova.",
      "footer.deleteAccount": "Elimina account",


      // Piani voce (dati + chiamate e SMS illimitati) — docs/ses-paketleri.md
      "home.tabs.voice": "eSIM con chiamate",
      "detail.voice": "Chiamate + SMS",
      "detail.voiceNote": "Questo piano include chiamate e SMS illimitati oltre ai dati: una sola eSIM per internet e chiamate.",
      "detail.calls": "Chiamate",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "Chiamate illimitate",
      "plan.unlimitedSms": "SMS illimitati",
      "plan.minutes": "{{n}} min di chiamate",
      "plan.sms": "{{n}} SMS",

      // Hercules — chiamate illimitate in Europa (docs/hercules-sayfasi.md)
      "hercules.subtitle": "Chiamate, SMS e dati illimitati in {{n}} Paesi europei: una sola eSIM.",
      "hercules.coverageTitle": "Paesi coperti ({{n}})",
      "hercules.promo.desc": "Chiamate e SMS illimitati in {{n}} Paesi, con 20–100 GB di dati.",
      "hercules.promo.cta": "Scopri",
      "loading": "Caricamento..."
    }
  },
  zh: {
    translation: {
      "language.title": "语言",
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "数字连接的未来",
      "hero.description": "我们通过新一代数字连接体验打破界限。",
      "hero.description2": "全球快速、安全且实惠的 eSIM 解决方案。",
      "features.countries": "150+ 国家",
      "features.activation": "即时激活",
      "features.support": "7/24 支持",
      "countdown.title": "我们的网站即将上线！",
      "countdown.days": "天",
      "countdown.hours": "小时",
      "countdown.minutes": "分钟",
      "countdown.seconds": "秒",
      "countdown.launch": "我们的网站已开通！",
      "countdown.loading": "加载中...",
      "apps.title": "我们的移动应用",
      "apps.ios.label": "下载于",
      "apps.ios.name": "App Store",
      "apps.android.label": "获取于",
      "apps.android.name": "Google Play",
      "contact.title": "在发布前联系我们",
      "contact.whatsapp": "WhatsApp：+90 540 155 13 33",
      "contact.email": "电子邮箱：info@utkanesim.com",
      "about.hero.title": "关于 Utkan eSIM",
      "about.hero.description": "您的个人数据安全对我们至关重要。本政策解释了您的数据是如何被收集、使用和保护的。",
      "about.story.title": "我们的故事",
      "about.story.content": "Utkan eSIM 由一群热情的旅行者和技术爱好者于 2024 年创立，旨在彻底改变人们在海外连接互联网的方式。通过为 190 多个国家和地区提供高质量、可靠的 eSIM 数据套餐，我们确保您在降落的那一刻就能快速接入互联网。",
      "about.mission.title": "我们的使命",
      "about.mission.content": "为全球旅行者提供简单、实惠且即时的连接，让他们能够无国界地探索、工作和保持联系。",
      "about.vision.title": "我们的愿景",
      "about.vision.content": "成为数字连接解决方案的领先全球平台，让世界对每个人来说变得更小、联系更紧密。",
      "about.features.title": "为什么选择我们？",
      "about.features.instant.title": "即时交付",
      "about.features.instant.content": "购买后通过二维码即时获取您的 eSIM。",
      "about.features.global.title": "全球覆盖",
      "about.features.global.content": "覆盖 190 多个国家和地区的数据套餐。",
      "about.features.affordable.title": "实惠价格",
      "about.features.affordable.content": "漫游费用最高可省 90%。",
      "about.features.support.title": "7/24 支持",
      "about.features.support.content": "我们的专属支持团队随时为您提供帮助。",
      "about.features.secure.title": "安全连接",
      "about.features.secure.content": "受最新安全协议保护的连接。",
      "about.features.fast.title": "高速上网",
      "about.features.fast.content": "4G/5G 速度下的无缝互联网体验。",
      "about.cta.title": "加入数字连接的未来",
      "about.cta.content": "感谢您选择 Utkan eSIM。祝您旅途愉快！",
      "about.cta.whatsapp": "通过 WhatsApp 联系",
      "about.cta.email": "发送电子邮件",
      "contact.hero.title": "联系我们",
      "contact.hero.description": "如果您对我们的 eSIM 有任何疑问、需要技术支持或只是想提供反馈，我们随时期待您的来信。",
      "contact.info.title": "我们的联系方式",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "7/24 快速支持",
      "contact.email.title": "电子邮箱",
      "contact.email.subtitle": "一般联系",
      "contact.support.title": "技术支持",
      "contact.support.subtitle": "eSIM 问题",
      "contact.business.title": "业务合作",
      "contact.business.subtitle": "企业联络",
      "contact.hours.title": "支持时间",
      "contact.hours.subtitle": "7/24 技术支持",
      "contact.hours.detail": "周一 - 周日：00:00 - 23:59",
      "contact.form.title": "发送消息",
      "contact.form.name": "您的姓名",
      "contact.form.name.placeholder": "请输入您的姓名",
      "contact.form.email": "您的电子邮箱",
      "contact.form.email.placeholder": "ornek@email.com",
      "contact.form.subject": "主题",
      "contact.form.subject.placeholder": "选择主题",
      "contact.form.subject.general": "一般信息",
      "contact.form.subject.technical": "技术支持",
      "contact.form.subject.billing": "账单问题",
      "contact.form.subject.partnership": "业务合作",
      "contact.form.subject.feedback": "反馈意见",
      "contact.form.message": "您的消息",
      "contact.form.message.placeholder": "在此处输入您的消息...",
      "contact.form.submit": "发送消息",
      "contact.faq.title": "常见问题",
      "contact.faq.esim.title": "eSIM 是如何工作的？",
      "contact.faq.esim.content": "eSIM 是一种无需实体 SIM 卡即可在手机上运行的数字 SIM 卡。它通过二维码即时激活。",
      "contact.faq.phones.title": "哪些手机支持 eSIM？",
      "contact.faq.phones.content": "iPhone XS 及更新机型、Samsung Galaxy S20 及更新机型、Google Pixel 3 及更新机型均支持 eSIM。",
      "contact.faq.validity.title": "我的数据套餐有效期是多久？",
      "contact.faq.validity.content": "套餐有效期根据您选择的计划在 1 至 30 天之间变化。",
      "contact.faq.payment.title": "如何进行支付？",
      "contact.faq.payment.content": "您可以使用信用卡、PayPal 和银行转账进行安全支付。",
      "privacy.hero.title": "隐私政策",
      "privacy.hero.description": "您的个人数据安全对我们至关重要。本政策解释了您的数据是如何被收集、使用和保护的。",
      "privacy.overview.title": "概述",
      "privacy.overview.content": "本隐私政策描述了当您使用我们的服务时，关于收集、使用和披露您的信息的政策和程序。它还告知您的隐私权以及法律如何保护您。",
      "privacy.data.title": "我们收集的数据",
      "privacy.data.personal.title": "个人信息",
      "privacy.data.personal.name": "姓名",
      "privacy.data.personal.email": "电子邮箱地址",
      "privacy.data.personal.phone": "电话号码",
      "privacy.data.personal.payment": "支付信息",
      "privacy.data.usage.title": "使用数据",
      "privacy.data.usage.ip": "IP 地址",
      "privacy.data.usage.browser": "浏览器类型",
      "privacy.data.usage.device": "设备信息",
      "privacy.data.usage.stats": "使用统计",
      "privacy.security.title": "数据安全",
      "privacy.security.ssl.title": "SSL 加密",
      "privacy.security.ssl.content": "所有数据传输均受到 256 位 SSL 加密保护。",
      "privacy.security.servers.title": "安全服务器",
      "privacy.security.servers.content": "您的数据存储在通过 ISO 27001 认证的安全服务器上。",
      "privacy.security.access.title": "访问控制",
      "privacy.security.access.content": "只有授权人员才能访问您的数据。",
      "privacy.usage.title": "数据使用",
      "privacy.usage.intro": "我们将收集的数据用于以下目的：",
      "privacy.usage.service.title": "提供服务",
      "privacy.usage.service.content": "为您提供和管理我们的 eSIM 服务",
      "privacy.usage.support.title": "客户支持",
      "privacy.usage.support.content": "提供技术支持和客户服务",
      "privacy.usage.security.title": "安全保障",
      "privacy.usage.security.content": "保护您的账户和我们的服务",
      "privacy.usage.improvement.title": "改进优化",
      "privacy.usage.improvement.content": "改进我们的服务并添加新功能",
      "privacy.sharing.title": "数据共享",
      "privacy.sharing.intro": "我们不会与第三方分享您的个人数据，但在以下情况下可能需要共享：",
      "privacy.sharing.legal": "在法律强制要求的情况下",
      "privacy.sharing.providers": "与我们的服务提供商（例如支付处理商）",
      "privacy.sharing.threats": "为了防范安全威胁",
      "privacy.sharing.consent": "在您明确同意的情况下",
      "privacy.rights.title": "您的权利",
      "privacy.rights.access.title": "访问权",
      "privacy.rights.access.content": "您可以请求访问我们持有的关于您的数据。",
      "privacy.rights.correction.title": "更正权",
      "privacy.rights.correction.content": "我们可以更正您不准确或不完整的数据。",
      "privacy.rights.deletion.title": "删除权",
      "privacy.rights.deletion.content": "在特定条件下我们可以删除您的数据。",
      "privacy.rights.objection.title": "异议权",
      "privacy.rights.objection.content": "您可以对我们的数据处理活动提出异议。",
      "privacy.contact.title": "联系方式",
      "privacy.contact.intro": "如果您对本隐私政策有任何疑问，可以通过以下渠道与我们联系：",
      "nav.about": "关于我们",
      "nav.contact": "联系我们",
      "nav.privacy": "隐私政策",
      "nav.login": "登录",
      "nav.account": "我的账户",
      "nav.logout": "退出登录",
      "auth.brand.eyebrow": "全球覆盖",
      "auth.brand.title": "覆盖 150 多个国家，落地即上网。",
      "auth.brand.subtitle": "无实体 SIM 卡，无漫游费。在几秒钟内激活您的 eSIM。",
      "auth.login.eyebrow": "账户登录",
      "auth.login.title": "欢迎回来",
      "auth.login.subtitle": "管理您的 eSIM 并发现新套餐。",
      "auth.signup.eyebrow": "新账户",
      "auth.signup.title": "加入我们",
      "auth.signup.subtitle": "只需几步即可准备好您的第一个 eSIM。",
      "auth.field.identifier": "电子邮箱或电话",
      "auth.field.identifier.ph": "ornek@email.com 或 +86…",
      "auth.field.email": "电子邮箱",
      "auth.field.email.ph": "ornek@email.com",
      "auth.field.fullName": "姓名",
      "auth.field.fullName.ph": "您的姓名",
      "auth.field.password": "密码",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "登录",
      "auth.action.loggingIn": "正在登录…",
      "auth.action.signup": "创建账户",
      "auth.action.signingUp": "正在创建账户…",
      "auth.toSignup.q": "没有账户？",
      "auth.toSignup.link": "注册",
      "auth.toLogin.q": "已经有账户了？",
      "auth.toLogin.link": "登录",
      "auth.password.show": "显示密码",
      "auth.password.hide": "隐藏密码",
      "auth.terms.prefix": "继续即表示我同意 ",
      "auth.terms.link": "使用条款与隐私政策",
      "auth.terms.suffix": "。",
      "auth.error.required": "请填写必填字段。",
      "auth.error.terms": "您必须接受条款才能继续。",
      "verify.eyebrow": "邮箱验证",
      "verify.title": "验证您的电子邮箱",
      "verify.subtitle": "我们已向 {{email}} 发送了 6 位验证码。请输入验证码进行验证。",
      "verify.code": "验证码",
      "verify.code.ph": "••••••",
      "verify.action": "验证",
      "verify.verifying": "正在验证…",
      "verify.resend": "重新发送验证码",
      "verify.resendIn": "{{seconds}} 秒后可重新发送",
      "verify.resent": "已发送新验证码。",
      "verify.skip": "暂时跳过",
      "auth.forgot.link": "忘记密码？",
      "forgot.eyebrow": "重置密码",
      "forgot.email.title": "重置您的密码",
      "forgot.email.subtitle": "输入您账户的电子邮箱地址；我们将向您发送一个 6 位数的重置验证码。",
      "forgot.email.action": "发送验证码",
      "forgot.email.sending": "正在发送…",
      "forgot.reset.title": "设置新密码",
      "forgot.reset.subtitle": "输入我们发送至 {{email}} 的 6 位验证码以及您的新密码。",
      "forgot.reset.action": "更新密码",
      "forgot.reset.updating": "正在更新…",
      "forgot.field.code": "重置验证码",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "新密码",
      "forgot.field.newPassword.ph": "至少 6 个字符",
      "forgot.resend": "重新发送验证码",
      "forgot.resendIn": "{{seconds}} 秒后可重新发送",
      "forgot.resent": "已发送新验证码。",
      "forgot.backToLogin": "返回登录",
      "forgot.changeEmail": "更改电子邮箱",
      "forgot.help.noMail": "如果未收到验证码，请检查垃圾邮件箱或确认您的电子邮箱地址。",
      "reset.RESET_CODE_SENT": "验证码已发送。请检查您的电子邮箱。",
      "reset.RATE_LIMITED": "尝试次数过多。请稍候再试。",
      "reset.MAIL_SEND_FAILED": "出了点问题。请稍后再试。",
      "reset.RESET_CODE_VALID": "验证码已确认。",
      "reset.INVALID_RESET_CODE": "验证码错误。请重试。",
      "reset.EXPIRED_RESET_CODE": "验证码已过期的。请请求新验证码。",
      "reset.WEAK_PASSWORD": "密码必须至少包含 6 个字符。",
      "reset.PASSWORD_RESET_SUCCESS": "您的密码已更新。您可以使用新密码登录。",
      "reset.generic": "出了点问题。请重试。",
      "login.resetSuccess": "您的密码已更新。您可以使用新密码登录。",
      "store.nav.shop": "商店",
      "home.hero.title1": "几分钟即可连接，",
      "home.hero.title2": "超越国界，时刻相连。",
      "home.hero.subtitle": "覆盖 190 多个国家的可靠 eSIM 套餐。无实体 SIM 卡，无漫游费。",
      "home.search.placeholder": "您要去哪里旅行？",
      "home.tabs.local": "本地 eSIM",
      "home.tabs.regional": "区域 eSIM",
      "home.tabs.lifetime": "终身 eSIM",
      "home.empty": "未找到与您的搜索相匹配的结果。",
      "home.error.title": "无法加载内容",
      "home.error.retry": "重试",
      "home.from": "起",
      "home.popular": "热门目的地",
      "home.coverage": "190+ 国家 · 即时激活",
      "home.detail.soon": "此选项的套餐很快将在这里列出。",
      "home.detail.back": "返回商店",
      "detail.plans": "套餐",
      "detail.count": "{{count}} 个套餐",
      "detail.validity": "{{days}} 天",
      "detail.validityLifetime": "无期限",
      "detail.buy": "购买",
      "detail.empty": "当前没有适用于此选项的套餐。",
      "detail.checkoutSoon": "支付流程即将添加。",
      "detail.loginToBuy": "您必须登录才能购买。",
      "detail.basicFeatures": "基本功能",
      "detail.dataAmount": "数据量",
      "detail.validityLabel": "有效期",
      "detail.coverageArea": "覆盖区域",
      "detail.activationNetworks": "激活与网络",
      "detail.activationMethod": "激活方式",
      "detail.esimActivation": "eSIM — 通过二维码即时激活",
      "detail.supportedNetworks": "支持的网络",
      "detail.description": "描述",
      "detail.price": "价格",
      "authprompt.title": "登录以继续",
      "authprompt.message": "登录您的账户以购买 eSIM，或在几秒钟内创建一个新账户。",
      "authprompt.close": "关闭",
      "footer.tagline": "全球快速、安全且实惠的 eSIM。落地即可连接互联网。",
      "footer.explore": "探索",
      "footer.support": "支持",
      "footer.legal": "法律条款",
      "footer.shop": "商店",
      "footer.help": "常见问题",
      "footer.terms": "使用条款",
      "footer.rights": "© {{year}} Utkan eSIM. 保留所有权利。",
      "footer.apps": "下载应用",
      "whatsapp.label": "通过 WhatsApp 联系",
      "whatsapp.message": "您好，我有一个 eSIM 支持请求。",
      "notfound.eyebrow": "无信号",
      "notfound.title": "无法访问此页面",
      "notfound.message": "您寻找的页面可能已被移动或从未存在。让我们带您回到覆盖范围内。",
      "order.congrats": "恭喜！",
      "order.message": "您的 eSIM 已准备就绪。您可以通过下方的二维码通过几个步骤进行安装。",
      "order.details": "订单摘要",
      "order.activation": "激活",
      "order.activationDesc": "要安装您的 eSIM，请使用设备相机扫描二维码或手动输入安装代码。",
      "order.qrTitle": "eSIM 二维码",
      "order.manualLabel": "安装代码",
      "order.copy": "复制",
      "order.copied": "已复制",
      "order.howTo": "如何激活？",
      "order.step1": "在您的设备上前往 设置 > 蜂窝网络 / 移动数据 > 添加 eSIM。",
      "order.step2": "选择“使用二维码”并扫描上方的二维码（或手动输入安装代码）。",
      "order.step3": "安装完成后，激活您的 eSIM 套餐。",
      "order.step4": "确保数据漫游已开启 — 您现在已连网！",
      "order.cta": "返回首页",
      "checkout.title": "结账",
      "checkout.summary": "订单摘要",
      "checkout.total": "总计",
      "checkout.eurNote": "金额在 PayPal 中以欧元 (€) 收取。",
      "checkout.processing": "正在验证您的支付…",
      "checkout.error": "支付未能完成。请重试。",
      "checkout.cancelled": "支付已取消。",
      "account.title": "我的账户",
      "account.tab.profile": "个人资料",
      "account.tab.esims": "我的 eSIM",
      "account.tab.security": "安全",
      "account.profile.title": "个人资料信息",
      "account.field.phone": "电话",
      "account.field.phone.ph": "+86…",
      "account.memberSince": "注册会员时间",
      "account.save": "保存",
      "account.saving": "正在保存…",
      "account.saved": "您的信息已更新。",
      "account.esims.title": "我的 eSIM",
      "account.esims.empty": "您还没有 eSIM。",
      "account.esims.emptyCta": "浏览商店",
      "account.esims.data": "数据",
      "account.esims.expires": "到期日期",
      "account.esims.viewQr": "显示二维码",
      "account.esims.hideQr": "隐藏二维码",
      "account.esims.active": "活动",
      "account.esims.passive": "非活动",
      "account.esims.noActive": "您没有活动的 eSIM。",
      "account.esims.noPassive": "您没有非活动的 eSIM。",
      "account.esims.readyHint": "准备就绪 — 时效从首次使用开始计算。",
      "account.esims.unavailableHint": "当前无法加载状态。请稍后重试。",
      "esimStatus.active": "活动",
      "esimStatus.readyToUse": "准备就绪",
      "esimStatus.inactive": "非活动",
      "esimStatus.unavailable": "无法加载状态",
      "account.security.title": "修改密码",
      "account.field.oldPassword": "当前密码",
      "account.field.newPassword": "新密码",
      "account.field.confirmPassword": "新密码（确认）",
      "account.changePassword": "更新密码",
      "account.passwordChanged": "您的密码已更新。",
      "account.error.passwordMismatch": "两次输入的新密码不一致。",
      "account.danger.title": "账户操作",
      "account.delete": "删除账户",
      "account.delete.confirm": "您即将永久删除您的账户。此操作无法撤销。",
      "account.delete.confirmBtn": "是的，删除",
      "account.cancel": "取消",
      "esimDetail.back": "返回",
      "esimDetail.dataUsage": "数据使用量",
      "esimDetail.left": "剩余",
      "esimDetail.leftData": "剩余数据",
      "esimDetail.usedData": "已使用",
      "esimDetail.totalData": "总数据",
      "esimDetail.qrDesc": "使用设备相机扫描此二维码以安装您的 eSIM。",
      "esimDetail.validity": "有效期",
      "esimDetail.daysLeft": "剩余 {{days}} 天",
      "esimDetail.expired": "已过期",
      "esimDetail.notYetActive": "尚未激活",
      "esimDetail.leftDate": "剩余时间",
      "esimDetail.activationDate": "激活日期",
      "esimDetail.endDate": "到期日期",
      "esimDetail.technical": "技术信息",
      "esimDetail.activationCode": "激活代码 (Android)",
      "esimDetail.smdp": "SM-DP+ 地址 (iOS)",
      "esimDetail.matchingId": "匹配 ID (iOS)",
      "esimDetail.support": "技术支持",
      "esimDetail.supportDesc": "遇到问题了吗？让我们来帮您。",
      "esimDetail.email": "发送电子邮件",
      "guide.eyebrow": "eSIM 指南",
      "guide.title": "什么是 eSIM，如何安装？",
      "guide.intro.title": "什么是 eSIM？",
      "guide.intro.body": "eSIM 是一种嵌入您设备中的数字 SIM 卡，无需实体 SIM 卡即可运行。扫描二维码即可在几秒钟内设置您的线路；在 190 多个国家/地区连接互联网，无需更换卡片，也无漫游费。",
      "guide.steps.title": "如何激活？",
      "guide.devices.title": "支持的设备",
      "guide.devices.desc": "您的设备必须支持 eSIM 才能正常使用。请查看您的品牌。",
      "guide.faq.title": "常见问题",
      "nav.guide": "eSIM 指南",
      "currency.label": "货币",
      "staticPage.loading": "页面加载中...",
      "staticPage.errorTitle": "发生错误",
      "staticPage.retry": "重试",
      "staticPage.loadFailed": "页面内容加载失败。请稍后重试。",
      "last.updated": "最后更新：2024年7月8日",

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      "home.tabs.unlimited": "无限流量 eSIM",
      "detail.unlimited": "无限流量",
      "detail.unlimitedNote": "此套餐没有流量上限——在整个有效期内畅享无限上网。",
      "detail.notPriced": "该套餐目前无法在网页端购买。",
      "checkout.priceUpdated": "该套餐价格已更新。请返回商店重新选择。",
      "order.pending.title": "正在准备您的 eSIM",
      "order.pending.message": "支付已成功。无限流量套餐可能需要几分钟才能开通。",
      "order.pending.waiting": "正在查询订单状态…",
      "order.pending.ready": "您的 eSIM 已就绪！",
      "order.pending.timeout": "耗时比预期长。您的付款已受保护——eSIM 准备就绪后会出现在“我的 eSIM”中。",
      "order.pending.cta": "前往我的 eSIM",
      "account.esims.unlimited": "无限流量",
      "account.esims.unlimitedHint": "无限流量——此套餐没有流量上限。",
      "esimDetail.unlimitedData": "此套餐没有流量上限；剩余时间见下方。",


      // 账户删除页面 (/hesap-sil · /account-deletion) — Google Play「Data deletion」要求
      "del.eyebrow": "账户删除",
      "del.title": "删除我的账户",
      "del.intro": "您可以在此永久删除您的 Utkan eSIM 账户及个人数据。无需安装应用程序，只需使用要删除的账户登录即可。",
      "del.deleted.title": "将被删除的数据",
      "del.deleted.identity": "您的姓名、电子邮箱和电话号码",
      "del.deleted.credentials": "您的密码和登录会话信息",
      "del.deleted.codes": "您的邮箱验证码和密码重置码",
      "del.deleted.esim": "您的 eSIM 号码 (MSISDN)、二维码/激活码以及使用数据",
      "del.kept.title": "我们保留的数据及原因",
      "del.kept.orders": "购买记录（订单号、日期、金额、支付状态）因税务和会计义务而保留。这些记录不包含您的姓名、邮箱或支付信息，仅包含无法与您关联的标识符。",
      "del.kept.period": "保留期限：5 年（土耳其税收程序法第 253 条）。",
      "del.warn.title": "删除前请注意",
      "del.warn.irreversible": "此操作无法撤销。",
      "del.warn.esim": "已激活的 eSIM 仍可在您的设备上继续使用，但您将无法再访问二维码和剩余流量。请在删除前保存您的二维码。",
      "del.warn.rejoin": "您可以使用同一邮箱重新注册，但原有的 eSIM 不会出现在新账户中。",
      "del.support": "如果您无法登录，也可以通过电子邮件申请删除：",
      "del.login.title": "请先登录",
      "del.login.subtitle": "请输入邮箱和密码，以确认该账户属于您。",
      "del.login.action": "登录",
      "del.login.loading": "正在登录...",
      "del.forgot": "忘记密码？",
      "del.confirm.title": "确定要删除吗？",
      "del.confirm.subtitle": "账户 {{email}} 及您的个人数据将被永久删除。",
      "del.confirm.field": "请再次输入您的邮箱以确认",
      "del.confirm.action": "永久删除我的账户",
      "del.confirm.deleting": "正在删除...",
      "del.confirm.cancel": "取消",
      "del.done.title": "您的账户已删除",
      "del.done.body": "您的个人数据已被永久删除。",
      "del.done.retained": "您的个人数据已被永久删除。因法律义务保留了 {{n}} 条购买记录，这些记录无法与您关联。",
      "del.done.home": "返回商店",
      "del.error.required": "请输入您的邮箱和密码。",
      "del.error.credentials": "邮箱或密码有误。",
      "del.error.suspended": "您的账户已被停用，请联系客服。",
      "del.error.session": "登录状态已过期，请重新登录。",
      "del.error.network": "无法连接。请检查网络后重试。",
      "del.error.generic": "出现问题，请重试。",
      "footer.deleteAccount": "删除账户",


      // 通话套餐（流量 + 无限通话和短信）— docs/ses-paketleri.md
      "home.tabs.voice": "通话 eSIM",
      "detail.voice": "通话 + 短信",
      "detail.voiceNote": "此套餐在流量之外还包含无限通话和短信——一张 eSIM 同时满足上网与通话。",
      "detail.calls": "通话",
      "detail.sms": "短信",
      "plan.unlimitedCalls": "无限通话",
      "plan.unlimitedSms": "无限短信",
      "plan.minutes": "{{n}} 分钟通话",
      "plan.sms": "{{n}} 条短信",

      // Hercules — 全欧洲无限通话 (docs/hercules-sayfasi.md)
      "hercules.subtitle": "在 {{n}} 个欧洲国家享受无限通话、短信和流量——一张 eSIM。",
      "hercules.coverageTitle": "覆盖国家（{{n}} 个）",
      "hercules.promo.desc": "{{n}} 个国家无限通话和短信，另含 20–100 GB 流量。",
      "hercules.promo.cta": "查看套餐",
      "loading": "加载中..."
    }
  },
  ja: {
    translation: {
      "language.title": "言語",
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "デジタル接続の未来",
      "hero.description": "次世代のデジタル接続体験で、境界線をなくします。",
      "hero.description2": "世界中で迅速、安全、かつ手頃な価格の eSIM ソリューション。",
      "features.countries": "150+ か国",
      "features.activation": "即時アクティベーション",
      "features.support": "24時間365日サポート",
      "countdown.title": "ウェブサイトはまもなく公開！",
      "countdown.days": "日",
      "countdown.hours": "時間",
      "countdown.minutes": "分",
      "countdown.seconds": "秒",
      "countdown.launch": "ウェブサイトがオープンしました！",
      "countdown.loading": "読み込み中...",
      "apps.title": "モバイルアプリ",
      "apps.ios.label": "ダウンロード:",
      "apps.ios.name": "App Store",
      "apps.android.label": "入手方法:",
      "apps.android.name": "Google Play",
      "contact.title": "ローンチ前のお問い合わせ",
      "contact.whatsapp": "WhatsApp: +90 540 155 13 33",
      "contact.email": "メール: info@utkanesim.com",
      "about.hero.title": "Utkan eSIM について",
      "about.hero.description": "お客様の個人情報の保護は私たちにとって非常に重要です。この方針では、データの収集、使用、保護の方法について説明します。",
      "about.story.title": "私たちのストーリー",
      "about.story.content": "情熱的な旅行者とテクノロジー愛好家のチームによって2024年に設立された Utkan eSIM は、海外でのインターネット接続方法を革新することを目指しています。190以上の国と地域に向けて高品質で信頼性の高い eSIM データプランを提供し、到着した瞬間から迅速なインターネットアクセスを保証します。",
      "about.mission.title": "私たちのミッション",
      "about.mission.content": "世界中の旅行者にシンプル、手頃、そして即時の接続を提供し、国境なしで探索、仕事、連絡が取れるようにすること。",
      "about.vision.title": "私たちのビジョン",
      "about.vision.content": "デジタル接続ソリューションの主要なグローバルプラットフォームとなり、世界をすべての人にとってより小さく、よりつながりのある場所にすること。",
      "about.features.title": "選ばれる理由",
      "about.features.instant.title": "即時配信",
      "about.features.instant.content": "購入後、QRコードで eSIM をすぐに入手できます。",
      "about.features.global.title": "グローバルカバレッジ",
      "about.features.global.content": "190以上の国と地域向けのデータプラン。",
      "about.features.affordable.title": "手頃な価格",
      "about.features.affordable.content": "ローミング料金を最大90%節約。",
      "about.features.support.title": "24時間365日サポート",
      "about.features.support.content": "専任のサポートチームがいつでもお手伝いします。",
      "about.features.secure.title": "安全な接続",
      "about.features.secure.content": "最新のセキュリティプロトコルで保護された接続。",
      "about.features.fast.title": "高速インターネット",
      "about.features.fast.content": "4G/5G の速度で中断のないインターネット体験。",
      "about.cta.title": "デジタル接続の未来に参加しよう",
      "about.cta.content": "Utkan eSIM をお選びいただきありがとうございます。良い旅を！",
      "about.cta.whatsapp": "WhatsAppで連絡",
      "about.cta.email": "メールを送信",
      "contact.hero.title": "お問い合わせ",
      "contact.hero.description": "eSIM に関するご質問、技術サポートが必要な場合、またはフィードバックをお寄せいただける場合は、お気軽にお問い合わせください。",
      "contact.info.title": "連絡先情報",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "24時間365日迅速サポート",
      "contact.email.title": "メール",
      "contact.email.subtitle": "一般お問い合わせ",
      "contact.support.title": "技術サポート",
      "contact.support.subtitle": "eSIM の問題",
      "contact.business.title": "ビジネスパートナーシップ",
      "contact.business.subtitle": "法人向け連絡先",
      "contact.hours.title": "サポート時間",
      "contact.hours.subtitle": "24時間365日技術サポート",
      "contact.hours.detail": "月曜日 - 日曜日: 00:00 - 23:59",
      "contact.form.title": "メッセージを送信",
      "contact.form.name": "お名前",
      "contact.form.name.placeholder": "お名前を入力してください",
      "contact.form.email": "メールアドレス",
      "contact.form.email.placeholder": "ornek@email.com",
      "contact.form.subject": "件名",
      "contact.form.subject.placeholder": "件名を選択",
      "contact.form.subject.general": "一般情報",
      "contact.form.subject.technical": "技術サポート",
      "contact.form.subject.billing": "請求に関する質問",
      "contact.form.subject.partnership": "ビジネスパートナーシップ",
      "contact.form.subject.feedback": "フィードバック",
      "contact.form.message": "メッセージ",
      "contact.form.message.placeholder": "ここにメッセージを入力してください...",
      "contact.form.submit": "メッセージを送信",
      "contact.faq.title": "よくある質問",
      "contact.faq.esim.title": "eSIM はどのように機能しますか？",
      "contact.faq.esim.content": "eSIM は、物理的な SIM カードを必要とせずにお使いの携帯電話で動作するデジタル SIM カードです。QRコードで即座に有効化されます。",
      "contact.faq.phones.title": "どの携帯電話が eSIM をサポートしていますか？",
      "contact.faq.phones.content": "iPhone XS 以降、Samsung Galaxy S20 以降、Google Pixel 3 以降のモデルが eSIM をサポートしています。",
      "contact.faq.validity.title": "データプランの有効期間はどのくらいですか？",
      "contact.faq.validity.content": "プランの有効期間は、選択したプランに応じて1〜30日です。",
      "contact.faq.payment.title": "支払いはどのように行われますか？",
      "contact.faq.payment.content": "クレジットカード、PayPal、銀行振込で安全にお支払いいただけます。",
      "privacy.hero.title": "プライバシーポリシー",
      "privacy.hero.description": "お客様の個人情報の保護は私たちにとって非常に重要です。この方針では、データの収集、使用、保護の方法について説明します。",
      "privacy.overview.title": "概要",
      "privacy.overview.content": "このプライバシーポリシーは、本サービスを利用する際のお客様情報の収集、使用、開示に関する当社のポリシーと手順について説明しています。また、お客様のプライバシーに関する権利と法律による保護の方法についてもお知らせします。",
      "privacy.data.title": "収集するデータ",
      "privacy.data.personal.title": "個人情報",
      "privacy.data.personal.name": "氏名",
      "privacy.data.personal.email": "メールアドレス",
      "privacy.data.personal.phone": "電話番号",
      "privacy.data.personal.payment": "支払い情報",
      "privacy.data.usage.title": "利用データ",
      "privacy.data.usage.ip": "IP アドレス",
      "privacy.data.usage.browser": "ブラウザの種類",
      "privacy.data.usage.device": "デバイス情報",
      "privacy.data.usage.stats": "利用統計",
      "privacy.security.title": "データセキュリティ",
      "privacy.security.ssl.title": "SSL 暗号化",
      "privacy.security.ssl.content": "すべてのデータ転送は 256-bit SSL 暗号化によって保護されます。",
      "privacy.security.servers.title": "安全なサーバー",
      "privacy.security.servers.content": "データは ISO 27001 認証済みの安全なサーバーに保存されます。",
      "privacy.security.access.title": "アクセス制御",
      "privacy.security.access.content": "権限を持つ担当者のみがデータにアクセスできます。",
      "privacy.usage.title": "データの利用",
      "privacy.usage.intro": "収集したデータは以下の目的で使用されます：",
      "privacy.usage.service.title": "サービスの提供",
      "privacy.usage.service.content": "eSIM サービスの提供および管理",
      "privacy.usage.support.title": "カスタマーサポート",
      "privacy.usage.support.content": "技術サポートおよびカスタマーサービスの提供",
      "privacy.usage.security.title": "セキュリティ",
      "privacy.usage.security.content": "アカウントとサービスの保護",
      "privacy.usage.improvement.title": "改善",
      "privacy.usage.improvement.content": "サービスの向上と新機能の追加",
      "privacy.sharing.title": "データの共有",
      "privacy.sharing.intro": "個人データを第三者と共有することはありませんが、以下の場合には共有が必要となることがあります：",
      "privacy.sharing.legal": "法的義務がある場合",
      "privacy.sharing.providers": "サービスプロバイダー（決済代行業者など）と",
      "privacy.sharing.threats": "セキュリティ上の脅威を防ぐため",
      "privacy.sharing.consent": "お客様の明確な同意がある場合",
      "privacy.rights.title": "お客様の権利",
      "privacy.rights.access.title": "アクセス権",
      "privacy.rights.access.content": "当社が保有するお客様のデータへのアクセスを要求できます。",
      "privacy.rights.correction.title": "訂正権",
      "privacy.rights.correction.content": "不正確または不完全なデータを訂正することができます。",
      "privacy.rights.deletion.title": "削除権",
      "privacy.rights.deletion.content": "一定の条件の下でデータを削除できます。",
      "privacy.rights.objection.title": "異議申立権",
      "privacy.rights.objection.content": "データ処理活動に対して異議を申し立てることができます。",
      "privacy.contact.title": "お問い合わせ",
      "privacy.contact.intro": "このプライバシーポリシーについてご質問がある場合は、以下のチャネルからお問い合わせください：",
      "nav.about": "私たちについて",
      "nav.contact": "お問い合わせ",
      "nav.privacy": "プライバシー",
      "nav.login": "ログイン",
      "nav.account": "マイアカウント",
      "nav.logout": "ログアウト",
      "auth.brand.eyebrow": "グローバルカバレッジ",
      "auth.brand.title": "150か国以上で、降り立った瞬間にインターネット。",
      "auth.brand.subtitle": "物理SIMなし、ローミング料金なし。数秒で eSIM を有効化。",
      "auth.login.eyebrow": "アカウントログイン",
      "auth.login.title": "おかえりなさい",
      "auth.login.subtitle": "eSIM を管理し、新しいプランを見つけましょう。",
      "auth.signup.eyebrow": "新規アカウント",
      "auth.signup.title": "参加する",
      "auth.signup.subtitle": "いくつかのステップで最初の eSIM の準備を整えましょう。",
      "auth.field.identifier": "メールまたは電話番号",
      "auth.field.identifier.ph": "ornek@email.com または +81…",
      "auth.field.email": "メールアドレス",
      "auth.field.email.ph": "ornek@email.com",
      "auth.field.fullName": "氏名",
      "auth.field.fullName.ph": "あなたの氏名",
      "auth.field.password": "パスワード",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "ログイン",
      "auth.action.loggingIn": "ログイン中…",
      "auth.action.signup": "アカウント作成",
      "auth.action.signingUp": "アカウント作成中…",
      "auth.toSignup.q": "アカウントをお持ちですか？いいえ",
      "auth.toSignup.link": "登録",
      "auth.toLogin.q": "すでにアカウントをお持ちですか？",
      "auth.toLogin.link": "ログイン",
      "auth.password.show": "パスワードを表示",
      "auth.password.hide": "パスワードを隠す",
      "auth.terms.prefix": "続行することで、",
      "auth.terms.link": "利用規約およびプライバシーポリシー",
      "auth.terms.suffix": "に同意したことになります。",
      "auth.error.required": "必須項目を入力してください。",
      "auth.error.terms": "続行するには規約に同意する必要があります。",
      "verify.eyebrow": "メール確認",
      "verify.title": "メールアドレスを確認",
      "verify.subtitle": "{{email}} に6桁のコードを送信しました。確認のためにコードを入力してください。",
      "verify.code": "確認コード",
      "verify.code.ph": "••••••",
      "verify.action": "確認",
      "verify.verifying": "確認中…",
      "verify.resend": "コードを再送信",
      "verify.resendIn": "{{seconds}} 秒後に再送信",
      "verify.resent": "新しいコードを送信しました。",
      "verify.skip": "今はスキップ",
      "auth.forgot.link": "パスワードをお忘れですか？",
      "forgot.eyebrow": "パスワードリセット",
      "forgot.email.title": "パスワードをリセット",
      "forgot.email.subtitle": "アカウントのメールアドレスを入力してください。6桁のリセットコードを送信します。",
      "forgot.email.action": "コードを送信",
      "forgot.email.sending": "送信中…",
      "forgot.reset.title": "新しいパスワードを設定",
      "forgot.reset.subtitle": "{{email}} に送信した6桁のコードと新しいパスワードを入力してください。",
      "forgot.reset.action": "パスワードを更新",
      "forgot.reset.updating": "更新中…",
      "forgot.field.code": "リセットコード",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "新しいパスワード",
      "forgot.field.newPassword.ph": "6文字以上",
      "forgot.resend": "コードを再送信",
      "forgot.resendIn": "{{seconds}} 秒後に再送信",
      "forgot.resent": "新しいコードを送信しました。",
      "forgot.backToLogin": "ログインに戻る",
      "forgot.changeEmail": "メールアドレスを変更",
      "forgot.help.noMail": "コードが届かない場合は、スパムフォルダを確認するか、メールアドレスを確認してください。",
      "reset.RESET_CODE_SENT": "コードを送信しました。メールをご確認ください。",
      "reset.RATE_LIMITED": "試行回数が多すぎます。しばらく待ってからもう一度お試しください。",
      "reset.MAIL_SEND_FAILED": "問題が発生しました。後でもう一度お試しください。",
      "reset.RESET_CODE_VALID": "コードが確認されました。",
      "reset.INVALID_RESET_CODE": "コードが間違っています。もう一度お試しください。",
      "reset.EXPIRED_RESET_CODE": "コードの有効期限が切れました。新しいコードをリクエストしてください。",
      "reset.WEAK_PASSWORD": "パスワードは6文字以上である必要があります。",
      "reset.PASSWORD_RESET_SUCCESS": "パスワードが更新されました。新しいパスワードでログインできます。",
      "reset.generic": "問題が発生しました。もう一度お試しください。",
      "login.resetSuccess": "パスワードが更新されました。新しいパスワードでログインできます。",
      "store.nav.shop": "ストア",
      "home.hero.title1": "数分で接続、",
      "home.hero.title2": "境界線を越えてつながる。",
      "home.hero.subtitle": "190か国以上で有効な信頼できる eSIM パッケージ。物理SIMなし、ローミング料金なし。",
      "home.search.placeholder": "どこへ旅行しますか？",
      "home.tabs.local": "ローカル eSIM",
      "home.tabs.regional": "リージョナル eSIM",
      "home.tabs.lifetime": "生涯 eSIM",
      "home.empty": "検索に一致する結果が見つかりませんでした。",
      "home.error.title": "コンテンツを読み込めませんでした",
      "home.error.retry": "再試行",
      "home.from": "から",
      "home.popular": "人気の目的地",
      "home.coverage": "190+ か国 · 即時アクティベーション",
      "home.detail.soon": "この選択のパッケージはまもなくここに表示されます。",
      "home.detail.back": "ストアに戻る",
      "detail.plans": "プラン",
      "detail.count": "{{count}} 件のプラン",
      "detail.validity": "{{days}} 日間",
      "detail.validityLifetime": "無期限",
      "detail.buy": "購入",
      "detail.empty": "この選択肢に対するプランは現在ありません。",
      "detail.checkoutSoon": "決済フローはまもなく追加されます。",
      "detail.loginToBuy": "購入するにはログインする必要があります。",
      "detail.basicFeatures": "基本機能",
      "detail.dataAmount": "データ量",
      "detail.validityLabel": "有効期間",
      "detail.coverageArea": "カバレッジエリア",
      "detail.activationNetworks": "アクティベーションとネットワーク",
      "detail.activationMethod": "アクティベーション方法",
      "detail.esimActivation": "eSIM — QRコードで即座に",
      "detail.supportedNetworks": "サポートされているネットワーク",
      "detail.description": "説明",
      "detail.price": "価格",
      "authprompt.title": "続行するにはログイン",
      "authprompt.message": "eSIM を購入するにはアカウントにログインするか、数秒で新しいアカウントを作成してください。",
      "authprompt.close": "閉じる",
      "footer.tagline": "世界中で迅速、安全、手頃な価格の eSIM。降り立った瞬間にインターネットに接続。",
      "footer.explore": "探索",
      "footer.support": "サポート",
      "footer.legal": "法的情報",
      "footer.shop": "ストア",
      "footer.help": "よくある質問",
      "footer.terms": "利用規約",
      "footer.rights": "© {{year}} Utkan eSIM. 無断転載を禁じます。",
      "footer.apps": "アプリをダウンロード",
      "whatsapp.label": "WhatsAppでメッセージ",
      "whatsapp.message": "こんにちは、eSIM のサポートリクエストがあります。",
      "notfound.eyebrow": "信号なし",
      "notfound.title": "このページにはアクセスできません",
      "notfound.message": "お探しのページは移動されたか、存在しない可能性があります。カバレッジエリアにお連れします。",
      "order.congrats": "おめでとうございます！",
      "order.message": "eSIM の準備ができました。以下の QR コードを使っていくつかのステップで設定できます。",
      "order.details": "注文概要",
      "order.activation": "アクティベーション",
      "order.activationDesc": "eSIM を設定するには、デバイスのカメラで QR コードをスキャンするか、セットアップコードを手動で入力します。",
      "order.qrTitle": "eSIM QRコード",
      "order.manualLabel": "セットアップコード",
      "order.copy": "コピー",
      "order.copied": "コピーしました",
      "order.howTo": "有効化の方法",
      "order.step1": "デバイスで「設定」>「モバイル通信」>「eSIMを追加」に移動します。",
      "order.step2": "「QRコードを使用」を選択し、上記の QR コードをスキャンします（またはセットアップコードを手動で入力）。",
      "order.step3": "インストールが完了したら、eSIM プランを有効にします。",
      "order.step4": "データローミングがオンになっていることを確認してください。これで接続完了です！",
      "order.cta": "ホームページに戻る",
      "checkout.title": "チェックアウト",
      "checkout.summary": "注文概要",
      "checkout.total": "合計",
      "checkout.eurNote": "金額は PayPal でユーロ（€）建てで請求されます。",
      "checkout.processing": "支払いの確認中…",
      "checkout.error": "支払いを完了できませんでした。もう一度お試しください。",
      "checkout.cancelled": "支払いがキャンセルされました。",
      "account.title": "マイアカウント",
      "account.tab.profile": "プロフィール",
      "account.tab.esims": "マイ eSIM",
      "account.tab.security": "セキュリティ",
      "account.profile.title": "プロフィール情報",
      "account.field.phone": "電話番号",
      "account.field.phone.ph": "+81…",
      "account.memberSince": "会員登録日",
      "account.save": "保存",
      "account.saving": "保存中…",
      "account.saved": "情報が更新されました。",
      "account.esims.title": "マイ eSIM",
      "account.esims.empty": "eSIM はまだありません。",
      "account.esims.emptyCta": "ストアを見る",
      "account.esims.data": "データ",
      "account.esims.expires": "有効期限",
      "account.esims.viewQr": "QRコードを表示",
      "account.esims.hideQr": "QRコードを隠す",
      "account.esims.active": "アクティブ",
      "account.esims.passive": "非アクティブ",
      "account.esims.noActive": "アクティブな eSIM はありません。",
      "account.esims.noPassive": "非アクティブな eSIM はありません。",
      "account.esims.readyHint": "利用準備完了 — 有効期間は初回の使用時に開始されます。",
      "account.esims.unavailableHint": "現在ステータスを読み込めません。後でもう一度お試しください。",
      "esimStatus.active": "アクティブ",
      "esimStatus.readyToUse": "利用準備完了",
      "esimStatus.inactive": "非アクティブ",
      "esimStatus.unavailable": "ステータスを読み込めません",
      "account.security.title": "パスワードの変更",
      "account.field.oldPassword": "現在のパスワード",
      "account.field.newPassword": "新しいパスワード",
      "account.field.confirmPassword": "新しいパスワード（確認）",
      "account.changePassword": "パスワードを更新",
      "account.passwordChanged": "パスワードが更新されました。",
      "account.error.passwordMismatch": "新しいパスワードが一致しません。",
      "account.danger.title": "アカウントの操作",
      "account.delete": "アカウントを削除",
      "account.delete.confirm": "アカウントを完全に削除しようとしています。この操作は元に戻せません。",
      "account.delete.confirmBtn": "はい、削除します",
      "account.cancel": "キャンセル",
      "esimDetail.back": "戻る",
      "esimDetail.dataUsage": "データ使用量",
      "esimDetail.left": "残り",
      "esimDetail.leftData": "残りデータ",
      "esimDetail.usedData": "使用済み",
      "esimDetail.totalData": "合計データ",
      "esimDetail.qrDesc": "デバイスのカメラでこの QR コードをスキャンして eSIM を設定します。",
      "esimDetail.validity": "有効性",
      "esimDetail.daysLeft": "残り {{days}} 日",
      "esimDetail.expired": "期限切れ",
      "esimDetail.notYetActive": "まだ有効ではありません",
      "esimDetail.leftDate": "残り時間",
      "esimDetail.activationDate": "アクティベーション日",
      "esimDetail.endDate": "終了日",
      "esimDetail.technical": "技術情報",
      "esimDetail.activationCode": "アクティベーションコード (Android)",
      "esimDetail.smdp": "SM-DP+ アドレス (iOS)",
      "esimDetail.matchingId": "マッチング ID (iOS)",
      "esimDetail.support": "技術サポート",
      "esimDetail.supportDesc": "問題がありますか？お手伝いします。",
      "esimDetail.email": "メールを送信",
      "guide.eyebrow": "eSIM ガイド",
      "guide.title": "eSIM とは？設定方法は？",
      "guide.intro.title": "eSIM とは？",
      "guide.intro.body": "eSIM は、物理的な SIM カードなしでデバイスに内蔵されているデジタル SIM です。QR コードをスキャンするだけで数秒で回線が設定され、カードの交換やローミング料金なしで 190 か国以上でインターネットに接続できます。",
      "guide.steps.title": "有効化の方法",
      "guide.devices.title": "サポートされているデバイス",
      "guide.devices.desc": "eSIM を動作させるには、デバイスが eSIM に対応している必要があります。ブランドを確認してください。",
      "guide.faq.title": "よくある質問",
      "nav.guide": "eSIM ガイド",
      "currency.label": "通貨",
      "staticPage.loading": "ページを読み込んでいます...",
      "staticPage.errorTitle": "エラーが発生しました",
      "staticPage.retry": "再試行",
      "staticPage.loadFailed": "ページコンテンツを読み込めませんでした。後でもう一度お試しください。",
      "last.updated": "最終更新日: 2024年7月8日",

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      "home.tabs.unlimited": "無制限 eSIM",
      "detail.unlimited": "無制限",
      "detail.unlimitedNote": "このプランにデータ上限はありません。有効期間中は無制限でインターネットをご利用いただけます。",
      "detail.notPriced": "このプランは現在ウェブでは購入できません。",
      "checkout.priceUpdated": "このプランの価格が更新されました。ストアに戻ってもう一度選択してください。",
      "order.pending.title": "eSIM を準備しています",
      "order.pending.message": "お支払いが完了しました。無制限プランは開通までに数分かかる場合があります。",
      "order.pending.waiting": "ご注文の状況を確認しています…",
      "order.pending.ready": "eSIM の準備ができました！",
      "order.pending.timeout": "予想より時間がかかっています。お支払いは保護されています。準備ができ次第、「マイ eSIM」に表示されます。",
      "order.pending.cta": "マイ eSIM へ",
      "account.esims.unlimited": "無制限",
      "account.esims.unlimitedHint": "無制限データ — このプランにデータ上限はありません。",
      "esimDetail.unlimitedData": "このプランにデータ上限はありません。残り期間は下記をご覧ください。",


      // アカウント削除ページ (/hesap-sil · /account-deletion) — Google Play「Data deletion」要件
      "del.eyebrow": "アカウント削除",
      "del.title": "アカウントを削除",
      "del.intro": "ここで Utkan eSIM のアカウントと個人データを完全に削除できます。アプリのインストールは不要です。削除したいアカウントでログインするだけです。",
      "del.deleted.title": "削除されるデータ",
      "del.deleted.identity": "氏名、メールアドレス、電話番号",
      "del.deleted.credentials": "パスワードおよびセッション情報",
      "del.deleted.codes": "メール認証コードおよびパスワード再設定コード",
      "del.deleted.esim": "eSIM 番号 (MSISDN)、QR/アクティベーションコード、利用データ",
      "del.kept.title": "保持されるデータとその理由",
      "del.kept.orders": "購入記録（注文番号、日付、金額、支払い状況）は税務・会計上の義務により保持されます。これらの記録には氏名、メールアドレス、支払い情報は含まれず、お客様と結び付けられない識別子のみが含まれます。",
      "del.kept.period": "保持期間：5 年（トルコ税務手続法 第253条）。",
      "del.warn.title": "削除前にご確認ください",
      "del.warn.irreversible": "この操作は取り消せません。",
      "del.warn.esim": "有効な eSIM は端末上で引き続き利用できますが、QR コードや残りのデータ量にはアクセスできなくなります。削除前に QR コードを保存してください。",
      "del.warn.rejoin": "同じメールアドレスで再登録できますが、以前の eSIM は新しいアカウントには表示されません。",
      "del.support": "ログインできない場合は、メールでも削除をご依頼いただけます:",
      "del.login.title": "まずログイン",
      "del.login.subtitle": "アカウントがご本人のものであることを確認するため、メールアドレスとパスワードを入力してください。",
      "del.login.action": "ログイン",
      "del.login.loading": "ログイン中...",
      "del.forgot": "パスワードをお忘れですか？",
      "del.confirm.title": "本当によろしいですか？",
      "del.confirm.subtitle": "アカウント {{email}} と個人データが完全に削除されます。",
      "del.confirm.field": "確認のためメールアドレスをもう一度入力してください",
      "del.confirm.action": "アカウントを完全に削除する",
      "del.confirm.deleting": "削除中...",
      "del.confirm.cancel": "キャンセル",
      "del.done.title": "アカウントを削除しました",
      "del.done.body": "個人データは完全に削除されました。",
      "del.done.retained": "個人データは完全に削除されました。法的義務により購入記録 {{n}} 件が保持されていますが、お客様と結び付けることはできません。",
      "del.done.home": "ストアに戻る",
      "del.error.required": "メールアドレスとパスワードを入力してください。",
      "del.error.credentials": "メールアドレスまたはパスワードが正しくありません。",
      "del.error.suspended": "アカウントが停止されています。サポートにお問い合わせください。",
      "del.error.session": "セッションの有効期限が切れました。再度ログインしてください。",
      "del.error.network": "接続できませんでした。インターネット接続を確認して再試行してください。",
      "del.error.generic": "問題が発生しました。もう一度お試しください。",
      "footer.deleteAccount": "アカウント削除",


      // 通話プラン（データ + 通話・SMS 無制限）— docs/ses-paketleri.md
      "home.tabs.voice": "通話付き eSIM",
      "detail.voice": "通話 + SMS",
      "detail.voiceNote": "このプランはデータに加えて通話と SMS が無制限です。1 枚の eSIM でインターネットも通話も使えます。",
      "detail.calls": "通話",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "通話無制限",
      "plan.unlimitedSms": "SMS 無制限",
      "plan.minutes": "通話 {{n}} 分",
      "plan.sms": "SMS {{n}} 通",

      // Hercules — ヨーロッパ全域で通話無制限 (docs/hercules-sayfasi.md)
      "hercules.subtitle": "ヨーロッパ {{n}} か国で通話・SMS・データが無制限。eSIM 1 枚で完結します。",
      "hercules.coverageTitle": "対象国（{{n}} か国）",
      "hercules.promo.desc": "{{n}} か国で通話・SMS 無制限、データは 20〜100 GB。",
      "hercules.promo.cta": "プランを見る",
      "loading": "読み込み中..."
    }
  },
  // Rusça
  ru: {
    translation: {
      "language.title": "Язык",
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "Будущее цифровой связи",
      "hero.description": "Мы стираем границы с помощью цифровой связи нового поколения.",
      "hero.description2": "Быстрые, надежные и доступные eSIM-решения по всему миру.",
      "features.countries": "150+ стран",
      "features.activation": "Мгновенная активация",
      "features.support": "Поддержка 24/7",
      "countdown.title": "Наш сайт скоро откроется!",
      "countdown.days": "Дней",
      "countdown.hours": "Часов",
      "countdown.minutes": "Минут",
      "countdown.seconds": "Секунд",
      "countdown.launch": "Наш сайт открыт!",
      "countdown.loading": "Загрузка...",
      "apps.title": "Наши мобильные приложения",
      "apps.ios.label": "Загрузите в",
      "apps.ios.name": "App Store",
      "apps.android.label": "ДОСТУПНО В",
      "apps.android.name": "Google Play",
      "contact.title": "Свяжитесь с нами до запуска",
      "contact.whatsapp": "WhatsApp: +90 540 155 13 33",
      "contact.email": "Эл. почта: info@utkanesim.com",
      "about.hero.title": "О Utkan eSIM",
      "about.hero.description": "Ваш надежный партнер, который помогает оставаться на связи, где бы вы ни находились. Мы считаем, что путешествия по миру должны быть удобными и доступными — без хлопот с физическими SIM-картами и дорогого роуминга.",
      "about.story.title": "Наша история",
      "about.story.content": "Компания основана в 2024 году командой увлеченных путешественников и энтузиастов технологий. Наша цель — изменить то, как люди выходят в интернет за границей. Мы предлагаем качественные и надежные eSIM-тарифы с данными более чем для 190 стран и регионов, чтобы у вас был быстрый интернет с момента приземления.",
      "about.mission.title": "Наша миссия",
      "about.mission.content": "Обеспечивать путешественников простой, доступной и мгновенной связью по всему миру, чтобы они могли открывать новое, работать и оставаться на связи без границ.",
      "about.vision.title": "Наше видение",
      "about.vision.content": "Стать ведущей мировой платформой решений для цифровой связи и сделать мир ближе и связаннее для каждого.",
      "about.features.title": "Почему мы?",
      "about.features.instant.title": "Мгновенная доставка",
      "about.features.instant.content": "Получите eSIM с QR-кодом сразу после покупки.",
      "about.features.global.title": "Глобальное покрытие",
      "about.features.global.content": "Тарифы с данными более чем для 190 стран и регионов.",
      "about.features.affordable.title": "Доступные цены",
      "about.features.affordable.content": "Экономьте до 90% на роуминге.",
      "about.features.support.title": "Поддержка 24/7",
      "about.features.support.content": "Наша служба поддержки всегда готова помочь.",
      "about.features.secure.title": "Защищенное соединение",
      "about.features.secure.content": "Соединение защищено современными протоколами безопасности.",
      "about.features.fast.title": "Быстрый интернет",
      "about.features.fast.content": "Стабильный интернет на скорости 4G/5G.",
      "about.cta.title": "Присоединяйтесь к будущему цифровой связи",
      "about.cta.content": "Спасибо, что выбрали Utkan eSIM. Приятных путешествий!",
      "about.cta.whatsapp": "Написать в WhatsApp",
      "about.cta.email": "Отправить письмо",
      "contact.hero.title": "Связаться с нами",
      "contact.hero.description": "Мы готовы помочь! Если у вас есть вопрос о наших eSIM, нужна техническая поддержка или вы хотите оставить отзыв — мы будем рады вас выслушать.",
      "contact.info.title": "Контактная информация",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "Быстрая поддержка 24/7",
      "contact.email.title": "Эл. почта",
      "contact.email.subtitle": "Общие вопросы",
      "contact.support.title": "Техническая поддержка",
      "contact.support.subtitle": "Проблемы с eSIM",
      "contact.business.title": "Сотрудничество",
      "contact.business.subtitle": "Для компаний",
      "contact.hours.title": "Часы поддержки",
      "contact.hours.subtitle": "Техническая поддержка 24/7",
      "contact.hours.detail": "Понедельник – воскресенье: 00:00 – 23:59",
      "contact.form.title": "Напишите нам",
      "contact.form.name": "Ваше имя",
      "contact.form.name.placeholder": "Введите имя и фамилию",
      "contact.form.email": "Ваша эл. почта",
      "contact.form.email.placeholder": "example@email.com",
      "contact.form.subject": "Тема",
      "contact.form.subject.placeholder": "Выберите тему",
      "contact.form.subject.general": "Общая информация",
      "contact.form.subject.technical": "Техническая поддержка",
      "contact.form.subject.billing": "Вопросы по оплате",
      "contact.form.subject.partnership": "Сотрудничество",
      "contact.form.subject.feedback": "Отзыв",
      "contact.form.message": "Ваше сообщение",
      "contact.form.message.placeholder": "Напишите сообщение здесь...",
      "contact.form.submit": "Отправить сообщение",
      "contact.faq.title": "Часто задаваемые вопросы",
      "contact.faq.esim.title": "Как работает eSIM?",
      "contact.faq.esim.content": "eSIM — это цифровая SIM-карта, которая работает в вашем телефоне без физической SIM-карты. Она активируется мгновенно с помощью QR-кода.",
      "contact.faq.phones.title": "Какие телефоны поддерживают eSIM?",
      "contact.faq.phones.content": "eSIM поддерживают iPhone XS и новее, Samsung Galaxy S20 и новее, Google Pixel 3 и новее.",
      "contact.faq.validity.title": "Сколько действует пакет данных?",
      "contact.faq.validity.content": "Срок действия пакета — от 1 до 30 дней в зависимости от выбранного тарифа.",
      "contact.faq.payment.title": "Как можно оплатить?",
      "contact.faq.payment.content": "Вы можете безопасно оплатить банковской картой, через PayPal или банковским переводом.",
      "privacy.hero.title": "Политика конфиденциальности",
      "privacy.hero.description": "Безопасность ваших персональных данных очень важна для нас. В этой политике описано, как ваши данные собираются, используются и защищаются.",
      "privacy.overview.title": "Обзор",
      "privacy.overview.content": "Настоящая Политика конфиденциальности описывает наши правила и процедуры сбора, использования и раскрытия ваших данных при использовании Сервиса, а также сообщает о ваших правах на конфиденциальность и о том, как вас защищает закон.",
      "privacy.data.title": "Какие данные мы собираем",
      "privacy.data.personal.title": "Персональные данные",
      "privacy.data.personal.name": "Имя и фамилия",
      "privacy.data.personal.email": "Адрес эл. почты",
      "privacy.data.personal.phone": "Номер телефона",
      "privacy.data.personal.payment": "Платежные данные",
      "privacy.data.usage.title": "Данные об использовании",
      "privacy.data.usage.ip": "IP-адрес",
      "privacy.data.usage.browser": "Тип браузера",
      "privacy.data.usage.device": "Сведения об устройстве",
      "privacy.data.usage.stats": "Статистика использования",
      "privacy.security.title": "Безопасность данных",
      "privacy.security.ssl.title": "SSL-шифрование",
      "privacy.security.ssl.content": "Все передаваемые данные защищены 256-битным SSL-шифрованием.",
      "privacy.security.servers.title": "Защищенные серверы",
      "privacy.security.servers.content": "Ваши данные хранятся на защищенных серверах с сертификатом ISO 27001.",
      "privacy.security.access.title": "Контроль доступа",
      "privacy.security.access.content": "Доступ к вашим данным есть только у уполномоченных сотрудников.",
      "privacy.usage.title": "Использование данных",
      "privacy.usage.intro": "Мы используем собранные данные для следующих целей:",
      "privacy.usage.service.title": "Предоставление услуг",
      "privacy.usage.service.content": "Предоставление и управление нашими eSIM-услугами",
      "privacy.usage.support.title": "Поддержка клиентов",
      "privacy.usage.support.content": "Техническая поддержка и обслуживание клиентов",
      "privacy.usage.security.title": "Безопасность",
      "privacy.usage.security.content": "Защита вашего аккаунта и наших сервисов",
      "privacy.usage.improvement.title": "Улучшение",
      "privacy.usage.improvement.content": "Улучшение наших услуг и добавление новых функций",
      "privacy.sharing.title": "Передача данных",
      "privacy.sharing.intro": "Мы не передаем ваши персональные данные третьим лицам, однако передача может потребоваться в следующих случаях:",
      "privacy.sharing.legal": "При наличии законного требования",
      "privacy.sharing.providers": "Нашим поставщикам услуг (например, платежным системам)",
      "privacy.sharing.threats": "Для предотвращения угроз безопасности",
      "privacy.sharing.consent": "С вашего явного согласия",
      "privacy.rights.title": "Ваши права",
      "privacy.rights.access.title": "Право на доступ",
      "privacy.rights.access.content": "Вы можете запросить доступ к хранящимся у нас данным о вас.",
      "privacy.rights.correction.title": "Право на исправление",
      "privacy.rights.correction.content": "Мы можем исправить ваши неверные или неполные данные.",
      "privacy.rights.deletion.title": "Право на удаление",
      "privacy.rights.deletion.content": "При определенных условиях мы можем удалить ваши данные.",
      "privacy.rights.objection.title": "Право на возражение",
      "privacy.rights.objection.content": "Вы можете возразить против обработки нами ваших данных.",
      "privacy.contact.title": "Контакты",
      "privacy.contact.intro": "Если у вас есть вопросы об этой Политике конфиденциальности, свяжитесь с нами по следующим каналам:",
      "nav.about": "О нас",
      "nav.contact": "Контакты",
      "nav.privacy": "Конфиденциальность",
      "nav.login": "Войти",
      "nav.account": "Аккаунт",
      "nav.logout": "Выйти",
      "auth.brand.eyebrow": "ГЛОБАЛЬНОЕ ПОКРЫТИЕ",
      "auth.brand.title": "Онлайн сразу после приземления — в 150+ странах.",
      "auth.brand.subtitle": "Без физической SIM-карты и счетов за роуминг. Активируйте eSIM за считаные секунды.",
      "auth.login.eyebrow": "ВХОД",
      "auth.login.title": "С возвращением",
      "auth.login.subtitle": "Управляйте своими eSIM и открывайте новые.",
      "auth.signup.eyebrow": "НОВЫЙ АККАУНТ",
      "auth.signup.title": "Создайте аккаунт",
      "auth.signup.subtitle": "Всего несколько шагов до вашей первой eSIM.",
      "auth.field.identifier": "Эл. почта или телефон",
      "auth.field.identifier.ph": "you@email.com или +7…",
      "auth.field.email": "Эл. почта",
      "auth.field.email.ph": "you@email.com",
      "auth.field.fullName": "Полное имя",
      "auth.field.fullName.ph": "Ваше имя и фамилия",
      "auth.field.password": "Пароль",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "Войти",
      "auth.action.loggingIn": "Выполняется вход…",
      "auth.action.signup": "Создать аккаунт",
      "auth.action.signingUp": "Создание аккаунта…",
      "auth.toSignup.q": "Нет аккаунта?",
      "auth.toSignup.link": "Зарегистрироваться",
      "auth.toLogin.q": "Уже есть аккаунт?",
      "auth.toLogin.link": "Войти",
      "auth.password.show": "Показать пароль",
      "auth.password.hide": "Скрыть пароль",
      "auth.terms.prefix": "Продолжая, я принимаю ",
      "auth.terms.link": "Условия использования и Политику конфиденциальности",
      "auth.terms.suffix": ".",
      "auth.error.required": "Пожалуйста, заполните обязательные поля.",
      "auth.error.terms": "Чтобы продолжить, примите условия.",
      "verify.eyebrow": "ПОДТВЕРЖДЕНИЕ ЭЛ. ПОЧТЫ",
      "verify.title": "Подтвердите эл. почту",
      "verify.subtitle": "Мы отправили 6-значный код на {{email}}. Введите его для подтверждения.",
      "verify.code": "Код подтверждения",
      "verify.code.ph": "••••••",
      "verify.action": "Подтвердить",
      "verify.verifying": "Проверка…",
      "verify.resend": "Отправить код повторно",
      "verify.resendIn": "Повторная отправка через {{seconds}} с",
      "verify.resent": "Новый код отправлен.",
      "verify.skip": "Пропустить",
      "auth.forgot.link": "Забыли пароль?",
      "forgot.eyebrow": "СБРОС ПАРОЛЯ",
      "forgot.email.title": "Сброс пароля",
      "forgot.email.subtitle": "Введите адрес эл. почты вашего аккаунта, и мы отправим 6-значный код для сброса.",
      "forgot.email.action": "Отправить код",
      "forgot.email.sending": "Отправка…",
      "forgot.reset.title": "Задайте новый пароль",
      "forgot.reset.subtitle": "Введите 6-значный код, отправленный на {{email}}, и новый пароль.",
      "forgot.reset.action": "Обновить пароль",
      "forgot.reset.updating": "Обновление…",
      "forgot.field.code": "Код сброса",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "Новый пароль",
      "forgot.field.newPassword.ph": "Не менее 6 символов",
      "forgot.resend": "Отправить код повторно",
      "forgot.resendIn": "Повторная отправка через {{seconds}} с",
      "forgot.resent": "Новый код отправлен.",
      "forgot.backToLogin": "Вернуться ко входу",
      "forgot.changeEmail": "Изменить эл. почту",
      "forgot.help.noMail": "Если код не пришел, проверьте папку «Спам» или убедитесь, что адрес эл. почты указан верно.",
      "reset.RESET_CODE_SENT": "Код отправлен. Пожалуйста, проверьте эл. почту.",
      "reset.RATE_LIMITED": "Слишком много запросов. Пожалуйста, подождите немного и попробуйте снова.",
      "reset.MAIL_SEND_FAILED": "Что-то пошло не так. Пожалуйста, попробуйте позже.",
      "reset.RESET_CODE_VALID": "Код подтвержден.",
      "reset.INVALID_RESET_CODE": "Неверный код. Пожалуйста, попробуйте снова.",
      "reset.EXPIRED_RESET_CODE": "Срок действия кода истек. Пожалуйста, запросите новый код.",
      "reset.WEAK_PASSWORD": "Пароль должен содержать не менее 6 символов.",
      "reset.PASSWORD_RESET_SUCCESS": "Ваш пароль обновлен. Пожалуйста, войдите с новым паролем.",
      "reset.generic": "Что-то пошло не так. Пожалуйста, попробуйте снова.",
      "login.resetSuccess": "Ваш пароль обновлен. Пожалуйста, войдите с новым паролем.",
      "store.nav.shop": "Магазин",
      "home.hero.title1": "Подключитесь за минуты,",
      "home.hero.title2": "оставайтесь онлайн без границ.",
      "home.hero.subtitle": "Надежные eSIM-тарифы, действующие в 190+ странах. Без физической SIM-карты и счетов за роуминг.",
      "home.search.placeholder": "Куда вы едете?",
      "home.tabs.local": "Местные eSIM",
      "home.tabs.regional": "Региональные eSIM",
      "home.tabs.lifetime": "Пожизненные eSIM",
      "home.empty": "По вашему запросу ничего не найдено.",
      "home.error.title": "Не удалось загрузить содержимое",
      "home.error.retry": "Повторить попытку",
      "home.from": "от",
      "home.popular": "Популярные направления",
      "home.coverage": "190+ стран · мгновенная активация",
      "home.detail.soon": "Тарифы для этого направления скоро появятся здесь.",
      "home.detail.back": "Вернуться в магазин",
      "detail.plans": "Тарифы",
      "detail.count": "Тарифов: {{count}}",
      "detail.validity": "{{days}} дн.",
      "detail.validityLifetime": "Бессрочно",
      "detail.buy": "Купить",
      "detail.empty": "Для этого направления сейчас нет доступных тарифов.",
      "detail.checkoutSoon": "Оформление заказа скоро будет доступно.",
      "detail.loginToBuy": "Пожалуйста, войдите, чтобы совершить покупку.",
      "detail.basicFeatures": "Основные характеристики",
      "detail.dataAmount": "Объем данных",
      "detail.validityLabel": "Срок действия",
      "detail.coverageArea": "Зона покрытия",
      "detail.activationNetworks": "Активация и сети",
      "detail.activationMethod": "Способ активации",
      "detail.esimActivation": "eSIM — мгновенно по QR-коду",
      "detail.supportedNetworks": "Поддерживаемые сети",
      "detail.description": "Описание",
      "detail.price": "Цена",
      "authprompt.title": "Войдите, чтобы продолжить",
      "authprompt.message": "Войдите в аккаунт, чтобы купить eSIM, или создайте его за считаные секунды.",
      "authprompt.close": "Закрыть",
      "footer.tagline": "Быстрая, надежная и доступная eSIM по всему миру. Будьте онлайн сразу после приземления.",
      "footer.explore": "Обзор",
      "footer.support": "Поддержка",
      "footer.legal": "Правовая информация",
      "footer.shop": "Магазин",
      "footer.help": "Часто задаваемые вопросы",
      "footer.terms": "Условия использования",
      "footer.rights": "© {{year}} Utkan eSIM. Все права защищены.",
      "footer.apps": "Скачайте приложение",
      "whatsapp.label": "Написать в WhatsApp",
      "whatsapp.message": "Здравствуйте, у меня есть запрос в службу поддержки eSIM.",
      "notfound.eyebrow": "НЕТ СИГНАЛА",
      "notfound.title": "Эта страница вне зоны доступа",
      "notfound.message": "Страница, которую вы ищете, перемещена или никогда не существовала. Давайте вернем вас в зону покрытия.",
      "order.congrats": "Поздравляем!",
      "order.message": "Ваша eSIM готова. Настройте ее за несколько шагов с помощью QR-кода ниже.",
      "order.details": "Сводка заказа",
      "order.activation": "Активация",
      "order.activationDesc": "Чтобы настроить eSIM, отсканируйте QR-код камерой устройства или введите код активации вручную.",
      "order.qrTitle": "QR-код eSIM",
      "order.manualLabel": "Код активации",
      "order.copy": "Копировать",
      "order.copied": "Скопировано",
      "order.howTo": "Как активировать",
      "order.step1": "На устройстве откройте Настройки > Сотовая связь / Мобильные данные > Добавить eSIM.",
      "order.step2": "Выберите «Использовать QR-код» и отсканируйте QR-код выше (или введите код активации вручную).",
      "order.step3": "После завершения настройки включите тариф eSIM.",
      "order.step4": "Убедитесь, что роуминг данных включен, — вы на связи!",
      "order.cta": "На главную",
      "checkout.title": "Оформление заказа",
      "checkout.summary": "Сводка заказа",
      "checkout.total": "Итого",
      "checkout.eurNote": "Оплата будет списана в евро (€) через PayPal.",
      "checkout.processing": "Проверяем ваш платеж…",
      "checkout.error": "Не удалось завершить оплату. Пожалуйста, попробуйте снова.",
      "checkout.cancelled": "Оплата отменена.",
      "account.title": "Мой аккаунт",
      "account.tab.profile": "Профиль",
      "account.tab.esims": "Мои eSIM",
      "account.tab.security": "Безопасность",
      "account.profile.title": "Данные профиля",
      "account.field.phone": "Телефон",
      "account.field.phone.ph": "+7…",
      "account.memberSince": "Участник с",
      "account.save": "Сохранить",
      "account.saving": "Сохранение…",
      "account.saved": "Ваши данные обновлены.",
      "account.esims.title": "Мои eSIM",
      "account.esims.empty": "У вас пока нет eSIM.",
      "account.esims.emptyCta": "Перейти в магазин",
      "account.esims.data": "Данные",
      "account.esims.expires": "Действует до",
      "account.esims.viewQr": "Показать QR-код",
      "account.esims.hideQr": "Скрыть QR-код",
      "account.esims.active": "Активные",
      "account.esims.passive": "Неактивные",
      "account.esims.noActive": "У вас нет активных eSIM.",
      "account.esims.noPassive": "У вас нет неактивных eSIM.",
      "account.esims.readyHint": "Готова к использованию — срок действия начнется с первого использования.",
      "account.esims.unavailableHint": "Статус сейчас недоступен. Пожалуйста, попробуйте позже.",
      "esimStatus.active": "Активна",
      "esimStatus.readyToUse": "Готова к использованию",
      "esimStatus.inactive": "Неактивна",
      "esimStatus.unavailable": "Статус недоступен",
      "account.security.title": "Смена пароля",
      "account.field.oldPassword": "Текущий пароль",
      "account.field.newPassword": "Новый пароль",
      "account.field.confirmPassword": "Новый пароль (еще раз)",
      "account.changePassword": "Обновить пароль",
      "account.passwordChanged": "Ваш пароль обновлен.",
      "account.error.passwordMismatch": "Новые пароли не совпадают.",
      "account.danger.title": "Действия с аккаунтом",
      "account.delete": "Удалить аккаунт",
      "account.delete.confirm": "Вы собираетесь безвозвратно удалить свой аккаунт. Это действие нельзя отменить.",
      "account.delete.confirmBtn": "Да, удалить",
      "account.cancel": "Отмена",
      "esimDetail.back": "Назад",
      "esimDetail.dataUsage": "Использование данных",
      "esimDetail.left": "осталось",
      "esimDetail.leftData": "Оставшиеся данные",
      "esimDetail.usedData": "Использовано",
      "esimDetail.totalData": "Всего данных",
      "esimDetail.qrDesc": "Отсканируйте этот QR-код камерой устройства, чтобы настроить eSIM.",
      "esimDetail.validity": "Срок действия",
      "esimDetail.daysLeft": "Осталось дней: {{days}}",
      "esimDetail.expired": "Истек",
      "esimDetail.notYetActive": "Еще не активна",
      "esimDetail.leftDate": "Оставшееся время",
      "esimDetail.activationDate": "Дата активации",
      "esimDetail.endDate": "Дата окончания",
      "esimDetail.technical": "Технические детали",
      "esimDetail.activationCode": "Код активации (Android)",
      "esimDetail.smdp": "Адрес SM-DP+ (iOS)",
      "esimDetail.matchingId": "Идентификатор соответствия (iOS)",
      "esimDetail.support": "Техническая поддержка",
      "esimDetail.supportDesc": "Что-то не так? Мы готовы помочь.",
      "esimDetail.email": "Отправить письмо",
      "guide.eyebrow": "РУКОВОДСТВО ПО eSIM",
      "guide.title": "Что такое eSIM и как ее настроить?",
      "guide.intro.title": "Что такое eSIM?",
      "guide.intro.body": "eSIM — это цифровая SIM-карта, встроенная в ваше устройство, поэтому физическая карта не нужна. Отсканируйте QR-код — и линия будет настроена за секунды. Выходите в интернет в 190+ странах без смены карт и счетов за роуминг.",
      "guide.steps.title": "Как активировать",
      "guide.devices.title": "Поддерживаемые устройства",
      "guide.devices.desc": "Для работы eSIM ваше устройство должно ее поддерживать. Найдите свой бренд ниже.",
      "guide.faq.title": "Часто задаваемые вопросы",
      "nav.guide": "Руководство по eSIM",
      "currency.label": "Валюта",
      "staticPage.loading": "Загрузка страницы...",
      "staticPage.errorTitle": "Произошла ошибка",
      "staticPage.retry": "Повторить попытку",
      "staticPage.loadFailed": "Не удалось загрузить содержимое страницы. Пожалуйста, попробуйте позже.",
      "last.updated": "Последнее обновление: 8 июля 2024 г.",
      "home.tabs.unlimited": "Безлимитные eSIM",
      "detail.unlimited": "Безлимит",
      "detail.unlimitedNote": "В этом пакете нет ограничения по трафику — пользуйтесь безлимитным интернетом в течение всего срока действия.",
      "detail.notPriced": "Этот пакет сейчас недоступен для покупки на сайте.",
      "checkout.priceUpdated": "Цена этого пакета изменилась. Пожалуйста, вернитесь в магазин и выберите его снова.",
      "order.pending.title": "Ваша eSIM готовится",
      "order.pending.message": "Оплата прошла успешно. Активация безлимитных пакетов может занять несколько минут.",
      "order.pending.waiting": "Проверяем статус заказа…",
      "order.pending.ready": "Ваша eSIM готова!",
      "order.pending.timeout": "Это занимает больше времени, чем ожидалось. Ваш платеж в безопасности — eSIM появится в разделе «Мои eSIM», как только будет готова.",
      "order.pending.cta": "Перейти к моим eSIM",
      "account.esims.unlimited": "Безлимит",
      "account.esims.unlimitedHint": "Безлимитные данные — в этом пакете нет ограничения по трафику.",
      "esimDetail.unlimitedData": "В этом пакете нет ограничения по трафику; оставшееся время указано ниже.",
      "del.eyebrow": "Удаление аккаунта",
      "del.title": "Удалить мой аккаунт",
      "del.intro": "Здесь вы можете безвозвратно удалить свой аккаунт Utkan eSIM и персональные данные. Приложение устанавливать не нужно — просто войдите в аккаунт, который хотите удалить.",
      "del.deleted.title": "Удаляемые данные",
      "del.deleted.identity": "Ваши имя, фамилия, адрес эл. почты и номер телефона",
      "del.deleted.credentials": "Ваш пароль и данные сеансов",
      "del.deleted.codes": "Коды подтверждения эл. почты и сброса пароля",
      "del.deleted.esim": "Номер вашей eSIM (MSISDN), QR-код/код активации и данные об использовании",
      "del.kept.title": "Какие данные мы храним и почему",
      "del.kept.orders": "Записи о покупках (номер заказа, дата, сумма, статус оплаты) хранятся для выполнения налоговых и бухгалтерских обязательств. Они не содержат имени, адреса эл. почты или платежных данных — только идентификатор, который невозможно связать с вами.",
      "del.kept.period": "Срок хранения: 5 лет (Налоговый процессуальный кодекс Турции, ст. 253).",
      "del.warn.title": "Перед удалением",
      "del.warn.irreversible": "Это действие нельзя отменить.",
      "del.warn.esim": "Активные eSIM продолжат работать на вашем устройстве, но вы больше не сможете получить доступ к QR-коду и оставшимся данным. Сохраните QR-код перед удалением.",
      "del.warn.rejoin": "Вы сможете снова зарегистрироваться с тем же адресом эл. почты, но ваши прежние eSIM не появятся в новом аккаунте.",
      "del.support": "Если вы не можете войти, запросить удаление можно также по эл. почте:",
      "del.login.title": "Сначала войдите",
      "del.login.subtitle": "Введите эл. почту и пароль, чтобы мы могли убедиться, что аккаунт принадлежит вам.",
      "del.login.action": "Войти",
      "del.login.loading": "Выполняется вход...",
      "del.forgot": "Забыли пароль?",
      "del.confirm.title": "Вы уверены?",
      "del.confirm.subtitle": "Аккаунт {{email}} и ваши персональные данные будут безвозвратно удалены.",
      "del.confirm.field": "Для подтверждения введите адрес эл. почты еще раз",
      "del.confirm.action": "Безвозвратно удалить аккаунт",
      "del.confirm.deleting": "Удаление...",
      "del.confirm.cancel": "Отмена",
      "del.done.title": "Ваш аккаунт удален",
      "del.done.body": "Ваши персональные данные безвозвратно удалены.",
      "del.done.retained": "Ваши персональные данные безвозвратно удалены. Для выполнения законных обязательств сохранено записей о покупках: {{n}}; их невозможно связать с вами.",
      "del.done.home": "Вернуться в магазин",
      "del.error.required": "Пожалуйста, введите эл. почту и пароль.",
      "del.error.credentials": "Неверная эл. почта или пароль.",
      "del.error.suspended": "Ваш аккаунт заблокирован. Пожалуйста, обратитесь в поддержку.",
      "del.error.session": "Срок действия сеанса истек. Пожалуйста, войдите снова.",
      "del.error.network": "Не удалось подключиться. Проверьте интернет-соединение и попробуйте снова.",
      "del.error.generic": "Что-то пошло не так. Пожалуйста, попробуйте снова.",
      "footer.deleteAccount": "Удалить аккаунт",
      "home.tabs.voice": "eSIM со звонками",
      "detail.voice": "Звонки + SMS",
      "detail.voiceNote": "Помимо данных, этот тариф включает безлимитные звонки и SMS — одна eSIM и для интернета, и для звонков.",
      "detail.calls": "Звонки",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "Безлимитные звонки",
      "plan.unlimitedSms": "Безлимитные SMS",
      "plan.minutes": "{{n}} мин звонков",
      "plan.sms": "{{n}} SMS",
      "hercules.subtitle": "Безлимитные звонки, SMS и данные в {{n}} странах Европы — на одной eSIM.",
      "hercules.coverageTitle": "Страны покрытия ({{n}})",
      "hercules.promo.desc": "Безлимитные звонки и SMS в {{n}} странах и 20–100 ГБ данных.",
      "hercules.promo.cta": "Смотреть тариф",
      "loading": "Загрузка..."
    }
  },
  // Urduca
  ur: {
    translation: {
      "language.title": "زبان",
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "ڈیجیٹل کنیکٹیویٹی کا مستقبل",
      "hero.description": "نئی نسل کے ڈیجیٹل کنیکٹیویٹی تجربے کے ساتھ ہم سرحدیں ختم کر رہے ہیں۔",
      "hero.description2": "دنیا بھر میں تیز، محفوظ اور کفایتی eSIM حل۔",
      "features.countries": "150+ ممالک",
      "features.activation": "فوری فعال سازی",
      "features.support": "24/7 سپورٹ",
      "countdown.title": "ہماری ویب سائٹ جلد آ رہی ہے!",
      "countdown.days": "دن",
      "countdown.hours": "گھنٹے",
      "countdown.minutes": "منٹ",
      "countdown.seconds": "سیکنڈ",
      "countdown.launch": "ہماری ویب سائٹ لائیو ہو گئی ہے!",
      "countdown.loading": "لوڈ ہو رہا ہے...",
      "apps.title": "ہماری موبائل ایپس",
      "apps.ios.label": "ڈاؤن لوڈ کریں",
      "apps.ios.name": "App Store",
      "apps.android.label": "حاصل کریں",
      "apps.android.name": "Google Play",
      "contact.title": "لانچ تک ہم سے رابطہ کریں",
      "contact.whatsapp": "WhatsApp: +90 540 155 13 33",
      "contact.email": "ای میل: info@utkanesim.com",
      "about.hero.title": "Utkan eSIM کے بارے میں",
      "about.hero.description": "آپ جہاں بھی جائیں، جڑے رہنے کے لیے آپ کا قابلِ اعتماد ساتھی۔ ہمارا ماننا ہے کہ بین الاقوامی سفر فزیکل سم کارڈ کی پریشانی اور مہنگے رومنگ چارجز کے بغیر آسان اور کفایتی ہونا چاہیے۔",
      "about.story.title": "ہماری کہانی",
      "about.story.content": "2024 میں پرجوش مسافروں اور ٹیکنالوجی کے شوقین افراد کی ایک ٹیم نے اس کی بنیاد رکھی۔ ہمارا مقصد بیرونِ ملک انٹرنیٹ سے جڑنے کے طریقے میں انقلاب لانا ہے۔ ہم 190 سے زائد ممالک اور خطوں کے لیے اعلیٰ معیار کے، قابلِ اعتماد eSIM ڈیٹا پلان فراہم کرتے ہیں تاکہ لینڈ کرتے ہی آپ کو تیز انٹرنیٹ میسر ہو۔",
      "about.mission.title": "ہمارا مشن",
      "about.mission.content": "مسافروں کو دنیا بھر میں آسان، کفایتی اور فوری کنیکٹیویٹی فراہم کرنا، تاکہ وہ بغیر کسی حد کے سیر کر سکیں، کام کر سکیں اور رابطے میں رہ سکیں۔",
      "about.vision.title": "ہمارا وژن",
      "about.vision.content": "ڈیجیٹل کنیکٹیویٹی حل کا صفِ اول کا عالمی پلیٹ فارم بننا اور دنیا کو ہر ایک کے لیے زیادہ قریب اور زیادہ جڑا ہوا بنانا۔",
      "about.features.title": "ہمیں کیوں منتخب کریں؟",
      "about.features.instant.title": "فوری ڈیلیوری",
      "about.features.instant.content": "خریداری کے فوراً بعد QR کوڈ کے ذریعے اپنا eSIM حاصل کریں۔",
      "about.features.global.title": "عالمی کوریج",
      "about.features.global.content": "190 سے زائد ممالک اور خطوں کے لیے ڈیٹا پلان۔",
      "about.features.affordable.title": "کفایتی نرخ",
      "about.features.affordable.content": "رومنگ چارجز پر 90% تک بچت کریں۔",
      "about.features.support.title": "24/7 سپورٹ",
      "about.features.support.content": "ہماری سرشار سپورٹ ٹیم ہمیشہ آپ کی مدد کے لیے موجود ہے۔",
      "about.features.secure.title": "محفوظ کنکشن",
      "about.features.secure.content": "جدید ترین سیکیورٹی پروٹوکولز سے محفوظ کنکشن۔",
      "about.features.fast.title": "تیز انٹرنیٹ",
      "about.features.fast.content": "4G/5G رفتار پر بلا تعطل انٹرنیٹ کا تجربہ۔",
      "about.cta.title": "ڈیجیٹل کنیکٹیویٹی کے مستقبل کا حصہ بنیں",
      "about.cta.content": "Utkan eSIM منتخب کرنے کا شکریہ۔ آپ کا سفر خوشگوار ہو!",
      "about.cta.whatsapp": "WhatsApp کے ذریعے رابطہ کریں",
      "about.cta.email": "ای میل بھیجیں",
      "contact.hero.title": "ہم سے رابطہ کریں",
      "contact.hero.description": "ہم مدد کے لیے حاضر ہیں! چاہے آپ کا ہمارے eSIM کے بارے میں کوئی سوال ہو، تکنیکی مدد درکار ہو یا صرف اپنی رائے دینا چاہتے ہوں، ہمیں آپ سے سن کر خوشی ہوگی۔",
      "contact.info.title": "رابطے کی معلومات",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "24/7 فوری سپورٹ",
      "contact.email.title": "ای میل",
      "contact.email.subtitle": "عمومی رابطہ",
      "contact.support.title": "تکنیکی سپورٹ",
      "contact.support.subtitle": "eSIM کے مسائل",
      "contact.business.title": "شراکت داری",
      "contact.business.subtitle": "کارپوریٹ رابطہ",
      "contact.hours.title": "سپورٹ کے اوقات",
      "contact.hours.subtitle": "24/7 تکنیکی سپورٹ",
      "contact.hours.detail": "پیر - اتوار: 00:00 - 23:59",
      "contact.form.title": "ہمیں پیغام بھیجیں",
      "contact.form.name": "آپ کا نام",
      "contact.form.name.placeholder": "اپنا نام اور خاندانی نام درج کریں",
      "contact.form.email": "آپ کا ای میل",
      "contact.form.email.placeholder": "example@email.com",
      "contact.form.subject": "موضوع",
      "contact.form.subject.placeholder": "موضوع منتخب کریں",
      "contact.form.subject.general": "عمومی معلومات",
      "contact.form.subject.technical": "تکنیکی سپورٹ",
      "contact.form.subject.billing": "بلنگ سے متعلق سوالات",
      "contact.form.subject.partnership": "شراکت داری",
      "contact.form.subject.feedback": "رائے",
      "contact.form.message": "آپ کا پیغام",
      "contact.form.message.placeholder": "اپنا پیغام یہاں لکھیں...",
      "contact.form.submit": "پیغام بھیجیں",
      "contact.faq.title": "اکثر پوچھے جانے والے سوالات",
      "contact.faq.esim.title": "eSIM کیسے کام کرتا ہے؟",
      "contact.faq.esim.content": "eSIM ایک ڈیجیٹل سم کارڈ ہے جو فزیکل سم کارڈ کے بغیر آپ کے فون میں کام کرتا ہے۔ یہ QR کوڈ کے ذریعے فوراً فعال ہو جاتا ہے۔",
      "contact.faq.phones.title": "کون سے فون eSIM کو سپورٹ کرتے ہیں؟",
      "contact.faq.phones.content": "iPhone XS اور اس سے جدید، Samsung Galaxy S20 اور اس سے جدید، اور Google Pixel 3 اور اس سے جدید ماڈلز eSIM کو سپورٹ کرتے ہیں۔",
      "contact.faq.validity.title": "میرا ڈیٹا پیکج کتنی مدت کے لیے کارآمد ہے؟",
      "contact.faq.validity.content": "پیکج کی میعاد آپ کے منتخب کردہ پلان کے مطابق 1 سے 30 دن تک ہوتی ہے۔",
      "contact.faq.payment.title": "میں ادائیگی کیسے کر سکتا ہوں؟",
      "contact.faq.payment.content": "آپ کریڈٹ کارڈ، PayPal اور بینک ٹرانسفر کے ذریعے محفوظ ادائیگی کر سکتے ہیں۔",
      "privacy.hero.title": "رازداری کی پالیسی",
      "privacy.hero.description": "آپ کے ذاتی ڈیٹا کی حفاظت ہمارے لیے نہایت اہم ہے۔ یہ پالیسی وضاحت کرتی ہے کہ آپ کا ڈیٹا کیسے جمع، استعمال اور محفوظ کیا جاتا ہے۔",
      "privacy.overview.title": "جائزہ",
      "privacy.overview.content": "یہ رازداری کی پالیسی بیان کرتی ہے کہ جب آپ سروس استعمال کرتے ہیں تو ہم آپ کی معلومات کو کیسے جمع، استعمال اور ظاہر کرتے ہیں، اور آپ کو آپ کے رازداری کے حقوق اور قانون آپ کو کیسے تحفظ دیتا ہے اس سے آگاہ کرتی ہے۔",
      "privacy.data.title": "ہم جو ڈیٹا جمع کرتے ہیں",
      "privacy.data.personal.title": "ذاتی معلومات",
      "privacy.data.personal.name": "نام اور خاندانی نام",
      "privacy.data.personal.email": "ای میل ایڈریس",
      "privacy.data.personal.phone": "فون نمبر",
      "privacy.data.personal.payment": "ادائیگی کی معلومات",
      "privacy.data.usage.title": "استعمال کا ڈیٹا",
      "privacy.data.usage.ip": "IP ایڈریس",
      "privacy.data.usage.browser": "براؤزر کی قسم",
      "privacy.data.usage.device": "ڈیوائس کی معلومات",
      "privacy.data.usage.stats": "استعمال کے اعداد و شمار",
      "privacy.security.title": "ڈیٹا کی حفاظت",
      "privacy.security.ssl.title": "SSL انکرپشن",
      "privacy.security.ssl.content": "تمام ڈیٹا کی منتقلی 256 بٹ SSL انکرپشن سے محفوظ ہے۔",
      "privacy.security.servers.title": "محفوظ سرورز",
      "privacy.security.servers.content": "آپ کا ڈیٹا ISO 27001 سے تصدیق شدہ محفوظ سرورز پر محفوظ کیا جاتا ہے۔",
      "privacy.security.access.title": "رسائی کا کنٹرول",
      "privacy.security.access.content": "صرف مجاز عملہ ہی آپ کے ڈیٹا تک رسائی حاصل کر سکتا ہے۔",
      "privacy.usage.title": "ڈیٹا کا استعمال",
      "privacy.usage.intro": "ہم جمع کردہ ڈیٹا کو درج ذیل مقاصد کے لیے استعمال کرتے ہیں:",
      "privacy.usage.service.title": "سروس کی فراہمی",
      "privacy.usage.service.content": "آپ کو ہماری eSIM سروسز فراہم کرنے اور ان کا انتظام کرنے کے لیے",
      "privacy.usage.support.title": "کسٹمر سپورٹ",
      "privacy.usage.support.content": "تکنیکی سپورٹ اور کسٹمر سروس فراہم کرنے کے لیے",
      "privacy.usage.security.title": "سیکیورٹی",
      "privacy.usage.security.content": "آپ کے اکاؤنٹ اور ہماری سروسز کو محفوظ رکھنے کے لیے",
      "privacy.usage.improvement.title": "بہتری",
      "privacy.usage.improvement.content": "اپنی سروسز کو بہتر بنانے اور نئی خصوصیات شامل کرنے کے لیے",
      "privacy.sharing.title": "ڈیٹا کا اشتراک",
      "privacy.sharing.intro": "ہم آپ کا ذاتی ڈیٹا تیسرے فریق کے ساتھ شیئر نہیں کرتے، تاہم درج ذیل صورتوں میں اشتراک ضروری ہو سکتا ہے:",
      "privacy.sharing.legal": "قانونی ذمہ داری کی صورت میں",
      "privacy.sharing.providers": "ہمارے سروس فراہم کنندگان کے ساتھ (جیسے ادائیگی پروسیسرز)",
      "privacy.sharing.threats": "سیکیورٹی خطرات کی روک تھام کے لیے",
      "privacy.sharing.consent": "جب آپ واضح رضامندی دیں",
      "privacy.rights.title": "آپ کے حقوق",
      "privacy.rights.access.title": "رسائی کا حق",
      "privacy.rights.access.content": "آپ ہمارے پاس محفوظ اپنے ڈیٹا تک رسائی کی درخواست کر سکتے ہیں۔",
      "privacy.rights.correction.title": "درستی کا حق",
      "privacy.rights.correction.content": "ہم آپ کے غلط یا نامکمل ڈیٹا کو درست کر سکتے ہیں۔",
      "privacy.rights.deletion.title": "حذف کرنے کا حق",
      "privacy.rights.deletion.content": "ہم مخصوص شرائط کے تحت آپ کا ڈیٹا حذف کر سکتے ہیں۔",
      "privacy.rights.objection.title": "اعتراض کا حق",
      "privacy.rights.objection.content": "آپ ہماری ڈیٹا پروسیسنگ سرگرمیوں پر اعتراض کر سکتے ہیں۔",
      "privacy.contact.title": "رابطہ",
      "privacy.contact.intro": "اگر اس رازداری کی پالیسی کے بارے میں آپ کے کوئی سوالات ہیں تو آپ درج ذیل ذرائع سے ہم سے رابطہ کر سکتے ہیں:",
      "nav.about": "ہمارے بارے میں",
      "nav.contact": "رابطہ",
      "nav.privacy": "رازداری",
      "nav.login": "لاگ ان",
      "nav.account": "اکاؤنٹ",
      "nav.logout": "لاگ آؤٹ",
      "auth.brand.eyebrow": "عالمی کوریج",
      "auth.brand.title": "150+ ممالک میں، لینڈ کرتے ہی آن لائن۔",
      "auth.brand.subtitle": "نہ فزیکل سم، نہ رومنگ بل۔ اپنا eSIM چند سیکنڈز میں فعال کریں۔",
      "auth.login.eyebrow": "لاگ ان",
      "auth.login.title": "دوبارہ خوش آمدید",
      "auth.login.subtitle": "اپنے eSIM کا انتظام کریں اور نئے eSIM دریافت کریں۔",
      "auth.signup.eyebrow": "نیا اکاؤنٹ",
      "auth.signup.title": "اپنا اکاؤنٹ بنائیں",
      "auth.signup.subtitle": "آپ کے پہلے eSIM سے بس چند قدم دور۔",
      "auth.field.identifier": "ای میل یا فون",
      "auth.field.identifier.ph": "you@email.com یا +92…",
      "auth.field.email": "ای میل",
      "auth.field.email.ph": "you@email.com",
      "auth.field.fullName": "پورا نام",
      "auth.field.fullName.ph": "آپ کا پورا نام",
      "auth.field.password": "پاس ورڈ",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "لاگ ان کریں",
      "auth.action.loggingIn": "لاگ ان ہو رہا ہے…",
      "auth.action.signup": "اکاؤنٹ بنائیں",
      "auth.action.signingUp": "اکاؤنٹ بن رہا ہے…",
      "auth.toSignup.q": "اکاؤنٹ نہیں ہے؟",
      "auth.toSignup.link": "سائن اپ کریں",
      "auth.toLogin.q": "پہلے سے اکاؤنٹ ہے؟",
      "auth.toLogin.link": "لاگ ان کریں",
      "auth.password.show": "پاس ورڈ دکھائیں",
      "auth.password.hide": "پاس ورڈ چھپائیں",
      "auth.terms.prefix": "جاری رکھ کر میں ",
      "auth.terms.link": "استعمال کی شرائط اور رازداری کی پالیسی",
      "auth.terms.suffix": " سے اتفاق کرتا ہوں۔",
      "auth.error.required": "براہ کرم مطلوبہ خانے پُر کریں۔",
      "auth.error.terms": "جاری رکھنے کے لیے براہ کرم شرائط قبول کریں۔",
      "verify.eyebrow": "ای میل کی تصدیق",
      "verify.title": "اپنے ای میل کی تصدیق کریں",
      "verify.subtitle": "ہم نے {{email}} پر 6 ہندسوں کا کوڈ بھیجا ہے۔ تصدیق کے لیے اسے درج کریں۔",
      "verify.code": "تصدیقی کوڈ",
      "verify.code.ph": "••••••",
      "verify.action": "تصدیق کریں",
      "verify.verifying": "تصدیق ہو رہی ہے…",
      "verify.resend": "کوڈ دوبارہ بھیجیں",
      "verify.resendIn": "{{seconds}} سیکنڈ میں دوبارہ بھیجیں",
      "verify.resent": "نیا کوڈ بھیج دیا گیا ہے۔",
      "verify.skip": "ابھی چھوڑ دیں",
      "auth.forgot.link": "پاس ورڈ بھول گئے؟",
      "forgot.eyebrow": "پاس ورڈ ری سیٹ",
      "forgot.email.title": "اپنا پاس ورڈ ری سیٹ کریں",
      "forgot.email.subtitle": "اپنے اکاؤنٹ کا ای میل درج کریں، ہم آپ کو 6 ہندسوں کا ری سیٹ کوڈ بھیجیں گے۔",
      "forgot.email.action": "کوڈ بھیجیں",
      "forgot.email.sending": "بھیجا جا رہا ہے…",
      "forgot.reset.title": "نیا پاس ورڈ مقرر کریں",
      "forgot.reset.subtitle": "{{email}} پر بھیجا گیا 6 ہندسوں کا کوڈ اور اپنا نیا پاس ورڈ درج کریں۔",
      "forgot.reset.action": "پاس ورڈ اپ ڈیٹ کریں",
      "forgot.reset.updating": "اپ ڈیٹ ہو رہا ہے…",
      "forgot.field.code": "ری سیٹ کوڈ",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "نیا پاس ورڈ",
      "forgot.field.newPassword.ph": "کم از کم 6 حروف",
      "forgot.resend": "کوڈ دوبارہ بھیجیں",
      "forgot.resendIn": "{{seconds}} سیکنڈ میں دوبارہ بھیجیں",
      "forgot.resent": "نیا کوڈ بھیج دیا گیا ہے۔",
      "forgot.backToLogin": "لاگ ان پر واپس جائیں",
      "forgot.changeEmail": "ای میل تبدیل کریں",
      "forgot.help.noMail": "اگر کوڈ موصول نہیں ہوا تو اپنا اسپام فولڈر چیک کریں یا اپنے ای میل ایڈریس کی تصدیق کریں۔",
      "reset.RESET_CODE_SENT": "کوڈ بھیج دیا گیا۔ براہ کرم اپنا ای میل چیک کریں۔",
      "reset.RATE_LIMITED": "بہت زیادہ درخواستیں۔ براہ کرم کچھ دیر انتظار کر کے دوبارہ کوشش کریں۔",
      "reset.MAIL_SEND_FAILED": "کچھ غلط ہو گیا۔ براہ کرم بعد میں دوبارہ کوشش کریں۔",
      "reset.RESET_CODE_VALID": "کوڈ کی تصدیق ہو گئی۔",
      "reset.INVALID_RESET_CODE": "کوڈ غلط ہے۔ براہ کرم دوبارہ کوشش کریں۔",
      "reset.EXPIRED_RESET_CODE": "کوڈ کی میعاد ختم ہو گئی ہے۔ براہ کرم نئے کوڈ کی درخواست کریں۔",
      "reset.WEAK_PASSWORD": "پاس ورڈ کم از کم 6 حروف کا ہونا چاہیے۔",
      "reset.PASSWORD_RESET_SUCCESS": "آپ کا پاس ورڈ اپ ڈیٹ ہو گیا ہے۔ براہ کرم اپنے نئے پاس ورڈ سے لاگ ان کریں۔",
      "reset.generic": "کچھ غلط ہو گیا۔ براہ کرم دوبارہ کوشش کریں۔",
      "login.resetSuccess": "آپ کا پاس ورڈ اپ ڈیٹ ہو گیا ہے۔ براہ کرم اپنے نئے پاس ورڈ سے لاگ ان کریں۔",
      "store.nav.shop": "اسٹور",
      "home.hero.title1": "منٹوں میں جڑیں،",
      "home.hero.title2": "سرحدوں کے پار آن لائن رہیں۔",
      "home.hero.subtitle": "190+ ممالک میں کارآمد قابلِ اعتماد eSIM پلان۔ نہ فزیکل سم، نہ رومنگ بل۔",
      "home.search.placeholder": "آپ کہاں سفر کر رہے ہیں؟",
      "home.tabs.local": "مقامی eSIM",
      "home.tabs.regional": "علاقائی eSIM",
      "home.tabs.lifetime": "لائف ٹائم eSIM",
      "home.empty": "آپ کی تلاش سے مطابقت رکھنے والا کوئی نتیجہ نہیں ملا۔",
      "home.error.title": "مواد لوڈ نہیں ہو سکا",
      "home.error.retry": "دوبارہ کوشش کریں",
      "home.from": "شروع",
      "home.popular": "مقبول مقامات",
      "home.coverage": "190+ ممالک · فوری فعال سازی",
      "home.detail.soon": "اس انتخاب کے پلان بہت جلد یہاں دکھائے جائیں گے۔",
      "home.detail.back": "اسٹور پر واپس جائیں",
      "detail.plans": "پلان",
      "detail.count": "{{count}} پلان",
      "detail.validity": "{{days}} دن",
      "detail.validityLifetime": "کوئی میعاد نہیں",
      "detail.buy": "خریدیں",
      "detail.empty": "اس وقت اس انتخاب کے لیے کوئی پلان دستیاب نہیں۔",
      "detail.checkoutSoon": "ادائیگی کی سہولت بہت جلد دستیاب ہوگی۔",
      "detail.loginToBuy": "خریدنے کے لیے براہ کرم لاگ ان کریں۔",
      "detail.basicFeatures": "بنیادی خصوصیات",
      "detail.dataAmount": "ڈیٹا کی مقدار",
      "detail.validityLabel": "میعاد",
      "detail.coverageArea": "کوریج",
      "detail.activationNetworks": "فعال سازی اور نیٹ ورکس",
      "detail.activationMethod": "فعال سازی کا طریقہ",
      "detail.esimActivation": "eSIM — QR کوڈ کے ذریعے فوری",
      "detail.supportedNetworks": "تعاون یافتہ نیٹ ورکس",
      "detail.description": "تفصیل",
      "detail.price": "قیمت",
      "authprompt.title": "جاری رکھنے کے لیے لاگ ان کریں",
      "authprompt.message": "eSIM خریدنے کے لیے اپنے اکاؤنٹ میں لاگ ان کریں، یا چند سیکنڈز میں نیا اکاؤنٹ بنائیں۔",
      "authprompt.close": "بند کریں",
      "footer.tagline": "دنیا بھر میں تیز، محفوظ اور کفایتی eSIM۔ لینڈ کرتے ہی آن لائن ہو جائیں۔",
      "footer.explore": "دریافت کریں",
      "footer.support": "سپورٹ",
      "footer.legal": "قانونی",
      "footer.shop": "اسٹور",
      "footer.help": "اکثر پوچھے جانے والے سوالات",
      "footer.terms": "استعمال کی شرائط",
      "footer.rights": "© {{year}} Utkan eSIM۔ جملہ حقوق محفوظ ہیں۔",
      "footer.apps": "ایپ حاصل کریں",
      "whatsapp.label": "WhatsApp پر چیٹ کریں",
      "whatsapp.message": "ہیلو، مجھے eSIM سپورٹ کی درخواست کرنی ہے۔",
      "notfound.eyebrow": "سگنل نہیں",
      "notfound.title": "یہ صفحہ دسترس سے باہر ہے",
      "notfound.message": "آپ جو صفحہ تلاش کر رہے ہیں وہ منتقل ہو چکا ہے یا کبھی موجود ہی نہیں تھا۔ آئیے آپ کو دوبارہ کوریج میں لے چلیں۔",
      "order.congrats": "مبارک ہو!",
      "order.message": "آپ کا eSIM تیار ہے۔ نیچے دیے گئے QR کوڈ سے چند مراحل میں اسے سیٹ اپ کریں۔",
      "order.details": "آرڈر کا خلاصہ",
      "order.activation": "فعال سازی",
      "order.activationDesc": "اپنا eSIM سیٹ اپ کرنے کے لیے اپنی ڈیوائس کے کیمرے سے QR کوڈ اسکین کریں یا ایکٹیویشن کوڈ دستی طور پر درج کریں۔",
      "order.qrTitle": "eSIM QR کوڈ",
      "order.manualLabel": "ایکٹیویشن کوڈ",
      "order.copy": "کاپی کریں",
      "order.copied": "کاپی ہو گیا",
      "order.howTo": "فعال کرنے کا طریقہ",
      "order.step1": "اپنی ڈیوائس پر سیٹنگز > سیلولر / موبائل ڈیٹا > eSIM شامل کریں پر جائیں۔",
      "order.step2": "“QR کوڈ استعمال کریں” منتخب کریں اور اوپر دیا گیا QR اسکین کریں (یا ایکٹیویشن کوڈ دستی طور پر درج کریں)۔",
      "order.step3": "سیٹ اپ مکمل ہونے کے بعد eSIM پلان کو فعال کریں۔",
      "order.step4": "یقینی بنائیں کہ ڈیٹا رومنگ آن ہے — آپ جڑ گئے ہیں!",
      "order.cta": "ہوم پر واپس جائیں",
      "checkout.title": "ادائیگی",
      "checkout.summary": "آرڈر کا خلاصہ",
      "checkout.total": "کل",
      "checkout.eurNote": "آپ سے PayPal کے ذریعے یورو (€) میں رقم وصول کی جائے گی۔",
      "checkout.processing": "آپ کی ادائیگی کی تصدیق ہو رہی ہے…",
      "checkout.error": "ادائیگی مکمل نہیں ہو سکی۔ براہ کرم دوبارہ کوشش کریں۔",
      "checkout.cancelled": "ادائیگی منسوخ کر دی گئی۔",
      "account.title": "میرا اکاؤنٹ",
      "account.tab.profile": "پروفائل",
      "account.tab.esims": "میرے eSIM",
      "account.tab.security": "سیکیورٹی",
      "account.profile.title": "پروفائل کی معلومات",
      "account.field.phone": "فون",
      "account.field.phone.ph": "+92…",
      "account.memberSince": "رکنیت کی تاریخ",
      "account.save": "محفوظ کریں",
      "account.saving": "محفوظ ہو رہا ہے…",
      "account.saved": "آپ کی تفصیلات اپ ڈیٹ ہو گئیں۔",
      "account.esims.title": "میرے eSIM",
      "account.esims.empty": "آپ کے پاس ابھی کوئی eSIM نہیں ہے۔",
      "account.esims.emptyCta": "اسٹور دیکھیں",
      "account.esims.data": "ڈیٹا",
      "account.esims.expires": "میعاد ختم",
      "account.esims.viewQr": "QR کوڈ دکھائیں",
      "account.esims.hideQr": "QR کوڈ چھپائیں",
      "account.esims.active": "فعال",
      "account.esims.passive": "غیر فعال",
      "account.esims.noActive": "آپ کے پاس کوئی فعال eSIM نہیں ہے۔",
      "account.esims.noPassive": "آپ کے پاس کوئی غیر فعال eSIM نہیں ہے۔",
      "account.esims.readyHint": "استعمال کے لیے تیار — میعاد پہلے استعمال سے شروع ہوگی۔",
      "account.esims.unavailableHint": "اس وقت اسٹیٹس دستیاب نہیں۔ براہ کرم بعد میں دوبارہ کوشش کریں۔",
      "esimStatus.active": "فعال",
      "esimStatus.readyToUse": "استعمال کے لیے تیار",
      "esimStatus.inactive": "غیر فعال",
      "esimStatus.unavailable": "اسٹیٹس دستیاب نہیں",
      "account.security.title": "پاس ورڈ تبدیل کریں",
      "account.field.oldPassword": "موجودہ پاس ورڈ",
      "account.field.newPassword": "نیا پاس ورڈ",
      "account.field.confirmPassword": "نیا پاس ورڈ (دوبارہ)",
      "account.changePassword": "پاس ورڈ اپ ڈیٹ کریں",
      "account.passwordChanged": "آپ کا پاس ورڈ اپ ڈیٹ ہو گیا۔",
      "account.error.passwordMismatch": "نئے پاس ورڈ مماثل نہیں ہیں۔",
      "account.danger.title": "اکاؤنٹ کے اقدامات",
      "account.delete": "اکاؤنٹ حذف کریں",
      "account.delete.confirm": "آپ اپنا اکاؤنٹ مستقل طور پر حذف کرنے والے ہیں۔ یہ عمل واپس نہیں ہو سکتا۔",
      "account.delete.confirmBtn": "ہاں، حذف کریں",
      "account.cancel": "منسوخ کریں",
      "esimDetail.back": "واپس",
      "esimDetail.dataUsage": "ڈیٹا کا استعمال",
      "esimDetail.left": "باقی",
      "esimDetail.leftData": "باقی ڈیٹا",
      "esimDetail.usedData": "استعمال شدہ",
      "esimDetail.totalData": "کل ڈیٹا",
      "esimDetail.qrDesc": "اپنا eSIM سیٹ اپ کرنے کے لیے اپنی ڈیوائس کے کیمرے سے یہ QR کوڈ اسکین کریں۔",
      "esimDetail.validity": "میعاد",
      "esimDetail.daysLeft": "{{days}} دن باقی ہیں",
      "esimDetail.expired": "میعاد ختم ہو گئی",
      "esimDetail.notYetActive": "ابھی فعال نہیں ہوا",
      "esimDetail.leftDate": "باقی وقت",
      "esimDetail.activationDate": "فعال سازی کی تاریخ",
      "esimDetail.endDate": "اختتامی تاریخ",
      "esimDetail.technical": "تکنیکی تفصیلات",
      "esimDetail.activationCode": "ایکٹیویشن کوڈ (Android)",
      "esimDetail.smdp": "SM-DP+ ایڈریس (iOS)",
      "esimDetail.matchingId": "Matching ID (iOS)",
      "esimDetail.support": "تکنیکی سپورٹ",
      "esimDetail.supportDesc": "کوئی مسئلہ ہے؟ ہم مدد کے لیے حاضر ہیں۔",
      "esimDetail.email": "ای میل بھیجیں",
      "guide.eyebrow": "eSIM گائیڈ",
      "guide.title": "eSIM کیا ہے اور اسے کیسے سیٹ اپ کریں؟",
      "guide.intro.title": "eSIM کیا ہے؟",
      "guide.intro.body": "eSIM آپ کی ڈیوائس میں موجود ایک ڈیجیٹل سم ہے — کسی فزیکل کارڈ کی ضرورت نہیں۔ ایک QR کوڈ اسکین کریں اور چند سیکنڈز میں آپ کی لائن سیٹ اپ ہو جائے گی، تاکہ آپ کارڈ بدلے اور رومنگ بل کے بغیر 190+ ممالک میں آن لائن ہو سکیں۔",
      "guide.steps.title": "فعال کرنے کا طریقہ",
      "guide.devices.title": "تعاون یافتہ آلات",
      "guide.devices.desc": "eSIM کے کام کرنے کے لیے آپ کی ڈیوائس کا eSIM کو سپورٹ کرنا ضروری ہے۔ نیچے اپنا برانڈ تلاش کریں۔",
      "guide.faq.title": "اکثر پوچھے جانے والے سوالات",
      "nav.guide": "eSIM گائیڈ",
      "currency.label": "کرنسی",
      "staticPage.loading": "صفحہ لوڈ ہو رہا ہے...",
      "staticPage.errorTitle": "ایک خرابی پیش آ گئی",
      "staticPage.retry": "دوبارہ کوشش کریں",
      "staticPage.loadFailed": "صفحے کا مواد لوڈ نہیں ہو سکا۔ براہ کرم بعد میں دوبارہ کوشش کریں۔",
      "last.updated": "آخری اپ ڈیٹ: 8 جولائی 2024",
      "home.tabs.unlimited": "لامحدود eSIM",
      "detail.unlimited": "لامحدود",
      "detail.unlimitedNote": "اس پیکج میں ڈیٹا کی کوئی حد نہیں — پوری میعاد کے دوران لامحدود انٹرنیٹ سے لطف اٹھائیں۔",
      "detail.notPriced": "یہ پیکج اس وقت ویب پر خریداری کے لیے دستیاب نہیں۔",
      "checkout.priceUpdated": "اس پیکج کی قیمت تبدیل ہو گئی ہے۔ براہ کرم اسٹور پر واپس جا کر اسے دوبارہ منتخب کریں۔",
      "order.pending.title": "آپ کا eSIM تیار کیا جا رہا ہے",
      "order.pending.message": "آپ کی ادائیگی کامیاب رہی۔ لامحدود پیکجز کو فعال ہونے میں چند منٹ لگ سکتے ہیں۔",
      "order.pending.waiting": "آپ کے آرڈر کا اسٹیٹس چیک کیا جا رہا ہے…",
      "order.pending.ready": "آپ کا eSIM تیار ہے!",
      "order.pending.timeout": "اس میں توقع سے زیادہ وقت لگ رہا ہے۔ آپ کی ادائیگی محفوظ ہے — تیار ہوتے ہی آپ کا eSIM “میرے eSIM” میں نظر آئے گا۔",
      "order.pending.cta": "میرے eSIM پر جائیں",
      "account.esims.unlimited": "لامحدود",
      "account.esims.unlimitedHint": "لامحدود ڈیٹا — اس پیکج میں ڈیٹا کی کوئی حد نہیں۔",
      "esimDetail.unlimitedData": "اس پیکج میں ڈیٹا کی کوئی حد نہیں؛ باقی وقت نیچے دیکھیں۔",
      "del.eyebrow": "اکاؤنٹ کی حذف کاری",
      "del.title": "میرا اکاؤنٹ حذف کریں",
      "del.intro": "یہاں آپ اپنا Utkan eSIM اکاؤنٹ اور ذاتی ڈیٹا مستقل طور پر حذف کر سکتے ہیں۔ ایپ انسٹال ہونا ضروری نہیں — بس اس اکاؤنٹ سے لاگ ان کریں جسے آپ حذف کرنا چاہتے ہیں۔",
      "del.deleted.title": "حذف کیا جانے والا ڈیٹا",
      "del.deleted.identity": "آپ کا نام، خاندانی نام، ای میل ایڈریس اور فون نمبر",
      "del.deleted.credentials": "آپ کا پاس ورڈ اور سیشن کا ڈیٹا",
      "del.deleted.codes": "آپ کے ای میل تصدیقی اور پاس ورڈ ری سیٹ کوڈز",
      "del.deleted.esim": "آپ کا eSIM نمبر (MSISDN)، QR/ایکٹیویشن کوڈ اور استعمال کا ڈیٹا",
      "del.kept.title": "ہم کون سا ڈیٹا رکھتے ہیں اور کیوں",
      "del.kept.orders": "ٹیکس اور اکاؤنٹنگ کی ذمہ داریاں پوری کرنے کے لیے خریداری کے ریکارڈ (آرڈر نمبر، تاریخ، رقم، ادائیگی کا اسٹیٹس) محفوظ رکھے جاتے ہیں۔ ان میں کوئی نام، ای میل ایڈریس یا ادائیگی کی تفصیلات شامل نہیں — صرف ایک شناخت کنندہ ہوتا ہے جسے آپ سے منسلک نہیں کیا جا سکتا۔",
      "del.kept.period": "محفوظ رکھنے کی مدت: 5 سال (ترکی کا ٹیکس طریقۂ کار قانون، دفعہ 253)۔",
      "del.warn.title": "حذف کرنے سے پہلے",
      "del.warn.irreversible": "یہ عمل واپس نہیں ہو سکتا۔",
      "del.warn.esim": "فعال eSIM آپ کی ڈیوائس پر کام کرتے رہیں گے، لیکن آپ اپنے QR کوڈ یا باقی ڈیٹا تک رسائی حاصل نہیں کر سکیں گے۔ حذف کرنے سے پہلے اپنا QR کوڈ محفوظ کر لیں۔",
      "del.warn.rejoin": "آپ اسی ای میل ایڈریس سے دوبارہ سائن اپ کر سکتے ہیں، لیکن آپ کے پچھلے eSIM نئے اکاؤنٹ میں نظر نہیں آئیں گے۔",
      "del.support": "اگر آپ لاگ ان نہیں کر سکتے تو ای میل کے ذریعے بھی حذف کرنے کی درخواست کر سکتے ہیں:",
      "del.login.title": "پہلے لاگ ان کریں",
      "del.login.subtitle": "اپنا ای میل اور پاس ورڈ درج کریں تاکہ ہم تصدیق کر سکیں کہ اکاؤنٹ آپ کا ہے۔",
      "del.login.action": "لاگ ان کریں",
      "del.login.loading": "لاگ ان ہو رہا ہے...",
      "del.forgot": "پاس ورڈ بھول گئے؟",
      "del.confirm.title": "کیا آپ کو یقین ہے؟",
      "del.confirm.subtitle": "{{email}} اکاؤنٹ اور آپ کا ذاتی ڈیٹا مستقل طور پر حذف کر دیا جائے گا۔",
      "del.confirm.field": "تصدیق کے لیے اپنا ای میل ایڈریس دوبارہ درج کریں",
      "del.confirm.action": "میرا اکاؤنٹ مستقل طور پر حذف کریں",
      "del.confirm.deleting": "حذف کیا جا رہا ہے...",
      "del.confirm.cancel": "منسوخ کریں",
      "del.done.title": "آپ کا اکاؤنٹ حذف کر دیا گیا ہے",
      "del.done.body": "آپ کا ذاتی ڈیٹا مستقل طور پر حذف کر دیا گیا ہے۔",
      "del.done.retained": "آپ کا ذاتی ڈیٹا مستقل طور پر حذف کر دیا گیا ہے۔ قانونی ذمہ داریاں پوری کرنے کے لیے خریداری کے {{n}} ریکارڈ محفوظ رکھے گئے ہیں؛ انہیں آپ سے منسلک نہیں کیا جا سکتا۔",
      "del.done.home": "اسٹور پر واپس جائیں",
      "del.error.required": "براہ کرم اپنا ای میل اور پاس ورڈ درج کریں۔",
      "del.error.credentials": "ای میل یا پاس ورڈ غلط ہے۔",
      "del.error.suspended": "آپ کا اکاؤنٹ معطل کر دیا گیا ہے۔ براہ کرم سپورٹ سے رابطہ کریں۔",
      "del.error.session": "آپ کے سیشن کی میعاد ختم ہو گئی ہے۔ براہ کرم دوبارہ لاگ ان کریں۔",
      "del.error.network": "رابطہ قائم نہیں ہو سکا۔ اپنا انٹرنیٹ کنکشن چیک کر کے دوبارہ کوشش کریں۔",
      "del.error.generic": "کچھ غلط ہو گیا۔ براہ کرم دوبارہ کوشش کریں۔",
      "footer.deleteAccount": "اکاؤنٹ حذف کریں",
      "home.tabs.voice": "کالنگ eSIM",
      "detail.voice": "کالز + SMS",
      "detail.voiceNote": "اس پلان میں ڈیٹا کے ساتھ لامحدود کالز اور SMS بھی شامل ہیں — انٹرنیٹ اور کالز دونوں کے لیے ایک ہی eSIM۔",
      "detail.calls": "کالز",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "لامحدود کالز",
      "plan.unlimitedSms": "لامحدود SMS",
      "plan.minutes": "{{n}} منٹ کالز",
      "plan.sms": "{{n}} SMS",
      "hercules.subtitle": "{{n}} یورپی ممالک میں لامحدود کالز، SMS اور ڈیٹا — ایک ہی eSIM میں۔",
      "hercules.coverageTitle": "شامل ممالک ({{n}})",
      "hercules.promo.desc": "{{n}} ممالک میں لامحدود کالز اور SMS، ساتھ میں 20–100 GB ڈیٹا۔",
      "hercules.promo.cta": "پلان دیکھیں",
      "loading": "لوڈ ہو رہا ہے..."
    }
  },
  // Sırpça (Latin)
  sr: {
    translation: {
      "language.title": "Jezik",
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "Budućnost digitalne povezanosti",
      "hero.description": "Uklanjamo granice uz digitalnu povezanost nove generacije.",
      "hero.description2": "Brza, bezbedna i pristupačna eSIM rešenja širom sveta.",
      "features.countries": "150+ zemalja",
      "features.activation": "Trenutna aktivacija",
      "features.support": "Podrška 24/7",
      "countdown.title": "Naš sajt uskoro stiže!",
      "countdown.days": "Dana",
      "countdown.hours": "Sati",
      "countdown.minutes": "Minuta",
      "countdown.seconds": "Sekundi",
      "countdown.launch": "Naš sajt je pokrenut!",
      "countdown.loading": "Učitavanje...",
      "apps.title": "Naše mobilne aplikacije",
      "apps.ios.label": "Preuzmite sa",
      "apps.ios.name": "App Store",
      "apps.android.label": "PREUZMITE NA",
      "apps.android.name": "Google Play",
      "contact.title": "Kontaktirajte nas do pokretanja",
      "contact.whatsapp": "WhatsApp: +90 540 155 13 33",
      "contact.email": "E-mail: info@utkanesim.com",
      "about.hero.title": "O Utkan eSIM-u",
      "about.hero.description": "Vaš pouzdan partner da ostanete povezani gde god da idete. Verujemo da putovanje po svetu treba da bude jednostavno i pristupačno, bez muke sa fizičkim SIM karticama i skupog rominga.",
      "about.story.title": "Naša priča",
      "about.story.content": "Osnovana 2024. godine od strane tima strastvenih putnika i ljubitelja tehnologije, naša misija je da promenimo način na koji se ljudi povezuju na internet u inostranstvu. Nudimo kvalitetne i pouzdane eSIM planove za podatke za više od 190 zemalja i regiona, kako biste imali brz internet od trenutka sletanja.",
      "about.mission.title": "Naša misija",
      "about.mission.content": "Da putnicima pružimo jednostavnu, pristupačnu i trenutnu povezanost širom sveta, kako bi mogli da istražuju, rade i ostanu u kontaktu bez granica.",
      "about.vision.title": "Naša vizija",
      "about.vision.content": "Da budemo vodeća globalna platforma za rešenja digitalne povezanosti i da svet učinimo manjim i povezanijim za svakoga.",
      "about.features.title": "Zašto baš mi?",
      "about.features.instant.title": "Trenutna isporuka",
      "about.features.instant.content": "Dobijte svoj eSIM putem QR koda odmah nakon kupovine.",
      "about.features.global.title": "Globalna pokrivenost",
      "about.features.global.content": "Planovi za podatke za više od 190 zemalja i regiona.",
      "about.features.affordable.title": "Pristupačne cene",
      "about.features.affordable.content": "Uštedite do 90% na troškovima rominga.",
      "about.features.support.title": "Podrška 24/7",
      "about.features.support.content": "Naš posvećeni tim podrške je uvek tu da pomogne.",
      "about.features.secure.title": "Bezbedna veza",
      "about.features.secure.content": "Veza zaštićena najnovijim bezbednosnim protokolima.",
      "about.features.fast.title": "Brz internet",
      "about.features.fast.content": "Neometan internet na 4G/5G brzinama.",
      "about.cta.title": "Pridružite se budućnosti digitalne povezanosti",
      "about.cta.content": "Hvala vam što ste izabrali Utkan eSIM. Srećan put!",
      "about.cta.whatsapp": "Kontakt putem WhatsApp-a",
      "about.cta.email": "Pošalji e-mail",
      "contact.hero.title": "Kontaktirajte nas",
      "contact.hero.description": "Tu smo da pomognemo! Bilo da imate pitanje o našim eSIM-ovima, potrebna vam je tehnička podrška ili želite da nam pošaljete povratne informacije, rado ćemo vas saslušati.",
      "contact.info.title": "Kontakt informacije",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "Brza podrška 24/7",
      "contact.email.title": "E-mail",
      "contact.email.subtitle": "Opšti kontakt",
      "contact.support.title": "Tehnička podrška",
      "contact.support.subtitle": "Problemi sa eSIM-om",
      "contact.business.title": "Partnerstvo",
      "contact.business.subtitle": "Korporativni kontakt",
      "contact.hours.title": "Radno vreme podrške",
      "contact.hours.subtitle": "Tehnička podrška 24/7",
      "contact.hours.detail": "Ponedeljak – nedelja: 00:00 – 23:59",
      "contact.form.title": "Pošaljite nam poruku",
      "contact.form.name": "Vaše ime",
      "contact.form.name.placeholder": "Unesite ime i prezime",
      "contact.form.email": "Vaš e-mail",
      "contact.form.email.placeholder": "example@email.com",
      "contact.form.subject": "Tema",
      "contact.form.subject.placeholder": "Izaberite temu",
      "contact.form.subject.general": "Opšte informacije",
      "contact.form.subject.technical": "Tehnička podrška",
      "contact.form.subject.billing": "Pitanja o naplati",
      "contact.form.subject.partnership": "Partnerstvo",
      "contact.form.subject.feedback": "Povratne informacije",
      "contact.form.message": "Vaša poruka",
      "contact.form.message.placeholder": "Ovde napišite svoju poruku...",
      "contact.form.submit": "Pošalji poruku",
      "contact.faq.title": "Česta pitanja",
      "contact.faq.esim.title": "Kako funkcioniše eSIM?",
      "contact.faq.esim.content": "eSIM je digitalna SIM kartica koja radi u vašem telefonu bez potrebe za fizičkom SIM karticom. Aktivira se trenutno putem QR koda.",
      "contact.faq.phones.title": "Koji telefoni podržavaju eSIM?",
      "contact.faq.phones.content": "eSIM podržavaju modeli iPhone XS i noviji, Samsung Galaxy S20 i noviji i Google Pixel 3 i noviji.",
      "contact.faq.validity.title": "Koliko dugo važi moj paket podataka?",
      "contact.faq.validity.content": "Period važenja paketa je od 1 do 30 dana, u zavisnosti od izabranog plana.",
      "contact.faq.payment.title": "Kako mogu da platim?",
      "contact.faq.payment.content": "Možete bezbedno platiti platnom karticom, putem PayPal-a ili bankovnim transferom.",
      "privacy.hero.title": "Politika privatnosti",
      "privacy.hero.description": "Bezbednost vaših ličnih podataka nam je veoma važna. Ova politika objašnjava kako se vaši podaci prikupljaju, koriste i štite.",
      "privacy.overview.title": "Pregled",
      "privacy.overview.content": "Ova Politika privatnosti opisuje naša pravila i postupke u vezi sa prikupljanjem, korišćenjem i otkrivanjem vaših informacija kada koristite Uslugu i obaveštava vas o vašim pravima na privatnost i o tome kako vas zakon štiti.",
      "privacy.data.title": "Podaci koje prikupljamo",
      "privacy.data.personal.title": "Lični podaci",
      "privacy.data.personal.name": "Ime i prezime",
      "privacy.data.personal.email": "E-mail adresa",
      "privacy.data.personal.phone": "Broj telefona",
      "privacy.data.personal.payment": "Podaci o plaćanju",
      "privacy.data.usage.title": "Podaci o korišćenju",
      "privacy.data.usage.ip": "IP adresa",
      "privacy.data.usage.browser": "Tip pregledača",
      "privacy.data.usage.device": "Informacije o uređaju",
      "privacy.data.usage.stats": "Statistika korišćenja",
      "privacy.security.title": "Bezbednost podataka",
      "privacy.security.ssl.title": "SSL šifrovanje",
      "privacy.security.ssl.content": "Svi prenosi podataka zaštićeni su 256-bitnim SSL šifrovanjem.",
      "privacy.security.servers.title": "Bezbedni serveri",
      "privacy.security.servers.content": "Vaši podaci se čuvaju na bezbednim serverima sertifikovanim prema standardu ISO 27001.",
      "privacy.security.access.title": "Kontrola pristupa",
      "privacy.security.access.content": "Samo ovlašćeno osoblje može pristupiti vašim podacima.",
      "privacy.usage.title": "Korišćenje podataka",
      "privacy.usage.intro": "Prikupljene podatke koristimo u sledeće svrhe:",
      "privacy.usage.service.title": "Pružanje usluga",
      "privacy.usage.service.content": "Da bismo vam pružali naše eSIM usluge i upravljali njima",
      "privacy.usage.support.title": "Korisnička podrška",
      "privacy.usage.support.content": "Da bismo pružili tehničku podršku i korisničku uslugu",
      "privacy.usage.security.title": "Bezbednost",
      "privacy.usage.security.content": "Da bismo zaštitili vaš nalog i naše usluge",
      "privacy.usage.improvement.title": "Unapređenje",
      "privacy.usage.improvement.content": "Da bismo unapredili naše usluge i dodali nove funkcije",
      "privacy.sharing.title": "Deljenje podataka",
      "privacy.sharing.intro": "Vaše lične podatke ne delimo sa trećim licima, ali deljenje može biti neophodno u sledećim slučajevima:",
      "privacy.sharing.legal": "U slučaju zakonske obaveze",
      "privacy.sharing.providers": "Sa našim pružaocima usluga (kao što su obrađivači plaćanja)",
      "privacy.sharing.threats": "Radi sprečavanja bezbednosnih pretnji",
      "privacy.sharing.consent": "Kada date izričitu saglasnost",
      "privacy.rights.title": "Vaša prava",
      "privacy.rights.access.title": "Pravo na pristup",
      "privacy.rights.access.content": "Možete zatražiti pristup podacima koje čuvamo o vama.",
      "privacy.rights.correction.title": "Pravo na ispravku",
      "privacy.rights.correction.content": "Možemo ispraviti vaše netačne ili nepotpune podatke.",
      "privacy.rights.deletion.title": "Pravo na brisanje",
      "privacy.rights.deletion.content": "Pod određenim uslovima možemo obrisati vaše podatke.",
      "privacy.rights.objection.title": "Pravo na prigovor",
      "privacy.rights.objection.content": "Možete uložiti prigovor na naše aktivnosti obrade podataka.",
      "privacy.contact.title": "Kontakt",
      "privacy.contact.intro": "Ako imate pitanja o ovoj Politici privatnosti, možete nas kontaktirati putem sledećih kanala:",
      "nav.about": "O nama",
      "nav.contact": "Kontakt",
      "nav.privacy": "Privatnost",
      "nav.login": "Prijavi se",
      "nav.account": "Nalog",
      "nav.logout": "Odjavi se",
      "auth.brand.eyebrow": "GLOBALNA POKRIVENOST",
      "auth.brand.title": "Na mreži čim sletite, u 150+ zemalja.",
      "auth.brand.subtitle": "Bez fizičke SIM kartice, bez računa za roming. Aktivirajte svoj eSIM za nekoliko sekundi.",
      "auth.login.eyebrow": "PRIJAVA",
      "auth.login.title": "Dobro došli nazad",
      "auth.login.subtitle": "Upravljajte svojim eSIM-ovima i otkrijte nove.",
      "auth.signup.eyebrow": "NOVI NALOG",
      "auth.signup.title": "Napravite nalog",
      "auth.signup.subtitle": "Samo nekoliko koraka do vašeg prvog eSIM-a.",
      "auth.field.identifier": "E-mail ili telefon",
      "auth.field.identifier.ph": "you@email.com ili +381…",
      "auth.field.email": "E-mail",
      "auth.field.email.ph": "you@email.com",
      "auth.field.fullName": "Ime i prezime",
      "auth.field.fullName.ph": "Vaše ime i prezime",
      "auth.field.password": "Lozinka",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "Prijavi se",
      "auth.action.loggingIn": "Prijavljivanje…",
      "auth.action.signup": "Napravi nalog",
      "auth.action.signingUp": "Pravljenje naloga…",
      "auth.toSignup.q": "Nemate nalog?",
      "auth.toSignup.link": "Registruj se",
      "auth.toLogin.q": "Već imate nalog?",
      "auth.toLogin.link": "Prijavi se",
      "auth.password.show": "Prikaži lozinku",
      "auth.password.hide": "Sakrij lozinku",
      "auth.terms.prefix": "Nastavkom prihvatam ",
      "auth.terms.link": "Uslove korišćenja i Politiku privatnosti",
      "auth.terms.suffix": ".",
      "auth.error.required": "Molimo popunite obavezna polja.",
      "auth.error.terms": "Molimo prihvatite uslove da biste nastavili.",
      "verify.eyebrow": "VERIFIKACIJA E-MAILA",
      "verify.title": "Potvrdite svoj e-mail",
      "verify.subtitle": "Poslali smo šestocifreni kod na {{email}}. Unesite ga radi potvrde.",
      "verify.code": "Verifikacioni kod",
      "verify.code.ph": "••••••",
      "verify.action": "Potvrdi",
      "verify.verifying": "Potvrđivanje…",
      "verify.resend": "Pošalji kod ponovo",
      "verify.resendIn": "Ponovno slanje za {{seconds}}s",
      "verify.resent": "Poslat je novi kod.",
      "verify.skip": "Preskoči za sada",
      "auth.forgot.link": "Zaboravili ste lozinku?",
      "forgot.eyebrow": "RESETOVANJE LOZINKE",
      "forgot.email.title": "Resetujte lozinku",
      "forgot.email.subtitle": "Unesite e-mail adresu svog naloga i poslaćemo vam šestocifreni kod za resetovanje.",
      "forgot.email.action": "Pošalji kod",
      "forgot.email.sending": "Slanje…",
      "forgot.reset.title": "Postavite novu lozinku",
      "forgot.reset.subtitle": "Unesite šestocifreni kod koji smo poslali na {{email}} i novu lozinku.",
      "forgot.reset.action": "Ažuriraj lozinku",
      "forgot.reset.updating": "Ažuriranje…",
      "forgot.field.code": "Kod za resetovanje",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "Nova lozinka",
      "forgot.field.newPassword.ph": "Najmanje 6 karaktera",
      "forgot.resend": "Pošalji kod ponovo",
      "forgot.resendIn": "Ponovno slanje za {{seconds}}s",
      "forgot.resent": "Poslat je novi kod.",
      "forgot.backToLogin": "Nazad na prijavu",
      "forgot.changeEmail": "Promeni e-mail",
      "forgot.help.noMail": "Ako kod nije stigao, proverite folder za neželjenu poštu ili potvrdite svoju e-mail adresu.",
      "reset.RESET_CODE_SENT": "Kod je poslat. Molimo proverite svoj e-mail.",
      "reset.RATE_LIMITED": "Previše zahteva. Molimo sačekajte neko vreme i pokušajte ponovo.",
      "reset.MAIL_SEND_FAILED": "Došlo je do greške. Molimo pokušajte ponovo kasnije.",
      "reset.RESET_CODE_VALID": "Kod je potvrđen.",
      "reset.INVALID_RESET_CODE": "Neispravan kod. Molimo pokušajte ponovo.",
      "reset.EXPIRED_RESET_CODE": "Kod je istekao. Molimo zatražite novi kod.",
      "reset.WEAK_PASSWORD": "Lozinka mora imati najmanje 6 karaktera.",
      "reset.PASSWORD_RESET_SUCCESS": "Vaša lozinka je ažurirana. Molimo prijavite se sa novom lozinkom.",
      "reset.generic": "Došlo je do greške. Molimo pokušajte ponovo.",
      "login.resetSuccess": "Vaša lozinka je ažurirana. Molimo prijavite se sa novom lozinkom.",
      "store.nav.shop": "Prodavnica",
      "home.hero.title1": "Povežite se za nekoliko minuta,",
      "home.hero.title2": "ostanite na mreži preko granica.",
      "home.hero.subtitle": "Pouzdani eSIM planovi koji važe u 190+ zemalja. Bez fizičke SIM kartice, bez računa za roming.",
      "home.search.placeholder": "Gde putujete?",
      "home.tabs.local": "Lokalni eSIM-ovi",
      "home.tabs.regional": "Regionalni eSIM-ovi",
      "home.tabs.lifetime": "Doživotni eSIM-ovi",
      "home.empty": "Nema rezultata za vašu pretragu.",
      "home.error.title": "Sadržaj nije mogao da se učita",
      "home.error.retry": "Pokušaj ponovo",
      "home.from": "od",
      "home.popular": "Popularne destinacije",
      "home.coverage": "190+ zemalja · trenutna aktivacija",
      "home.detail.soon": "Planovi za ovaj izbor uskoro će biti navedeni ovde.",
      "home.detail.back": "Nazad u prodavnicu",
      "detail.plans": "Planovi",
      "detail.count": "Broj planova: {{count}}",
      "detail.validity": "{{days}} dana",
      "detail.validityLifetime": "Bez isteka",
      "detail.buy": "Kupi",
      "detail.empty": "Trenutno nema dostupnih planova za ovaj izbor.",
      "detail.checkoutSoon": "Plaćanje će uskoro biti dostupno.",
      "detail.loginToBuy": "Molimo prijavite se da biste kupili.",
      "detail.basicFeatures": "Osnovne karakteristike",
      "detail.dataAmount": "Količina podataka",
      "detail.validityLabel": "Važenje",
      "detail.coverageArea": "Pokrivenost",
      "detail.activationNetworks": "Aktivacija i mreže",
      "detail.activationMethod": "Način aktivacije",
      "detail.esimActivation": "eSIM — trenutno putem QR koda",
      "detail.supportedNetworks": "Podržane mreže",
      "detail.description": "Opis",
      "detail.price": "Cena",
      "authprompt.title": "Prijavite se da biste nastavili",
      "authprompt.message": "Prijavite se na svoj nalog da biste kupili eSIM ili napravite nalog za nekoliko sekundi.",
      "authprompt.close": "Zatvori",
      "footer.tagline": "Brz, bezbedan i pristupačan eSIM širom sveta. Budite na mreži čim sletite.",
      "footer.explore": "Istražite",
      "footer.support": "Podrška",
      "footer.legal": "Pravne informacije",
      "footer.shop": "Prodavnica",
      "footer.help": "Česta pitanja",
      "footer.terms": "Uslovi korišćenja",
      "footer.rights": "© {{year}} Utkan eSIM. Sva prava zadržana.",
      "footer.apps": "Preuzmite aplikaciju",
      "whatsapp.label": "Ćaskajte na WhatsApp-u",
      "whatsapp.message": "Zdravo, imam zahtev za podršku za eSIM.",
      "notfound.eyebrow": "NEMA SIGNALA",
      "notfound.title": "Ova stranica je van dometa",
      "notfound.message": "Stranica koju tražite je premeštena ili nikada nije postojala. Vratimo vas u zonu pokrivenosti.",
      "order.congrats": "Čestitamo!",
      "order.message": "Vaš eSIM je spreman. Podesite ga u nekoliko koraka pomoću QR koda ispod.",
      "order.details": "Pregled porudžbine",
      "order.activation": "Aktivacija",
      "order.activationDesc": "Da biste podesili svoj eSIM, skenirajte QR kod kamerom uređaja ili ručno unesite aktivacioni kod.",
      "order.qrTitle": "eSIM QR kod",
      "order.manualLabel": "Aktivacioni kod",
      "order.copy": "Kopiraj",
      "order.copied": "Kopirano",
      "order.howTo": "Kako aktivirati",
      "order.step1": "Na uređaju idite na Podešavanja > Mobilna mreža / Mobilni podaci > Dodaj eSIM.",
      "order.step2": "Izaberite „Koristi QR kod“ i skenirajte QR kod iznad (ili ručno unesite aktivacioni kod).",
      "order.step3": "Kada se podešavanje završi, uključite eSIM plan.",
      "order.step4": "Proverite da li je roming podataka uključen — povezani ste!",
      "order.cta": "Nazad na početnu",
      "checkout.title": "Plaćanje",
      "checkout.summary": "Pregled porudžbine",
      "checkout.total": "Ukupno",
      "checkout.eurNote": "Iznos će biti naplaćen u evrima (€) putem PayPal-a.",
      "checkout.processing": "Proveravamo vašu uplatu…",
      "checkout.error": "Plaćanje nije moglo da se završi. Molimo pokušajte ponovo.",
      "checkout.cancelled": "Plaćanje je otkazano.",
      "account.title": "Moj nalog",
      "account.tab.profile": "Profil",
      "account.tab.esims": "Moji eSIM-ovi",
      "account.tab.security": "Bezbednost",
      "account.profile.title": "Podaci profila",
      "account.field.phone": "Telefon",
      "account.field.phone.ph": "+381…",
      "account.memberSince": "Član od",
      "account.save": "Sačuvaj",
      "account.saving": "Čuvanje…",
      "account.saved": "Vaši podaci su ažurirani.",
      "account.esims.title": "Moji eSIM-ovi",
      "account.esims.empty": "Još uvek nemate nijedan eSIM.",
      "account.esims.emptyCta": "Pregledajte prodavnicu",
      "account.esims.data": "Podaci",
      "account.esims.expires": "Ističe",
      "account.esims.viewQr": "Prikaži QR kod",
      "account.esims.hideQr": "Sakrij QR kod",
      "account.esims.active": "Aktivni",
      "account.esims.passive": "Neaktivni",
      "account.esims.noActive": "Nemate aktivnih eSIM-ova.",
      "account.esims.noPassive": "Nemate neaktivnih eSIM-ova.",
      "account.esims.readyHint": "Spreman za korišćenje — period važenja počinje od prve upotrebe.",
      "account.esims.unavailableHint": "Status trenutno nije dostupan. Molimo pokušajte ponovo kasnije.",
      "esimStatus.active": "Aktivan",
      "esimStatus.readyToUse": "Spreman za korišćenje",
      "esimStatus.inactive": "Neaktivan",
      "esimStatus.unavailable": "Status nije dostupan",
      "account.security.title": "Promena lozinke",
      "account.field.oldPassword": "Trenutna lozinka",
      "account.field.newPassword": "Nova lozinka",
      "account.field.confirmPassword": "Nova lozinka (ponovo)",
      "account.changePassword": "Ažuriraj lozinku",
      "account.passwordChanged": "Vaša lozinka je ažurirana.",
      "account.error.passwordMismatch": "Nove lozinke se ne podudaraju.",
      "account.danger.title": "Radnje sa nalogom",
      "account.delete": "Obriši nalog",
      "account.delete.confirm": "Upravo ćete trajno obrisati svoj nalog. Ovo se ne može poništiti.",
      "account.delete.confirmBtn": "Da, obriši",
      "account.cancel": "Otkaži",
      "esimDetail.back": "Nazad",
      "esimDetail.dataUsage": "Potrošnja podataka",
      "esimDetail.left": "preostalo",
      "esimDetail.leftData": "Preostalo podataka",
      "esimDetail.usedData": "Potrošeno",
      "esimDetail.totalData": "Ukupno podataka",
      "esimDetail.qrDesc": "Skenirajte ovaj QR kod kamerom uređaja da biste podesili svoj eSIM.",
      "esimDetail.validity": "Period važenja",
      "esimDetail.daysLeft": "Preostalo dana: {{days}}",
      "esimDetail.expired": "Istekao",
      "esimDetail.notYetActive": "Još uvek nije aktivan",
      "esimDetail.leftDate": "Preostalo vreme",
      "esimDetail.activationDate": "Datum aktivacije",
      "esimDetail.endDate": "Datum isteka",
      "esimDetail.technical": "Tehnički detalji",
      "esimDetail.activationCode": "Aktivacioni kod (Android)",
      "esimDetail.smdp": "SM-DP+ adresa (iOS)",
      "esimDetail.matchingId": "Identifikator podudaranja (iOS)",
      "esimDetail.support": "Tehnička podrška",
      "esimDetail.supportDesc": "Nešto nije u redu? Tu smo da pomognemo.",
      "esimDetail.email": "Pošalji e-mail",
      "guide.eyebrow": "eSIM VODIČ",
      "guide.title": "Šta je eSIM i kako ga podesiti?",
      "guide.intro.title": "Šta je eSIM?",
      "guide.intro.body": "eSIM je digitalna SIM kartica ugrađena u vaš uređaj — fizička kartica nije potrebna. Skenirajte QR kod i vaša linija je podešena za nekoliko sekundi, pa možete biti na mreži u 190+ zemalja bez menjanja kartica i bez računa za roming.",
      "guide.steps.title": "Kako aktivirati",
      "guide.devices.title": "Podržani uređaji",
      "guide.devices.desc": "Da bi eSIM radio, vaš uređaj mora da ga podržava. Pronađite svoj brend ispod.",
      "guide.faq.title": "Česta pitanja",
      "nav.guide": "eSIM vodič",
      "currency.label": "Valuta",
      "staticPage.loading": "Učitavanje stranice...",
      "staticPage.errorTitle": "Došlo je do greške",
      "staticPage.retry": "Pokušaj ponovo",
      "staticPage.loadFailed": "Sadržaj stranice nije mogao da se učita. Molimo pokušajte ponovo kasnije.",
      "last.updated": "Poslednje ažuriranje: 8. jul 2024.",
      "home.tabs.unlimited": "Neograničeni eSIM-ovi",
      "detail.unlimited": "Neograničeno",
      "detail.unlimitedNote": "Ovaj paket nema ograničenje podataka — uživajte u neograničenom internetu tokom celog perioda važenja.",
      "detail.notPriced": "Ovaj paket trenutno nije dostupan za kupovinu na vebu.",
      "checkout.priceUpdated": "Cena ovog paketa je promenjena. Molimo vratite se u prodavnicu i ponovo ga izaberite.",
      "order.pending.title": "Vaš eSIM se priprema",
      "order.pending.message": "Vaša uplata je uspešna. Aktivacija neograničenih paketa može trajati nekoliko minuta.",
      "order.pending.waiting": "Proveravamo status porudžbine…",
      "order.pending.ready": "Vaš eSIM je spreman!",
      "order.pending.timeout": "Ovo traje duže nego što je očekivano. Vaša uplata je bezbedna — vaš eSIM će se pojaviti u odeljku „Moji eSIM-ovi“ čim bude spreman.",
      "order.pending.cta": "Idi na moje eSIM-ove",
      "account.esims.unlimited": "Neograničeno",
      "account.esims.unlimitedHint": "Neograničeni podaci — ovaj paket nema ograničenje podataka.",
      "esimDetail.unlimitedData": "Ovaj paket nema ograničenje podataka; preostalo vreme pogledajte ispod.",
      "del.eyebrow": "Brisanje naloga",
      "del.title": "Obriši moj nalog",
      "del.intro": "Ovde možete trajno obrisati svoj Utkan eSIM nalog i lične podatke. Nije vam potrebna instalirana aplikacija — samo se prijavite sa nalogom koji želite da obrišete.",
      "del.deleted.title": "Podaci koji se brišu",
      "del.deleted.identity": "Vaše ime, prezime, e-mail adresa i broj telefona",
      "del.deleted.credentials": "Vaša lozinka i podaci o sesijama",
      "del.deleted.codes": "Vaši kodovi za verifikaciju e-maila i resetovanje lozinke",
      "del.deleted.esim": "Vaš eSIM broj (MSISDN), QR/aktivacioni kod i podaci o potrošnji",
      "del.kept.title": "Podaci koje čuvamo i zašto",
      "del.kept.orders": "Evidencija kupovina (broj porudžbine, datum, iznos, status plaćanja) čuva se radi ispunjavanja poreskih i računovodstvenih obaveza. Ne sadrži ime, e-mail adresu niti podatke o plaćanju — samo identifikator koji se ne može povezati sa vama.",
      "del.kept.period": "Period čuvanja: 5 godina (turski Zakon o poreskom postupku, čl. 253).",
      "del.warn.title": "Pre brisanja",
      "del.warn.irreversible": "Ova radnja se ne može poništiti.",
      "del.warn.esim": "Aktivni eSIM-ovi nastavljaju da rade na vašem uređaju, ali više nećete moći da pristupite QR kodu ni preostalim podacima. Sačuvajte QR kod pre brisanja.",
      "del.warn.rejoin": "Možete se ponovo registrovati sa istom e-mail adresom, ali vaši prethodni eSIM-ovi se neće pojaviti u novom nalogu.",
      "del.support": "Ako ne možete da se prijavite, brisanje možete zatražiti i putem e-maila:",
      "del.login.title": "Prvo se prijavite",
      "del.login.subtitle": "Unesite e-mail i lozinku kako bismo potvrdili da je nalog vaš.",
      "del.login.action": "Prijavi se",
      "del.login.loading": "Prijavljivanje...",
      "del.forgot": "Zaboravili ste lozinku?",
      "del.confirm.title": "Da li ste sigurni?",
      "del.confirm.subtitle": "Nalog {{email}} i vaši lični podaci biće trajno obrisani.",
      "del.confirm.field": "Radi potvrde ponovo unesite svoju e-mail adresu",
      "del.confirm.action": "Trajno obriši moj nalog",
      "del.confirm.deleting": "Brisanje...",
      "del.confirm.cancel": "Otkaži",
      "del.done.title": "Vaš nalog je obrisan",
      "del.done.body": "Vaši lični podaci su trajno obrisani.",
      "del.done.retained": "Vaši lični podaci su trajno obrisani. Radi ispunjavanja zakonskih obaveza sačuvano je zapisa o kupovini: {{n}}; oni se ne mogu povezati sa vama.",
      "del.done.home": "Nazad u prodavnicu",
      "del.error.required": "Molimo unesite e-mail i lozinku.",
      "del.error.credentials": "Pogrešan e-mail ili lozinka.",
      "del.error.suspended": "Vaš nalog je suspendovan. Molimo kontaktirajte podršku.",
      "del.error.session": "Vaša sesija je istekla. Molimo prijavite se ponovo.",
      "del.error.network": "Povezivanje nije uspelo. Proverite internet vezu i pokušajte ponovo.",
      "del.error.generic": "Došlo je do greške. Molimo pokušajte ponovo.",
      "footer.deleteAccount": "Obriši nalog",
      "home.tabs.voice": "eSIM-ovi sa pozivima",
      "detail.voice": "Pozivi + SMS",
      "detail.voiceNote": "Pored podataka, ovaj plan uključuje neograničene pozive i SMS poruke — jedan eSIM i za internet i za pozive.",
      "detail.calls": "Pozivi",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "Neograničeni pozivi",
      "plan.unlimitedSms": "Neograničeni SMS",
      "plan.minutes": "{{n}} min poziva",
      "plan.sms": "{{n}} SMS",
      "hercules.subtitle": "Neograničeni pozivi, SMS i podaci u {{n}} evropskih zemalja — jedan eSIM.",
      "hercules.coverageTitle": "Obuhvaćene zemlje ({{n}})",
      "hercules.promo.desc": "Neograničeni pozivi i SMS u {{n}} zemalja, uz 20–100 GB podataka.",
      "hercules.promo.cta": "Pogledaj plan",
      "loading": "Učitavanje..."
    }
  },
  // Endonezce
  id: {
    translation: {
      "language.title": "Bahasa",
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "Masa Depan Konektivitas Digital",
      "hero.description": "Kami menghapus batas dengan pengalaman konektivitas digital generasi baru.",
      "hero.description2": "Solusi eSIM yang cepat, aman, dan terjangkau di seluruh dunia.",
      "features.countries": "150+ Negara",
      "features.activation": "Aktivasi Instan",
      "features.support": "Dukungan 24/7",
      "countdown.title": "Situs Web Kami Segera Hadir!",
      "countdown.days": "Hari",
      "countdown.hours": "Jam",
      "countdown.minutes": "Menit",
      "countdown.seconds": "Detik",
      "countdown.launch": "Situs Web Kami Telah Hadir!",
      "countdown.loading": "Memuat...",
      "apps.title": "Aplikasi Seluler Kami",
      "apps.ios.label": "Unduh di",
      "apps.ios.name": "App Store",
      "apps.android.label": "TERSEDIA DI",
      "apps.android.name": "Google Play",
      "contact.title": "Hubungi Kami Hingga Peluncuran",
      "contact.whatsapp": "WhatsApp: +90 540 155 13 33",
      "contact.email": "Email: info@utkanesim.com",
      "about.hero.title": "Tentang Utkan eSIM",
      "about.hero.description": "Mitra tepercaya Anda untuk tetap terhubung ke mana pun Anda pergi. Kami percaya bahwa perjalanan global harus mulus dan terjangkau, tanpa repot dengan kartu SIM fisik dan biaya roaming yang mahal.",
      "about.story.title": "Kisah Kami",
      "about.story.content": "Didirikan pada tahun 2024 oleh tim pelancong dan penggemar teknologi yang bersemangat, tujuan kami adalah merevolusi cara orang terhubung ke internet di luar negeri. Kami menyediakan paket data eSIM berkualitas tinggi dan andal untuk lebih dari 190 negara dan wilayah, sehingga Anda mendapatkan akses internet cepat sejak saat mendarat.",
      "about.mission.title": "Misi Kami",
      "about.mission.content": "Memberikan konektivitas yang sederhana, terjangkau, dan instan bagi para pelancong di seluruh dunia, sehingga mereka dapat menjelajah, bekerja, dan tetap terhubung tanpa batas.",
      "about.vision.title": "Visi Kami",
      "about.vision.content": "Menjadi platform global terdepan untuk solusi konektivitas digital, menjadikan dunia lebih dekat dan lebih terhubung bagi semua orang.",
      "about.features.title": "Mengapa Memilih Kami?",
      "about.features.instant.title": "Pengiriman Instan",
      "about.features.instant.content": "Terima eSIM Anda melalui kode QR segera setelah pembelian.",
      "about.features.global.title": "Jangkauan Global",
      "about.features.global.content": "Paket data untuk lebih dari 190 negara dan wilayah.",
      "about.features.affordable.title": "Harga Terjangkau",
      "about.features.affordable.content": "Hemat hingga 90% biaya roaming.",
      "about.features.support.title": "Dukungan 24/7",
      "about.features.support.content": "Tim dukungan kami yang berdedikasi selalu siap membantu.",
      "about.features.secure.title": "Koneksi Aman",
      "about.features.secure.content": "Koneksi dilindungi dengan protokol keamanan terbaru.",
      "about.features.fast.title": "Internet Cepat",
      "about.features.fast.content": "Pengalaman internet yang mulus dengan kecepatan 4G/5G.",
      "about.cta.title": "Bergabunglah dengan Masa Depan Konektivitas Digital",
      "about.cta.content": "Terima kasih telah memilih Utkan eSIM. Selamat bepergian!",
      "about.cta.whatsapp": "Hubungi via WhatsApp",
      "about.cta.email": "Kirim Email",
      "contact.hero.title": "Hubungi Kami",
      "contact.hero.description": "Kami siap membantu! Baik Anda memiliki pertanyaan tentang eSIM kami, membutuhkan dukungan teknis, atau hanya ingin memberikan masukan, kami senang mendengarnya dari Anda.",
      "contact.info.title": "Informasi Kontak",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "Dukungan Cepat 24/7",
      "contact.email.title": "Email",
      "contact.email.subtitle": "Kontak Umum",
      "contact.support.title": "Dukungan Teknis",
      "contact.support.subtitle": "Masalah eSIM",
      "contact.business.title": "Kemitraan",
      "contact.business.subtitle": "Kontak Korporat",
      "contact.hours.title": "Jam Dukungan",
      "contact.hours.subtitle": "Dukungan Teknis 24/7",
      "contact.hours.detail": "Senin - Minggu: 00:00 - 23:59",
      "contact.form.title": "Kirimi Kami Pesan",
      "contact.form.name": "Nama Anda",
      "contact.form.name.placeholder": "Masukkan nama lengkap Anda",
      "contact.form.email": "Email Anda",
      "contact.form.email.placeholder": "example@email.com",
      "contact.form.subject": "Subjek",
      "contact.form.subject.placeholder": "Pilih subjek",
      "contact.form.subject.general": "Informasi Umum",
      "contact.form.subject.technical": "Dukungan Teknis",
      "contact.form.subject.billing": "Pertanyaan Tagihan",
      "contact.form.subject.partnership": "Kemitraan",
      "contact.form.subject.feedback": "Masukan",
      "contact.form.message": "Pesan Anda",
      "contact.form.message.placeholder": "Tulis pesan Anda di sini...",
      "contact.form.submit": "Kirim Pesan",
      "contact.faq.title": "Pertanyaan yang Sering Diajukan",
      "contact.faq.esim.title": "Bagaimana cara kerja eSIM?",
      "contact.faq.esim.content": "eSIM adalah kartu SIM digital yang berfungsi di ponsel Anda tanpa memerlukan kartu SIM fisik. eSIM diaktifkan secara instan melalui kode QR.",
      "contact.faq.phones.title": "Ponsel mana saja yang mendukung eSIM?",
      "contact.faq.phones.content": "Model iPhone XS ke atas, Samsung Galaxy S20 ke atas, dan Google Pixel 3 ke atas mendukung eSIM.",
      "contact.faq.validity.title": "Berapa lama paket data saya berlaku?",
      "contact.faq.validity.content": "Masa berlaku paket bervariasi antara 1-30 hari, tergantung pada paket yang Anda pilih.",
      "contact.faq.payment.title": "Bagaimana cara membayar?",
      "contact.faq.payment.content": "Anda dapat melakukan pembayaran yang aman dengan kartu kredit, PayPal, dan transfer bank.",
      "privacy.hero.title": "Kebijakan Privasi",
      "privacy.hero.description": "Keamanan data pribadi Anda sangat penting bagi kami. Kebijakan ini menjelaskan bagaimana data Anda dikumpulkan, digunakan, dan dilindungi.",
      "privacy.overview.title": "Ikhtisar",
      "privacy.overview.content": "Kebijakan Privasi ini menjelaskan kebijakan dan prosedur Kami terkait pengumpulan, penggunaan, dan pengungkapan informasi Anda saat Anda menggunakan Layanan, serta memberi tahu Anda tentang hak privasi Anda dan bagaimana hukum melindungi Anda.",
      "privacy.data.title": "Data yang Kami Kumpulkan",
      "privacy.data.personal.title": "Informasi Pribadi",
      "privacy.data.personal.name": "Nama lengkap",
      "privacy.data.personal.email": "Alamat email",
      "privacy.data.personal.phone": "Nomor telepon",
      "privacy.data.personal.payment": "Informasi pembayaran",
      "privacy.data.usage.title": "Data Penggunaan",
      "privacy.data.usage.ip": "Alamat IP",
      "privacy.data.usage.browser": "Jenis browser",
      "privacy.data.usage.device": "Informasi perangkat",
      "privacy.data.usage.stats": "Statistik penggunaan",
      "privacy.security.title": "Keamanan Data",
      "privacy.security.ssl.title": "Enkripsi SSL",
      "privacy.security.ssl.content": "Semua transfer data dilindungi dengan enkripsi SSL 256-bit.",
      "privacy.security.servers.title": "Server Aman",
      "privacy.security.servers.content": "Data Anda disimpan di server aman bersertifikat ISO 27001.",
      "privacy.security.access.title": "Kontrol Akses",
      "privacy.security.access.content": "Hanya personel berwenang yang dapat mengakses data Anda.",
      "privacy.usage.title": "Penggunaan Data",
      "privacy.usage.intro": "Kami menggunakan data yang kami kumpulkan untuk tujuan berikut:",
      "privacy.usage.service.title": "Penyediaan Layanan",
      "privacy.usage.service.content": "Untuk menyediakan dan mengelola layanan eSIM kami bagi Anda",
      "privacy.usage.support.title": "Dukungan Pelanggan",
      "privacy.usage.support.content": "Untuk memberikan dukungan teknis dan layanan pelanggan",
      "privacy.usage.security.title": "Keamanan",
      "privacy.usage.security.content": "Untuk melindungi akun Anda dan layanan kami",
      "privacy.usage.improvement.title": "Peningkatan",
      "privacy.usage.improvement.content": "Untuk meningkatkan layanan kami dan menambahkan fitur baru",
      "privacy.sharing.title": "Berbagi Data",
      "privacy.sharing.intro": "Kami tidak membagikan data pribadi Anda kepada pihak ketiga, tetapi pembagian mungkin diperlukan dalam kasus berikut:",
      "privacy.sharing.legal": "Jika ada kewajiban hukum",
      "privacy.sharing.providers": "Dengan penyedia layanan kami (seperti pemroses pembayaran)",
      "privacy.sharing.threats": "Untuk mencegah ancaman keamanan",
      "privacy.sharing.consent": "Jika Anda memberikan persetujuan secara eksplisit",
      "privacy.rights.title": "Hak Anda",
      "privacy.rights.access.title": "Hak Akses",
      "privacy.rights.access.content": "Anda dapat meminta akses ke data yang kami simpan tentang Anda.",
      "privacy.rights.correction.title": "Hak Koreksi",
      "privacy.rights.correction.content": "Kami dapat mengoreksi data Anda yang salah atau tidak lengkap.",
      "privacy.rights.deletion.title": "Hak Penghapusan",
      "privacy.rights.deletion.content": "Kami dapat menghapus data Anda dalam kondisi tertentu.",
      "privacy.rights.objection.title": "Hak Keberatan",
      "privacy.rights.objection.content": "Anda dapat mengajukan keberatan atas aktivitas pemrosesan data kami.",
      "privacy.contact.title": "Kontak",
      "privacy.contact.intro": "Jika Anda memiliki pertanyaan tentang Kebijakan Privasi ini, Anda dapat menghubungi kami melalui saluran berikut:",
      "nav.about": "Tentang",
      "nav.contact": "Kontak",
      "nav.privacy": "Privasi",
      "nav.login": "Masuk",
      "nav.account": "Akun",
      "nav.logout": "Keluar",
      "auth.brand.eyebrow": "JANGKAUAN GLOBAL",
      "auth.brand.title": "Langsung online saat mendarat, di lebih dari 150 negara.",
      "auth.brand.subtitle": "Tanpa SIM fisik, tanpa tagihan roaming. Aktifkan eSIM Anda dalam hitungan detik.",
      "auth.login.eyebrow": "MASUK",
      "auth.login.title": "Selamat datang kembali",
      "auth.login.subtitle": "Kelola eSIM Anda dan temukan yang baru.",
      "auth.signup.eyebrow": "AKUN BARU",
      "auth.signup.title": "Buat akun Anda",
      "auth.signup.subtitle": "Beberapa langkah menuju eSIM pertama Anda.",
      "auth.field.identifier": "Email atau telepon",
      "auth.field.identifier.ph": "anda@email.com atau +62…",
      "auth.field.email": "Email",
      "auth.field.email.ph": "anda@email.com",
      "auth.field.fullName": "Nama lengkap",
      "auth.field.fullName.ph": "Nama lengkap Anda",
      "auth.field.password": "Kata Sandi",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "Masuk",
      "auth.action.loggingIn": "Sedang masuk…",
      "auth.action.signup": "Buat akun",
      "auth.action.signingUp": "Membuat akun…",
      "auth.toSignup.q": "Belum punya akun?",
      "auth.toSignup.link": "Daftar",
      "auth.toLogin.q": "Sudah punya akun?",
      "auth.toLogin.link": "Masuk",
      "auth.password.show": "Tampilkan kata sandi",
      "auth.password.hide": "Sembunyikan kata sandi",
      "auth.terms.prefix": "Dengan melanjutkan, saya menyetujui ",
      "auth.terms.link": "Ketentuan Penggunaan dan Kebijakan Privasi",
      "auth.terms.suffix": ".",
      "auth.error.required": "Harap isi kolom yang wajib diisi.",
      "auth.error.terms": "Harap setujui ketentuan untuk melanjutkan.",
      "verify.eyebrow": "VERIFIKASI EMAIL",
      "verify.title": "Verifikasi email Anda",
      "verify.subtitle": "Kami telah mengirimkan kode 6 digit ke {{email}}. Masukkan kode tersebut untuk verifikasi.",
      "verify.code": "Kode verifikasi",
      "verify.code.ph": "••••••",
      "verify.action": "Verifikasi",
      "verify.verifying": "Memverifikasi…",
      "verify.resend": "Kirim ulang kode",
      "verify.resendIn": "Kirim ulang dalam {{seconds}} dtk",
      "verify.resent": "Kode baru telah dikirim.",
      "verify.skip": "Lewati untuk saat ini",
      "auth.forgot.link": "Lupa kata sandi?",
      "forgot.eyebrow": "ATUR ULANG KATA SANDI",
      "forgot.email.title": "Atur ulang kata sandi Anda",
      "forgot.email.subtitle": "Masukkan email akun Anda dan kami akan mengirimkan kode pengaturan ulang 6 digit.",
      "forgot.email.action": "Kirim kode",
      "forgot.email.sending": "Mengirim…",
      "forgot.reset.title": "Buat kata sandi baru",
      "forgot.reset.subtitle": "Masukkan kode 6 digit yang kami kirim ke {{email}} dan kata sandi baru Anda.",
      "forgot.reset.action": "Perbarui kata sandi",
      "forgot.reset.updating": "Memperbarui…",
      "forgot.field.code": "Kode pengaturan ulang",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "Kata sandi baru",
      "forgot.field.newPassword.ph": "Minimal 6 karakter",
      "forgot.resend": "Kirim ulang kode",
      "forgot.resendIn": "Kirim ulang dalam {{seconds}} dtk",
      "forgot.resent": "Kode baru telah dikirim.",
      "forgot.backToLogin": "Kembali ke halaman masuk",
      "forgot.changeEmail": "Ubah email",
      "forgot.help.noMail": "Jika kode tidak diterima, periksa folder spam Anda atau pastikan alamat email Anda benar.",
      "reset.RESET_CODE_SENT": "Kode telah dikirim. Silakan periksa email Anda.",
      "reset.RATE_LIMITED": "Terlalu banyak permintaan. Harap tunggu sebentar dan coba lagi.",
      "reset.MAIL_SEND_FAILED": "Terjadi kesalahan. Silakan coba lagi nanti.",
      "reset.RESET_CODE_VALID": "Kode terverifikasi.",
      "reset.INVALID_RESET_CODE": "Kode tidak valid. Silakan coba lagi.",
      "reset.EXPIRED_RESET_CODE": "Kode telah kedaluwarsa. Silakan minta kode baru.",
      "reset.WEAK_PASSWORD": "Kata sandi minimal harus 6 karakter.",
      "reset.PASSWORD_RESET_SUCCESS": "Kata sandi Anda telah diperbarui. Silakan masuk dengan kata sandi baru Anda.",
      "reset.generic": "Terjadi kesalahan. Silakan coba lagi.",
      "login.resetSuccess": "Kata sandi Anda telah diperbarui. Silakan masuk dengan kata sandi baru Anda.",
      "store.nav.shop": "Toko",
      "home.hero.title1": "Terhubung dalam hitungan menit,",
      "home.hero.title2": "tetap online lintas negara.",
      "home.hero.subtitle": "Paket eSIM andal yang berlaku di 190+ negara. Tanpa SIM fisik, tanpa tagihan roaming.",
      "home.search.placeholder": "Ke mana Anda akan bepergian?",
      "home.tabs.local": "eSIM Lokal",
      "home.tabs.regional": "eSIM Regional",
      "home.tabs.lifetime": "eSIM Seumur Hidup",
      "home.empty": "Tidak ada hasil yang cocok dengan pencarian Anda.",
      "home.error.title": "Konten tidak dapat dimuat",
      "home.error.retry": "Coba lagi",
      "home.from": "mulai dari",
      "home.popular": "Destinasi populer",
      "home.coverage": "190+ negara · aktivasi instan",
      "home.detail.soon": "Paket untuk pilihan ini akan segera tersedia di sini.",
      "home.detail.back": "Kembali ke toko",
      "detail.plans": "Paket",
      "detail.count": "{{count}} paket",
      "detail.validity": "{{days}} hari",
      "detail.validityLifetime": "Tanpa masa berlaku",
      "detail.buy": "Beli",
      "detail.empty": "Saat ini tidak ada paket yang tersedia untuk pilihan ini.",
      "detail.checkoutSoon": "Pembayaran akan segera tersedia.",
      "detail.loginToBuy": "Silakan masuk untuk membeli.",
      "detail.basicFeatures": "Fitur dasar",
      "detail.dataAmount": "Jumlah data",
      "detail.validityLabel": "Masa berlaku",
      "detail.coverageArea": "Jangkauan",
      "detail.activationNetworks": "Aktivasi & jaringan",
      "detail.activationMethod": "Metode aktivasi",
      "detail.esimActivation": "eSIM — instan melalui kode QR",
      "detail.supportedNetworks": "Jaringan yang didukung",
      "detail.description": "Deskripsi",
      "detail.price": "Harga",
      "authprompt.title": "Masuk untuk melanjutkan",
      "authprompt.message": "Masuk ke akun Anda untuk membeli eSIM, atau buat akun dalam hitungan detik.",
      "authprompt.close": "Tutup",
      "footer.tagline": "eSIM yang cepat, aman, dan terjangkau di seluruh dunia. Langsung online saat Anda mendarat.",
      "footer.explore": "Jelajahi",
      "footer.support": "Dukungan",
      "footer.legal": "Hukum",
      "footer.shop": "Toko",
      "footer.help": "Pertanyaan yang Sering Diajukan",
      "footer.terms": "Ketentuan Penggunaan",
      "footer.rights": "© {{year}} Utkan eSIM. Hak cipta dilindungi undang-undang.",
      "footer.apps": "Unduh aplikasinya",
      "whatsapp.label": "Chat di WhatsApp",
      "whatsapp.message": "Halo, saya memiliki permintaan dukungan eSIM.",
      "notfound.eyebrow": "TIDAK ADA SINYAL",
      "notfound.title": "Halaman ini tidak dapat dijangkau",
      "notfound.message": "Halaman yang Anda cari telah dipindahkan atau tidak pernah ada. Mari kembalikan Anda ke area jangkauan.",
      "order.congrats": "Selamat!",
      "order.message": "eSIM Anda sudah siap. Atur dalam beberapa langkah dengan kode QR di bawah ini.",
      "order.details": "Ringkasan pesanan",
      "order.activation": "Aktivasi",
      "order.activationDesc": "Untuk mengatur eSIM Anda, pindai kode QR dengan kamera perangkat atau masukkan kode aktivasi secara manual.",
      "order.qrTitle": "Kode QR eSIM",
      "order.manualLabel": "Kode aktivasi",
      "order.copy": "Salin",
      "order.copied": "Disalin",
      "order.howTo": "Cara mengaktifkan",
      "order.step1": "Di perangkat Anda, buka Pengaturan > Seluler / Data Seluler > Tambah eSIM.",
      "order.step2": "Pilih “Gunakan kode QR” lalu pindai kode QR di atas (atau masukkan kode aktivasi secara manual).",
      "order.step3": "Setelah pengaturan selesai, aktifkan paket eSIM.",
      "order.step4": "Pastikan roaming data aktif — Anda sudah terhubung!",
      "order.cta": "Kembali ke beranda",
      "checkout.title": "Pembayaran",
      "checkout.summary": "Ringkasan pesanan",
      "checkout.total": "Total",
      "checkout.eurNote": "Anda akan ditagih dalam euro (€) melalui PayPal.",
      "checkout.processing": "Memverifikasi pembayaran Anda…",
      "checkout.error": "Pembayaran tidak dapat diselesaikan. Silakan coba lagi.",
      "checkout.cancelled": "Pembayaran dibatalkan.",
      "account.title": "Akun saya",
      "account.tab.profile": "Profil",
      "account.tab.esims": "eSIM Saya",
      "account.tab.security": "Keamanan",
      "account.profile.title": "Informasi profil",
      "account.field.phone": "Telepon",
      "account.field.phone.ph": "+62…",
      "account.memberSince": "Anggota sejak",
      "account.save": "Simpan",
      "account.saving": "Menyimpan…",
      "account.saved": "Data Anda telah diperbarui.",
      "account.esims.title": "eSIM Saya",
      "account.esims.empty": "Anda belum memiliki eSIM.",
      "account.esims.emptyCta": "Jelajahi toko",
      "account.esims.data": "Data",
      "account.esims.expires": "Berakhir",
      "account.esims.viewQr": "Tampilkan kode QR",
      "account.esims.hideQr": "Sembunyikan kode QR",
      "account.esims.active": "Aktif",
      "account.esims.passive": "Tidak aktif",
      "account.esims.noActive": "Anda tidak memiliki eSIM aktif.",
      "account.esims.noPassive": "Anda tidak memiliki eSIM tidak aktif.",
      "account.esims.readyHint": "Siap digunakan — masa berlaku dimulai saat pertama kali digunakan.",
      "account.esims.unavailableHint": "Status tidak tersedia saat ini. Silakan coba lagi nanti.",
      "esimStatus.active": "Aktif",
      "esimStatus.readyToUse": "Siap digunakan",
      "esimStatus.inactive": "Tidak aktif",
      "esimStatus.unavailable": "Status tidak tersedia",
      "account.security.title": "Ubah kata sandi",
      "account.field.oldPassword": "Kata sandi saat ini",
      "account.field.newPassword": "Kata sandi baru",
      "account.field.confirmPassword": "Kata sandi baru (ulangi)",
      "account.changePassword": "Perbarui kata sandi",
      "account.passwordChanged": "Kata sandi Anda telah diperbarui.",
      "account.error.passwordMismatch": "Kata sandi baru tidak cocok.",
      "account.danger.title": "Tindakan akun",
      "account.delete": "Hapus akun",
      "account.delete.confirm": "Anda akan menghapus akun Anda secara permanen. Tindakan ini tidak dapat dibatalkan.",
      "account.delete.confirmBtn": "Ya, hapus",
      "account.cancel": "Batal",
      "esimDetail.back": "Kembali",
      "esimDetail.dataUsage": "Penggunaan Data",
      "esimDetail.left": "tersisa",
      "esimDetail.leftData": "Data Tersisa",
      "esimDetail.usedData": "Terpakai",
      "esimDetail.totalData": "Total Data",
      "esimDetail.qrDesc": "Pindai kode QR ini dengan kamera perangkat Anda untuk mengatur eSIM.",
      "esimDetail.validity": "Masa berlaku",
      "esimDetail.daysLeft": "{{days}} hari tersisa",
      "esimDetail.expired": "Kedaluwarsa",
      "esimDetail.notYetActive": "Belum aktif",
      "esimDetail.leftDate": "Sisa waktu",
      "esimDetail.activationDate": "Tanggal aktivasi",
      "esimDetail.endDate": "Tanggal berakhir",
      "esimDetail.technical": "Detail teknis",
      "esimDetail.activationCode": "Kode aktivasi (Android)",
      "esimDetail.smdp": "Alamat SM-DP+ (iOS)",
      "esimDetail.matchingId": "Matching ID (iOS)",
      "esimDetail.support": "Dukungan Teknis",
      "esimDetail.supportDesc": "Ada masalah? Kami siap membantu.",
      "esimDetail.email": "Kirim email",
      "guide.eyebrow": "PANDUAN eSIM",
      "guide.title": "Apa itu eSIM dan bagaimana cara mengaturnya?",
      "guide.intro.title": "Apa itu eSIM?",
      "guide.intro.body": "eSIM adalah SIM digital yang tertanam di perangkat Anda — tanpa perlu kartu fisik. Pindai kode QR dan saluran Anda siap dalam hitungan detik, sehingga Anda dapat online di 190+ negara tanpa ganti kartu dan tanpa tagihan roaming.",
      "guide.steps.title": "Cara mengaktifkan",
      "guide.devices.title": "Perangkat yang didukung",
      "guide.devices.desc": "Perangkat Anda harus mendukung eSIM agar dapat berfungsi. Temukan merek Anda di bawah ini.",
      "guide.faq.title": "Pertanyaan yang sering diajukan",
      "nav.guide": "Panduan eSIM",
      "currency.label": "Mata uang",
      "staticPage.loading": "Memuat halaman...",
      "staticPage.errorTitle": "Terjadi Kesalahan",
      "staticPage.retry": "Coba Lagi",
      "staticPage.loadFailed": "Konten halaman tidak dapat dimuat. Silakan coba lagi nanti.",
      "last.updated": "Terakhir diperbarui: 8 Juli 2024",
      "home.tabs.unlimited": "eSIM Tanpa Batas",
      "detail.unlimited": "Tanpa Batas",
      "detail.unlimitedNote": "Paket ini tidak memiliki batas data — nikmati internet tanpa batas selama seluruh masa berlaku.",
      "detail.notPriced": "Paket ini saat ini tidak dapat dibeli melalui web.",
      "checkout.priceUpdated": "Harga paket ini telah berubah. Silakan kembali ke toko dan pilih paket ini lagi.",
      "order.pending.title": "eSIM Anda sedang disiapkan",
      "order.pending.message": "Pembayaran Anda berhasil. Aktivasi paket tanpa batas dapat memerlukan beberapa menit.",
      "order.pending.waiting": "Memeriksa status pesanan Anda…",
      "order.pending.ready": "eSIM Anda sudah siap!",
      "order.pending.timeout": "Proses ini memakan waktu lebih lama dari perkiraan. Pembayaran Anda aman — eSIM Anda akan muncul di “eSIM Saya” segera setelah siap.",
      "order.pending.cta": "Buka eSIM Saya",
      "account.esims.unlimited": "Tanpa Batas",
      "account.esims.unlimitedHint": "Data tanpa batas — paket ini tidak memiliki batas data.",
      "esimDetail.unlimitedData": "Paket ini tidak memiliki batas data; lihat sisa waktu di bawah.",
      "del.eyebrow": "Penghapusan akun",
      "del.title": "Hapus akun saya",
      "del.intro": "Di sini Anda dapat menghapus akun Utkan eSIM dan data pribadi Anda secara permanen. Anda tidak perlu memasang aplikasi — cukup masuk dengan akun yang ingin dihapus.",
      "del.deleted.title": "Data yang dihapus",
      "del.deleted.identity": "Nama depan, nama belakang, alamat email, dan nomor telepon Anda",
      "del.deleted.credentials": "Kata sandi dan data sesi Anda",
      "del.deleted.codes": "Kode verifikasi email dan kode pengaturan ulang kata sandi Anda",
      "del.deleted.esim": "Nomor eSIM (MSISDN), kode QR/aktivasi, dan data penggunaan Anda",
      "del.kept.title": "Data yang kami simpan dan alasannya",
      "del.kept.orders": "Catatan pembelian (nomor pesanan, tanggal, jumlah, status pembayaran) disimpan untuk memenuhi kewajiban pajak dan akuntansi. Catatan ini tidak berisi nama, alamat email, atau detail pembayaran — hanya pengenal yang tidak dapat dikaitkan kembali dengan Anda.",
      "del.kept.period": "Masa penyimpanan: 5 tahun (Undang-Undang Tata Cara Perpajakan Turki, pasal 253).",
      "del.warn.title": "Sebelum Anda menghapus",
      "del.warn.irreversible": "Tindakan ini tidak dapat dibatalkan.",
      "del.warn.esim": "eSIM aktif tetap berfungsi di perangkat Anda, tetapi Anda tidak akan dapat lagi mengakses kode QR atau sisa data Anda. Simpan kode QR Anda sebelum menghapus.",
      "del.warn.rejoin": "Anda dapat mendaftar lagi dengan alamat email yang sama, tetapi eSIM Anda sebelumnya tidak akan muncul di akun baru.",
      "del.support": "Jika Anda tidak dapat masuk, Anda juga dapat meminta penghapusan melalui email:",
      "del.login.title": "Masuk terlebih dahulu",
      "del.login.subtitle": "Masukkan email dan kata sandi Anda agar kami dapat memastikan akun ini milik Anda.",
      "del.login.action": "Masuk",
      "del.login.loading": "Sedang masuk...",
      "del.forgot": "Lupa kata sandi?",
      "del.confirm.title": "Apakah Anda yakin?",
      "del.confirm.subtitle": "Akun {{email}} dan data pribadi Anda akan dihapus secara permanen.",
      "del.confirm.field": "Ketik ulang alamat email Anda untuk konfirmasi",
      "del.confirm.action": "Hapus akun saya secara permanen",
      "del.confirm.deleting": "Menghapus...",
      "del.confirm.cancel": "Batal",
      "del.done.title": "Akun Anda telah dihapus",
      "del.done.body": "Data pribadi Anda telah dihapus secara permanen.",
      "del.done.retained": "Data pribadi Anda telah dihapus secara permanen. {{n}} catatan pembelian disimpan untuk memenuhi kewajiban hukum; catatan tersebut tidak dapat dikaitkan dengan Anda.",
      "del.done.home": "Kembali ke toko",
      "del.error.required": "Silakan masukkan email dan kata sandi Anda.",
      "del.error.credentials": "Email atau kata sandi salah.",
      "del.error.suspended": "Akun Anda telah ditangguhkan. Silakan hubungi dukungan.",
      "del.error.session": "Sesi Anda telah berakhir. Silakan masuk lagi.",
      "del.error.network": "Tidak dapat terhubung. Periksa koneksi internet Anda dan coba lagi.",
      "del.error.generic": "Terjadi kesalahan. Silakan coba lagi.",
      "footer.deleteAccount": "Hapus akun",
      "home.tabs.voice": "eSIM Panggilan",
      "detail.voice": "Panggilan + SMS",
      "detail.voiceNote": "Paket ini mencakup panggilan dan SMS tanpa batas selain data — satu eSIM untuk internet sekaligus panggilan.",
      "detail.calls": "Panggilan",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "Panggilan tanpa batas",
      "plan.unlimitedSms": "SMS tanpa batas",
      "plan.minutes": "{{n}} menit panggilan",
      "plan.sms": "{{n}} SMS",
      "hercules.subtitle": "Panggilan, SMS, dan data tanpa batas di {{n}} negara Eropa — satu eSIM.",
      "hercules.coverageTitle": "Negara yang dicakup ({{n}})",
      "hercules.promo.desc": "Panggilan dan SMS tanpa batas di {{n}} negara, dengan data 20–100 GB.",
      "hercules.promo.cta": "Lihat paket",
      "loading": "Memuat..."
    }
  },
  // Makedonca
  mk: {
    translation: {
      "language.title": "Јазик",
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "Иднината на дигиталната поврзаност",
      "hero.description": "Ги отстрануваме границите со дигитална поврзаност од новата генерација.",
      "hero.description2": "Брзи, безбедни и достапни eSIM решенија ширум светот.",
      "features.countries": "150+ земји",
      "features.activation": "Инстант активација",
      "features.support": "Поддршка 24/7",
      "countdown.title": "Нашата веб-страница наскоро!",
      "countdown.days": "Денови",
      "countdown.hours": "Часови",
      "countdown.minutes": "Минути",
      "countdown.seconds": "Секунди",
      "countdown.launch": "Нашата веб-страница е активна!",
      "countdown.loading": "Се вчитува...",
      "apps.title": "Нашите мобилни апликации",
      "apps.ios.label": "Преземете од",
      "apps.ios.name": "App Store",
      "apps.android.label": "ДОСТАПНО НА",
      "apps.android.name": "Google Play",
      "contact.title": "Контактирајте нè до лансирањето",
      "contact.whatsapp": "WhatsApp: +90 540 155 13 33",
      "contact.email": "Е-пошта: info@utkanesim.com",
      "about.hero.title": "За Utkan eSIM",
      "about.hero.description": "Вашиот доверлив партнер за да останете поврзани каде и да одите. Веруваме дека патувањето низ светот треба да биде непречено и достапно, без мака со физички SIM-картички и скап роаминг.",
      "about.story.title": "Нашата приказна",
      "about.story.content": "Основана во 2024 година од тим страсни патници и љубители на технологијата, нашата цел е да го револуционизираме начинот на кој луѓето се поврзуваат на интернет во странство. Нудиме квалитетни и сигурни eSIM планови за податоци за повеќе од 190 земји и региони, за да имате брз интернет уште од моментот кога ќе слетате.",
      "about.mission.title": "Нашата мисија",
      "about.mission.content": "Да им обезбедиме на патниците едноставна, достапна и инстант поврзаност ширум светот, за да истражуваат, работат и да останат во контакт без граници.",
      "about.vision.title": "Нашата визија",
      "about.vision.content": "Да бидеме водечка глобална платформа за решенија за дигитална поврзаност и да го направиме светот помал и поповрзан за секого.",
      "about.features.title": "Зошто да нè изберете?",
      "about.features.instant.title": "Инстант испорака",
      "about.features.instant.content": "Добијте го вашиот eSIM со QR-код веднаш по купувањето.",
      "about.features.global.title": "Глобална покриеност",
      "about.features.global.content": "Планови за податоци за повеќе од 190 земји и региони.",
      "about.features.affordable.title": "Достапни цени",
      "about.features.affordable.content": "Заштедете до 90% на трошоците за роаминг.",
      "about.features.support.title": "Поддршка 24/7",
      "about.features.support.content": "Нашиот посветен тим за поддршка е секогаш тука да помогне.",
      "about.features.secure.title": "Безбедна врска",
      "about.features.secure.content": "Врска заштитена со најнови безбедносни протоколи.",
      "about.features.fast.title": "Брз интернет",
      "about.features.fast.content": "Непречено интернет искуство со 4G/5G брзина.",
      "about.cta.title": "Приклучете се кон иднината на дигиталната поврзаност",
      "about.cta.content": "Ви благодариме што го избравте Utkan eSIM. Среќен пат!",
      "about.cta.whatsapp": "Контакт преку WhatsApp",
      "about.cta.email": "Испрати е-пошта",
      "contact.hero.title": "Контактирајте нè",
      "contact.hero.description": "Тука сме да помогнеме! Без разлика дали имате прашање за нашите eSIM, ви треба техничка поддршка или сакате да ни дадете повратна информација, со задоволство ќе ве слушнеме.",
      "contact.info.title": "Информации за контакт",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "Брза поддршка 24/7",
      "contact.email.title": "Е-пошта",
      "contact.email.subtitle": "Општ контакт",
      "contact.support.title": "Техничка поддршка",
      "contact.support.subtitle": "Проблеми со eSIM",
      "contact.business.title": "Партнерство",
      "contact.business.subtitle": "Корпоративен контакт",
      "contact.hours.title": "Работно време на поддршката",
      "contact.hours.subtitle": "Техничка поддршка 24/7",
      "contact.hours.detail": "Понеделник – недела: 00:00 – 23:59",
      "contact.form.title": "Испратете ни порака",
      "contact.form.name": "Вашето име",
      "contact.form.name.placeholder": "Внесете име и презиме",
      "contact.form.email": "Вашата е-пошта",
      "contact.form.email.placeholder": "example@email.com",
      "contact.form.subject": "Тема",
      "contact.form.subject.placeholder": "Изберете тема",
      "contact.form.subject.general": "Општи информации",
      "contact.form.subject.technical": "Техничка поддршка",
      "contact.form.subject.billing": "Прашања за наплата",
      "contact.form.subject.partnership": "Партнерство",
      "contact.form.subject.feedback": "Повратна информација",
      "contact.form.message": "Вашата порака",
      "contact.form.message.placeholder": "Напишете ја вашата порака тука...",
      "contact.form.submit": "Испрати порака",
      "contact.faq.title": "Често поставувани прашања",
      "contact.faq.esim.title": "Како функционира eSIM?",
      "contact.faq.esim.content": "eSIM е дигитална SIM-картичка што работи во вашиот телефон без потреба од физичка SIM-картичка. Се активира веднаш преку QR-код.",
      "contact.faq.phones.title": "Кои телефони поддржуваат eSIM?",
      "contact.faq.phones.content": "eSIM го поддржуваат iPhone XS и понови, Samsung Galaxy S20 и понови и Google Pixel 3 и понови модели.",
      "contact.faq.validity.title": "Колку долго важи мојот пакет податоци?",
      "contact.faq.validity.content": "Важноста на пакетот е од 1 до 30 дена, во зависност од планот што ќе го изберете.",
      "contact.faq.payment.title": "Како можам да платам?",
      "contact.faq.payment.content": "Можете безбедно да платите со платежна картичка, PayPal или банкарски трансфер.",
      "privacy.hero.title": "Политика за приватност",
      "privacy.hero.description": "Безбедноста на вашите лични податоци е многу важна за нас. Оваа политика објаснува како вашите податоци се собираат, користат и заштитуваат.",
      "privacy.overview.title": "Преглед",
      "privacy.overview.content": "Оваа Политика за приватност ги опишува нашите правила и постапки за собирање, користење и откривање на вашите информации кога ја користите Услугата и ве информира за вашите права на приватност и за тоа како законот ве штити.",
      "privacy.data.title": "Податоци што ги собираме",
      "privacy.data.personal.title": "Лични информации",
      "privacy.data.personal.name": "Име и презиме",
      "privacy.data.personal.email": "Адреса на е-пошта",
      "privacy.data.personal.phone": "Телефонски број",
      "privacy.data.personal.payment": "Информации за плаќање",
      "privacy.data.usage.title": "Податоци за користење",
      "privacy.data.usage.ip": "IP-адреса",
      "privacy.data.usage.browser": "Тип на прелистувач",
      "privacy.data.usage.device": "Информации за уредот",
      "privacy.data.usage.stats": "Статистика за користење",
      "privacy.security.title": "Безбедност на податоците",
      "privacy.security.ssl.title": "SSL-шифрирање",
      "privacy.security.ssl.content": "Сите преноси на податоци се заштитени со 256-битно SSL-шифрирање.",
      "privacy.security.servers.title": "Безбедни сервери",
      "privacy.security.servers.content": "Вашите податоци се чуваат на безбедни сервери сертифицирани според ISO 27001.",
      "privacy.security.access.title": "Контрола на пристап",
      "privacy.security.access.content": "Само овластен персонал може да пристапи до вашите податоци.",
      "privacy.usage.title": "Користење на податоците",
      "privacy.usage.intro": "Податоците што ги собираме ги користиме за следниве цели:",
      "privacy.usage.service.title": "Обезбедување услуги",
      "privacy.usage.service.content": "За да ви ги обезбедиме и управуваме нашите eSIM услуги",
      "privacy.usage.support.title": "Поддршка за корисници",
      "privacy.usage.support.content": "За да обезбедиме техничка поддршка и услуги за корисници",
      "privacy.usage.security.title": "Безбедност",
      "privacy.usage.security.content": "За да ја заштитиме вашата сметка и нашите услуги",
      "privacy.usage.improvement.title": "Подобрување",
      "privacy.usage.improvement.content": "За да ги подобриме нашите услуги и да додадеме нови функции",
      "privacy.sharing.title": "Споделување податоци",
      "privacy.sharing.intro": "Не ги споделуваме вашите лични податоци со трети страни, но споделувањето може да биде потребно во следниве случаи:",
      "privacy.sharing.legal": "Во случај на законска обврска",
      "privacy.sharing.providers": "Со нашите даватели на услуги (како што се обработувачите на плаќања)",
      "privacy.sharing.threats": "За спречување безбедносни закани",
      "privacy.sharing.consent": "Кога ќе дадете изречна согласност",
      "privacy.rights.title": "Вашите права",
      "privacy.rights.access.title": "Право на пристап",
      "privacy.rights.access.content": "Можете да побарате пристап до податоците што ги чуваме за вас.",
      "privacy.rights.correction.title": "Право на исправка",
      "privacy.rights.correction.content": "Можеме да ги исправиме вашите неточни или нецелосни податоци.",
      "privacy.rights.deletion.title": "Право на бришење",
      "privacy.rights.deletion.content": "Под одредени услови можеме да ги избришеме вашите податоци.",
      "privacy.rights.objection.title": "Право на приговор",
      "privacy.rights.objection.content": "Можете да поднесете приговор на нашите активности за обработка на податоци.",
      "privacy.contact.title": "Контакт",
      "privacy.contact.intro": "Ако имате прашања за оваа Политика за приватност, можете да нè контактирате преку следниве канали:",
      "nav.about": "За нас",
      "nav.contact": "Контакт",
      "nav.privacy": "Приватност",
      "nav.login": "Најави се",
      "nav.account": "Сметка",
      "nav.logout": "Одјави се",
      "auth.brand.eyebrow": "ГЛОБАЛНА ПОКРИЕНОСТ",
      "auth.brand.title": "Онлајн веднаш штом ќе слетате, во 150+ земји.",
      "auth.brand.subtitle": "Без физичка SIM-картичка, без сметки за роаминг. Активирајте го вашиот eSIM за неколку секунди.",
      "auth.login.eyebrow": "НАЈАВА",
      "auth.login.title": "Добредојдовте повторно",
      "auth.login.subtitle": "Управувајте со вашите eSIM и откријте нови.",
      "auth.signup.eyebrow": "НОВА СМЕТКА",
      "auth.signup.title": "Креирајте сметка",
      "auth.signup.subtitle": "Само неколку чекори до вашиот прв eSIM.",
      "auth.field.identifier": "Е-пошта или телефон",
      "auth.field.identifier.ph": "you@email.com или +389…",
      "auth.field.email": "Е-пошта",
      "auth.field.email.ph": "you@email.com",
      "auth.field.fullName": "Име и презиме",
      "auth.field.fullName.ph": "Вашето име и презиме",
      "auth.field.password": "Лозинка",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "Најави се",
      "auth.action.loggingIn": "Најавување…",
      "auth.action.signup": "Креирај сметка",
      "auth.action.signingUp": "Се креира сметка…",
      "auth.toSignup.q": "Немате сметка?",
      "auth.toSignup.link": "Регистрирај се",
      "auth.toLogin.q": "Веќе имате сметка?",
      "auth.toLogin.link": "Најави се",
      "auth.password.show": "Прикажи лозинка",
      "auth.password.hide": "Сокриј лозинка",
      "auth.terms.prefix": "Со продолжување, се согласувам со ",
      "auth.terms.link": "Условите за користење и Политиката за приватност",
      "auth.terms.suffix": ".",
      "auth.error.required": "Ве молиме, пополнете ги задолжителните полиња.",
      "auth.error.terms": "Ве молиме, прифатете ги условите за да продолжите.",
      "verify.eyebrow": "ПОТВРДА НА Е-ПОШТА",
      "verify.title": "Потврдете ја вашата е-пошта",
      "verify.subtitle": "Испративме 6-цифрен код на {{email}}. Внесете го за потврда.",
      "verify.code": "Код за верификација",
      "verify.code.ph": "••••••",
      "verify.action": "Потврди",
      "verify.verifying": "Се потврдува…",
      "verify.resend": "Испрати го кодот повторно",
      "verify.resendIn": "Испрати повторно за {{seconds}}с",
      "verify.resent": "Испратен е нов код.",
      "verify.skip": "Прескокни засега",
      "auth.forgot.link": "Ја заборавивте лозинката?",
      "forgot.eyebrow": "РЕСЕТИРАЊЕ ЛОЗИНКА",
      "forgot.email.title": "Ресетирајте ја лозинката",
      "forgot.email.subtitle": "Внесете ја е-поштата на вашата сметка и ќе ви испратиме 6-цифрен код за ресетирање.",
      "forgot.email.action": "Испрати код",
      "forgot.email.sending": "Се испраќа…",
      "forgot.reset.title": "Поставете нова лозинка",
      "forgot.reset.subtitle": "Внесете го 6-цифрениот код што го испративме на {{email}} и новата лозинка.",
      "forgot.reset.action": "Ажурирај лозинка",
      "forgot.reset.updating": "Се ажурира…",
      "forgot.field.code": "Код за ресетирање",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "Нова лозинка",
      "forgot.field.newPassword.ph": "Најмалку 6 знаци",
      "forgot.resend": "Испрати го кодот повторно",
      "forgot.resendIn": "Испрати повторно за {{seconds}}с",
      "forgot.resent": "Испратен е нов код.",
      "forgot.backToLogin": "Назад кон најавата",
      "forgot.changeEmail": "Промени е-пошта",
      "forgot.help.noMail": "Ако кодот не пристигна, проверете ја папката за несакана пошта или потврдете ја вашата адреса на е-пошта.",
      "reset.RESET_CODE_SENT": "Кодот е испратен. Ве молиме, проверете ја вашата е-пошта.",
      "reset.RATE_LIMITED": "Премногу барања. Ве молиме, почекајте малку и обидете се повторно.",
      "reset.MAIL_SEND_FAILED": "Нешто тргна наопаку. Ве молиме, обидете се повторно подоцна.",
      "reset.RESET_CODE_VALID": "Кодот е потврден.",
      "reset.INVALID_RESET_CODE": "Неважечки код. Ве молиме, обидете се повторно.",
      "reset.EXPIRED_RESET_CODE": "Кодот истече. Ве молиме, побарајте нов код.",
      "reset.WEAK_PASSWORD": "Лозинката мора да има најмалку 6 знаци.",
      "reset.PASSWORD_RESET_SUCCESS": "Вашата лозинка е ажурирана. Ве молиме, најавете се со новата лозинка.",
      "reset.generic": "Нешто тргна наопаку. Ве молиме, обидете се повторно.",
      "login.resetSuccess": "Вашата лозинка е ажурирана. Ве молиме, најавете се со новата лозинка.",
      "store.nav.shop": "Продавница",
      "home.hero.title1": "Поврзете се за неколку минути,",
      "home.hero.title2": "останете онлајн преку границите.",
      "home.hero.subtitle": "Сигурни eSIM планови што важат во 190+ земји. Без физичка SIM-картичка, без сметки за роаминг.",
      "home.search.placeholder": "Каде патувате?",
      "home.tabs.local": "Локални eSIM",
      "home.tabs.regional": "Регионални eSIM",
      "home.tabs.lifetime": "Доживотни eSIM",
      "home.empty": "Нема резултати за вашето пребарување.",
      "home.error.title": "Содржината не може да се вчита",
      "home.error.retry": "Обиди се повторно",
      "home.from": "од",
      "home.popular": "Популарни дестинации",
      "home.coverage": "190+ земји · инстант активација",
      "home.detail.soon": "Плановите за овој избор наскоро ќе бидат објавени тука.",
      "home.detail.back": "Назад кон продавницата",
      "detail.plans": "Планови",
      "detail.count": "Планови: {{count}}",
      "detail.validity": "{{days}} дена",
      "detail.validityLifetime": "Без рок на важност",
      "detail.buy": "Купи",
      "detail.empty": "Во моментов нема достапни планови за овој избор.",
      "detail.checkoutSoon": "Плаќањето наскоро ќе биде достапно.",
      "detail.loginToBuy": "Ве молиме, најавете се за да купите.",
      "detail.basicFeatures": "Основни карактеристики",
      "detail.dataAmount": "Количина на податоци",
      "detail.validityLabel": "Важност",
      "detail.coverageArea": "Покриеност",
      "detail.activationNetworks": "Активација и мрежи",
      "detail.activationMethod": "Начин на активација",
      "detail.esimActivation": "eSIM — инстант преку QR-код",
      "detail.supportedNetworks": "Поддржани мрежи",
      "detail.description": "Опис",
      "detail.price": "Цена",
      "authprompt.title": "Најавете се за да продолжите",
      "authprompt.message": "Најавете се на вашата сметка за да купите eSIM или креирајте сметка за неколку секунди.",
      "authprompt.close": "Затвори",
      "footer.tagline": "Брз, безбеден и достапен eSIM ширум светот. Бидете онлајн веднаш штом ќе слетате.",
      "footer.explore": "Истражете",
      "footer.support": "Поддршка",
      "footer.legal": "Правни информации",
      "footer.shop": "Продавница",
      "footer.help": "Често поставувани прашања",
      "footer.terms": "Услови за користење",
      "footer.rights": "© {{year}} Utkan eSIM. Сите права се задржани.",
      "footer.apps": "Преземете ја апликацијата",
      "whatsapp.label": "Разговарајте на WhatsApp",
      "whatsapp.message": "Здраво, имам барање за поддршка за eSIM.",
      "notfound.eyebrow": "НЕМА СИГНАЛ",
      "notfound.title": "Оваа страница е надвор од дофат",
      "notfound.message": "Страницата што ја барате е преместена или никогаш не постоела. Да ве вратиме во зоната на покриеност.",
      "order.congrats": "Честитки!",
      "order.message": "Вашиот eSIM е подготвен. Поставете го во неколку чекори со QR-кодот подолу.",
      "order.details": "Преглед на нарачка",
      "order.activation": "Активација",
      "order.activationDesc": "За да го поставите вашиот eSIM, скенирајте го QR-кодот со камерата на уредот или внесете го кодот за активација рачно.",
      "order.qrTitle": "eSIM QR-код",
      "order.manualLabel": "Код за активација",
      "order.copy": "Копирај",
      "order.copied": "Копирано",
      "order.howTo": "Како да се активира",
      "order.step1": "На уредот одете во Поставки > Мобилна мрежа / Мобилни податоци > Додај eSIM.",
      "order.step2": "Изберете „Користи QR-код“ и скенирајте го QR-кодот погоре (или внесете го кодот за активација рачно).",
      "order.step3": "Штом поставувањето заврши, вклучете го eSIM планот.",
      "order.step4": "Проверете дали е вклучен роамингот на податоци — поврзани сте!",
      "order.cta": "Назад на почетната",
      "checkout.title": "Плаќање",
      "checkout.summary": "Преглед на нарачка",
      "checkout.total": "Вкупно",
      "checkout.eurNote": "Ќе бидете задолжени во евра (€) преку PayPal.",
      "checkout.processing": "Го потврдуваме вашето плаќање…",
      "checkout.error": "Плаќањето не можеше да се заврши. Ве молиме, обидете се повторно.",
      "checkout.cancelled": "Плаќањето е откажано.",
      "account.title": "Мојата сметка",
      "account.tab.profile": "Профил",
      "account.tab.esims": "Мои eSIM",
      "account.tab.security": "Безбедност",
      "account.profile.title": "Информации за профилот",
      "account.field.phone": "Телефон",
      "account.field.phone.ph": "+389…",
      "account.memberSince": "Член од",
      "account.save": "Зачувај",
      "account.saving": "Зачувување…",
      "account.saved": "Вашите податоци се ажурирани.",
      "account.esims.title": "Мои eSIM",
      "account.esims.empty": "Сè уште немате eSIM.",
      "account.esims.emptyCta": "Разгледајте ја продавницата",
      "account.esims.data": "Податоци",
      "account.esims.expires": "Истекува",
      "account.esims.viewQr": "Прикажи QR-код",
      "account.esims.hideQr": "Сокриј QR-код",
      "account.esims.active": "Активни",
      "account.esims.passive": "Неактивни",
      "account.esims.noActive": "Немате активни eSIM.",
      "account.esims.noPassive": "Немате неактивни eSIM.",
      "account.esims.readyHint": "Подготвен за користење — важноста започнува со првото користење.",
      "account.esims.unavailableHint": "Статусот моментално не е достапен. Ве молиме, обидете се повторно подоцна.",
      "esimStatus.active": "Активен",
      "esimStatus.readyToUse": "Подготвен за користење",
      "esimStatus.inactive": "Неактивен",
      "esimStatus.unavailable": "Статусот не е достапен",
      "account.security.title": "Промена на лозинка",
      "account.field.oldPassword": "Тековна лозинка",
      "account.field.newPassword": "Нова лозинка",
      "account.field.confirmPassword": "Нова лозинка (повторно)",
      "account.changePassword": "Ажурирај лозинка",
      "account.passwordChanged": "Вашата лозинка е ажурирана.",
      "account.error.passwordMismatch": "Новите лозинки не се совпаѓаат.",
      "account.danger.title": "Дејства за сметката",
      "account.delete": "Избриши сметка",
      "account.delete.confirm": "Ќе ја избришете вашата сметка трајно. Ова не може да се поништи.",
      "account.delete.confirmBtn": "Да, избриши",
      "account.cancel": "Откажи",
      "esimDetail.back": "Назад",
      "esimDetail.dataUsage": "Искористеност на податоци",
      "esimDetail.left": "преостанато",
      "esimDetail.leftData": "Преостанати податоци",
      "esimDetail.usedData": "Искористено",
      "esimDetail.totalData": "Вкупно податоци",
      "esimDetail.qrDesc": "Скенирајте го овој QR-код со камерата на уредот за да го поставите вашиот eSIM.",
      "esimDetail.validity": "Важност",
      "esimDetail.daysLeft": "Преостануваат {{days}} дена",
      "esimDetail.expired": "Истечен",
      "esimDetail.notYetActive": "Сè уште не е активен",
      "esimDetail.leftDate": "Преостанато време",
      "esimDetail.activationDate": "Датум на активација",
      "esimDetail.endDate": "Краен датум",
      "esimDetail.technical": "Технички детали",
      "esimDetail.activationCode": "Код за активација (Android)",
      "esimDetail.smdp": "SM-DP+ адреса (iOS)",
      "esimDetail.matchingId": "ID за совпаѓање (iOS)",
      "esimDetail.support": "Техничка поддршка",
      "esimDetail.supportDesc": "Нешто не е во ред? Тука сме да помогнеме.",
      "esimDetail.email": "Испрати е-пошта",
      "guide.eyebrow": "eSIM ВОДИЧ",
      "guide.title": "Што е eSIM и како да се постави?",
      "guide.intro.title": "Што е eSIM?",
      "guide.intro.body": "eSIM е дигитална SIM-картичка вградена во вашиот уред — не ви треба физичка картичка. Скенирајте QR-код и вашата линија е поставена за неколку секунди, за да можете да бидете онлајн во 190+ земји без менување картички и без сметки за роаминг.",
      "guide.steps.title": "Како да се активира",
      "guide.devices.title": "Поддржани уреди",
      "guide.devices.desc": "Вашиот уред мора да поддржува eSIM за да функционира. Пронајдете го вашиот бренд подолу.",
      "guide.faq.title": "Често поставувани прашања",
      "nav.guide": "eSIM водич",
      "currency.label": "Валута",
      "staticPage.loading": "Страницата се вчитува...",
      "staticPage.errorTitle": "Настана грешка",
      "staticPage.retry": "Обиди се повторно",
      "staticPage.loadFailed": "Содржината на страницата не може да се вчита. Ве молиме, обидете се повторно подоцна.",
      "last.updated": "Последно ажурирање: 8 јули 2024",
      "home.tabs.unlimited": "Неограничени eSIM",
      "detail.unlimited": "Неограничено",
      "detail.unlimitedNote": "Овој пакет нема ограничување на податоците — уживајте во неограничен интернет во текот на целиот период на важност.",
      "detail.notPriced": "Овој пакет моментално не е достапен за купување на веб.",
      "checkout.priceUpdated": "Цената на овој пакет е променета. Ве молиме, вратете се во продавницата и изберете го повторно.",
      "order.pending.title": "Вашиот eSIM се подготвува",
      "order.pending.message": "Вашето плаќање е успешно. Активирањето на неограничените пакети може да трае неколку минути.",
      "order.pending.waiting": "Го проверуваме статусот на нарачката…",
      "order.pending.ready": "Вашиот eSIM е подготвен!",
      "order.pending.timeout": "Ова трае подолго од очекуваното. Вашето плаќање е безбедно — вашиот eSIM ќе се појави во „Мои eSIM“ штом биде подготвен.",
      "order.pending.cta": "Оди на моите eSIM",
      "account.esims.unlimited": "Неограничено",
      "account.esims.unlimitedHint": "Неограничени податоци — овој пакет нема ограничување на податоците.",
      "esimDetail.unlimitedData": "Овој пакет нема ограничување на податоците; преостанатото време е прикажано подолу.",
      "del.eyebrow": "Бришење сметка",
      "del.title": "Избриши ја мојата сметка",
      "del.intro": "Овде можете трајно да ја избришете вашата Utkan eSIM сметка и личните податоци. Не ви треба инсталирана апликација — само најавете се со сметката што сакате да ја избришете.",
      "del.deleted.title": "Податоци што се бришат",
      "del.deleted.identity": "Вашето име, презиме, адреса на е-пошта и телефонски број",
      "del.deleted.credentials": "Вашата лозинка и податоците за сесиите",
      "del.deleted.codes": "Вашите кодови за потврда на е-пошта и за ресетирање лозинка",
      "del.deleted.esim": "Вашиот eSIM број (MSISDN), QR-кодот/кодот за активација и податоците за користење",
      "del.kept.title": "Податоци што ги чуваме и зошто",
      "del.kept.orders": "Записите за купувања (број на нарачка, датум, износ, статус на плаќање) се чуваат за исполнување на даночните и сметководствените обврски. Тие не содржат име, адреса на е-пошта или детали за плаќање — само идентификатор што не може да се поврзе со вас.",
      "del.kept.period": "Период на чување: 5 години (Закон за даночна постапка на Турција, чл. 253).",
      "del.warn.title": "Пред да избришете",
      "del.warn.irreversible": "Ова дејство не може да се поништи.",
      "del.warn.esim": "Активните eSIM продолжуваат да работат на вашиот уред, но повеќе нема да можете да пристапите до QR-кодот или преостанатите податоци. Зачувајте го QR-кодот пред бришењето.",
      "del.warn.rejoin": "Можете повторно да се регистрирате со истата адреса на е-пошта, но вашите претходни eSIM нема да се појават во новата сметка.",
      "del.support": "Ако не можете да се најавите, бришење можете да побарате и по е-пошта:",
      "del.login.title": "Прво најавете се",
      "del.login.subtitle": "Внесете ја вашата е-пошта и лозинка за да потврдиме дека сметката е ваша.",
      "del.login.action": "Најави се",
      "del.login.loading": "Најавување...",
      "del.forgot": "Ја заборавивте лозинката?",
      "del.confirm.title": "Дали сте сигурни?",
      "del.confirm.subtitle": "Сметката {{email}} и вашите лични податоци ќе бидат трајно избришани.",
      "del.confirm.field": "За потврда, повторно внесете ја вашата адреса на е-пошта",
      "del.confirm.action": "Трајно избриши ја мојата сметка",
      "del.confirm.deleting": "Се брише...",
      "del.confirm.cancel": "Откажи",
      "del.done.title": "Вашата сметка е избришана",
      "del.done.body": "Вашите лични податоци се трајно избришани.",
      "del.done.retained": "Вашите лични податоци се трајно избришани. Заради законски обврски се зачувани записи за купувања: {{n}}; тие не можат да се поврзат со вас.",
      "del.done.home": "Назад кон продавницата",
      "del.error.required": "Ве молиме, внесете е-пошта и лозинка.",
      "del.error.credentials": "Погрешна е-пошта или лозинка.",
      "del.error.suspended": "Вашата сметка е суспендирана. Ве молиме, контактирајте ја поддршката.",
      "del.error.session": "Вашата сесија истече. Ве молиме, најавете се повторно.",
      "del.error.network": "Не може да се воспостави врска. Проверете ја интернет-врската и обидете се повторно.",
      "del.error.generic": "Нешто тргна наопаку. Ве молиме, обидете се повторно.",
      "footer.deleteAccount": "Избриши сметка",
      "home.tabs.voice": "eSIM со повици",
      "detail.voice": "Повици + SMS",
      "detail.voiceNote": "Овој план, покрај податоците, вклучува неограничени повици и SMS — еден eSIM и за интернет и за повици.",
      "detail.calls": "Повици",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "Неограничени повици",
      "plan.unlimitedSms": "Неограничени SMS",
      "plan.minutes": "{{n}} мин. повици",
      "plan.sms": "{{n}} SMS",
      "hercules.subtitle": "Неограничени повици, SMS и податоци во {{n}} европски земји — со еден eSIM.",
      "hercules.coverageTitle": "Опфатени земји ({{n}})",
      "hercules.promo.desc": "Неограничени повици и SMS во {{n}} земји, со 20–100 GB податоци.",
      "hercules.promo.cta": "Види го планот",
      "loading": "Се вчитува..."
    }
  },
  // Macarca
  hu: {
    translation: {
      "language.title": "Nyelv",
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "A digitális kapcsolódás jövője",
      "hero.description": "Új generációs digitális kapcsolódási élménnyel bontjuk le a határokat.",
      "hero.description2": "Gyors, biztonságos és kedvező árú eSIM-megoldások világszerte.",
      "features.countries": "150+ ország",
      "features.activation": "Azonnali aktiválás",
      "features.support": "0–24 órás támogatás",
      "countdown.title": "Weboldalunk hamarosan elindul!",
      "countdown.days": "Nap",
      "countdown.hours": "Óra",
      "countdown.minutes": "Perc",
      "countdown.seconds": "Másodperc",
      "countdown.launch": "Weboldalunk elindult!",
      "countdown.loading": "Betöltés...",
      "apps.title": "Mobilalkalmazásaink",
      "apps.ios.label": "Letöltés az",
      "apps.ios.name": "App Store",
      "apps.android.label": "ELÉRHETŐ:",
      "apps.android.name": "Google Play",
      "contact.title": "Az indulásig itt érhet el minket",
      "contact.whatsapp": "WhatsApp: +90 540 155 13 33",
      "contact.email": "E-mail: info@utkanesim.com",
      "about.hero.title": "Az Utkan eSIM-ről",
      "about.hero.description": "Megbízható partnere, hogy bárhol is jár, mindig kapcsolatban maradjon. Hiszünk abban, hogy a világ körüli utazásnak zökkenőmentesnek és megfizethetőnek kell lennie, fizikai SIM-kártyák és drága roamingdíjak nélkül.",
      "about.story.title": "Történetünk",
      "about.story.content": "2024-ben alapította szenvedélyes utazókból és technológiai rajongókból álló csapatunk, azzal a céllal, hogy forradalmasítsa, hogyan csatlakoznak az emberek az internethez külföldön. Kiváló minőségű, megbízható eSIM-adatcsomagokat kínálunk több mint 190 országban és régióban, így már a landolás pillanatától gyors internethez fér hozzá.",
      "about.mission.title": "Küldetésünk",
      "about.mission.content": "Egyszerű, megfizethető és azonnali kapcsolatot biztosítani az utazóknak világszerte, hogy határok nélkül fedezhessenek fel, dolgozhassanak és tarthassák a kapcsolatot.",
      "about.vision.title": "Jövőképünk",
      "about.vision.content": "A digitális kapcsolódási megoldások vezető globális platformjává válni, és mindenki számára kisebbé, összekapcsoltabbá tenni a világot.",
      "about.features.title": "Miért minket válasszon?",
      "about.features.instant.title": "Azonnali kézbesítés",
      "about.features.instant.content": "A vásárlás után azonnal megkapja eSIM-jét QR-kóddal.",
      "about.features.global.title": "Globális lefedettség",
      "about.features.global.content": "Adatcsomagok több mint 190 országban és régióban.",
      "about.features.affordable.title": "Kedvező árak",
      "about.features.affordable.content": "Akár 90%-ot is megtakaríthat a roamingdíjakon.",
      "about.features.support.title": "0–24 órás támogatás",
      "about.features.support.content": "Elkötelezett ügyfélszolgálatunk mindig készen áll a segítségre.",
      "about.features.secure.title": "Biztonságos kapcsolat",
      "about.features.secure.content": "A legújabb biztonsági protokollokkal védett kapcsolat.",
      "about.features.fast.title": "Gyors internet",
      "about.features.fast.content": "Zökkenőmentes internetélmény 4G/5G sebességgel.",
      "about.cta.title": "Csatlakozzon a digitális kapcsolódás jövőjéhez",
      "about.cta.content": "Köszönjük, hogy az Utkan eSIM-et választotta. Jó utat kívánunk!",
      "about.cta.whatsapp": "Kapcsolat WhatsAppon",
      "about.cta.email": "E-mail küldése",
      "contact.hero.title": "Kapcsolat",
      "contact.hero.description": "Segítünk! Akár kérdése van eSIM-jeinkkel kapcsolatban, akár technikai támogatásra van szüksége, vagy csak visszajelzést adna, örömmel hallunk Öntől.",
      "contact.info.title": "Elérhetőségek",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "Gyors támogatás 0–24 órában",
      "contact.email.title": "E-mail",
      "contact.email.subtitle": "Általános kapcsolat",
      "contact.support.title": "Technikai támogatás",
      "contact.support.subtitle": "eSIM-problémák",
      "contact.business.title": "Partnerség",
      "contact.business.subtitle": "Vállalati kapcsolat",
      "contact.hours.title": "Ügyfélszolgálati idő",
      "contact.hours.subtitle": "Technikai támogatás 0–24 órában",
      "contact.hours.detail": "Hétfő – vasárnap: 00:00 – 23:59",
      "contact.form.title": "Küldjön nekünk üzenetet",
      "contact.form.name": "Név",
      "contact.form.name.placeholder": "Adja meg a teljes nevét",
      "contact.form.email": "E-mail-cím",
      "contact.form.email.placeholder": "example@email.com",
      "contact.form.subject": "Tárgy",
      "contact.form.subject.placeholder": "Válasszon tárgyat",
      "contact.form.subject.general": "Általános információ",
      "contact.form.subject.technical": "Technikai támogatás",
      "contact.form.subject.billing": "Számlázási kérdések",
      "contact.form.subject.partnership": "Partnerség",
      "contact.form.subject.feedback": "Visszajelzés",
      "contact.form.message": "Üzenet",
      "contact.form.message.placeholder": "Írja ide üzenetét...",
      "contact.form.submit": "Üzenet küldése",
      "contact.faq.title": "Gyakran ismételt kérdések",
      "contact.faq.esim.title": "Hogyan működik az eSIM?",
      "contact.faq.esim.content": "Az eSIM egy digitális SIM-kártya, amely fizikai SIM-kártya nélkül működik a telefonjában. QR-kóddal azonnal aktiválható.",
      "contact.faq.phones.title": "Mely telefonok támogatják az eSIM-et?",
      "contact.faq.phones.content": "Az iPhone XS és újabb, a Samsung Galaxy S20 és újabb, valamint a Google Pixel 3 és újabb modellek támogatják az eSIM-et.",
      "contact.faq.validity.title": "Meddig érvényes az adatcsomagom?",
      "contact.faq.validity.content": "A csomag érvényességi ideje a választott csomagtól függően 1–30 nap.",
      "contact.faq.payment.title": "Hogyan fizethetek?",
      "contact.faq.payment.content": "Biztonságosan fizethet bankkártyával, PayPallal és banki átutalással.",
      "privacy.hero.title": "Adatvédelmi szabályzat",
      "privacy.hero.description": "Személyes adatainak biztonsága kiemelten fontos számunkra. Ez a szabályzat bemutatja, hogyan gyűjtjük, használjuk és védjük adatait.",
      "privacy.overview.title": "Áttekintés",
      "privacy.overview.content": "Ez az Adatvédelmi szabályzat ismerteti az Ön adatainak gyűjtésére, felhasználására és közlésére vonatkozó irányelveinket és eljárásainkat a Szolgáltatás használata során, valamint tájékoztatja Önt adatvédelmi jogairól és arról, hogyan védi Önt a jog.",
      "privacy.data.title": "Általunk gyűjtött adatok",
      "privacy.data.personal.title": "Személyes adatok",
      "privacy.data.personal.name": "Vezeték- és keresztnév",
      "privacy.data.personal.email": "E-mail-cím",
      "privacy.data.personal.phone": "Telefonszám",
      "privacy.data.personal.payment": "Fizetési adatok",
      "privacy.data.usage.title": "Használati adatok",
      "privacy.data.usage.ip": "IP-cím",
      "privacy.data.usage.browser": "Böngésző típusa",
      "privacy.data.usage.device": "Eszközadatok",
      "privacy.data.usage.stats": "Használati statisztikák",
      "privacy.security.title": "Adatbiztonság",
      "privacy.security.ssl.title": "SSL-titkosítás",
      "privacy.security.ssl.content": "Minden adatátvitelt 256 bites SSL-titkosítás véd.",
      "privacy.security.servers.title": "Biztonságos szerverek",
      "privacy.security.servers.content": "Adatait ISO 27001 tanúsítvánnyal rendelkező biztonságos szervereken tároljuk.",
      "privacy.security.access.title": "Hozzáférés-szabályozás",
      "privacy.security.access.content": "Adataihoz csak jogosult munkatársak férhetnek hozzá.",
      "privacy.usage.title": "Adatfelhasználás",
      "privacy.usage.intro": "Az általunk gyűjtött adatokat a következő célokra használjuk:",
      "privacy.usage.service.title": "Szolgáltatásnyújtás",
      "privacy.usage.service.content": "eSIM-szolgáltatásaink nyújtása és kezelése",
      "privacy.usage.support.title": "Ügyfélszolgálat",
      "privacy.usage.support.content": "Technikai támogatás és ügyfélszolgálat biztosítása",
      "privacy.usage.security.title": "Biztonság",
      "privacy.usage.security.content": "Fiókja és szolgáltatásaink védelme",
      "privacy.usage.improvement.title": "Fejlesztés",
      "privacy.usage.improvement.content": "Szolgáltatásaink fejlesztése és új funkciók bevezetése",
      "privacy.sharing.title": "Adatmegosztás",
      "privacy.sharing.intro": "Személyes adatait nem osztjuk meg harmadik felekkel, azonban a következő esetekben megosztásra lehet szükség:",
      "privacy.sharing.legal": "Jogi kötelezettség esetén",
      "privacy.sharing.providers": "Szolgáltatóinkkal (például fizetésfeldolgozókkal)",
      "privacy.sharing.threats": "Biztonsági fenyegetések megelőzése érdekében",
      "privacy.sharing.consent": "Az Ön kifejezett hozzájárulása esetén",
      "privacy.rights.title": "Az Ön jogai",
      "privacy.rights.access.title": "Hozzáférési jog",
      "privacy.rights.access.content": "Kérheti az Önről tárolt adatokhoz való hozzáférést.",
      "privacy.rights.correction.title": "Helyesbítéshez való jog",
      "privacy.rights.correction.content": "Helyesbíthetjük hibás vagy hiányos adatait.",
      "privacy.rights.deletion.title": "Törléshez való jog",
      "privacy.rights.deletion.content": "Bizonyos feltételek mellett törölhetjük adatait.",
      "privacy.rights.objection.title": "Tiltakozáshoz való jog",
      "privacy.rights.objection.content": "Tiltakozhat adatkezelési tevékenységeink ellen.",
      "privacy.contact.title": "Kapcsolat",
      "privacy.contact.intro": "Ha kérdése van ezzel az Adatvédelmi szabályzattal kapcsolatban, az alábbi csatornákon érhet el minket:",
      "nav.about": "Rólunk",
      "nav.contact": "Kapcsolat",
      "nav.privacy": "Adatvédelem",
      "nav.login": "Bejelentkezés",
      "nav.account": "Fiók",
      "nav.logout": "Kijelentkezés",
      "auth.brand.eyebrow": "GLOBÁLIS LEFEDETTSÉG",
      "auth.brand.title": "Már a landoláskor online – több mint 150 országban.",
      "auth.brand.subtitle": "Nincs fizikai SIM, nincs roamingszámla. Aktiválja eSIM-jét másodpercek alatt.",
      "auth.login.eyebrow": "BEJELENTKEZÉS",
      "auth.login.title": "Üdvözöljük újra",
      "auth.login.subtitle": "Kezelje eSIM-jeit, és fedezzen fel újakat.",
      "auth.signup.eyebrow": "ÚJ FIÓK",
      "auth.signup.title": "Hozza létre fiókját",
      "auth.signup.subtitle": "Néhány lépés az első eSIM-jéig.",
      "auth.field.identifier": "E-mail vagy telefonszám",
      "auth.field.identifier.ph": "on@email.com vagy +36…",
      "auth.field.email": "E-mail",
      "auth.field.email.ph": "on@email.com",
      "auth.field.fullName": "Teljes név",
      "auth.field.fullName.ph": "Az Ön teljes neve",
      "auth.field.password": "Jelszó",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "Bejelentkezés",
      "auth.action.loggingIn": "Bejelentkezés…",
      "auth.action.signup": "Fiók létrehozása",
      "auth.action.signingUp": "Fiók létrehozása…",
      "auth.toSignup.q": "Még nincs fiókja?",
      "auth.toSignup.link": "Regisztráció",
      "auth.toLogin.q": "Már van fiókja?",
      "auth.toLogin.link": "Bejelentkezés",
      "auth.password.show": "Jelszó megjelenítése",
      "auth.password.hide": "Jelszó elrejtése",
      "auth.terms.prefix": "A folytatással elfogadom a(z) ",
      "auth.terms.link": "Felhasználási feltételeket és az Adatvédelmi szabályzatot",
      "auth.terms.suffix": ".",
      "auth.error.required": "Kérjük, töltse ki a kötelező mezőket.",
      "auth.error.terms": "A folytatáshoz kérjük, fogadja el a feltételeket.",
      "verify.eyebrow": "E-MAIL-ELLENŐRZÉS",
      "verify.title": "Erősítse meg e-mail-címét",
      "verify.subtitle": "6 jegyű kódot küldtünk a(z) {{email}} címre. Az ellenőrzéshez adja meg a kódot.",
      "verify.code": "Ellenőrző kód",
      "verify.code.ph": "••••••",
      "verify.action": "Ellenőrzés",
      "verify.verifying": "Ellenőrzés…",
      "verify.resend": "Kód újraküldése",
      "verify.resendIn": "Újraküldés {{seconds}} mp múlva",
      "verify.resent": "Új kódot küldtünk.",
      "verify.skip": "Most kihagyom",
      "auth.forgot.link": "Elfelejtette jelszavát?",
      "forgot.eyebrow": "JELSZÓ-VISSZAÁLLÍTÁS",
      "forgot.email.title": "Jelszó visszaállítása",
      "forgot.email.subtitle": "Adja meg fiókja e-mail-címét, és küldünk egy 6 jegyű visszaállító kódot.",
      "forgot.email.action": "Kód küldése",
      "forgot.email.sending": "Küldés…",
      "forgot.reset.title": "Új jelszó megadása",
      "forgot.reset.subtitle": "Adja meg a(z) {{email}} címre küldött 6 jegyű kódot és új jelszavát.",
      "forgot.reset.action": "Jelszó frissítése",
      "forgot.reset.updating": "Frissítés…",
      "forgot.field.code": "Visszaállító kód",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "Új jelszó",
      "forgot.field.newPassword.ph": "Legalább 6 karakter",
      "forgot.resend": "Kód újraküldése",
      "forgot.resendIn": "Újraküldés {{seconds}} mp múlva",
      "forgot.resent": "Új kódot küldtünk.",
      "forgot.backToLogin": "Vissza a bejelentkezéshez",
      "forgot.changeEmail": "E-mail-cím módosítása",
      "forgot.help.noMail": "Ha nem érkezett meg a kód, nézze meg a levélszemét mappát, vagy ellenőrizze e-mail-címét.",
      "reset.RESET_CODE_SENT": "A kódot elküldtük. Kérjük, ellenőrizze e-mailjeit.",
      "reset.RATE_LIMITED": "Túl sok kérés. Kérjük, várjon egy kicsit, majd próbálja újra.",
      "reset.MAIL_SEND_FAILED": "Hiba történt. Kérjük, próbálja újra később.",
      "reset.RESET_CODE_VALID": "A kód ellenőrizve.",
      "reset.INVALID_RESET_CODE": "Érvénytelen kód. Kérjük, próbálja újra.",
      "reset.EXPIRED_RESET_CODE": "A kód lejárt. Kérjük, kérjen új kódot.",
      "reset.WEAK_PASSWORD": "A jelszónak legalább 6 karakter hosszúnak kell lennie.",
      "reset.PASSWORD_RESET_SUCCESS": "Jelszava frissült. Kérjük, jelentkezzen be az új jelszavával.",
      "reset.generic": "Hiba történt. Kérjük, próbálja újra.",
      "login.resetSuccess": "Jelszava frissült. Kérjük, jelentkezzen be az új jelszavával.",
      "store.nav.shop": "Áruház",
      "home.hero.title1": "Percek alatt csatlakozzon,",
      "home.hero.title2": "maradjon online határokon át.",
      "home.hero.subtitle": "Megbízható eSIM-csomagok több mint 190 országban. Nincs fizikai SIM, nincs roamingszámla.",
      "home.search.placeholder": "Hová utazik?",
      "home.tabs.local": "Helyi eSIM-ek",
      "home.tabs.regional": "Regionális eSIM-ek",
      "home.tabs.lifetime": "Élettartam eSIM-ek",
      "home.empty": "Nincs a keresésnek megfelelő találat.",
      "home.error.title": "A tartalom nem tölthető be",
      "home.error.retry": "Próbálja újra",
      "home.from": "kezdő ár",
      "home.popular": "Népszerű úti célok",
      "home.coverage": "190+ ország · azonnali aktiválás",
      "home.detail.soon": "Az ehhez a választáshoz tartozó csomagok hamarosan itt lesznek.",
      "home.detail.back": "Vissza az áruházba",
      "detail.plans": "Csomagok",
      "detail.count": "{{count}} csomag",
      "detail.validity": "{{days}} nap",
      "detail.validityLifetime": "Nem jár le",
      "detail.buy": "Vásárlás",
      "detail.empty": "Ehhez a választáshoz jelenleg nincs elérhető csomag.",
      "detail.checkoutSoon": "A fizetés hamarosan elérhető lesz.",
      "detail.loginToBuy": "A vásárláshoz kérjük, jelentkezzen be.",
      "detail.basicFeatures": "Alapfunkciók",
      "detail.dataAmount": "Adatmennyiség",
      "detail.validityLabel": "Érvényesség",
      "detail.coverageArea": "Lefedettség",
      "detail.activationNetworks": "Aktiválás és hálózatok",
      "detail.activationMethod": "Aktiválás módja",
      "detail.esimActivation": "eSIM – azonnal, QR-kóddal",
      "detail.supportedNetworks": "Támogatott hálózatok",
      "detail.description": "Leírás",
      "detail.price": "Ár",
      "authprompt.title": "A folytatáshoz jelentkezzen be",
      "authprompt.message": "eSIM vásárlásához jelentkezzen be fiókjába, vagy hozzon létre egyet másodpercek alatt.",
      "authprompt.close": "Bezárás",
      "footer.tagline": "Gyors, biztonságos és kedvező árú eSIM világszerte. Legyen online már a landoláskor.",
      "footer.explore": "Felfedezés",
      "footer.support": "Támogatás",
      "footer.legal": "Jogi információk",
      "footer.shop": "Áruház",
      "footer.help": "Gyakran ismételt kérdések",
      "footer.terms": "Felhasználási feltételek",
      "footer.rights": "© {{year}} Utkan eSIM. Minden jog fenntartva.",
      "footer.apps": "Töltse le az alkalmazást",
      "whatsapp.label": "Csevegés WhatsAppon",
      "whatsapp.message": "Helló, eSIM támogatási kérésem van.",
      "notfound.eyebrow": "NINCS TÉRERŐ",
      "notfound.title": "Ez az oldal nem érhető el",
      "notfound.message": "A keresett oldal elköltözött, vagy soha nem is létezett. Segítünk visszatérni a lefedettségbe.",
      "order.congrats": "Gratulálunk!",
      "order.message": "eSIM-je elkészült. Az alábbi QR-kóddal néhány lépésben beállíthatja.",
      "order.details": "Rendelés összesítése",
      "order.activation": "Aktiválás",
      "order.activationDesc": "Az eSIM beállításához olvassa be a QR-kódot a készülék kamerájával, vagy adja meg manuálisan az aktiváló kódot.",
      "order.qrTitle": "eSIM QR-kód",
      "order.manualLabel": "Aktiváló kód",
      "order.copy": "Másolás",
      "order.copied": "Másolva",
      "order.howTo": "Az aktiválás lépései",
      "order.step1": "Készülékén lépjen a Beállítások > Mobilhálózat / Mobiladat > eSIM hozzáadása menüpontba.",
      "order.step2": "Válassza a „QR-kód használata” lehetőséget, és olvassa be a fenti QR-kódot (vagy adja meg manuálisan az aktiváló kódot).",
      "order.step3": "A beállítás befejezése után kapcsolja be az eSIM-csomagot.",
      "order.step4": "Győződjön meg róla, hogy az adatroaming be van kapcsolva – és már csatlakozott is!",
      "order.cta": "Vissza a főoldalra",
      "checkout.title": "Fizetés",
      "checkout.summary": "Rendelés összesítése",
      "checkout.total": "Összesen",
      "checkout.eurNote": "A terhelés euróban (€) történik a PayPalon keresztül.",
      "checkout.processing": "Fizetés ellenőrzése…",
      "checkout.error": "A fizetés nem sikerült. Kérjük, próbálja újra.",
      "checkout.cancelled": "A fizetés megszakítva.",
      "account.title": "Fiókom",
      "account.tab.profile": "Profil",
      "account.tab.esims": "eSIM-jeim",
      "account.tab.security": "Biztonság",
      "account.profile.title": "Profiladatok",
      "account.field.phone": "Telefon",
      "account.field.phone.ph": "+36…",
      "account.memberSince": "Tagság kezdete",
      "account.save": "Mentés",
      "account.saving": "Mentés…",
      "account.saved": "Adatai frissültek.",
      "account.esims.title": "eSIM-jeim",
      "account.esims.empty": "Még nincs eSIM-je.",
      "account.esims.emptyCta": "Az áruház böngészése",
      "account.esims.data": "Adat",
      "account.esims.expires": "Lejárat",
      "account.esims.viewQr": "QR-kód megjelenítése",
      "account.esims.hideQr": "QR-kód elrejtése",
      "account.esims.active": "Aktív",
      "account.esims.passive": "Inaktív",
      "account.esims.noActive": "Nincs aktív eSIM-je.",
      "account.esims.noPassive": "Nincs inaktív eSIM-je.",
      "account.esims.readyHint": "Használatra kész – az érvényesség az első használattal kezdődik.",
      "account.esims.unavailableHint": "Az állapot jelenleg nem érhető el. Kérjük, próbálja újra később.",
      "esimStatus.active": "Aktív",
      "esimStatus.readyToUse": "Használatra kész",
      "esimStatus.inactive": "Inaktív",
      "esimStatus.unavailable": "Az állapot nem érhető el",
      "account.security.title": "Jelszó módosítása",
      "account.field.oldPassword": "Jelenlegi jelszó",
      "account.field.newPassword": "Új jelszó",
      "account.field.confirmPassword": "Új jelszó (ismét)",
      "account.changePassword": "Jelszó frissítése",
      "account.passwordChanged": "Jelszava frissült.",
      "account.error.passwordMismatch": "Az új jelszavak nem egyeznek.",
      "account.danger.title": "Fiókműveletek",
      "account.delete": "Fiók törlése",
      "account.delete.confirm": "Fiókja végleges törlésére készül. Ez a művelet nem vonható vissza.",
      "account.delete.confirmBtn": "Igen, törlöm",
      "account.cancel": "Mégse",
      "esimDetail.back": "Vissza",
      "esimDetail.dataUsage": "Adatforgalom",
      "esimDetail.left": "maradt",
      "esimDetail.leftData": "Fennmaradó adat",
      "esimDetail.usedData": "Felhasznált",
      "esimDetail.totalData": "Teljes adatmennyiség",
      "esimDetail.qrDesc": "Az eSIM beállításához olvassa be ezt a QR-kódot a készülék kamerájával.",
      "esimDetail.validity": "Érvényesség",
      "esimDetail.daysLeft": "{{days}} nap van hátra",
      "esimDetail.expired": "Lejárt",
      "esimDetail.notYetActive": "Még nem aktív",
      "esimDetail.leftDate": "Hátralévő idő",
      "esimDetail.activationDate": "Aktiválás dátuma",
      "esimDetail.endDate": "Lejárat dátuma",
      "esimDetail.technical": "Műszaki adatok",
      "esimDetail.activationCode": "Aktiváló kód (Android)",
      "esimDetail.smdp": "SM-DP+ cím (iOS)",
      "esimDetail.matchingId": "Egyeztető azonosító (iOS)",
      "esimDetail.support": "Technikai támogatás",
      "esimDetail.supportDesc": "Valami nem működik? Segítünk.",
      "esimDetail.email": "E-mail küldése",
      "guide.eyebrow": "eSIM-ÚTMUTATÓ",
      "guide.title": "Mi az eSIM, és hogyan állítható be?",
      "guide.intro.title": "Mi az eSIM?",
      "guide.intro.body": "Az eSIM egy készülékébe épített digitális SIM – nincs szükség fizikai kártyára. Olvasson be egy QR-kódot, és vonala másodpercek alatt beáll, így kártyacsere és roamingszámla nélkül internetezhet több mint 190 országban.",
      "guide.steps.title": "Az aktiválás lépései",
      "guide.devices.title": "Támogatott eszközök",
      "guide.devices.desc": "A működéshez készülékének támogatnia kell az eSIM-et. Keresse meg alább a márkáját.",
      "guide.faq.title": "Gyakran ismételt kérdések",
      "nav.guide": "eSIM-útmutató",
      "currency.label": "Pénznem",
      "staticPage.loading": "Oldal betöltése...",
      "staticPage.errorTitle": "Hiba történt",
      "staticPage.retry": "Próbálja újra",
      "staticPage.loadFailed": "Az oldal tartalma nem tölthető be. Kérjük, próbálja újra később.",
      "last.updated": "Utolsó frissítés: 2024. július 8.",
      "home.tabs.unlimited": "Korlátlan eSIM-ek",
      "detail.unlimited": "Korlátlan",
      "detail.unlimitedNote": "Ennél a csomagnál nincs adatkorlát – korlátlanul internetezhet a teljes érvényességi idő alatt.",
      "detail.notPriced": "Ez a csomag jelenleg nem vásárolható meg a weben.",
      "checkout.priceUpdated": "A csomag ára megváltozott. Kérjük, térjen vissza az áruházba, és válassza ki újra.",
      "order.pending.title": "eSIM-je előkészítés alatt",
      "order.pending.message": "A fizetés sikeres volt. A korlátlan csomagok aktiválása néhány percig is eltarthat.",
      "order.pending.waiting": "Rendelése állapotának ellenőrzése…",
      "order.pending.ready": "eSIM-je elkészült!",
      "order.pending.timeout": "Ez a vártnál tovább tart. A fizetése biztonságban van – eSIM-je megjelenik az „eSIM-jeim” alatt, amint elkészül.",
      "order.pending.cta": "Ugrás az eSIM-jeimhez",
      "account.esims.unlimited": "Korlátlan",
      "account.esims.unlimitedHint": "Korlátlan adatforgalom – ennél a csomagnál nincs adatkorlát.",
      "esimDetail.unlimitedData": "Ennél a csomagnál nincs adatkorlát; a hátralévő időt lent láthatja.",
      "del.eyebrow": "Fiók törlése",
      "del.title": "Fiókom törlése",
      "del.intro": "Itt véglegesen törölheti Utkan eSIM-fiókját és személyes adatait. Nincs szükség az alkalmazásra – csak jelentkezzen be a törölni kívánt fiókkal.",
      "del.deleted.title": "Törlésre kerülő adatok",
      "del.deleted.identity": "Vezeték- és keresztneve, e-mail-címe és telefonszáma",
      "del.deleted.credentials": "Jelszava és munkamenet-adatai",
      "del.deleted.codes": "E-mail-ellenőrző és jelszó-visszaállító kódjai",
      "del.deleted.esim": "eSIM-száma (MSISDN), QR-/aktiváló kódja és használati adatai",
      "del.kept.title": "Megőrzött adatok és ennek oka",
      "del.kept.orders": "A vásárlási nyilvántartásokat (rendelésszám, dátum, összeg, fizetési állapot) adózási és számviteli kötelezettségek teljesítése érdekében megőrizzük. Ezek nem tartalmaznak nevet, e-mail-címet vagy fizetési adatokat – csak egy Önhöz vissza nem köthető azonosítót.",
      "del.kept.period": "Megőrzési idő: 5 év (török adóeljárási törvény, 253. cikk).",
      "del.warn.title": "Törlés előtt",
      "del.warn.irreversible": "Ez a művelet nem vonható vissza.",
      "del.warn.esim": "Az aktív eSIM-ek továbbra is működnek a készülékén, de a QR-kódhoz és a fennmaradó adatkerethez már nem fér hozzá. Törlés előtt mentse el QR-kódját.",
      "del.warn.rejoin": "Ugyanazzal az e-mail-címmel újra regisztrálhat, de korábbi eSIM-jei nem jelennek meg az új fiókban.",
      "del.support": "Ha nem tud bejelentkezni, e-mailben is kérheti a törlést:",
      "del.login.title": "Először jelentkezzen be",
      "del.login.subtitle": "Adja meg e-mail-címét és jelszavát, hogy megerősíthessük: a fiók az Öné.",
      "del.login.action": "Bejelentkezés",
      "del.login.loading": "Bejelentkezés...",
      "del.forgot": "Elfelejtette jelszavát?",
      "del.confirm.title": "Biztos benne?",
      "del.confirm.subtitle": "A(z) {{email}} fiók és személyes adatai véglegesen törlődnek.",
      "del.confirm.field": "A megerősítéshez írja be újra e-mail-címét",
      "del.confirm.action": "Fiókom végleges törlése",
      "del.confirm.deleting": "Törlés...",
      "del.confirm.cancel": "Mégse",
      "del.done.title": "Fiókját töröltük",
      "del.done.body": "Személyes adatait véglegesen töröltük.",
      "del.done.retained": "Személyes adatait véglegesen töröltük. Jogi kötelezettségek miatt {{n}} vásárlási nyilvántartást megőriztünk; ezek nem köthetők Önhöz.",
      "del.done.home": "Vissza az áruházba",
      "del.error.required": "Kérjük, adja meg e-mail-címét és jelszavát.",
      "del.error.credentials": "Hibás e-mail-cím vagy jelszó.",
      "del.error.suspended": "Fiókját felfüggesztettük. Kérjük, forduljon az ügyfélszolgálathoz.",
      "del.error.session": "A munkamenet lejárt. Kérjük, jelentkezzen be újra.",
      "del.error.network": "Nem sikerült csatlakozni. Ellenőrizze internetkapcsolatát, és próbálja újra.",
      "del.error.generic": "Hiba történt. Kérjük, próbálja újra.",
      "footer.deleteAccount": "Fiók törlése",
      "home.tabs.voice": "Hívás + SMS eSIM-ek",
      "detail.voice": "Hívás + SMS",
      "detail.voiceNote": "Ez a csomag az adatforgalom mellett korlátlan hívást és SMS-t is tartalmaz – egyetlen eSIM az internethez és a hívásokhoz.",
      "detail.calls": "Hívások",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "Korlátlan hívás",
      "plan.unlimitedSms": "Korlátlan SMS",
      "plan.minutes": "{{n}} perc hívás",
      "plan.sms": "{{n}} SMS",
      "hercules.subtitle": "Korlátlan hívás, SMS és adatforgalom {{n}} európai országban – egyetlen eSIM-mel.",
      "hercules.coverageTitle": "Lefedett országok ({{n}})",
      "hercules.promo.desc": "Korlátlan hívás és SMS {{n}} országban, 20–100 GB adatforgalommal.",
      "hercules.promo.cta": "Csomag megtekintése",
      "loading": "Betöltés..."
    }
  },
  // Tayca
  th: {
    translation: {
      "language.title": "ภาษา",
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "อนาคตของการเชื่อมต่อดิจิทัล",
      "hero.description": "เราทลายทุกขีดจำกัดด้วยประสบการณ์การเชื่อมต่อดิจิทัลยุคใหม่",
      "hero.description2": "โซลูชัน eSIM ที่รวดเร็ว ปลอดภัย และราคาคุ้มค่าทั่วโลก",
      "features.countries": "150+ ประเทศ",
      "features.activation": "เปิดใช้งานทันที",
      "features.support": "บริการช่วยเหลือ 24/7",
      "countdown.title": "เว็บไซต์ของเราจะเปิดตัวเร็วๆ นี้!",
      "countdown.days": "วัน",
      "countdown.hours": "ชั่วโมง",
      "countdown.minutes": "นาที",
      "countdown.seconds": "วินาที",
      "countdown.launch": "เว็บไซต์ของเราเปิดให้บริการแล้ว!",
      "countdown.loading": "กำลังโหลด...",
      "apps.title": "แอปพลิเคชันมือถือของเรา",
      "apps.ios.label": "ดาวน์โหลดได้ที่",
      "apps.ios.name": "App Store",
      "apps.android.label": "ดาวน์โหลดได้ที่",
      "apps.android.name": "Google Play",
      "contact.title": "ติดต่อเราได้จนถึงวันเปิดตัว",
      "contact.whatsapp": "WhatsApp: +90 540 155 13 33",
      "contact.email": "อีเมล: info@utkanesim.com",
      "about.hero.title": "เกี่ยวกับ Utkan eSIM",
      "about.hero.description": "พาร์ทเนอร์ที่ไว้วางใจได้ที่ช่วยให้คุณเชื่อมต่อได้ทุกที่ที่คุณไป เราเชื่อว่าการเดินทางทั่วโลกควรราบรื่นและคุ้มค่า โดยไม่ต้องยุ่งยากกับซิมการ์ดแบบเดิมหรือค่าโรมมิ่งราคาแพง",
      "about.story.title": "เรื่องราวของเรา",
      "about.story.content": "ก่อตั้งขึ้นในปี 2024 โดยทีมนักเดินทางและผู้หลงใหลในเทคโนโลยี เป้าหมายของเราคือการปฏิวัติวิธีที่ผู้คนเชื่อมต่ออินเทอร์เน็ตในต่างประเทศ เรานำเสนอแพ็กเกจดาต้า eSIM คุณภาพสูงและเชื่อถือได้ในกว่า 190 ประเทศและภูมิภาค เพื่อให้คุณใช้อินเทอร์เน็ตความเร็วสูงได้ตั้งแต่วินาทีที่เครื่องลงจอด",
      "about.mission.title": "พันธกิจของเรา",
      "about.mission.content": "มอบการเชื่อมต่อที่ง่าย คุ้มค่า และใช้งานได้ทันทีให้กับนักเดินทางทั่วโลก เพื่อให้พวกเขาได้สำรวจ ทำงาน และติดต่อสื่อสารได้อย่างไร้ขีดจำกัด",
      "about.vision.title": "วิสัยทัศน์ของเรา",
      "about.vision.content": "เป็นแพลตฟอร์มระดับโลกชั้นนำด้านโซลูชันการเชื่อมต่อดิจิทัล ที่ทำให้โลกใกล้กันและเชื่อมต่อกันมากขึ้นสำหรับทุกคน",
      "about.features.title": "ทำไมต้องเลือกเรา?",
      "about.features.instant.title": "จัดส่งทันที",
      "about.features.instant.content": "รับ eSIM ผ่านคิวอาร์โค้ดทันทีหลังการซื้อ",
      "about.features.global.title": "ครอบคลุมทั่วโลก",
      "about.features.global.content": "แพ็กเกจดาต้าสำหรับกว่า 190 ประเทศและภูมิภาค",
      "about.features.affordable.title": "ราคาคุ้มค่า",
      "about.features.affordable.content": "ประหยัดค่าโรมมิ่งได้สูงสุดถึง 90%",
      "about.features.support.title": "บริการช่วยเหลือ 24/7",
      "about.features.support.content": "ทีมงานของเราพร้อมให้ความช่วยเหลือคุณเสมอ",
      "about.features.secure.title": "การเชื่อมต่อที่ปลอดภัย",
      "about.features.secure.content": "การเชื่อมต่อได้รับการปกป้องด้วยโปรโตคอลความปลอดภัยล่าสุด",
      "about.features.fast.title": "อินเทอร์เน็ตความเร็วสูง",
      "about.features.fast.content": "ใช้งานอินเทอร์เน็ตได้อย่างราบรื่นด้วยความเร็ว 4G/5G",
      "about.cta.title": "ร่วมเป็นส่วนหนึ่งของอนาคตการเชื่อมต่อดิจิทัล",
      "about.cta.content": "ขอบคุณที่เลือก Utkan eSIM ขอให้เดินทางอย่างมีความสุข!",
      "about.cta.whatsapp": "ติดต่อผ่าน WhatsApp",
      "about.cta.email": "ส่งอีเมล",
      "contact.hero.title": "ติดต่อเรา",
      "contact.hero.description": "เราพร้อมช่วยเหลือ! ไม่ว่าคุณจะมีคำถามเกี่ยวกับ eSIM ของเรา ต้องการความช่วยเหลือด้านเทคนิค หรือเพียงแค่อยากให้ข้อเสนอแนะ เรายินดีรับฟังเสมอ",
      "contact.info.title": "ข้อมูลการติดต่อ",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "ช่วยเหลือรวดเร็วตลอด 24/7",
      "contact.email.title": "อีเมล",
      "contact.email.subtitle": "ติดต่อทั่วไป",
      "contact.support.title": "ฝ่ายสนับสนุนด้านเทคนิค",
      "contact.support.subtitle": "ปัญหาเกี่ยวกับ eSIM",
      "contact.business.title": "ความร่วมมือทางธุรกิจ",
      "contact.business.subtitle": "ติดต่อองค์กร",
      "contact.hours.title": "เวลาทำการฝ่ายช่วยเหลือ",
      "contact.hours.subtitle": "ฝ่ายสนับสนุนด้านเทคนิค 24/7",
      "contact.hours.detail": "จันทร์ - อาทิตย์: 00:00 - 23:59",
      "contact.form.title": "ส่งข้อความถึงเรา",
      "contact.form.name": "ชื่อของคุณ",
      "contact.form.name.placeholder": "กรอกชื่อและนามสกุล",
      "contact.form.email": "อีเมลของคุณ",
      "contact.form.email.placeholder": "example@email.com",
      "contact.form.subject": "หัวข้อ",
      "contact.form.subject.placeholder": "เลือกหัวข้อ",
      "contact.form.subject.general": "ข้อมูลทั่วไป",
      "contact.form.subject.technical": "ฝ่ายสนับสนุนด้านเทคนิค",
      "contact.form.subject.billing": "คำถามเกี่ยวกับการเรียกเก็บเงิน",
      "contact.form.subject.partnership": "ความร่วมมือทางธุรกิจ",
      "contact.form.subject.feedback": "ข้อเสนอแนะ",
      "contact.form.message": "ข้อความของคุณ",
      "contact.form.message.placeholder": "เขียนข้อความของคุณที่นี่...",
      "contact.form.submit": "ส่งข้อความ",
      "contact.faq.title": "คำถามที่พบบ่อย",
      "contact.faq.esim.title": "eSIM ทำงานอย่างไร?",
      "contact.faq.esim.content": "eSIM คือซิมการ์ดดิจิทัลที่ทำงานในโทรศัพท์ของคุณโดยไม่ต้องใช้ซิมการ์ดแบบเดิม และเปิดใช้งานได้ทันทีผ่านคิวอาร์โค้ด",
      "contact.faq.phones.title": "โทรศัพท์รุ่นใดบ้างที่รองรับ eSIM?",
      "contact.faq.phones.content": "iPhone XS ขึ้นไป, Samsung Galaxy S20 ขึ้นไป และ Google Pixel 3 ขึ้นไป รองรับ eSIM",
      "contact.faq.validity.title": "แพ็กเกจดาต้าของฉันใช้ได้นานเท่าไร?",
      "contact.faq.validity.content": "ระยะเวลาใช้งานของแพ็กเกจอยู่ระหว่าง 1-30 วัน ขึ้นอยู่กับแพ็กเกจที่คุณเลือก",
      "contact.faq.payment.title": "ฉันชำระเงินได้อย่างไร?",
      "contact.faq.payment.content": "คุณสามารถชำระเงินอย่างปลอดภัยด้วยบัตรเครดิต, PayPal และการโอนเงินผ่านธนาคาร",
      "privacy.hero.title": "นโยบายความเป็นส่วนตัว",
      "privacy.hero.description": "ความปลอดภัยของข้อมูลส่วนบุคคลของคุณมีความสำคัญอย่างยิ่งสำหรับเรา นโยบายนี้อธิบายถึงวิธีการเก็บรวบรวม ใช้ และปกป้องข้อมูลของคุณ",
      "privacy.overview.title": "ภาพรวม",
      "privacy.overview.content": "นโยบายความเป็นส่วนตัวนี้อธิบายนโยบายและขั้นตอนของเราเกี่ยวกับการเก็บรวบรวม การใช้ และการเปิดเผยข้อมูลของคุณเมื่อคุณใช้บริการ รวมถึงแจ้งให้คุณทราบถึงสิทธิความเป็นส่วนตัวของคุณและวิธีที่กฎหมายคุ้มครองคุณ",
      "privacy.data.title": "ข้อมูลที่เราเก็บรวบรวม",
      "privacy.data.personal.title": "ข้อมูลส่วนบุคคล",
      "privacy.data.personal.name": "ชื่อและนามสกุล",
      "privacy.data.personal.email": "ที่อยู่อีเมล",
      "privacy.data.personal.phone": "หมายเลขโทรศัพท์",
      "privacy.data.personal.payment": "ข้อมูลการชำระเงิน",
      "privacy.data.usage.title": "ข้อมูลการใช้งาน",
      "privacy.data.usage.ip": "ที่อยู่ IP",
      "privacy.data.usage.browser": "ประเภทเบราว์เซอร์",
      "privacy.data.usage.device": "ข้อมูลอุปกรณ์",
      "privacy.data.usage.stats": "สถิติการใช้งาน",
      "privacy.security.title": "ความปลอดภัยของข้อมูล",
      "privacy.security.ssl.title": "การเข้ารหัส SSL",
      "privacy.security.ssl.content": "การรับส่งข้อมูลทั้งหมดได้รับการปกป้องด้วยการเข้ารหัส SSL 256 บิต",
      "privacy.security.servers.title": "เซิร์ฟเวอร์ที่ปลอดภัย",
      "privacy.security.servers.content": "ข้อมูลของคุณจัดเก็บบนเซิร์ฟเวอร์ที่ปลอดภัยซึ่งได้รับการรับรอง ISO 27001",
      "privacy.security.access.title": "การควบคุมการเข้าถึง",
      "privacy.security.access.content": "เฉพาะบุคลากรที่ได้รับอนุญาตเท่านั้นที่สามารถเข้าถึงข้อมูลของคุณได้",
      "privacy.usage.title": "การใช้ข้อมูล",
      "privacy.usage.intro": "เราใช้ข้อมูลที่เก็บรวบรวมเพื่อวัตถุประสงค์ดังต่อไปนี้:",
      "privacy.usage.service.title": "การให้บริการ",
      "privacy.usage.service.content": "เพื่อให้บริการและจัดการบริการ eSIM ของเราแก่คุณ",
      "privacy.usage.support.title": "บริการลูกค้า",
      "privacy.usage.support.content": "เพื่อให้การสนับสนุนด้านเทคนิคและบริการลูกค้า",
      "privacy.usage.security.title": "ความปลอดภัย",
      "privacy.usage.security.content": "เพื่อปกป้องบัญชีของคุณและบริการของเรา",
      "privacy.usage.improvement.title": "การปรับปรุง",
      "privacy.usage.improvement.content": "เพื่อปรับปรุงบริการของเราและเพิ่มฟีเจอร์ใหม่",
      "privacy.sharing.title": "การแบ่งปันข้อมูล",
      "privacy.sharing.intro": "เราไม่แบ่งปันข้อมูลส่วนบุคคลของคุณกับบุคคลภายนอก แต่อาจจำเป็นต้องแบ่งปันในกรณีต่อไปนี้:",
      "privacy.sharing.legal": "กรณีมีข้อผูกพันทางกฎหมาย",
      "privacy.sharing.providers": "กับผู้ให้บริการของเรา (เช่น ผู้ประมวลผลการชำระเงิน)",
      "privacy.sharing.threats": "เพื่อป้องกันภัยคุกคามด้านความปลอดภัย",
      "privacy.sharing.consent": "เมื่อคุณให้ความยินยอมอย่างชัดแจ้ง",
      "privacy.rights.title": "สิทธิของคุณ",
      "privacy.rights.access.title": "สิทธิในการเข้าถึง",
      "privacy.rights.access.content": "คุณสามารถขอเข้าถึงข้อมูลที่เราจัดเก็บเกี่ยวกับคุณได้",
      "privacy.rights.correction.title": "สิทธิในการแก้ไข",
      "privacy.rights.correction.content": "เราสามารถแก้ไขข้อมูลของคุณที่ไม่ถูกต้องหรือไม่ครบถ้วนได้",
      "privacy.rights.deletion.title": "สิทธิในการลบ",
      "privacy.rights.deletion.content": "เราสามารถลบข้อมูลของคุณได้ภายใต้เงื่อนไขบางประการ",
      "privacy.rights.objection.title": "สิทธิในการคัดค้าน",
      "privacy.rights.objection.content": "คุณสามารถคัดค้านกิจกรรมการประมวลผลข้อมูลของเราได้",
      "privacy.contact.title": "ติดต่อ",
      "privacy.contact.intro": "หากคุณมีคำถามเกี่ยวกับนโยบายความเป็นส่วนตัวนี้ คุณสามารถติดต่อเราผ่านช่องทางต่อไปนี้:",
      "nav.about": "เกี่ยวกับเรา",
      "nav.contact": "ติดต่อ",
      "nav.privacy": "ความเป็นส่วนตัว",
      "nav.login": "เข้าสู่ระบบ",
      "nav.account": "บัญชี",
      "nav.logout": "ออกจากระบบ",
      "auth.brand.eyebrow": "ครอบคลุมทั่วโลก",
      "auth.brand.title": "ออนไลน์ได้ทันทีที่ลงจอด ในกว่า 150 ประเทศ",
      "auth.brand.subtitle": "ไม่ต้องใช้ซิมการ์ด ไม่มีค่าโรมมิ่ง เปิดใช้งาน eSIM ได้ในไม่กี่วินาที",
      "auth.login.eyebrow": "เข้าสู่ระบบ",
      "auth.login.title": "ยินดีต้อนรับกลับมา",
      "auth.login.subtitle": "จัดการ eSIM ของคุณและค้นหา eSIM ใหม่ๆ",
      "auth.signup.eyebrow": "บัญชีใหม่",
      "auth.signup.title": "สร้างบัญชีของคุณ",
      "auth.signup.subtitle": "อีกไม่กี่ขั้นตอนสู่ eSIM แรกของคุณ",
      "auth.field.identifier": "อีเมลหรือโทรศัพท์",
      "auth.field.identifier.ph": "you@email.com หรือ +66…",
      "auth.field.email": "อีเมล",
      "auth.field.email.ph": "you@email.com",
      "auth.field.fullName": "ชื่อ-นามสกุล",
      "auth.field.fullName.ph": "ชื่อ-นามสกุลของคุณ",
      "auth.field.password": "รหัสผ่าน",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "เข้าสู่ระบบ",
      "auth.action.loggingIn": "กำลังเข้าสู่ระบบ…",
      "auth.action.signup": "สร้างบัญชี",
      "auth.action.signingUp": "กำลังสร้างบัญชี…",
      "auth.toSignup.q": "ยังไม่มีบัญชีใช่ไหม?",
      "auth.toSignup.link": "สมัครสมาชิก",
      "auth.toLogin.q": "มีบัญชีอยู่แล้วใช่ไหม?",
      "auth.toLogin.link": "เข้าสู่ระบบ",
      "auth.password.show": "แสดงรหัสผ่าน",
      "auth.password.hide": "ซ่อนรหัสผ่าน",
      "auth.terms.prefix": "เมื่อดำเนินการต่อ ฉันยอมรับ",
      "auth.terms.link": "ข้อกำหนดการใช้งานและนโยบายความเป็นส่วนตัว",
      "auth.terms.suffix": "",
      "auth.error.required": "กรุณากรอกข้อมูลในช่องที่จำเป็น",
      "auth.error.terms": "กรุณายอมรับข้อกำหนดเพื่อดำเนินการต่อ",
      "verify.eyebrow": "ยืนยันอีเมล",
      "verify.title": "ยืนยันอีเมลของคุณ",
      "verify.subtitle": "เราได้ส่งรหัส 6 หลักไปที่ {{email}} แล้ว กรุณากรอกรหัสเพื่อยืนยัน",
      "verify.code": "รหัสยืนยัน",
      "verify.code.ph": "••••••",
      "verify.action": "ยืนยัน",
      "verify.verifying": "กำลังยืนยัน…",
      "verify.resend": "ส่งรหัสอีกครั้ง",
      "verify.resendIn": "ส่งอีกครั้งได้ใน {{seconds}} วินาที",
      "verify.resent": "ส่งรหัสใหม่แล้ว",
      "verify.skip": "ข้ามไปก่อน",
      "auth.forgot.link": "ลืมรหัสผ่านใช่ไหม?",
      "forgot.eyebrow": "รีเซ็ตรหัสผ่าน",
      "forgot.email.title": "รีเซ็ตรหัสผ่านของคุณ",
      "forgot.email.subtitle": "กรอกอีเมลบัญชีของคุณ แล้วเราจะส่งรหัสรีเซ็ต 6 หลักให้คุณ",
      "forgot.email.action": "ส่งรหัส",
      "forgot.email.sending": "กำลังส่ง…",
      "forgot.reset.title": "ตั้งรหัสผ่านใหม่",
      "forgot.reset.subtitle": "กรอกรหัส 6 หลักที่เราส่งไปที่ {{email}} และรหัสผ่านใหม่ของคุณ",
      "forgot.reset.action": "อัปเดตรหัสผ่าน",
      "forgot.reset.updating": "กำลังอัปเดต…",
      "forgot.field.code": "รหัสรีเซ็ต",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "รหัสผ่านใหม่",
      "forgot.field.newPassword.ph": "อย่างน้อย 6 ตัวอักษร",
      "forgot.resend": "ส่งรหัสอีกครั้ง",
      "forgot.resendIn": "ส่งอีกครั้งได้ใน {{seconds}} วินาที",
      "forgot.resent": "ส่งรหัสใหม่แล้ว",
      "forgot.backToLogin": "กลับไปหน้าเข้าสู่ระบบ",
      "forgot.changeEmail": "เปลี่ยนอีเมล",
      "forgot.help.noMail": "หากไม่ได้รับรหัส โปรดตรวจสอบโฟลเดอร์สแปมหรือยืนยันที่อยู่อีเมลของคุณ",
      "reset.RESET_CODE_SENT": "ส่งรหัสแล้ว กรุณาตรวจสอบอีเมลของคุณ",
      "reset.RATE_LIMITED": "มีคำขอมากเกินไป กรุณารอสักครู่แล้วลองอีกครั้ง",
      "reset.MAIL_SEND_FAILED": "เกิดข้อผิดพลาด กรุณาลองอีกครั้งในภายหลัง",
      "reset.RESET_CODE_VALID": "ยืนยันรหัสแล้ว",
      "reset.INVALID_RESET_CODE": "รหัสไม่ถูกต้อง กรุณาลองอีกครั้ง",
      "reset.EXPIRED_RESET_CODE": "รหัสหมดอายุแล้ว กรุณาขอรหัสใหม่",
      "reset.WEAK_PASSWORD": "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร",
      "reset.PASSWORD_RESET_SUCCESS": "อัปเดตรหัสผ่านของคุณแล้ว กรุณาเข้าสู่ระบบด้วยรหัสผ่านใหม่",
      "reset.generic": "เกิดข้อผิดพลาด กรุณาลองอีกครั้ง",
      "login.resetSuccess": "อัปเดตรหัสผ่านของคุณแล้ว กรุณาเข้าสู่ระบบด้วยรหัสผ่านใหม่",
      "store.nav.shop": "ร้านค้า",
      "home.hero.title1": "เชื่อมต่อได้ในไม่กี่นาที",
      "home.hero.title2": "ออนไลน์ได้ทุกที่ไร้พรมแดน",
      "home.hero.subtitle": "แพ็กเกจ eSIM ที่เชื่อถือได้ ใช้งานได้ในกว่า 190 ประเทศ ไม่ต้องใช้ซิมการ์ด ไม่มีค่าโรมมิ่ง",
      "home.search.placeholder": "คุณกำลังจะเดินทางไปที่ไหน?",
      "home.tabs.local": "eSIM ท้องถิ่น",
      "home.tabs.regional": "eSIM ระดับภูมิภาค",
      "home.tabs.lifetime": "eSIM ตลอดชีพ",
      "home.empty": "ไม่พบผลลัพธ์ที่ตรงกับการค้นหาของคุณ",
      "home.error.title": "ไม่สามารถโหลดเนื้อหาได้",
      "home.error.retry": "ลองอีกครั้ง",
      "home.from": "เริ่มต้น",
      "home.popular": "จุดหมายยอดนิยม",
      "home.coverage": "190+ ประเทศ · เปิดใช้งานทันที",
      "home.detail.soon": "แพ็กเกจสำหรับตัวเลือกนี้จะแสดงที่นี่เร็วๆ นี้",
      "home.detail.back": "กลับไปที่ร้านค้า",
      "detail.plans": "แพ็กเกจ",
      "detail.count": "{{count}} แพ็กเกจ",
      "detail.validity": "{{days}} วัน",
      "detail.validityLifetime": "ไม่มีวันหมดอายุ",
      "detail.buy": "ซื้อ",
      "detail.empty": "ขณะนี้ยังไม่มีแพ็กเกจสำหรับตัวเลือกนี้",
      "detail.checkoutSoon": "ระบบชำระเงินจะเปิดให้บริการเร็วๆ นี้",
      "detail.loginToBuy": "กรุณาเข้าสู่ระบบเพื่อซื้อ",
      "detail.basicFeatures": "คุณสมบัติพื้นฐาน",
      "detail.dataAmount": "ปริมาณดาต้า",
      "detail.validityLabel": "ระยะเวลาใช้งาน",
      "detail.coverageArea": "พื้นที่ครอบคลุม",
      "detail.activationNetworks": "การเปิดใช้งานและเครือข่าย",
      "detail.activationMethod": "วิธีเปิดใช้งาน",
      "detail.esimActivation": "eSIM — เปิดใช้งานทันทีผ่านคิวอาร์โค้ด",
      "detail.supportedNetworks": "เครือข่ายที่รองรับ",
      "detail.description": "รายละเอียด",
      "detail.price": "ราคา",
      "authprompt.title": "เข้าสู่ระบบเพื่อดำเนินการต่อ",
      "authprompt.message": "เข้าสู่ระบบบัญชีของคุณเพื่อซื้อ eSIM หรือสร้างบัญชีใหม่ได้ในไม่กี่วินาที",
      "authprompt.close": "ปิด",
      "footer.tagline": "eSIM ที่รวดเร็ว ปลอดภัย และคุ้มค่าทั่วโลก ออนไลน์ได้ทันทีที่ลงจอด",
      "footer.explore": "สำรวจ",
      "footer.support": "ช่วยเหลือ",
      "footer.legal": "กฎหมาย",
      "footer.shop": "ร้านค้า",
      "footer.help": "คำถามที่พบบ่อย",
      "footer.terms": "ข้อกำหนดการใช้งาน",
      "footer.rights": "© {{year}} Utkan eSIM สงวนลิขสิทธิ์",
      "footer.apps": "ดาวน์โหลดแอป",
      "whatsapp.label": "แชทผ่าน WhatsApp",
      "whatsapp.message": "สวัสดีครับ/ค่ะ ฉันต้องการความช่วยเหลือเกี่ยวกับ eSIM",
      "notfound.eyebrow": "ไม่มีสัญญาณ",
      "notfound.title": "ไม่สามารถเข้าถึงหน้านี้ได้",
      "notfound.message": "หน้าที่คุณกำลังค้นหาถูกย้ายหรือไม่มีอยู่ เราจะพาคุณกลับเข้าสู่พื้นที่ให้บริการ",
      "order.congrats": "ยินดีด้วย!",
      "order.message": "eSIM ของคุณพร้อมแล้ว ตั้งค่าได้ในไม่กี่ขั้นตอนด้วยคิวอาร์โค้ดด้านล่าง",
      "order.details": "สรุปคำสั่งซื้อ",
      "order.activation": "การเปิดใช้งาน",
      "order.activationDesc": "ในการตั้งค่า eSIM ให้สแกนคิวอาร์โค้ดด้วยกล้องของอุปกรณ์ หรือกรอกรหัสเปิดใช้งานด้วยตนเอง",
      "order.qrTitle": "คิวอาร์โค้ด eSIM",
      "order.manualLabel": "รหัสเปิดใช้งาน",
      "order.copy": "คัดลอก",
      "order.copied": "คัดลอกแล้ว",
      "order.howTo": "วิธีเปิดใช้งาน",
      "order.step1": "บนอุปกรณ์ของคุณ ไปที่ การตั้งค่า > เซลลูลาร์ / ข้อมูลมือถือ > เพิ่ม eSIM",
      "order.step2": "เลือก “ใช้คิวอาร์โค้ด” แล้วสแกน QR ด้านบน (หรือกรอกรหัสเปิดใช้งานด้วยตนเอง)",
      "order.step3": "เมื่อการตั้งค่าเสร็จสิ้น ให้เปิดใช้แพ็กเกจ eSIM",
      "order.step4": "ตรวจสอบให้แน่ใจว่าเปิดโรมมิ่งข้อมูลแล้ว — คุณเชื่อมต่อได้แล้ว!",
      "order.cta": "กลับสู่หน้าแรก",
      "checkout.title": "ชำระเงิน",
      "checkout.summary": "สรุปคำสั่งซื้อ",
      "checkout.total": "ยอดรวม",
      "checkout.eurNote": "คุณจะถูกเรียกเก็บเงินเป็นสกุลยูโร (€) ผ่าน PayPal",
      "checkout.processing": "กำลังตรวจสอบการชำระเงินของคุณ…",
      "checkout.error": "ไม่สามารถชำระเงินได้ กรุณาลองอีกครั้ง",
      "checkout.cancelled": "ยกเลิกการชำระเงินแล้ว",
      "account.title": "บัญชีของฉัน",
      "account.tab.profile": "โปรไฟล์",
      "account.tab.esims": "eSIM ของฉัน",
      "account.tab.security": "ความปลอดภัย",
      "account.profile.title": "ข้อมูลโปรไฟล์",
      "account.field.phone": "โทรศัพท์",
      "account.field.phone.ph": "+66…",
      "account.memberSince": "เป็นสมาชิกตั้งแต่",
      "account.save": "บันทึก",
      "account.saving": "กำลังบันทึก…",
      "account.saved": "อัปเดตข้อมูลของคุณแล้ว",
      "account.esims.title": "eSIM ของฉัน",
      "account.esims.empty": "คุณยังไม่มี eSIM",
      "account.esims.emptyCta": "เลือกชมร้านค้า",
      "account.esims.data": "ดาต้า",
      "account.esims.expires": "หมดอายุ",
      "account.esims.viewQr": "แสดงคิวอาร์โค้ด",
      "account.esims.hideQr": "ซ่อนคิวอาร์โค้ด",
      "account.esims.active": "ใช้งานอยู่",
      "account.esims.passive": "ไม่ได้ใช้งาน",
      "account.esims.noActive": "คุณไม่มี eSIM ที่ใช้งานอยู่",
      "account.esims.noPassive": "คุณไม่มี eSIM ที่ไม่ได้ใช้งาน",
      "account.esims.readyHint": "พร้อมใช้งาน — ระยะเวลาใช้งานจะเริ่มนับเมื่อใช้งานครั้งแรก",
      "account.esims.unavailableHint": "ไม่สามารถแสดงสถานะได้ในขณะนี้ กรุณาลองอีกครั้งในภายหลัง",
      "esimStatus.active": "ใช้งานอยู่",
      "esimStatus.readyToUse": "พร้อมใช้งาน",
      "esimStatus.inactive": "ไม่ได้ใช้งาน",
      "esimStatus.unavailable": "ไม่สามารถแสดงสถานะได้",
      "account.security.title": "เปลี่ยนรหัสผ่าน",
      "account.field.oldPassword": "รหัสผ่านปัจจุบัน",
      "account.field.newPassword": "รหัสผ่านใหม่",
      "account.field.confirmPassword": "รหัสผ่านใหม่ (อีกครั้ง)",
      "account.changePassword": "อัปเดตรหัสผ่าน",
      "account.passwordChanged": "อัปเดตรหัสผ่านของคุณแล้ว",
      "account.error.passwordMismatch": "รหัสผ่านใหม่ไม่ตรงกัน",
      "account.danger.title": "การจัดการบัญชี",
      "account.delete": "ลบบัญชี",
      "account.delete.confirm": "คุณกำลังจะลบบัญชีของคุณอย่างถาวร การดำเนินการนี้ไม่สามารถย้อนกลับได้",
      "account.delete.confirmBtn": "ใช่ ลบเลย",
      "account.cancel": "ยกเลิก",
      "esimDetail.back": "กลับ",
      "esimDetail.dataUsage": "การใช้ดาต้า",
      "esimDetail.left": "คงเหลือ",
      "esimDetail.leftData": "ดาต้าคงเหลือ",
      "esimDetail.usedData": "ใช้ไปแล้ว",
      "esimDetail.totalData": "ดาต้าทั้งหมด",
      "esimDetail.qrDesc": "สแกนคิวอาร์โค้ดนี้ด้วยกล้องของอุปกรณ์เพื่อตั้งค่า eSIM",
      "esimDetail.validity": "ระยะเวลาใช้งาน",
      "esimDetail.daysLeft": "เหลืออีก {{days}} วัน",
      "esimDetail.expired": "หมดอายุแล้ว",
      "esimDetail.notYetActive": "ยังไม่เปิดใช้งาน",
      "esimDetail.leftDate": "เวลาคงเหลือ",
      "esimDetail.activationDate": "วันที่เปิดใช้งาน",
      "esimDetail.endDate": "วันที่สิ้นสุด",
      "esimDetail.technical": "รายละเอียดทางเทคนิค",
      "esimDetail.activationCode": "รหัสเปิดใช้งาน (Android)",
      "esimDetail.smdp": "ที่อยู่ SM-DP+ (iOS)",
      "esimDetail.matchingId": "Matching ID (iOS)",
      "esimDetail.support": "ฝ่ายสนับสนุนด้านเทคนิค",
      "esimDetail.supportDesc": "มีปัญหาใช่ไหม? เราพร้อมช่วยเหลือ",
      "esimDetail.email": "ส่งอีเมล",
      "guide.eyebrow": "คู่มือ eSIM",
      "guide.title": "eSIM คืออะไรและตั้งค่าอย่างไร?",
      "guide.intro.title": "eSIM คืออะไร?",
      "guide.intro.body": "eSIM คือซิมดิจิทัลที่ฝังอยู่ในอุปกรณ์ของคุณ — ไม่ต้องใช้ซิมการ์ด เพียงสแกนคิวอาร์โค้ด หมายเลขของคุณก็พร้อมใช้งานในไม่กี่วินาที ให้คุณออนไลน์ได้ในกว่า 190 ประเทศ โดยไม่ต้องเปลี่ยนซิมและไม่มีค่าโรมมิ่ง",
      "guide.steps.title": "วิธีเปิดใช้งาน",
      "guide.devices.title": "อุปกรณ์ที่รองรับ",
      "guide.devices.desc": "อุปกรณ์ของคุณต้องรองรับ eSIM จึงจะใช้งานได้ ค้นหายี่ห้อของคุณด้านล่าง",
      "guide.faq.title": "คำถามที่พบบ่อย",
      "nav.guide": "คู่มือ eSIM",
      "currency.label": "สกุลเงิน",
      "staticPage.loading": "กำลังโหลดหน้า...",
      "staticPage.errorTitle": "เกิดข้อผิดพลาด",
      "staticPage.retry": "ลองอีกครั้ง",
      "staticPage.loadFailed": "ไม่สามารถโหลดเนื้อหาหน้าได้ กรุณาลองอีกครั้งในภายหลัง",
      "last.updated": "อัปเดตล่าสุด: 8 กรกฎาคม 2024",
      "home.tabs.unlimited": "eSIM ไม่จำกัด",
      "detail.unlimited": "ไม่จำกัด",
      "detail.unlimitedNote": "แพ็กเกจนี้ไม่จำกัดปริมาณดาต้า — ใช้อินเทอร์เน็ตได้ไม่จำกัดตลอดระยะเวลาใช้งาน",
      "detail.notPriced": "ขณะนี้แพ็กเกจนี้ไม่สามารถซื้อผ่านเว็บได้",
      "checkout.priceUpdated": "ราคาของแพ็กเกจนี้มีการเปลี่ยนแปลง กรุณากลับไปที่ร้านค้าแล้วเลือกใหม่อีกครั้ง",
      "order.pending.title": "กำลังเตรียม eSIM ของคุณ",
      "order.pending.message": "ชำระเงินเรียบร้อยแล้ว แพ็กเกจไม่จำกัดอาจใช้เวลาเปิดใช้งานสักครู่",
      "order.pending.waiting": "กำลังตรวจสอบสถานะคำสั่งซื้อของคุณ…",
      "order.pending.ready": "eSIM ของคุณพร้อมแล้ว!",
      "order.pending.timeout": "ใช้เวลานานกว่าที่คาดไว้ การชำระเงินของคุณปลอดภัย — eSIM จะปรากฏใน “eSIM ของฉัน” ทันทีที่พร้อม",
      "order.pending.cta": "ไปที่ eSIM ของฉัน",
      "account.esims.unlimited": "ไม่จำกัด",
      "account.esims.unlimitedHint": "ดาต้าไม่จำกัด — แพ็กเกจนี้ไม่จำกัดปริมาณดาต้า",
      "esimDetail.unlimitedData": "แพ็กเกจนี้ไม่จำกัดปริมาณดาต้า ดูเวลาคงเหลือได้ด้านล่าง",
      "del.eyebrow": "การลบบัญชี",
      "del.title": "ลบบัญชีของฉัน",
      "del.intro": "คุณสามารถลบบัญชี Utkan eSIM และข้อมูลส่วนบุคคลของคุณอย่างถาวรได้ที่นี่ ไม่จำเป็นต้องติดตั้งแอป — เพียงเข้าสู่ระบบด้วยบัญชีที่ต้องการลบ",
      "del.deleted.title": "ข้อมูลที่จะถูกลบ",
      "del.deleted.identity": "ชื่อ นามสกุล ที่อยู่อีเมล และหมายเลขโทรศัพท์ของคุณ",
      "del.deleted.credentials": "รหัสผ่านและข้อมูลเซสชันของคุณ",
      "del.deleted.codes": "รหัสยืนยันอีเมลและรหัสรีเซ็ตรหัสผ่านของคุณ",
      "del.deleted.esim": "หมายเลข eSIM (MSISDN), รหัส QR/รหัสเปิดใช้งาน และข้อมูลการใช้งานของคุณ",
      "del.kept.title": "ข้อมูลที่เราเก็บไว้และเหตุผล",
      "del.kept.orders": "บันทึกการซื้อ (หมายเลขคำสั่งซื้อ วันที่ จำนวนเงิน สถานะการชำระเงิน) จะถูกเก็บไว้เพื่อปฏิบัติตามข้อผูกพันด้านภาษีและบัญชี โดยไม่มีชื่อ ที่อยู่อีเมล หรือรายละเอียดการชำระเงิน — มีเพียงรหัสระบุที่ไม่สามารถเชื่อมโยงกลับมาถึงคุณได้",
      "del.kept.period": "ระยะเวลาการเก็บรักษา: 5 ปี (กฎหมายวิธีพิจารณาภาษีของตุรกี มาตรา 253)",
      "del.warn.title": "ก่อนลบบัญชี",
      "del.warn.irreversible": "การดำเนินการนี้ไม่สามารถย้อนกลับได้",
      "del.warn.esim": "eSIM ที่ใช้งานอยู่จะยังทำงานบนอุปกรณ์ของคุณ แต่คุณจะไม่สามารถเข้าถึงคิวอาร์โค้ดหรือดาต้าคงเหลือได้อีก กรุณาบันทึกคิวอาร์โค้ดก่อนลบบัญชี",
      "del.warn.rejoin": "คุณสามารถสมัครใหม่ด้วยอีเมลเดิมได้ แต่ eSIM ก่อนหน้าจะไม่ปรากฏในบัญชีใหม่",
      "del.support": "หากคุณไม่สามารถเข้าสู่ระบบได้ คุณสามารถขอลบบัญชีทางอีเมลได้เช่นกัน:",
      "del.login.title": "เข้าสู่ระบบก่อน",
      "del.login.subtitle": "กรอกอีเมลและรหัสผ่านเพื่อให้เรายืนยันว่าบัญชีนี้เป็นของคุณ",
      "del.login.action": "เข้าสู่ระบบ",
      "del.login.loading": "กำลังเข้าสู่ระบบ...",
      "del.forgot": "ลืมรหัสผ่านใช่ไหม?",
      "del.confirm.title": "คุณแน่ใจหรือไม่?",
      "del.confirm.subtitle": "บัญชี {{email}} และข้อมูลส่วนบุคคลของคุณจะถูกลบอย่างถาวร",
      "del.confirm.field": "พิมพ์ที่อยู่อีเมลของคุณอีกครั้งเพื่อยืนยัน",
      "del.confirm.action": "ลบบัญชีของฉันอย่างถาวร",
      "del.confirm.deleting": "กำลังลบ...",
      "del.confirm.cancel": "ยกเลิก",
      "del.done.title": "ลบบัญชีของคุณแล้ว",
      "del.done.body": "ข้อมูลส่วนบุคคลของคุณถูกลบอย่างถาวรแล้ว",
      "del.done.retained": "ข้อมูลส่วนบุคคลของคุณถูกลบอย่างถาวรแล้ว มีการเก็บบันทึกการซื้อ {{n}} รายการไว้เพื่อปฏิบัติตามข้อผูกพันทางกฎหมาย ซึ่งไม่สามารถเชื่อมโยงถึงคุณได้",
      "del.done.home": "กลับไปที่ร้านค้า",
      "del.error.required": "กรุณากรอกอีเมลและรหัสผ่านของคุณ",
      "del.error.credentials": "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
      "del.error.suspended": "บัญชีของคุณถูกระงับ กรุณาติดต่อฝ่ายช่วยเหลือ",
      "del.error.session": "เซสชันของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบอีกครั้ง",
      "del.error.network": "ไม่สามารถเชื่อมต่อได้ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ตแล้วลองอีกครั้ง",
      "del.error.generic": "เกิดข้อผิดพลาด กรุณาลองอีกครั้ง",
      "footer.deleteAccount": "ลบบัญชี",
      "home.tabs.voice": "eSIM โทร + SMS",
      "detail.voice": "โทร + SMS",
      "detail.voiceNote": "แพ็กเกจนี้รวมการโทรและ SMS ไม่จำกัดนอกเหนือจากดาต้า — eSIM เดียวใช้ได้ทั้งอินเทอร์เน็ตและการโทร",
      "detail.calls": "การโทร",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "โทรไม่จำกัด",
      "plan.unlimitedSms": "SMS ไม่จำกัด",
      "plan.minutes": "โทรได้ {{n}} นาที",
      "plan.sms": "{{n}} SMS",
      "hercules.subtitle": "โทร SMS และดาต้าไม่จำกัดใน {{n}} ประเทศในยุโรป — ด้วย eSIM เดียว",
      "hercules.coverageTitle": "ประเทศที่ครอบคลุม ({{n}})",
      "hercules.promo.desc": "โทรและ SMS ไม่จำกัดใน {{n}} ประเทศ พร้อมดาต้า 20–100 GB",
      "hercules.promo.cta": "ดูแพ็กเกจ",
      "loading": "กำลังโหลด..."
    }
  },
  // Farsça
  fa: {
    translation: {
      "language.title": "زبان",
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "آینده اتصال دیجیتال",
      "hero.description": "با تجربه نسل جدید اتصال دیجیتال، مرزها را از میان برمی‌داریم.",
      "hero.description2": "راهکارهای eSIM سریع، امن و مقرون‌به‌صرفه در سراسر جهان.",
      "features.countries": "بیش از 150 کشور",
      "features.activation": "فعال‌سازی فوری",
      "features.support": "پشتیبانی 24/7",
      "countdown.title": "وب‌سایت ما به‌زودی راه‌اندازی می‌شود!",
      "countdown.days": "روز",
      "countdown.hours": "ساعت",
      "countdown.minutes": "دقیقه",
      "countdown.seconds": "ثانیه",
      "countdown.launch": "وب‌سایت ما راه‌اندازی شد!",
      "countdown.loading": "در حال بارگیری...",
      "apps.title": "برنامه‌های موبایل ما",
      "apps.ios.label": "دانلود از",
      "apps.ios.name": "App Store",
      "apps.android.label": "دریافت از",
      "apps.android.name": "Google Play",
      "contact.title": "تا زمان راه‌اندازی با ما در تماس باشید",
      "contact.whatsapp": "WhatsApp: +90 540 155 13 33",
      "contact.email": "ایمیل: info@utkanesim.com",
      "about.hero.title": "درباره Utkan eSIM",
      "about.hero.description": "همراه مطمئن شما برای متصل ماندن در هر کجا که باشید. ما معتقدیم سفرهای بین‌المللی باید بی‌دغدغه و مقرون‌به‌صرفه باشد، بدون دردسر سیم‌کارت فیزیکی و هزینه‌های گران رومینگ.",
      "about.story.title": "داستان ما",
      "about.story.content": "ما در سال 2024 توسط گروهی از مسافران پرشور و علاقه‌مندان به فناوری تأسیس شدیم و هدفمان متحول کردن شیوه اتصال مردم به اینترنت در خارج از کشور است. ما طرح‌های داده eSIM باکیفیت و قابل اعتماد را برای بیش از 190 کشور و منطقه ارائه می‌دهیم تا از لحظه فرود به اینترنت پرسرعت دسترسی داشته باشید.",
      "about.mission.title": "مأموریت ما",
      "about.mission.content": "ارائه اتصال ساده، مقرون‌به‌صرفه و فوری در سراسر جهان به مسافران، تا بتوانند بدون محدودیت کشف کنند، کار کنند و در ارتباط بمانند.",
      "about.vision.title": "چشم‌انداز ما",
      "about.vision.content": "تبدیل شدن به پلتفرم پیشرو جهانی در راهکارهای اتصال دیجیتال و ساختن جهانی کوچک‌تر و متصل‌تر برای همه.",
      "about.features.title": "چرا ما را انتخاب کنید؟",
      "about.features.instant.title": "تحویل فوری",
      "about.features.instant.content": "eSIM خود را بلافاصله پس از خرید از طریق کد QR دریافت کنید.",
      "about.features.global.title": "پوشش جهانی",
      "about.features.global.content": "طرح‌های داده برای بیش از 190 کشور و منطقه.",
      "about.features.affordable.title": "قیمت‌های مناسب",
      "about.features.affordable.content": "تا 90% در هزینه‌های رومینگ صرفه‌جویی کنید.",
      "about.features.support.title": "پشتیبانی 24/7",
      "about.features.support.content": "تیم پشتیبانی ما همیشه آماده کمک به شماست.",
      "about.features.secure.title": "اتصال امن",
      "about.features.secure.content": "اتصالی محافظت‌شده با جدیدترین پروتکل‌های امنیتی.",
      "about.features.fast.title": "اینترنت پرسرعت",
      "about.features.fast.content": "تجربه اینترنت بی‌وقفه با سرعت 4G/5G.",
      "about.cta.title": "به آینده اتصال دیجیتال بپیوندید",
      "about.cta.content": "از اینکه Utkan eSIM را انتخاب کردید سپاسگزاریم. سفر خوشی داشته باشید!",
      "about.cta.whatsapp": "تماس از طریق WhatsApp",
      "about.cta.email": "ارسال ایمیل",
      "contact.hero.title": "تماس با ما",
      "contact.hero.description": "ما اینجا هستیم تا کمک کنیم! چه درباره eSIMهای ما سؤالی داشته باشید، چه به پشتیبانی فنی نیاز داشته باشید یا فقط بخواهید نظرتان را با ما در میان بگذارید، خوشحال می‌شویم از شما بشنویم.",
      "contact.info.title": "اطلاعات تماس",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "پشتیبانی سریع 24/7",
      "contact.email.title": "ایمیل",
      "contact.email.subtitle": "ارتباط عمومی",
      "contact.support.title": "پشتیبانی فنی",
      "contact.support.subtitle": "مشکلات eSIM",
      "contact.business.title": "همکاری",
      "contact.business.subtitle": "ارتباط سازمانی",
      "contact.hours.title": "ساعات پشتیبانی",
      "contact.hours.subtitle": "پشتیبانی فنی 24/7",
      "contact.hours.detail": "دوشنبه تا یکشنبه: 00:00 - 23:59",
      "contact.form.title": "برای ما پیام بفرستید",
      "contact.form.name": "نام شما",
      "contact.form.name.placeholder": "نام و نام خانوادگی خود را وارد کنید",
      "contact.form.email": "ایمیل شما",
      "contact.form.email.placeholder": "example@email.com",
      "contact.form.subject": "موضوع",
      "contact.form.subject.placeholder": "موضوع را انتخاب کنید",
      "contact.form.subject.general": "اطلاعات عمومی",
      "contact.form.subject.technical": "پشتیبانی فنی",
      "contact.form.subject.billing": "سؤالات مالی و صورتحساب",
      "contact.form.subject.partnership": "همکاری",
      "contact.form.subject.feedback": "بازخورد",
      "contact.form.message": "پیام شما",
      "contact.form.message.placeholder": "پیام خود را اینجا بنویسید...",
      "contact.form.submit": "ارسال پیام",
      "contact.faq.title": "سؤالات متداول",
      "contact.faq.esim.title": "eSIM چگونه کار می‌کند؟",
      "contact.faq.esim.content": "eSIM یک سیم‌کارت دیجیتال است که بدون نیاز به سیم‌کارت فیزیکی در گوشی شما کار می‌کند و از طریق کد QR فوراً فعال می‌شود.",
      "contact.faq.phones.title": "کدام گوشی‌ها از eSIM پشتیبانی می‌کنند؟",
      "contact.faq.phones.content": "مدل‌های iPhone XS و بالاتر، Samsung Galaxy S20 و بالاتر و Google Pixel 3 و بالاتر از eSIM پشتیبانی می‌کنند.",
      "contact.faq.validity.title": "بسته داده من چه مدت اعتبار دارد؟",
      "contact.faq.validity.content": "مدت اعتبار بسته بسته به طرحی که انتخاب می‌کنید بین 1 تا 30 روز است.",
      "contact.faq.payment.title": "چگونه می‌توانم پرداخت کنم؟",
      "contact.faq.payment.content": "می‌توانید با کارت اعتباری، PayPal و حواله بانکی به‌صورت امن پرداخت کنید.",
      "privacy.hero.title": "سیاست حفظ حریم خصوصی",
      "privacy.hero.description": "امنیت داده‌های شخصی شما برای ما بسیار مهم است. این سیاست توضیح می‌دهد که داده‌های شما چگونه جمع‌آوری، استفاده و محافظت می‌شوند.",
      "privacy.overview.title": "نمای کلی",
      "privacy.overview.content": "این سیاست حفظ حریم خصوصی، سیاست‌ها و رویه‌های ما را در زمینه جمع‌آوری، استفاده و افشای اطلاعات شما هنگام استفاده از سرویس شرح می‌دهد و شما را از حقوق حریم خصوصی‌تان و نحوه حمایت قانون از شما آگاه می‌کند.",
      "privacy.data.title": "داده‌هایی که جمع‌آوری می‌کنیم",
      "privacy.data.personal.title": "اطلاعات شخصی",
      "privacy.data.personal.name": "نام و نام خانوادگی",
      "privacy.data.personal.email": "آدرس ایمیل",
      "privacy.data.personal.phone": "شماره تلفن",
      "privacy.data.personal.payment": "اطلاعات پرداخت",
      "privacy.data.usage.title": "داده‌های استفاده",
      "privacy.data.usage.ip": "آدرس IP",
      "privacy.data.usage.browser": "نوع مرورگر",
      "privacy.data.usage.device": "اطلاعات دستگاه",
      "privacy.data.usage.stats": "آمار استفاده",
      "privacy.security.title": "امنیت داده‌ها",
      "privacy.security.ssl.title": "رمزنگاری SSL",
      "privacy.security.ssl.content": "تمام انتقال‌های داده با رمزنگاری SSL 256 بیتی محافظت می‌شوند.",
      "privacy.security.servers.title": "سرورهای امن",
      "privacy.security.servers.content": "داده‌های شما روی سرورهای امن دارای گواهی ISO 27001 ذخیره می‌شوند.",
      "privacy.security.access.title": "کنترل دسترسی",
      "privacy.security.access.content": "فقط کارکنان مجاز به داده‌های شما دسترسی دارند.",
      "privacy.usage.title": "استفاده از داده‌ها",
      "privacy.usage.intro": "ما از داده‌های جمع‌آوری‌شده برای اهداف زیر استفاده می‌کنیم:",
      "privacy.usage.service.title": "ارائه خدمات",
      "privacy.usage.service.content": "برای ارائه و مدیریت خدمات eSIM به شما",
      "privacy.usage.support.title": "پشتیبانی مشتریان",
      "privacy.usage.support.content": "برای ارائه پشتیبانی فنی و خدمات مشتریان",
      "privacy.usage.security.title": "امنیت",
      "privacy.usage.security.content": "برای محافظت از حساب شما و خدمات ما",
      "privacy.usage.improvement.title": "بهبود",
      "privacy.usage.improvement.content": "برای بهبود خدمات و افزودن ویژگی‌های جدید",
      "privacy.sharing.title": "اشتراک‌گذاری داده‌ها",
      "privacy.sharing.intro": "ما داده‌های شخصی شما را با اشخاص ثالث به اشتراک نمی‌گذاریم، اما ممکن است در موارد زیر اشتراک‌گذاری لازم باشد:",
      "privacy.sharing.legal": "در صورت الزام قانونی",
      "privacy.sharing.providers": "با ارائه‌دهندگان خدمات ما (مانند پردازشگران پرداخت)",
      "privacy.sharing.threats": "برای جلوگیری از تهدیدهای امنیتی",
      "privacy.sharing.consent": "در صورتی که رضایت صریح دهید",
      "privacy.rights.title": "حقوق شما",
      "privacy.rights.access.title": "حق دسترسی",
      "privacy.rights.access.content": "می‌توانید درخواست دسترسی به داده‌هایی را که درباره شما نگهداری می‌کنیم بدهید.",
      "privacy.rights.correction.title": "حق اصلاح",
      "privacy.rights.correction.content": "ما می‌توانیم داده‌های نادرست یا ناقص شما را اصلاح کنیم.",
      "privacy.rights.deletion.title": "حق حذف",
      "privacy.rights.deletion.content": "ما می‌توانیم تحت شرایط خاصی داده‌های شما را حذف کنیم.",
      "privacy.rights.objection.title": "حق اعتراض",
      "privacy.rights.objection.content": "می‌توانید به فعالیت‌های پردازش داده ما اعتراض کنید.",
      "privacy.contact.title": "تماس",
      "privacy.contact.intro": "اگر درباره این سیاست حفظ حریم خصوصی سؤالی دارید، می‌توانید از طریق راه‌های زیر با ما تماس بگیرید:",
      "nav.about": "درباره ما",
      "nav.contact": "تماس",
      "nav.privacy": "حریم خصوصی",
      "nav.login": "ورود",
      "nav.account": "حساب",
      "nav.logout": "خروج",
      "auth.brand.eyebrow": "پوشش جهانی",
      "auth.brand.title": "در بیش از 150 کشور، از لحظه فرود آنلاین باشید.",
      "auth.brand.subtitle": "بدون سیم‌کارت فیزیکی، بدون هزینه رومینگ. eSIM خود را در چند ثانیه فعال کنید.",
      "auth.login.eyebrow": "ورود",
      "auth.login.title": "خوش آمدید",
      "auth.login.subtitle": "eSIMهای خود را مدیریت کنید و eSIMهای جدید را کشف کنید.",
      "auth.signup.eyebrow": "حساب جدید",
      "auth.signup.title": "حساب خود را ایجاد کنید",
      "auth.signup.subtitle": "تنها چند قدم تا اولین eSIM شما.",
      "auth.field.identifier": "ایمیل یا تلفن",
      "auth.field.identifier.ph": "you@email.com یا +98…",
      "auth.field.email": "ایمیل",
      "auth.field.email.ph": "you@email.com",
      "auth.field.fullName": "نام و نام خانوادگی",
      "auth.field.fullName.ph": "نام و نام خانوادگی شما",
      "auth.field.password": "رمز عبور",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "ورود",
      "auth.action.loggingIn": "در حال ورود…",
      "auth.action.signup": "ایجاد حساب",
      "auth.action.signingUp": "در حال ایجاد حساب…",
      "auth.toSignup.q": "حساب کاربری ندارید؟",
      "auth.toSignup.link": "ثبت‌نام",
      "auth.toLogin.q": "قبلاً حساب ایجاد کرده‌اید؟",
      "auth.toLogin.link": "ورود",
      "auth.password.show": "نمایش رمز عبور",
      "auth.password.hide": "پنهان کردن رمز عبور",
      "auth.terms.prefix": "با ادامه، ",
      "auth.terms.link": "شرایط استفاده و سیاست حفظ حریم خصوصی",
      "auth.terms.suffix": " را می‌پذیرم.",
      "auth.error.required": "لطفاً فیلدهای الزامی را پر کنید.",
      "auth.error.terms": "برای ادامه، لطفاً شرایط را بپذیرید.",
      "verify.eyebrow": "تأیید ایمیل",
      "verify.title": "ایمیل خود را تأیید کنید",
      "verify.subtitle": "یک کد 6 رقمی به {{email}} ارسال کردیم. برای تأیید، آن را وارد کنید.",
      "verify.code": "کد تأیید",
      "verify.code.ph": "••••••",
      "verify.action": "تأیید",
      "verify.verifying": "در حال تأیید…",
      "verify.resend": "ارسال مجدد کد",
      "verify.resendIn": "ارسال مجدد تا {{seconds}} ثانیه دیگر",
      "verify.resent": "کد جدیدی ارسال شد.",
      "verify.skip": "فعلاً رد شوید",
      "auth.forgot.link": "رمز عبور را فراموش کرده‌اید؟",
      "forgot.eyebrow": "بازنشانی رمز عبور",
      "forgot.email.title": "رمز عبور خود را بازنشانی کنید",
      "forgot.email.subtitle": "ایمیل حساب خود را وارد کنید تا یک کد 6 رقمی بازنشانی برایتان ارسال کنیم.",
      "forgot.email.action": "ارسال کد",
      "forgot.email.sending": "در حال ارسال…",
      "forgot.reset.title": "تعیین رمز عبور جدید",
      "forgot.reset.subtitle": "کد 6 رقمی ارسال‌شده به {{email}} و رمز عبور جدید خود را وارد کنید.",
      "forgot.reset.action": "به‌روزرسانی رمز عبور",
      "forgot.reset.updating": "در حال به‌روزرسانی…",
      "forgot.field.code": "کد بازنشانی",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "رمز عبور جدید",
      "forgot.field.newPassword.ph": "حداقل 6 کاراکتر",
      "forgot.resend": "ارسال مجدد کد",
      "forgot.resendIn": "ارسال مجدد تا {{seconds}} ثانیه دیگر",
      "forgot.resent": "کد جدیدی ارسال شد.",
      "forgot.backToLogin": "بازگشت به ورود",
      "forgot.changeEmail": "تغییر ایمیل",
      "forgot.help.noMail": "اگر کد را دریافت نکردید، پوشه هرزنامه را بررسی کنید یا از صحت آدرس ایمیل خود مطمئن شوید.",
      "reset.RESET_CODE_SENT": "کد ارسال شد. لطفاً ایمیل خود را بررسی کنید.",
      "reset.RATE_LIMITED": "تعداد درخواست‌ها بیش از حد مجاز است. لطفاً کمی صبر کنید و دوباره امتحان کنید.",
      "reset.MAIL_SEND_FAILED": "مشکلی پیش آمد. لطفاً بعداً دوباره امتحان کنید.",
      "reset.RESET_CODE_VALID": "کد تأیید شد.",
      "reset.INVALID_RESET_CODE": "کد نامعتبر است. لطفاً دوباره امتحان کنید.",
      "reset.EXPIRED_RESET_CODE": "کد منقضی شده است. لطفاً کد جدیدی درخواست کنید.",
      "reset.WEAK_PASSWORD": "رمز عبور باید حداقل 6 کاراکتر باشد.",
      "reset.PASSWORD_RESET_SUCCESS": "رمز عبور شما به‌روزرسانی شد. لطفاً با رمز عبور جدید خود وارد شوید.",
      "reset.generic": "مشکلی پیش آمد. لطفاً دوباره امتحان کنید.",
      "login.resetSuccess": "رمز عبور شما به‌روزرسانی شد. لطفاً با رمز عبور جدید خود وارد شوید.",
      "store.nav.shop": "فروشگاه",
      "home.hero.title1": "در چند دقیقه متصل شوید،",
      "home.hero.title2": "فراتر از مرزها آنلاین بمانید.",
      "home.hero.subtitle": "طرح‌های eSIM قابل اعتماد، معتبر در بیش از 190 کشور. بدون سیم‌کارت فیزیکی، بدون هزینه رومینگ.",
      "home.search.placeholder": "به کجا سفر می‌کنید؟",
      "home.tabs.local": "eSIM محلی",
      "home.tabs.regional": "eSIM منطقه‌ای",
      "home.tabs.lifetime": "eSIM دائمی",
      "home.empty": "نتیجه‌ای با جستجوی شما مطابقت ندارد.",
      "home.error.title": "بارگیری محتوا ممکن نشد",
      "home.error.retry": "تلاش دوباره",
      "home.from": "از",
      "home.popular": "مقاصد محبوب",
      "home.coverage": "بیش از 190 کشور · فعال‌سازی فوری",
      "home.detail.soon": "طرح‌های این انتخاب به‌زودی در اینجا نمایش داده می‌شوند.",
      "home.detail.back": "بازگشت به فروشگاه",
      "detail.plans": "طرح‌ها",
      "detail.count": "{{count}} طرح",
      "detail.validity": "{{days}} روز",
      "detail.validityLifetime": "بدون انقضا",
      "detail.buy": "خرید",
      "detail.empty": "در حال حاضر طرحی برای این انتخاب موجود نیست.",
      "detail.checkoutSoon": "امکان پرداخت به‌زودی فراهم می‌شود.",
      "detail.loginToBuy": "برای خرید لطفاً وارد شوید.",
      "detail.basicFeatures": "ویژگی‌های اصلی",
      "detail.dataAmount": "مقدار داده",
      "detail.validityLabel": "اعتبار",
      "detail.coverageArea": "پوشش",
      "detail.activationNetworks": "فعال‌سازی و شبکه‌ها",
      "detail.activationMethod": "روش فعال‌سازی",
      "detail.esimActivation": "eSIM — فوری از طریق کد QR",
      "detail.supportedNetworks": "شبکه‌های پشتیبانی‌شده",
      "detail.description": "توضیحات",
      "detail.price": "قیمت",
      "authprompt.title": "برای ادامه وارد شوید",
      "authprompt.message": "برای خرید eSIM وارد حساب خود شوید، یا در چند ثانیه حساب جدیدی بسازید.",
      "authprompt.close": "بستن",
      "footer.tagline": "eSIM سریع، امن و مقرون‌به‌صرفه در سراسر جهان. از لحظه فرود آنلاین باشید.",
      "footer.explore": "کاوش",
      "footer.support": "پشتیبانی",
      "footer.legal": "حقوقی",
      "footer.shop": "فروشگاه",
      "footer.help": "سؤالات متداول",
      "footer.terms": "شرایط استفاده",
      "footer.rights": "© {{year}} Utkan eSIM. تمامی حقوق محفوظ است.",
      "footer.apps": "دریافت برنامه",
      "whatsapp.label": "گفتگو در WhatsApp",
      "whatsapp.message": "سلام، من یک درخواست پشتیبانی eSIM دارم.",
      "notfound.eyebrow": "بدون سیگنال",
      "notfound.title": "این صفحه در دسترس نیست",
      "notfound.message": "صفحه‌ای که به دنبال آن هستید منتقل شده یا هرگز وجود نداشته است. بیایید شما را به محدوده پوشش بازگردانیم.",
      "order.congrats": "تبریک!",
      "order.message": "eSIM شما آماده است. با کد QR زیر در چند مرحله آن را راه‌اندازی کنید.",
      "order.details": "خلاصه سفارش",
      "order.activation": "فعال‌سازی",
      "order.activationDesc": "برای راه‌اندازی eSIM، کد QR را با دوربین دستگاه خود اسکن کنید یا کد فعال‌سازی را به‌صورت دستی وارد کنید.",
      "order.qrTitle": "کد QR eSIM",
      "order.manualLabel": "کد فعال‌سازی",
      "order.copy": "کپی",
      "order.copied": "کپی شد",
      "order.howTo": "نحوه فعال‌سازی",
      "order.step1": "در دستگاه خود به تنظیمات > سلولی / داده موبایل > افزودن eSIM بروید.",
      "order.step2": "گزینه «استفاده از کد QR» را انتخاب کرده و کد QR بالا را اسکن کنید (یا کد فعال‌سازی را به‌صورت دستی وارد کنید).",
      "order.step3": "پس از اتمام راه‌اندازی، طرح eSIM را فعال کنید.",
      "order.step4": "مطمئن شوید رومینگ داده روشن است — شما متصل هستید!",
      "order.cta": "بازگشت به صفحه اصلی",
      "checkout.title": "پرداخت",
      "checkout.summary": "خلاصه سفارش",
      "checkout.total": "مجموع",
      "checkout.eurNote": "مبلغ به یورو (€) از طریق PayPal از شما دریافت می‌شود.",
      "checkout.processing": "در حال تأیید پرداخت شما…",
      "checkout.error": "پرداخت انجام نشد. لطفاً دوباره امتحان کنید.",
      "checkout.cancelled": "پرداخت لغو شد.",
      "account.title": "حساب من",
      "account.tab.profile": "نمایه",
      "account.tab.esims": "eSIMهای من",
      "account.tab.security": "امنیت",
      "account.profile.title": "اطلاعات نمایه",
      "account.field.phone": "تلفن",
      "account.field.phone.ph": "+98…",
      "account.memberSince": "عضو از",
      "account.save": "ذخیره",
      "account.saving": "در حال ذخیره…",
      "account.saved": "اطلاعات شما به‌روزرسانی شد.",
      "account.esims.title": "eSIMهای من",
      "account.esims.empty": "هنوز هیچ eSIMی ندارید.",
      "account.esims.emptyCta": "مشاهده فروشگاه",
      "account.esims.data": "داده",
      "account.esims.expires": "تاریخ انقضا",
      "account.esims.viewQr": "نمایش کد QR",
      "account.esims.hideQr": "پنهان کردن کد QR",
      "account.esims.active": "فعال",
      "account.esims.passive": "غیرفعال",
      "account.esims.noActive": "هیچ eSIM فعالی ندارید.",
      "account.esims.noPassive": "هیچ eSIM غیرفعالی ندارید.",
      "account.esims.readyHint": "آماده استفاده — اعتبار از اولین استفاده آغاز می‌شود.",
      "account.esims.unavailableHint": "در حال حاضر وضعیت در دسترس نیست. لطفاً بعداً دوباره امتحان کنید.",
      "esimStatus.active": "فعال",
      "esimStatus.readyToUse": "آماده استفاده",
      "esimStatus.inactive": "غیرفعال",
      "esimStatus.unavailable": "وضعیت در دسترس نیست",
      "account.security.title": "تغییر رمز عبور",
      "account.field.oldPassword": "رمز عبور فعلی",
      "account.field.newPassword": "رمز عبور جدید",
      "account.field.confirmPassword": "رمز عبور جدید (تکرار)",
      "account.changePassword": "به‌روزرسانی رمز عبور",
      "account.passwordChanged": "رمز عبور شما به‌روزرسانی شد.",
      "account.error.passwordMismatch": "رمزهای عبور جدید مطابقت ندارند.",
      "account.danger.title": "عملیات حساب",
      "account.delete": "حذف حساب",
      "account.delete.confirm": "در شرف حذف دائمی حساب خود هستید. این عمل قابل برگشت نیست.",
      "account.delete.confirmBtn": "بله، حذف شود",
      "account.cancel": "لغو",
      "esimDetail.back": "بازگشت",
      "esimDetail.dataUsage": "مصرف داده",
      "esimDetail.left": "باقی‌مانده",
      "esimDetail.leftData": "داده باقی‌مانده",
      "esimDetail.usedData": "مصرف‌شده",
      "esimDetail.totalData": "کل داده",
      "esimDetail.qrDesc": "برای راه‌اندازی eSIM، این کد QR را با دوربین دستگاه خود اسکن کنید.",
      "esimDetail.validity": "اعتبار",
      "esimDetail.daysLeft": "{{days}} روز باقی‌مانده",
      "esimDetail.expired": "منقضی شده",
      "esimDetail.notYetActive": "هنوز فعال نشده",
      "esimDetail.leftDate": "زمان باقی‌مانده",
      "esimDetail.activationDate": "تاریخ فعال‌سازی",
      "esimDetail.endDate": "تاریخ پایان",
      "esimDetail.technical": "جزئیات فنی",
      "esimDetail.activationCode": "کد فعال‌سازی (Android)",
      "esimDetail.smdp": "آدرس SM-DP+ (iOS)",
      "esimDetail.matchingId": "Matching ID (iOS)",
      "esimDetail.support": "پشتیبانی فنی",
      "esimDetail.supportDesc": "مشکلی دارید؟ ما برای کمک اینجا هستیم.",
      "esimDetail.email": "ارسال ایمیل",
      "guide.eyebrow": "راهنمای eSIM",
      "guide.title": "eSIM چیست و چگونه آن را راه‌اندازی کنیم؟",
      "guide.intro.title": "eSIM چیست؟",
      "guide.intro.body": "eSIM یک سیم‌کارت دیجیتال تعبیه‌شده در دستگاه شماست و به کارت فیزیکی نیازی ندارد. یک کد QR را اسکن کنید تا خط شما در چند ثانیه راه‌اندازی شود؛ بدون تعویض کارت و بدون هزینه رومینگ در بیش از 190 کشور آنلاین شوید.",
      "guide.steps.title": "نحوه فعال‌سازی",
      "guide.devices.title": "دستگاه‌های پشتیبانی‌شده",
      "guide.devices.desc": "برای کار کردن eSIM، دستگاه شما باید از آن پشتیبانی کند. برند خود را در زیر پیدا کنید.",
      "guide.faq.title": "سؤالات متداول",
      "nav.guide": "راهنمای eSIM",
      "currency.label": "واحد پول",
      "staticPage.loading": "در حال بارگیری صفحه...",
      "staticPage.errorTitle": "خطایی رخ داد",
      "staticPage.retry": "تلاش دوباره",
      "staticPage.loadFailed": "محتوای صفحه بارگیری نشد. لطفاً بعداً دوباره امتحان کنید.",
      "last.updated": "آخرین به‌روزرسانی: 8 ژوئیه 2024",
      "home.tabs.unlimited": "eSIM نامحدود",
      "detail.unlimited": "نامحدود",
      "detail.unlimitedNote": "این بسته محدودیت حجم ندارد — در تمام مدت اعتبار از اینترنت نامحدود لذت ببرید.",
      "detail.notPriced": "در حال حاضر امکان خرید این بسته از طریق وب وجود ندارد.",
      "checkout.priceUpdated": "قیمت این بسته تغییر کرده است. لطفاً به فروشگاه بازگردید و دوباره آن را انتخاب کنید.",
      "order.pending.title": "eSIM شما در حال آماده‌سازی است",
      "order.pending.message": "پرداخت شما با موفقیت انجام شد. فعال‌سازی بسته‌های نامحدود ممکن است چند دقیقه طول بکشد.",
      "order.pending.waiting": "در حال بررسی وضعیت سفارش شما…",
      "order.pending.ready": "eSIM شما آماده است!",
      "order.pending.timeout": "این کار بیش از حد انتظار طول کشیده است. پرداخت شما امن است — eSIM شما به محض آماده شدن در بخش «eSIMهای من» نمایش داده می‌شود.",
      "order.pending.cta": "رفتن به eSIMهای من",
      "account.esims.unlimited": "نامحدود",
      "account.esims.unlimitedHint": "داده نامحدود — این بسته محدودیت حجم ندارد.",
      "esimDetail.unlimitedData": "این بسته محدودیت حجم ندارد؛ زمان باقی‌مانده را در زیر ببینید.",
      "del.eyebrow": "حذف حساب",
      "del.title": "حذف حساب من",
      "del.intro": "در اینجا می‌توانید حساب Utkan eSIM و داده‌های شخصی خود را به‌طور دائمی حذف کنید. نیازی به نصب برنامه نیست — کافی است با حسابی که می‌خواهید حذف کنید وارد شوید.",
      "del.deleted.title": "داده‌هایی که حذف می‌شوند",
      "del.deleted.identity": "نام، نام خانوادگی، آدرس ایمیل و شماره تلفن شما",
      "del.deleted.credentials": "رمز عبور و داده‌های نشست شما",
      "del.deleted.codes": "کدهای تأیید ایمیل و بازنشانی رمز عبور شما",
      "del.deleted.esim": "شماره eSIM (MSISDN)، کد QR/فعال‌سازی و داده‌های مصرف شما",
      "del.kept.title": "داده‌هایی که نگه می‌داریم و دلیل آن",
      "del.kept.orders": "سوابق خرید (شماره سفارش، تاریخ، مبلغ، وضعیت پرداخت) برای انجام تعهدات مالیاتی و حسابداری نگهداری می‌شوند. این سوابق شامل نام، آدرس ایمیل یا جزئیات پرداخت نیستند — تنها یک شناسه که قابل ارتباط با شما نیست.",
      "del.kept.period": "مدت نگهداری: 5 سال (قانون آیین دادرسی مالیاتی ترکیه، ماده 253).",
      "del.warn.title": "پیش از حذف",
      "del.warn.irreversible": "این عمل قابل برگشت نیست.",
      "del.warn.esim": "eSIMهای فعال روی دستگاه شما به کار خود ادامه می‌دهند، اما دیگر به کد QR یا داده باقی‌مانده خود دسترسی نخواهید داشت. پیش از حذف، کد QR خود را ذخیره کنید.",
      "del.warn.rejoin": "می‌توانید دوباره با همان آدرس ایمیل ثبت‌نام کنید، اما eSIMهای قبلی شما در حساب جدید نمایش داده نمی‌شوند.",
      "del.support": "اگر نمی‌توانید وارد شوید، می‌توانید درخواست حذف را از طریق ایمیل نیز ارسال کنید:",
      "del.login.title": "ابتدا وارد شوید",
      "del.login.subtitle": "ایمیل و رمز عبور خود را وارد کنید تا مطمئن شویم حساب متعلق به شماست.",
      "del.login.action": "ورود",
      "del.login.loading": "در حال ورود...",
      "del.forgot": "رمز عبور را فراموش کرده‌اید؟",
      "del.confirm.title": "آیا مطمئن هستید؟",
      "del.confirm.subtitle": "حساب {{email}} و داده‌های شخصی شما به‌طور دائمی حذف خواهند شد.",
      "del.confirm.field": "برای تأیید، آدرس ایمیل خود را دوباره وارد کنید",
      "del.confirm.action": "حذف دائمی حساب من",
      "del.confirm.deleting": "در حال حذف...",
      "del.confirm.cancel": "لغو",
      "del.done.title": "حساب شما حذف شد",
      "del.done.body": "داده‌های شخصی شما به‌طور دائمی حذف شدند.",
      "del.done.retained": "داده‌های شخصی شما به‌طور دائمی حذف شدند. {{n}} سابقه خرید برای انجام تعهدات قانونی نگهداری شد؛ این سوابق قابل ارتباط با شما نیستند.",
      "del.done.home": "بازگشت به فروشگاه",
      "del.error.required": "لطفاً ایمیل و رمز عبور خود را وارد کنید.",
      "del.error.credentials": "ایمیل یا رمز عبور نادرست است.",
      "del.error.suspended": "حساب شما تعلیق شده است. لطفاً با پشتیبانی تماس بگیرید.",
      "del.error.session": "نشست شما منقضی شده است. لطفاً دوباره وارد شوید.",
      "del.error.network": "اتصال برقرار نشد. اتصال اینترنت خود را بررسی کرده و دوباره امتحان کنید.",
      "del.error.generic": "مشکلی پیش آمد. لطفاً دوباره امتحان کنید.",
      "footer.deleteAccount": "حذف حساب",
      "home.tabs.voice": "eSIM دارای تماس",
      "detail.voice": "تماس + SMS",
      "detail.voiceNote": "این طرح علاوه بر داده، تماس و SMS نامحدود نیز دارد — یک eSIM هم برای اینترنت و هم برای تماس.",
      "detail.calls": "تماس",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "تماس نامحدود",
      "plan.unlimitedSms": "SMS نامحدود",
      "plan.minutes": "{{n}} دقیقه تماس",
      "plan.sms": "{{n}} SMS",
      "hercules.subtitle": "تماس، SMS و داده نامحدود در {{n}} کشور اروپایی — با یک eSIM.",
      "hercules.coverageTitle": "کشورهای تحت پوشش ({{n}})",
      "hercules.promo.desc": "تماس و SMS نامحدود در {{n}} کشور، همراه با 20 تا 100 GB داده.",
      "hercules.promo.cta": "مشاهده طرح",
      "loading": "در حال بارگیری..."
    }
  },
  // Bengalce
  bn: {
    translation: {
      "language.title": "ভাষা",
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "ডিজিটাল সংযোগের ভবিষ্যৎ",
      "hero.description": "নতুন প্রজন্মের ডিজিটাল সংযোগ অভিজ্ঞতার মাধ্যমে আমরা সীমানা মুছে দিচ্ছি।",
      "hero.description2": "বিশ্বজুড়ে দ্রুত, নিরাপদ ও সাশ্রয়ী eSIM সমাধান।",
      "features.countries": "150+ দেশ",
      "features.activation": "তাৎক্ষণিক সক্রিয়করণ",
      "features.support": "24/7 সহায়তা",
      "countdown.title": "আমাদের ওয়েবসাইট শীঘ্রই আসছে!",
      "countdown.days": "দিন",
      "countdown.hours": "ঘণ্টা",
      "countdown.minutes": "মিনিট",
      "countdown.seconds": "সেকেন্ড",
      "countdown.launch": "আমাদের ওয়েবসাইট এখন চালু!",
      "countdown.loading": "লোড হচ্ছে...",
      "apps.title": "আমাদের মোবাইল অ্যাপ",
      "apps.ios.label": "ডাউনলোড করুন",
      "apps.ios.name": "App Store",
      "apps.android.label": "ডাউনলোড করুন",
      "apps.android.name": "Google Play",
      "contact.title": "চালু না হওয়া পর্যন্ত আমাদের সাথে যোগাযোগ করুন",
      "contact.whatsapp": "WhatsApp: +90 540 155 13 33",
      "contact.email": "ইমেল: info@utkanesim.com",
      "about.hero.title": "Utkan eSIM সম্পর্কে",
      "about.hero.description": "আপনি যেখানেই যান, সংযুক্ত থাকার জন্য আপনার বিশ্বস্ত সঙ্গী। আমরা বিশ্বাস করি, ফিজিক্যাল সিম কার্ডের ঝামেলা ও ব্যয়বহুল রোমিং চার্জ ছাড়াই আন্তর্জাতিক ভ্রমণ সহজ ও সাশ্রয়ী হওয়া উচিত।",
      "about.story.title": "আমাদের গল্প",
      "about.story.content": "2024 সালে একদল উৎসাহী ভ্রমণকারী ও প্রযুক্তিপ্রেমী মিলে প্রতিষ্ঠিত, আমাদের লক্ষ্য বিদেশে ইন্টারনেটে সংযুক্ত হওয়ার পদ্ধতিতে বিপ্লব আনা। আমরা 190টিরও বেশি দেশ ও অঞ্চলের জন্য উচ্চমানের, নির্ভরযোগ্য eSIM ডেটা প্ল্যান সরবরাহ করি, যাতে অবতরণের মুহূর্ত থেকেই আপনি দ্রুত ইন্টারনেট পান।",
      "about.mission.title": "আমাদের লক্ষ্য",
      "about.mission.content": "ভ্রমণকারীদের বিশ্বজুড়ে সহজ, সাশ্রয়ী ও তাৎক্ষণিক সংযোগ প্রদান করা, যাতে তারা সীমাহীনভাবে ঘুরে দেখতে, কাজ করতে ও যোগাযোগ রাখতে পারেন।",
      "about.vision.title": "আমাদের দৃষ্টিভঙ্গি",
      "about.vision.content": "ডিজিটাল সংযোগ সমাধানের শীর্ষস্থানীয় বৈশ্বিক প্ল্যাটফর্ম হয়ে ওঠা এবং সবার জন্য বিশ্বকে আরও কাছের ও আরও সংযুক্ত করে তোলা।",
      "about.features.title": "কেন আমাদের বেছে নেবেন?",
      "about.features.instant.title": "তাৎক্ষণিক ডেলিভারি",
      "about.features.instant.content": "কেনার সঙ্গে সঙ্গেই QR কোডের মাধ্যমে আপনার eSIM পান।",
      "about.features.global.title": "বৈশ্বিক কভারেজ",
      "about.features.global.content": "190টিরও বেশি দেশ ও অঞ্চলের জন্য ডেটা প্ল্যান।",
      "about.features.affordable.title": "সাশ্রয়ী মূল্য",
      "about.features.affordable.content": "রোমিং খরচে 90% পর্যন্ত সাশ্রয় করুন।",
      "about.features.support.title": "24/7 সহায়তা",
      "about.features.support.content": "আমাদের নিবেদিত সহায়তা দল সবসময় আপনার পাশে আছে।",
      "about.features.secure.title": "নিরাপদ সংযোগ",
      "about.features.secure.content": "সর্বাধুনিক নিরাপত্তা প্রোটোকলে সুরক্ষিত সংযোগ।",
      "about.features.fast.title": "দ্রুত ইন্টারনেট",
      "about.features.fast.content": "4G/5G গতিতে নিরবচ্ছিন্ন ইন্টারনেট অভিজ্ঞতা।",
      "about.cta.title": "ডিজিটাল সংযোগের ভবিষ্যতে যোগ দিন",
      "about.cta.content": "Utkan eSIM বেছে নেওয়ার জন্য ধন্যবাদ। শুভ ভ্রমণ!",
      "about.cta.whatsapp": "WhatsApp-এ যোগাযোগ করুন",
      "about.cta.email": "ইমেল পাঠান",
      "contact.hero.title": "যোগাযোগ করুন",
      "contact.hero.description": "আমরা সাহায্য করতে প্রস্তুত! আমাদের eSIM সম্পর্কে প্রশ্ন থাকুক, প্রযুক্তিগত সহায়তা প্রয়োজন হোক বা শুধু মতামত জানাতে চান — আমরা আপনার কথা শুনতে আগ্রহী।",
      "contact.info.title": "যোগাযোগের তথ্য",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "24/7 দ্রুত সহায়তা",
      "contact.email.title": "ইমেল",
      "contact.email.subtitle": "সাধারণ যোগাযোগ",
      "contact.support.title": "প্রযুক্তিগত সহায়তা",
      "contact.support.subtitle": "eSIM সংক্রান্ত সমস্যা",
      "contact.business.title": "অংশীদারিত্ব",
      "contact.business.subtitle": "কর্পোরেট যোগাযোগ",
      "contact.hours.title": "সহায়তার সময়",
      "contact.hours.subtitle": "24/7 প্রযুক্তিগত সহায়তা",
      "contact.hours.detail": "সোমবার - রবিবার: 00:00 - 23:59",
      "contact.form.title": "আমাদের বার্তা পাঠান",
      "contact.form.name": "আপনার নাম",
      "contact.form.name.placeholder": "আপনার নাম ও পদবি লিখুন",
      "contact.form.email": "আপনার ইমেল",
      "contact.form.email.placeholder": "example@email.com",
      "contact.form.subject": "বিষয়",
      "contact.form.subject.placeholder": "বিষয় নির্বাচন করুন",
      "contact.form.subject.general": "সাধারণ তথ্য",
      "contact.form.subject.technical": "প্রযুক্তিগত সহায়তা",
      "contact.form.subject.billing": "বিলিং সংক্রান্ত প্রশ্ন",
      "contact.form.subject.partnership": "অংশীদারিত্ব",
      "contact.form.subject.feedback": "মতামত",
      "contact.form.message": "আপনার বার্তা",
      "contact.form.message.placeholder": "এখানে আপনার বার্তা লিখুন...",
      "contact.form.submit": "বার্তা পাঠান",
      "contact.faq.title": "সচরাচর জিজ্ঞাসিত প্রশ্ন",
      "contact.faq.esim.title": "eSIM কীভাবে কাজ করে?",
      "contact.faq.esim.content": "eSIM হলো একটি ডিজিটাল সিম কার্ড, যা ফিজিক্যাল সিম কার্ড ছাড়াই আপনার ফোনে কাজ করে। এটি QR কোডের মাধ্যমে তাৎক্ষণিকভাবে সক্রিয় হয়।",
      "contact.faq.phones.title": "কোন ফোনগুলো eSIM সমর্থন করে?",
      "contact.faq.phones.content": "iPhone XS ও পরবর্তী, Samsung Galaxy S20 ও পরবর্তী এবং Google Pixel 3 ও পরবর্তী মডেলগুলো eSIM সমর্থন করে।",
      "contact.faq.validity.title": "আমার ডেটা প্যাকেজের মেয়াদ কতদিন?",
      "contact.faq.validity.content": "আপনার বেছে নেওয়া প্ল্যান অনুযায়ী প্যাকেজের মেয়াদ 1-30 দিনের মধ্যে হয়।",
      "contact.faq.payment.title": "আমি কীভাবে পেমেন্ট করতে পারি?",
      "contact.faq.payment.content": "ক্রেডিট কার্ড, PayPal ও ব্যাংক ট্রান্সফারের মাধ্যমে নিরাপদে পেমেন্ট করতে পারেন।",
      "privacy.hero.title": "গোপনীয়তা নীতি",
      "privacy.hero.description": "আপনার ব্যক্তিগত ডেটার নিরাপত্তা আমাদের কাছে অত্যন্ত গুরুত্বপূর্ণ। এই নীতিতে আপনার ডেটা কীভাবে সংগ্রহ, ব্যবহার ও সুরক্ষিত করা হয় তা ব্যাখ্যা করা হয়েছে।",
      "privacy.overview.title": "সংক্ষিপ্ত বিবরণ",
      "privacy.overview.content": "এই গোপনীয়তা নীতি বর্ণনা করে যে আপনি পরিষেবাটি ব্যবহার করার সময় আমরা কীভাবে আপনার তথ্য সংগ্রহ, ব্যবহার ও প্রকাশ করি, এবং আপনার গোপনীয়তার অধিকার ও আইন কীভাবে আপনাকে সুরক্ষা দেয় তা জানায়।",
      "privacy.data.title": "আমরা যে ডেটা সংগ্রহ করি",
      "privacy.data.personal.title": "ব্যক্তিগত তথ্য",
      "privacy.data.personal.name": "নাম ও পদবি",
      "privacy.data.personal.email": "ইমেল ঠিকানা",
      "privacy.data.personal.phone": "ফোন নম্বর",
      "privacy.data.personal.payment": "পেমেন্টের তথ্য",
      "privacy.data.usage.title": "ব্যবহারের ডেটা",
      "privacy.data.usage.ip": "IP ঠিকানা",
      "privacy.data.usage.browser": "ব্রাউজারের ধরন",
      "privacy.data.usage.device": "ডিভাইসের তথ্য",
      "privacy.data.usage.stats": "ব্যবহারের পরিসংখ্যান",
      "privacy.security.title": "ডেটা নিরাপত্তা",
      "privacy.security.ssl.title": "SSL এনক্রিপশন",
      "privacy.security.ssl.content": "সমস্ত ডেটা স্থানান্তর 256-বিট SSL এনক্রিপশনে সুরক্ষিত।",
      "privacy.security.servers.title": "নিরাপদ সার্ভার",
      "privacy.security.servers.content": "আপনার ডেটা ISO 27001 সনদপ্রাপ্ত নিরাপদ সার্ভারে সংরক্ষিত থাকে।",
      "privacy.security.access.title": "অ্যাক্সেস নিয়ন্ত্রণ",
      "privacy.security.access.content": "শুধুমাত্র অনুমোদিত কর্মীরাই আপনার ডেটা অ্যাক্সেস করতে পারেন।",
      "privacy.usage.title": "ডেটার ব্যবহার",
      "privacy.usage.intro": "আমরা সংগৃহীত ডেটা নিম্নলিখিত উদ্দেশ্যে ব্যবহার করি:",
      "privacy.usage.service.title": "পরিষেবা প্রদান",
      "privacy.usage.service.content": "আপনাকে আমাদের eSIM পরিষেবা প্রদান ও পরিচালনা করতে",
      "privacy.usage.support.title": "গ্রাহক সহায়তা",
      "privacy.usage.support.content": "প্রযুক্তিগত সহায়তা ও গ্রাহক পরিষেবা প্রদান করতে",
      "privacy.usage.security.title": "নিরাপত্তা",
      "privacy.usage.security.content": "আপনার অ্যাকাউন্ট ও আমাদের পরিষেবা সুরক্ষিত রাখতে",
      "privacy.usage.improvement.title": "উন্নয়ন",
      "privacy.usage.improvement.content": "আমাদের পরিষেবা উন্নত করতে ও নতুন ফিচার যোগ করতে",
      "privacy.sharing.title": "ডেটা শেয়ারিং",
      "privacy.sharing.intro": "আমরা আপনার ব্যক্তিগত ডেটা তৃতীয় পক্ষের সাথে শেয়ার করি না, তবে নিম্নলিখিত ক্ষেত্রে শেয়ার করার প্রয়োজন হতে পারে:",
      "privacy.sharing.legal": "আইনি বাধ্যবাধকতার ক্ষেত্রে",
      "privacy.sharing.providers": "আমাদের পরিষেবা প্রদানকারীদের সাথে (যেমন পেমেন্ট প্রসেসর)",
      "privacy.sharing.threats": "নিরাপত্তা হুমকি প্রতিরোধে",
      "privacy.sharing.consent": "আপনি সুস্পষ্ট সম্মতি দিলে",
      "privacy.rights.title": "আপনার অধিকার",
      "privacy.rights.access.title": "অ্যাক্সেসের অধিকার",
      "privacy.rights.access.content": "আপনার সম্পর্কে আমাদের সংরক্ষিত ডেটা দেখার অনুরোধ করতে পারেন।",
      "privacy.rights.correction.title": "সংশোধনের অধিকার",
      "privacy.rights.correction.content": "আমরা আপনার ভুল বা অসম্পূর্ণ ডেটা সংশোধন করতে পারি।",
      "privacy.rights.deletion.title": "মুছে ফেলার অধিকার",
      "privacy.rights.deletion.content": "নির্দিষ্ট শর্তে আমরা আপনার ডেটা মুছে ফেলতে পারি।",
      "privacy.rights.objection.title": "আপত্তির অধিকার",
      "privacy.rights.objection.content": "আমাদের ডেটা প্রক্রিয়াকরণ কার্যক্রমে আপনি আপত্তি জানাতে পারেন।",
      "privacy.contact.title": "যোগাযোগ",
      "privacy.contact.intro": "এই গোপনীয়তা নীতি সম্পর্কে কোনো প্রশ্ন থাকলে নিম্নলিখিত মাধ্যমে আমাদের সাথে যোগাযোগ করতে পারেন:",
      "nav.about": "আমাদের সম্পর্কে",
      "nav.contact": "যোগাযোগ",
      "nav.privacy": "গোপনীয়তা",
      "nav.login": "লগইন",
      "nav.account": "অ্যাকাউন্ট",
      "nav.logout": "লগ আউট",
      "auth.brand.eyebrow": "বৈশ্বিক কভারেজ",
      "auth.brand.title": "150+ দেশে, অবতরণের মুহূর্তেই অনলাইন।",
      "auth.brand.subtitle": "ফিজিক্যাল সিম নেই, রোমিং বিল নেই। কয়েক সেকেন্ডে আপনার eSIM সক্রিয় করুন।",
      "auth.login.eyebrow": "লগইন",
      "auth.login.title": "আবার স্বাগতম",
      "auth.login.subtitle": "আপনার eSIM পরিচালনা করুন এবং নতুনগুলো আবিষ্কার করুন।",
      "auth.signup.eyebrow": "নতুন অ্যাকাউন্ট",
      "auth.signup.title": "আপনার অ্যাকাউন্ট তৈরি করুন",
      "auth.signup.subtitle": "আপনার প্রথম eSIM থেকে মাত্র কয়েক ধাপ দূরে।",
      "auth.field.identifier": "ইমেল বা ফোন",
      "auth.field.identifier.ph": "you@email.com অথবা +880…",
      "auth.field.email": "ইমেল",
      "auth.field.email.ph": "you@email.com",
      "auth.field.fullName": "পূর্ণ নাম",
      "auth.field.fullName.ph": "আপনার পূর্ণ নাম",
      "auth.field.password": "পাসওয়ার্ড",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "লগইন করুন",
      "auth.action.loggingIn": "লগইন হচ্ছে…",
      "auth.action.signup": "অ্যাকাউন্ট তৈরি করুন",
      "auth.action.signingUp": "অ্যাকাউন্ট তৈরি হচ্ছে…",
      "auth.toSignup.q": "অ্যাকাউন্ট নেই?",
      "auth.toSignup.link": "সাইন আপ করুন",
      "auth.toLogin.q": "ইতিমধ্যে অ্যাকাউন্ট আছে?",
      "auth.toLogin.link": "লগইন করুন",
      "auth.password.show": "পাসওয়ার্ড দেখান",
      "auth.password.hide": "পাসওয়ার্ড লুকান",
      "auth.terms.prefix": "চালিয়ে যাওয়ার মাধ্যমে আমি ",
      "auth.terms.link": "ব্যবহারের শর্তাবলী ও গোপনীয়তা নীতি",
      "auth.terms.suffix": "-তে সম্মত হচ্ছি।",
      "auth.error.required": "অনুগ্রহ করে প্রয়োজনীয় ঘরগুলো পূরণ করুন।",
      "auth.error.terms": "চালিয়ে যেতে অনুগ্রহ করে শর্তাবলী গ্রহণ করুন।",
      "verify.eyebrow": "ইমেল যাচাইকরণ",
      "verify.title": "আপনার ইমেল যাচাই করুন",
      "verify.subtitle": "আমরা {{email}}-এ একটি 6-সংখ্যার কোড পাঠিয়েছি। যাচাই করতে কোডটি লিখুন।",
      "verify.code": "যাচাইকরণ কোড",
      "verify.code.ph": "••••••",
      "verify.action": "যাচাই করুন",
      "verify.verifying": "যাচাই করা হচ্ছে…",
      "verify.resend": "আবার কোড পাঠান",
      "verify.resendIn": "{{seconds}} সেকেন্ড পর আবার পাঠান",
      "verify.resent": "একটি নতুন কোড পাঠানো হয়েছে।",
      "verify.skip": "এখন এড়িয়ে যান",
      "auth.forgot.link": "পাসওয়ার্ড ভুলে গেছেন?",
      "forgot.eyebrow": "পাসওয়ার্ড রিসেট",
      "forgot.email.title": "আপনার পাসওয়ার্ড রিসেট করুন",
      "forgot.email.subtitle": "আপনার অ্যাকাউন্টের ইমেল লিখুন, আমরা আপনাকে একটি 6-সংখ্যার রিসেট কোড পাঠাব।",
      "forgot.email.action": "কোড পাঠান",
      "forgot.email.sending": "পাঠানো হচ্ছে…",
      "forgot.reset.title": "নতুন পাসওয়ার্ড সেট করুন",
      "forgot.reset.subtitle": "{{email}}-এ পাঠানো 6-সংখ্যার কোড এবং আপনার নতুন পাসওয়ার্ড লিখুন।",
      "forgot.reset.action": "পাসওয়ার্ড আপডেট করুন",
      "forgot.reset.updating": "আপডেট হচ্ছে…",
      "forgot.field.code": "রিসেট কোড",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "নতুন পাসওয়ার্ড",
      "forgot.field.newPassword.ph": "কমপক্ষে 6টি অক্ষর",
      "forgot.resend": "আবার কোড পাঠান",
      "forgot.resendIn": "{{seconds}} সেকেন্ড পর আবার পাঠান",
      "forgot.resent": "একটি নতুন কোড পাঠানো হয়েছে।",
      "forgot.backToLogin": "লগইনে ফিরে যান",
      "forgot.changeEmail": "ইমেল পরিবর্তন করুন",
      "forgot.help.noMail": "কোড না পেলে আপনার স্প্যাম ফোল্ডার দেখুন অথবা ইমেল ঠিকানাটি সঠিক কিনা যাচাই করুন।",
      "reset.RESET_CODE_SENT": "কোড পাঠানো হয়েছে। অনুগ্রহ করে আপনার ইমেল দেখুন।",
      "reset.RATE_LIMITED": "অনেক বেশি অনুরোধ করা হয়েছে। অনুগ্রহ করে কিছুক্ষণ অপেক্ষা করে আবার চেষ্টা করুন।",
      "reset.MAIL_SEND_FAILED": "কিছু একটা ভুল হয়েছে। অনুগ্রহ করে পরে আবার চেষ্টা করুন।",
      "reset.RESET_CODE_VALID": "কোড যাচাই করা হয়েছে।",
      "reset.INVALID_RESET_CODE": "কোডটি সঠিক নয়। অনুগ্রহ করে আবার চেষ্টা করুন।",
      "reset.EXPIRED_RESET_CODE": "কোডের মেয়াদ শেষ হয়ে গেছে। অনুগ্রহ করে নতুন কোডের অনুরোধ করুন।",
      "reset.WEAK_PASSWORD": "পাসওয়ার্ড কমপক্ষে 6 অক্ষরের হতে হবে।",
      "reset.PASSWORD_RESET_SUCCESS": "আপনার পাসওয়ার্ড আপডেট হয়েছে। অনুগ্রহ করে নতুন পাসওয়ার্ড দিয়ে লগইন করুন।",
      "reset.generic": "কিছু একটা ভুল হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।",
      "login.resetSuccess": "আপনার পাসওয়ার্ড আপডেট হয়েছে। অনুগ্রহ করে নতুন পাসওয়ার্ড দিয়ে লগইন করুন।",
      "store.nav.shop": "স্টোর",
      "home.hero.title1": "কয়েক মিনিটে সংযুক্ত হন,",
      "home.hero.title2": "সীমানা পেরিয়েও অনলাইনে থাকুন।",
      "home.hero.subtitle": "190+ দেশে কার্যকর নির্ভরযোগ্য eSIM প্ল্যান। ফিজিক্যাল সিম নেই, রোমিং বিল নেই।",
      "home.search.placeholder": "কোথায় ভ্রমণ করছেন?",
      "home.tabs.local": "স্থানীয় eSIM",
      "home.tabs.regional": "আঞ্চলিক eSIM",
      "home.tabs.lifetime": "আজীবন eSIM",
      "home.empty": "আপনার অনুসন্ধানের সাথে মেলে এমন কোনো ফলাফল নেই।",
      "home.error.title": "কনটেন্ট লোড করা যায়নি",
      "home.error.retry": "আবার চেষ্টা করুন",
      "home.from": "শুরু",
      "home.popular": "জনপ্রিয় গন্তব্য",
      "home.coverage": "190+ দেশ · তাৎক্ষণিক সক্রিয়করণ",
      "home.detail.soon": "এই নির্বাচনের প্ল্যানগুলো খুব শীঘ্রই এখানে দেখানো হবে।",
      "home.detail.back": "স্টোরে ফিরে যান",
      "detail.plans": "প্ল্যান",
      "detail.count": "{{count}}টি প্ল্যান",
      "detail.validity": "{{days}} দিন",
      "detail.validityLifetime": "মেয়াদহীন",
      "detail.buy": "কিনুন",
      "detail.empty": "এই মুহূর্তে এই নির্বাচনের জন্য কোনো প্ল্যান নেই।",
      "detail.checkoutSoon": "পেমেন্ট শীঘ্রই চালু হচ্ছে।",
      "detail.loginToBuy": "কিনতে অনুগ্রহ করে লগইন করুন।",
      "detail.basicFeatures": "মূল বৈশিষ্ট্য",
      "detail.dataAmount": "ডেটার পরিমাণ",
      "detail.validityLabel": "মেয়াদ",
      "detail.coverageArea": "কভারেজ",
      "detail.activationNetworks": "সক্রিয়করণ ও নেটওয়ার্ক",
      "detail.activationMethod": "সক্রিয়করণ পদ্ধতি",
      "detail.esimActivation": "eSIM — QR কোডের মাধ্যমে তাৎক্ষণিক",
      "detail.supportedNetworks": "সমর্থিত নেটওয়ার্ক",
      "detail.description": "বিবরণ",
      "detail.price": "মূল্য",
      "authprompt.title": "চালিয়ে যেতে লগইন করুন",
      "authprompt.message": "eSIM কিনতে আপনার অ্যাকাউন্টে লগইন করুন, অথবা কয়েক সেকেন্ডে একটি অ্যাকাউন্ট তৈরি করুন।",
      "authprompt.close": "বন্ধ করুন",
      "footer.tagline": "বিশ্বজুড়ে দ্রুত, নিরাপদ ও সাশ্রয়ী eSIM। অবতরণের মুহূর্তেই অনলাইনে থাকুন।",
      "footer.explore": "ঘুরে দেখুন",
      "footer.support": "সহায়তা",
      "footer.legal": "আইনি",
      "footer.shop": "স্টোর",
      "footer.help": "সচরাচর জিজ্ঞাসিত প্রশ্ন",
      "footer.terms": "ব্যবহারের শর্তাবলী",
      "footer.rights": "© {{year}} Utkan eSIM. সর্বস্বত্ব সংরক্ষিত।",
      "footer.apps": "অ্যাপটি ডাউনলোড করুন",
      "whatsapp.label": "WhatsApp-এ চ্যাট করুন",
      "whatsapp.message": "হ্যালো, আমার একটি eSIM সহায়তার অনুরোধ আছে।",
      "notfound.eyebrow": "সিগন্যাল নেই",
      "notfound.title": "এই পৃষ্ঠাটি নাগালের বাইরে",
      "notfound.message": "আপনি যে পৃষ্ঠাটি খুঁজছেন সেটি সরানো হয়েছে বা কখনো ছিল না। চলুন, আপনাকে আবার কভারেজে ফিরিয়ে আনি।",
      "order.congrats": "অভিনন্দন!",
      "order.message": "আপনার eSIM প্রস্তুত। নিচের QR কোড দিয়ে কয়েক ধাপে এটি সেট আপ করুন।",
      "order.details": "অর্ডারের সারাংশ",
      "order.activation": "সক্রিয়করণ",
      "order.activationDesc": "আপনার eSIM সেট আপ করতে ডিভাইসের ক্যামেরা দিয়ে QR কোডটি স্ক্যান করুন অথবা সক্রিয়করণ কোডটি ম্যানুয়ালি লিখুন।",
      "order.qrTitle": "eSIM QR কোড",
      "order.manualLabel": "সক্রিয়করণ কোড",
      "order.copy": "কপি করুন",
      "order.copied": "কপি হয়েছে",
      "order.howTo": "কীভাবে সক্রিয় করবেন",
      "order.step1": "আপনার ডিভাইসে সেটিংস > সেলুলার / মোবাইল ডেটা > eSIM যোগ করুন-এ যান।",
      "order.step2": "“QR কোড ব্যবহার করুন” নির্বাচন করে ওপরের QR কোডটি স্ক্যান করুন (অথবা সক্রিয়করণ কোডটি ম্যানুয়ালি লিখুন)।",
      "order.step3": "সেটআপ শেষ হলে eSIM প্ল্যানটি চালু করুন।",
      "order.step4": "ডেটা রোমিং চালু আছে কিনা নিশ্চিত করুন — আপনি সংযুক্ত!",
      "order.cta": "হোমে ফিরে যান",
      "checkout.title": "পেমেন্ট",
      "checkout.summary": "অর্ডারের সারাংশ",
      "checkout.total": "মোট",
      "checkout.eurNote": "PayPal-এর মাধ্যমে আপনার কাছ থেকে ইউরোতে (€) চার্জ নেওয়া হবে।",
      "checkout.processing": "আপনার পেমেন্ট যাচাই করা হচ্ছে…",
      "checkout.error": "পেমেন্ট সম্পন্ন করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।",
      "checkout.cancelled": "পেমেন্ট বাতিল করা হয়েছে।",
      "account.title": "আমার অ্যাকাউন্ট",
      "account.tab.profile": "প্রোফাইল",
      "account.tab.esims": "আমার eSIM",
      "account.tab.security": "নিরাপত্তা",
      "account.profile.title": "প্রোফাইলের তথ্য",
      "account.field.phone": "ফোন",
      "account.field.phone.ph": "+880…",
      "account.memberSince": "সদস্য হওয়ার তারিখ",
      "account.save": "সংরক্ষণ করুন",
      "account.saving": "সংরক্ষণ করা হচ্ছে…",
      "account.saved": "আপনার তথ্য আপডেট করা হয়েছে।",
      "account.esims.title": "আমার eSIM",
      "account.esims.empty": "আপনার এখনো কোনো eSIM নেই।",
      "account.esims.emptyCta": "স্টোর ঘুরে দেখুন",
      "account.esims.data": "ডেটা",
      "account.esims.expires": "মেয়াদ শেষ",
      "account.esims.viewQr": "QR কোড দেখান",
      "account.esims.hideQr": "QR কোড লুকান",
      "account.esims.active": "সক্রিয়",
      "account.esims.passive": "নিষ্ক্রিয়",
      "account.esims.noActive": "আপনার কোনো সক্রিয় eSIM নেই।",
      "account.esims.noPassive": "আপনার কোনো নিষ্ক্রিয় eSIM নেই।",
      "account.esims.readyHint": "ব্যবহারের জন্য প্রস্তুত — প্রথম ব্যবহারে মেয়াদ শুরু হবে।",
      "account.esims.unavailableHint": "এই মুহূর্তে স্ট্যাটাস পাওয়া যাচ্ছে না। অনুগ্রহ করে পরে আবার চেষ্টা করুন।",
      "esimStatus.active": "সক্রিয়",
      "esimStatus.readyToUse": "ব্যবহারের জন্য প্রস্তুত",
      "esimStatus.inactive": "নিষ্ক্রিয়",
      "esimStatus.unavailable": "স্ট্যাটাস পাওয়া যাচ্ছে না",
      "account.security.title": "পাসওয়ার্ড পরিবর্তন করুন",
      "account.field.oldPassword": "বর্তমান পাসওয়ার্ড",
      "account.field.newPassword": "নতুন পাসওয়ার্ড",
      "account.field.confirmPassword": "নতুন পাসওয়ার্ড (আবার)",
      "account.changePassword": "পাসওয়ার্ড আপডেট করুন",
      "account.passwordChanged": "আপনার পাসওয়ার্ড আপডেট করা হয়েছে।",
      "account.error.passwordMismatch": "নতুন পাসওয়ার্ড দুটি মিলছে না।",
      "account.danger.title": "অ্যাকাউন্ট সংক্রান্ত কাজ",
      "account.delete": "অ্যাকাউন্ট মুছুন",
      "account.delete.confirm": "আপনি আপনার অ্যাকাউন্ট স্থায়ীভাবে মুছে ফেলতে যাচ্ছেন। এটি আর ফেরানো যাবে না।",
      "account.delete.confirmBtn": "হ্যাঁ, মুছুন",
      "account.cancel": "বাতিল",
      "esimDetail.back": "ফিরে যান",
      "esimDetail.dataUsage": "ডেটা ব্যবহার",
      "esimDetail.left": "বাকি",
      "esimDetail.leftData": "অবশিষ্ট ডেটা",
      "esimDetail.usedData": "ব্যবহৃত",
      "esimDetail.totalData": "মোট ডেটা",
      "esimDetail.qrDesc": "আপনার eSIM সেট আপ করতে ডিভাইসের ক্যামেরা দিয়ে এই QR কোডটি স্ক্যান করুন।",
      "esimDetail.validity": "মেয়াদ",
      "esimDetail.daysLeft": "{{days}} দিন বাকি",
      "esimDetail.expired": "মেয়াদ উত্তীর্ণ",
      "esimDetail.notYetActive": "এখনো সক্রিয় হয়নি",
      "esimDetail.leftDate": "অবশিষ্ট সময়",
      "esimDetail.activationDate": "সক্রিয়করণের তারিখ",
      "esimDetail.endDate": "শেষ তারিখ",
      "esimDetail.technical": "প্রযুক্তিগত বিবরণ",
      "esimDetail.activationCode": "সক্রিয়করণ কোড (Android)",
      "esimDetail.smdp": "SM-DP+ ঠিকানা (iOS)",
      "esimDetail.matchingId": "Matching ID (iOS)",
      "esimDetail.support": "প্রযুক্তিগত সহায়তা",
      "esimDetail.supportDesc": "কোনো সমস্যা হচ্ছে? আমরা সাহায্য করতে প্রস্তুত।",
      "esimDetail.email": "ইমেল পাঠান",
      "guide.eyebrow": "eSIM নির্দেশিকা",
      "guide.title": "eSIM কী এবং কীভাবে সেট আপ করবেন?",
      "guide.intro.title": "eSIM কী?",
      "guide.intro.body": "eSIM হলো আপনার ডিভাইসে বিল্ট-ইন একটি ডিজিটাল সিম — কোনো ফিজিক্যাল কার্ডের প্রয়োজন নেই। একটি QR কোড স্ক্যান করুন, কয়েক সেকেন্ডেই আপনার লাইন সেট আপ হয়ে যাবে; কার্ড বদলানো বা রোমিং বিল ছাড়াই 190+ দেশে অনলাইনে থাকুন।",
      "guide.steps.title": "কীভাবে সক্রিয় করবেন",
      "guide.devices.title": "সমর্থিত ডিভাইস",
      "guide.devices.desc": "eSIM কাজ করার জন্য আপনার ডিভাইসকে eSIM সমর্থন করতে হবে। নিচে আপনার ব্র্যান্ড খুঁজুন।",
      "guide.faq.title": "সচরাচর জিজ্ঞাসিত প্রশ্ন",
      "nav.guide": "eSIM নির্দেশিকা",
      "currency.label": "মুদ্রা",
      "staticPage.loading": "পৃষ্ঠা লোড হচ্ছে...",
      "staticPage.errorTitle": "একটি ত্রুটি ঘটেছে",
      "staticPage.retry": "আবার চেষ্টা করুন",
      "staticPage.loadFailed": "পৃষ্ঠার কনটেন্ট লোড করা যায়নি। অনুগ্রহ করে পরে আবার চেষ্টা করুন।",
      "last.updated": "সর্বশেষ আপডেট: 8 জুলাই, 2024",
      "home.tabs.unlimited": "আনলিমিটেড eSIM",
      "detail.unlimited": "আনলিমিটেড",
      "detail.unlimitedNote": "এই প্যাকেজে কোনো ডেটা সীমা নেই — পুরো মেয়াদজুড়ে আনলিমিটেড ইন্টারনেট উপভোগ করুন।",
      "detail.notPriced": "এই প্যাকেজটি এই মুহূর্তে ওয়েবে কেনা যাচ্ছে না।",
      "checkout.priceUpdated": "এই প্যাকেজের মূল্য পরিবর্তিত হয়েছে। অনুগ্রহ করে স্টোরে ফিরে গিয়ে আবার নির্বাচন করুন।",
      "order.pending.title": "আপনার eSIM প্রস্তুত করা হচ্ছে",
      "order.pending.message": "আপনার পেমেন্ট সফল হয়েছে। আনলিমিটেড প্যাকেজ সক্রিয় হতে কয়েক মিনিট সময় লাগতে পারে।",
      "order.pending.waiting": "আপনার অর্ডারের স্ট্যাটাস যাচাই করা হচ্ছে…",
      "order.pending.ready": "আপনার eSIM প্রস্তুত!",
      "order.pending.timeout": "প্রত্যাশার চেয়ে বেশি সময় লাগছে। আপনার পেমেন্ট নিরাপদ — প্রস্তুত হওয়ার সঙ্গে সঙ্গে আপনার eSIM “আমার eSIM”-এ দেখা যাবে।",
      "order.pending.cta": "আমার eSIM-এ যান",
      "account.esims.unlimited": "আনলিমিটেড",
      "account.esims.unlimitedHint": "আনলিমিটেড ডেটা — এই প্যাকেজে কোনো ডেটা সীমা নেই।",
      "esimDetail.unlimitedData": "এই প্যাকেজে কোনো ডেটা সীমা নেই; অবশিষ্ট সময় নিচে দেখুন।",
      "del.eyebrow": "অ্যাকাউন্ট মুছে ফেলা",
      "del.title": "আমার অ্যাকাউন্ট মুছুন",
      "del.intro": "এখানে আপনি আপনার Utkan eSIM অ্যাকাউন্ট ও ব্যক্তিগত ডেটা স্থায়ীভাবে মুছে ফেলতে পারেন। অ্যাপ ইনস্টল থাকার প্রয়োজন নেই — যে অ্যাকাউন্টটি মুছতে চান সেটি দিয়ে লগইন করলেই হবে।",
      "del.deleted.title": "যে ডেটা মুছে ফেলা হয়",
      "del.deleted.identity": "আপনার নাম, পদবি, ইমেল ঠিকানা ও ফোন নম্বর",
      "del.deleted.credentials": "আপনার পাসওয়ার্ড ও সেশনের ডেটা",
      "del.deleted.codes": "আপনার ইমেল যাচাইকরণ ও পাসওয়ার্ড রিসেট কোড",
      "del.deleted.esim": "আপনার eSIM নম্বর (MSISDN), QR/সক্রিয়করণ কোড ও ব্যবহারের ডেটা",
      "del.kept.title": "যে ডেটা আমরা রাখি এবং কেন",
      "del.kept.orders": "কর ও হিসাবরক্ষণ সংক্রান্ত বাধ্যবাধকতা পূরণের জন্য ক্রয়ের রেকর্ড (অর্ডার নম্বর, তারিখ, পরিমাণ, পেমেন্টের স্ট্যাটাস) সংরক্ষণ করা হয়। এতে কোনো নাম, ইমেল ঠিকানা বা পেমেন্টের বিবরণ থাকে না — শুধু এমন একটি শনাক্তকারী থাকে যা আপনার সাথে যুক্ত করা যায় না।",
      "del.kept.period": "সংরক্ষণের মেয়াদ: 5 বছর (তুরস্কের কর পদ্ধতি আইন, ধারা 253)।",
      "del.warn.title": "মুছে ফেলার আগে",
      "del.warn.irreversible": "এই কাজটি আর ফেরানো যাবে না।",
      "del.warn.esim": "সক্রিয় eSIM গুলো আপনার ডিভাইসে কাজ করতে থাকবে, তবে আপনি আর আপনার QR কোড বা অবশিষ্ট ডেটা দেখতে পারবেন না। মুছে ফেলার আগে আপনার QR কোড সংরক্ষণ করে রাখুন।",
      "del.warn.rejoin": "একই ইমেল ঠিকানা দিয়ে আবার সাইন আপ করতে পারবেন, তবে আপনার আগের eSIM গুলো নতুন অ্যাকাউন্টে দেখা যাবে না।",
      "del.support": "লগইন করতে না পারলে ইমেলের মাধ্যমেও মুছে ফেলার অনুরোধ করতে পারেন:",
      "del.login.title": "প্রথমে লগইন করুন",
      "del.login.subtitle": "অ্যাকাউন্টটি আপনার কিনা নিশ্চিত করতে আপনার ইমেল ও পাসওয়ার্ড লিখুন।",
      "del.login.action": "লগইন করুন",
      "del.login.loading": "লগইন হচ্ছে...",
      "del.forgot": "পাসওয়ার্ড ভুলে গেছেন?",
      "del.confirm.title": "আপনি কি নিশ্চিত?",
      "del.confirm.subtitle": "{{email}} অ্যাকাউন্ট এবং আপনার ব্যক্তিগত ডেটা স্থায়ীভাবে মুছে ফেলা হবে।",
      "del.confirm.field": "নিশ্চিত করতে আপনার ইমেল ঠিকানা আবার লিখুন",
      "del.confirm.action": "আমার অ্যাকাউন্ট স্থায়ীভাবে মুছুন",
      "del.confirm.deleting": "মুছে ফেলা হচ্ছে...",
      "del.confirm.cancel": "বাতিল",
      "del.done.title": "আপনার অ্যাকাউন্ট মুছে ফেলা হয়েছে",
      "del.done.body": "আপনার ব্যক্তিগত ডেটা স্থায়ীভাবে মুছে ফেলা হয়েছে।",
      "del.done.retained": "আপনার ব্যক্তিগত ডেটা স্থায়ীভাবে মুছে ফেলা হয়েছে। আইনি বাধ্যবাধকতা পূরণের জন্য {{n}}টি ক্রয়ের রেকর্ড রাখা হয়েছে; এগুলো আপনার সাথে যুক্ত করা যায় না।",
      "del.done.home": "স্টোরে ফিরে যান",
      "del.error.required": "অনুগ্রহ করে আপনার ইমেল ও পাসওয়ার্ড লিখুন।",
      "del.error.credentials": "ইমেল বা পাসওয়ার্ড ভুল।",
      "del.error.suspended": "আপনার অ্যাকাউন্ট স্থগিত করা হয়েছে। অনুগ্রহ করে সহায়তা দলের সাথে যোগাযোগ করুন।",
      "del.error.session": "আপনার সেশনের মেয়াদ শেষ হয়ে গেছে। অনুগ্রহ করে আবার লগইন করুন।",
      "del.error.network": "সংযোগ স্থাপন করা যায়নি। আপনার ইন্টারনেট সংযোগ পরীক্ষা করে আবার চেষ্টা করুন।",
      "del.error.generic": "কিছু একটা ভুল হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।",
      "footer.deleteAccount": "অ্যাকাউন্ট মুছুন",
      "home.tabs.voice": "কল সহ eSIM",
      "detail.voice": "কল + SMS",
      "detail.voiceNote": "এই প্ল্যানে ডেটার পাশাপাশি আনলিমিটেড কল ও SMS রয়েছে — ইন্টারনেট ও কলের জন্য একটিই eSIM।",
      "detail.calls": "কল",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "আনলিমিটেড কল",
      "plan.unlimitedSms": "আনলিমিটেড SMS",
      "plan.minutes": "{{n}} মিনিট কল",
      "plan.sms": "{{n}}টি SMS",
      "hercules.subtitle": "{{n}}টি ইউরোপীয় দেশে আনলিমিটেড কল, SMS ও ডেটা — একটিই eSIM-এ।",
      "hercules.coverageTitle": "কভারেজভুক্ত দেশ ({{n}})",
      "hercules.promo.desc": "{{n}}টি দেশে আনলিমিটেড কল ও SMS, সাথে 20–100 GB ডেটা।",
      "hercules.promo.cta": "প্ল্যান দেখুন",
      "loading": "লোড হচ্ছে..."
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'tr',
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
    },
  });

export default i18n; 